export type Maybe<T> = T | null
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  DateTime: any
  /** Formatted full-name of a US state. */
  USStateName: any
  /** The URL scalar type represents URL addresses. */
  URL: any
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any
  Date: any
  /** A field representing a standard email address. https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address */
  Email: any
  /** The last four numbers of a card. */
  CardNumberMasked: any
  /** A key for clients to use to map to strings in external repositories */
  StringKey: any
  /** A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/. */
  EmailAddress: any
  TickerSymbol: any
  BigDecimal: any
  Url: any
  /** Represents NULL values */
  Void: any
  /** A routing number for a bank */
  RoutingNumber: any
  /** An account number for a corepro account */
  AccountNumber: any
  /** Floats that will have a value greater than 0. */
  PositiveFloat: any
  /** Four digit PIN. */
  BankCardPin: any
  /** The `Upload` scalar type represents a file upload. */
  Upload: any
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  PhoneNumber: any
  /** The Long scalar type represents a signed 64-bit numeric non-fractional value */
  Long: any
  /** The Short scalar type represents a signed 16-bit numeric non-fractional value */
  Short: any
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: any
}

export type AboutSection = {
  __typename?: 'AboutSection'
  image?: Maybe<Image>
  title: Scalars['String']
}

/** Describes the employer switch based on the switch type. */
export type AbstractSwitch = AcornsPdfSwitch | OnlineSwitch | SubmittableSwitch

export type AcceptanceDocument = {
  __typename?: 'AcceptanceDocument'
  id: Scalars['ID']
  /** The name of the document */
  name: Scalars['String']
  /** The type of document (arbitrary right now) */
  type: Scalars['String']
  /** The version of the document */
  version: Scalars['String']
  /** The URL to the document text */
  url: Scalars['URL']
  /** The name of the summary */
  summaryName?: Maybe<Scalars['String']>
  /** The URL to the summary text */
  summaryUrl?: Maybe<Scalars['URL']>
  /**
   * Indicates wether the app should force the user to scroll to
   * the bottom before accepting
   */
  mustScrollToBottom?: Maybe<Scalars['Boolean']>
  /**
   * A string indicating a specific app feature that the acceptance
   * of the document is required for using
   */
  requiredFor?: Maybe<Scalars['String']>
}

export enum AcceptanceDocumentType {
  /** Required agreement when user is signed up through a referral program or code */
  ReferralDisclosure = 'referralDisclosure',
}

/** Bundle of acceptance date, signature, and document type */
export type AcceptDocumentInput = {
  /** The date the document was signed by the user */
  acceptedDate: Scalars['Date']
  /** Name to apply to the accepted document */
  signature: Scalars['String']
  /** Type of document the given signature is accepting */
  documentType: AcceptanceDocumentType
  /** The version of the document the user is accepting */
  documentVersion: Scalars['String']
}

/** What happens when a user accepts a document */
export type AcceptDocumentResponse =
  | AcceptedDocument
  | DocumentNotFound
  | UserNotFound

/** A document that a user has accepted */
export type AcceptedDocument = {
  __typename?: 'AcceptedDocument'
  acceptedDate: Scalars['Date']
  documentType: AcceptanceDocumentType
  documentUrl: Scalars['String']
  documentVersion: Scalars['String']
  signature: Scalars['String']
}

export type AcceptUploadedDocumentInput = {
  documentRequestId: Scalars['ID']
  reviewerId: Scalars['ID']
}

/** Individual accounts opened by a user at Acorns */
export type Account = TimestampsInterface & {
  __typename?: 'Account'
  /** Type of account */
  accountType: AccountType
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Internal ID for account creator */
  creatorId: Scalars['ID']
  /** Internal ID for account */
  id: Scalars['ID']
  /** Status of account */
  status: AccountStatus
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export type AccountAchievement = {
  __typename?: 'AccountAchievement'
  achievement: AchievementItem
  completed: Scalars['Boolean']
  dateCompleted: Scalars['DateTime']
}

/** The account provided is already closed */
export type AccountAlreadyClosedException = {
  __typename?: 'AccountAlreadyClosedException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Investment account is already closed */
export type AccountClosedException = {
  __typename?: 'AccountClosedException'
  /** message */
  errorMessage?: Maybe<Scalars['String']>
}

/** When investment account id doesn't match with user */
export type AccountNotFoundException = {
  __typename?: 'AccountNotFoundException'
  /** message */
  errorMessage?: Maybe<Scalars['String']>
}

export type AccountPoints = {
  __typename?: 'AccountPoints'
  /** detailed explanation about how points are earned */
  details: Scalars['String']
  earned: Scalars['Int']
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']
  /** summarized explanation about how points are earned */
  summary?: Maybe<Scalars['String']>
}

export type AccountPointsRule = {
  __typename?: 'AccountPointsRule'
  /** detailed explanation about how points are earned */
  details: Scalars['String']
  milestoneID: Scalars['ID']
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']
  /** summarized explanation about how points are earned */
  summary?: Maybe<Scalars['String']>
}

export type AccountRequirement = {
  __typename?: 'AccountRequirement'
  actionable: Scalars['Boolean']
  description?: Maybe<Scalars['String']>
  status: AccountRequirementStatus
  type: AccountRequirementType
}

export type AccountRequirements = {
  __typename?: 'AccountRequirements'
  close: AccountRequirement[]
}

export enum AccountRequirementStatus {
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  Completed = 'COMPLETED',
}

export enum AccountRequirementType {
  FundingSource = 'FUNDING_SOURCE',
  VerifiedFundingSource = 'VERIFIED_FUNDING_SOURCE',
  NoTransferringInvestments = 'NO_TRANSFERRING_INVESTMENTS',
  NoTransferringDividends = 'NO_TRANSFERRING_DIVIDENDS',
  Liquidated = 'LIQUIDATED',
  NoPendingInvestments = 'NO_PENDING_INVESTMENTS',
  RecurringDepositsDisabled = 'RECURRING_DEPOSITS_DISABLED',
}

export enum AccountStatus {
  /** Account is in process of being opened or verified */
  Pending = 'pending',
  /** Open account ready for use */
  Open = 'open',
  /** Account closure is in progress */
  Inactive = 'inactive',
  /** Account has been closed */
  Closed = 'closed',
}

export type AccountStrengthResult = {
  __typename?: 'AccountStrengthResult'
  achievements?: Maybe<Array<Maybe<AccountAchievement>>>
  percentage: Scalars['Float']
}

export enum AccountType {
  /** Core basic investment account */
  Basic = 'basic',
  /** Later ROTH IRA account */
  RothIra = 'rothIra',
  /** Later traditional IRA account */
  TraditionalIra = 'traditionalIra',
  /** Later SEP IRA account */
  SepIra = 'sepIra',
  /** Spend LSB checking account */
  Checking = 'checking',
  /** Uniform Gift to Minors Act */
  Ugma = 'ugma',
  /** Uniform Transfers to Minors Act */
  Utma = 'utma',
}

/** Account values over the reporting period */
export type AccountValue = {
  __typename?: 'AccountValue'
  /** The dollar amount of the account's balance */
  amount?: Maybe<Scalars['Float']>
  /** The time of the associated account value */
  timestamp?: Maybe<Scalars['DateTime']>
}

export enum AchievementItem {
  RoundupAccountLinked = 'roundupAccountLinked',
  AutomaticRoundupsOn = 'automaticRoundupsOn',
  MultipleRoundupAccountsLinked = 'multipleRoundupAccountsLinked',
  AccountValueGte10 = 'accountValueGte10',
  AccountValueGte100 = 'accountValueGte100',
  FundingSourceLinked = 'fundingSourceLinked',
  AutomaticInvestmentOn = 'automaticInvestmentOn',
  RegistrationComplete = 'registrationComplete',
}

/** Acorns PDF Switches are performed by emailing and printing a PDF. */
export type AcornsPdfSwitch = SwitchInterface & {
  __typename?: 'AcornsPdfSwitch'
  source: SwitchSource
  type: SwitchType
}

export type ActionCard = {
  __typename?: 'ActionCard'
  userCardDigest?: Maybe<Scalars['ID']>
  style: ActionCardStyle
  type: Scalars['String']
  eyebrow?: Maybe<Scalars['String']>
  headline?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  body?: Maybe<Scalars['String']>
  icon?: Maybe<Scalars['String']>
  imageUrl?: Maybe<Scalars['URL']>
  image?: Maybe<Scalars['JSON']>
  heroImageUrl?: Maybe<Scalars['URL']>
  ctaDetails?: Maybe<ActionCardButton>
  widget?: Maybe<Scalars['JSON']>
  ownerName?: Maybe<Scalars['String']>
}

export type ActionCardButton = {
  __typename?: 'ActionCardButton'
  type: Scalars['String']
  id?: Maybe<Scalars['String']>
  title: Scalars['String']
  videoUrl?: Maybe<Scalars['URL']>
  video?: Maybe<Scalars['URL']>
  image?: Maybe<Scalars['URL']>
}

export type ActionCardsInput = {
  feedContext?: Maybe<ActionFeedContext>
}

export enum ActionCardStyle {
  Alert = 'alert',
  AnnouncingLater = 'announcingLater',
  Basic = 'basic',
  BasicVideo = 'basicVideo',
  FoundMoney = 'foundMoney',
  Grow = 'grow',
  Snackable = 'snackable',
  Widget = 'widget',
}

export enum ActionFeedContext {
  A3Core = 'a3Core',
  A3Later = 'a3Later',
  A3Present = 'a3Present',
  A3Spend = 'a3Spend',
  A4Early = 'a4Early',
  A4EarlyDetails = 'a4EarlyDetails',
  A4Home = 'a4Home',
  A4Invest = 'a4Invest',
  A4Later = 'a4Later',
  A4Spend = 'a4Spend',
  Later = 'later',
}

export type ActionFeedCta = {
  __typename?: 'ActionFeedCta'
  hideCardIfUnknown?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['ID']>
  image?: Maybe<Scalars['String']>
  title: Scalars['String']
  type?: Maybe<ActionFeedCtaType>
  video?: Maybe<Scalars['String']>
  videoUrl?: Maybe<Scalars['String']>
}

export enum ActionFeedCtaType {
  /** link */
  Link = 'link',
  /** grow article link */
  GrowArticle = 'grow_article',
  /** link to view a video */
  Video = 'video',
  /** insights sequence wizard */
  Wizard = 'wizard',
  /** insights sequence offer */
  Offer = 'offer',
  /** insights sequence spell */
  Spell = 'spell',
  /** triggers an email download */
  Email = 'email',
  /** customer feedback survey */
  Survey = 'survey',
}

/** input for an action feed event */
export type ActionFeedEvent = {
  /** event action type */
  action: ActionFeedEventAction
  /** CARD | TIP */
  eventType: ActionFeedEventType
  /** card type */
  eventKey: Scalars['ID']
  /** body of event */
  body?: Maybe<Scalars['String']>
  /** card digest id */
  userCardDigest?: Maybe<Scalars['String']>
  /** cta id */
  ctaId?: Maybe<Scalars['ID']>
  /** investment account id */
  accountId?: Maybe<Scalars['ID']>
}

export enum ActionFeedEventAction {
  /** Card Impression */
  Impression = 'impression',
  /** CTA Tapped */
  Tapped = 'tapped',
  /** Dismissed */
  Dismissed = 'dismissed',
  /** Completed */
  Completed = 'completed',
}

/** Response to recording a feed event */
export type ActionFeedEventResponse = {
  __typename?: 'ActionFeedEventResponse'
  success: Scalars['Boolean']
}

export enum ActionFeedEventType {
  /** Card Event - impression, tapped, dismissed */
  Card = 'CARD',
  /** Tip Event - completed, dismissed */
  Tip = 'TIP',
}

export type ActivateBankCardInput = {
  cardNumberMasked: Scalars['CardNumberMasked']
}

export type ActivateBankCardPayload = {
  __typename?: 'ActivateBankCardPayload'
  bankCard?: Maybe<BankCard>
}

export type Activity = {
  __typename?: 'Activity'
  id: Scalars['ID']
  type: ActivityType
  createdAt: Scalars['DateTime']
  pending?: Maybe<Scalars['Boolean']>
  meta: Scalars['JSON']
}

export enum ActivitySummaryProduct {
  /** Core investment product */
  Invest = 'INVEST',
  /** Later investment product */
  Later = 'LATER',
  /** Early investment product */
  Early = 'EARLY',
}

export type ActivitySummaryResponse = {
  __typename?: 'ActivitySummaryResponse'
  activitySummaryItems?: Maybe<SummaryItem[]>
  numberOfDays?: Maybe<Scalars['Int']>
  total?: Maybe<CurrencyAmount>
}

export enum ActivityType {
  Seeding = 'seeding',
  OneTimeInvestment = 'oneTimeInvestment',
  RecurringInvestment = 'recurringInvestment',
  Withdrawal = 'withdrawal',
  Dividend = 'dividend',
  ReferralReward = 'referralReward',
  FoundMoney = 'foundMoney',
  Fee = 'fee',
  Rebalance = 'rebalance',
  RoundUp = 'roundUp',
  BonusRoundup = 'bonusRoundup',
  EmployeeContribution = 'employeeContribution',
  GiftCard = 'giftCard',
  Credit = 'credit',
  PartnerReward = 'partnerReward',
  AchFee = 'achFee',
  DirectFee = 'directFee',
}

export type AddActionToMilestoneAchievementActionRuleInput = {
  /** an action type to add to the list of side-effects the milestone can trigger when it is completed */
  actionToAdd: MilestoneAchievementActionType
  milestoneID: Scalars['ID']
}

export type AddActionToMilestoneAchievementActionRuleResult =
  | MilestoneAchievementActionRule
  | RecordAlreadyExistsError
  | RecordDoesNotExistError

export type AddDocumentUrlsInput = {
  documents: DocumentInput[]
  documentRequestId: Scalars['ID']
}

/** Miscellaneous attributes and information about a user's address */
export type Address = TimestampsInterface & {
  __typename?: 'Address'
  /** Type of address */
  addressType: AddressType
  /** City */
  city: Scalars['String']
  /** Country */
  country: Scalars['String']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Internal ID for address */
  id: Scalars['ID']
  /** State */
  state: Scalars['String']
  /** First street address */
  street1: Scalars['String']
  /** Second street address */
  street2?: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Internal ID for user */
  userId: Scalars['ID']
  /** Address has been verified */
  verified: Scalars['Boolean']
  /** Zip code */
  zipCode: Scalars['String']
}

export type AddressDeliverabilityAdditionalInfo = {
  __typename?: 'AddressDeliverabilityAdditionalInfo'
  isPoBox?: Maybe<Scalars['Boolean']>
  isBusiness?: Maybe<Scalars['Boolean']>
  isPrivateMailbox?: Maybe<Scalars['Boolean']>
  isVacant?: Maybe<Scalars['Boolean']>
}

/**
 * The Address is verified as deliverable but requires corrections to one or more input fields.
 * Note: Clients can determine what fields are different by diffing their input with the corrected field.
 */
export type AddressDeliverabilityCorrectedAddress = {
  __typename?: 'AddressDeliverabilityCorrectedAddress'
  city?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  street1?: Maybe<Scalars['String']>
  street2?: Maybe<Scalars['String']>
  zipCode?: Maybe<Scalars['String']>
  additionalInfo?: Maybe<AddressDeliverabilityAdditionalInfo>
}

/** Changeable attributes for addresses */
export type AddressDeliverabilityInput = {
  street1: Scalars['String']
  street2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  /** 5 digit zip code */
  zipCode?: Maybe<Scalars['String']>
}

export type AddressDeliverabilityResult =
  | AddressDeliverabilityVerified
  | AddressDeliverabilityVerificationError
  | AddressDeliverabilityCorrectedAddress
  | AddressDeliverabilityUnavailableError

/** The Verification was unavailable. Clients should determine how to handle this case according to product requirements */
export type AddressDeliverabilityUnavailableError = {
  __typename?: 'AddressDeliverabilityUnavailableError'
  requestId?: Maybe<Scalars['String']>
}

/** The Verification rejected the address as undeliverable. */
export type AddressDeliverabilityVerificationError = {
  __typename?: 'AddressDeliverabilityVerificationError'
  requestId?: Maybe<Scalars['String']>
  failureReason?: Maybe<AddressDeliverabilityVerificationErrorFailureReason>
}

export enum AddressDeliverabilityVerificationErrorFailureReason {
  /** The input address is missing or was not found */
  AddressNotFound = 'addressNotFound',
  /** The input state code is missing or invalid */
  InvalidState = 'invalidState',
  /** The input city is missing or invalid */
  InvalidCity = 'invalidCity',
  /** The input postal code is missing or invalid */
  InvalidZipCode = 'invalidZipCode',
  /** The input address contains an invalid ste, apt, or box number */
  InvalidAddressSecondaryNumber = 'invalidAddressSecondaryNumber',
  /** The input address is missing ste, apt, or box number */
  MissingAddressSecondaryNumber = 'missingAddressSecondaryNumber',
  /** The input address has an invalid house number */
  InvalidAddressPrimaryNumber = 'invalidAddressPrimaryNumber',
  /** The input address is missing a house number */
  MissingAddressPrimaryNumber = 'missingAddressPrimaryNumber',
  /** The input matched multiple addresses, needs more info */
  AmbiguousAddress = 'ambiguousAddress',
  /** The input address is missing PO, RR, or HC box number */
  MissingPoBoxNumber = 'missingPoBoxNumber',
  /** The input address' PO, RR, or HC box number invalid */
  InvalidPoBoxNumber = 'invalidPoBoxNumber',
  /** The input address matched to CMRA but PMB designator not present (PMB 123 or # 123) */
  MissingPmbNumber = 'missingPmbNumber',
  /** The input address matched to a physical address that does not receive delivery from the USPS */
  AddressNotDeliverable = 'addressNotDeliverable',
  /** An unknown or unmapped error occurred */
  Unknown = 'unknown',
}

/** The Address is verified as deliverable with no corrections issued on any input fields. */
export type AddressDeliverabilityVerified = {
  __typename?: 'AddressDeliverabilityVerified'
  requestId?: Maybe<Scalars['String']>
  additionalInfo?: Maybe<AddressDeliverabilityAdditionalInfo>
}

/** Address Document Requested Alert. */
export type AddressDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'AddressDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Changeable attributes for addresses */
export type AddressInput = {
  /** Street 1 */
  street1?: Maybe<Scalars['String']>
  /** Street 2 */
  street2?: Maybe<Scalars['String']>
  /** City */
  city?: Maybe<Scalars['String']>
  /** State */
  state?: Maybe<Scalars['String']>
  /** Country */
  country?: Maybe<Scalars['String']>
  /** Zip code */
  zipCode?: Maybe<Scalars['String']>
}

export enum AddressType {
  /** A residential address */
  Residential = 'residential',
  /** A mailing address */
  Mailing = 'mailing',
  /** A billing address */
  Billing = 'billing',
}

/** Input for creating a Self Directed Portfolio */
export type AddSelfDirectedPortfolioInput = {
  /** ID of the existing investment account for this portfolio to be associated with */
  investmentAccountId: Scalars['ID']
}

/** Result from opening a Self Directed Portfolio */
export type AddSelfDirectedPortfolioResult =
  | InvestmentAccount
  | PortfolioNotFoundException

/** An existing Acorns user that has referred friends to Acorns */
export type Advocate = {
  __typename?: 'Advocate'
  /** UUID of the existing Acorns user */
  userId?: Maybe<Scalars['ID']>
  /** The referral code associated with the advocate */
  referralCodes?: Maybe<Array<Scalars['String']>>
  /** A list of people that have used the advocate's share link */
  friends?: Maybe<Friend[]>
  /** An object with referral metrics for the advocate */
  referralHistory?: Maybe<ReferralHistory>
  /** The content that supports and drives the user experience */
  experienceContent?: Maybe<ExperienceContent>
}

/** List of referral codes and friends that were referred by an existing Acorns user */
export type AdvocateFriendsStatuses = {
  __typename?: 'AdvocateFriendsStatuses'
  /** User ID of the advocate */
  userId: Scalars['ID']
  /** The referral codes associated with the advocate */
  referralCodes?: Maybe<Array<Scalars['String']>>
  /** A list of people that have used the advocate's share link */
  friends?: Maybe<Friend[]>
}

export type Alert = {
  type: Scalars['String']
  userId: Scalars['ID']
}

/** Response from beneficiary alert hub alerts query */
export type AlertHubBeneficiaryAlert =
  | MissingSsnBeneficiaryAlertItem
  | UnverifiedBeneficiarySsnAlertItem

export type AllBankAccountsInput = {
  type?: Maybe<BankAccountType>
}

export type AllBankCardsFilter = {
  showNonActive?: Maybe<Scalars['Boolean']>
}

export type AllBankDocumentsInput = {
  isActive?: Maybe<Scalars['Boolean']>
}

/** The result of the allCheckPayments query */
export type AllCheckPaymentsResult = CheckPaymentConnection | AuthorizationError

export type AllPastCoreItemsSchemaFilter = {
  /** Only return pending items */
  pending?: Maybe<Scalars['Boolean']>
}

export type AllPastEarlyItemsSchemaFilter = {
  /** Only return pending items */
  pending?: Maybe<Scalars['Boolean']>
}

export type AllPastLaterItemsSchemaFilter = {
  /** Only return pending items */
  pending?: Maybe<Scalars['Boolean']>
}

export type AllPastSpendItemsSchemaFilter = {
  /** Only return pending items */
  pending?: Maybe<Scalars['Boolean']>
}

export type AllSupportArticlesFilterInput = {
  promoted?: Maybe<Scalars['Boolean']>
}

export type AllTransferableToInput = {
  /** ID of TransferableAccounts that money can be taken from */
  from: Scalars['ID']
}

/** Possible answer for an onboarding question */
export type Answer = {
  __typename?: 'Answer'
  /** Internal answer ID */
  id: Scalars['ID']
  /** Answer text */
  title: Scalars['String']
  /** type of this answer */
  type: AnswerType
}

export enum AnswerType {
  /** yes/true */
  Yes = 'yes',
  /** no/false */
  No = 'no',
  /** informational */
  Next = 'next',
  /** skip this question */
  Skip = 'skip',
  /** defined value */
  Value = 'value',
}

export type ApplyPromotionInput = {
  promotionId: Scalars['ID']
  subscriptionId: Scalars['ID']
}

export type ApplyPromotionResult =
  | PromotionConsumedError
  | PromotionExpiredError
  | PromotionNotFoundError
  | SubscriberIneligibleError
  | TierSubscription

export type Article = {
  __typename?: 'Article'
  body: Scalars['String']
  cta?: Maybe<Cta>
  eyebrow: Scalars['String']
  id: Scalars['ID']
  image?: Maybe<Image>
  title: Scalars['String']
}

/** Options to assign a subaccount to a given role */
export type AssignLinkedSubaccountInput = {
  /** Role to give the linked subaccount */
  role: LinkedSubaccountRoleEnum
}

/** Response returned if the link session is asynchronous. */
export type AsyncLinkSessionResult = {
  __typename?: 'AsyncLinkSessionResult'
  /** The asynchronous process was kicked off successfully? */
  success: Scalars['Boolean']
}

export type AuthAlert = {
  userId: Scalars['ID']
  type: Scalars['String']
}

export type AuthChallenge = {
  id: Scalars['ID']
  alternateAuthenticators: AuthenticatorInfo[]
}

export type AuthChallengeAnswerAttemptsExhaustedException = {
  __typename?: 'AuthChallengeAnswerAttemptsExhaustedException'
  message: Scalars['String']
}

export type AuthChallengeAnswerIncorrectException = {
  __typename?: 'AuthChallengeAnswerIncorrectException'
  message: Scalars['String']
}

/** exceptions */
export type AuthChallengeExpiredException = {
  __typename?: 'AuthChallengeExpiredException'
  message: Scalars['String']
}

export type AuthenticateForFeeNegotiationChallengeInput = {
  /** A MFA authorization code, answer to a security question. */
  tfaInput: Scalars['String']
  linkedAccountId: Scalars['ID']
}

export type AuthenticateForFeeNegotiationChallengeMethodInput = {
  /** The email, phone number, or question a user has chosen to complete TFA. */
  tfaOption: Scalars['String']
  linkedAccountId: Scalars['ID']
  tfaType: TfaType
  restart: Scalars['Boolean']
}

export type AuthenticateForFeeNegotiationInput = {
  /** The username for the bank connection. */
  userName: Scalars['String']
  /** The password for the bank connection. */
  password: Scalars['String']
  /** The ID of the bank connection. */
  linkedAccountId: Scalars['ID']
  /** The name of the bank connection. */
  bankName: BankName
  /**
   * If True, the system will ignore the user_name/password provided in this
   * request and login with the credentials previously provided for this connection.
   */
  reconnect: Scalars['Boolean']
}

export type AuthenticateForFeeNegotiationResult =
  | AuthenticateForFeeNegotiationStatus
  | LinkedAccountNotFound
  | NegotiationServiceConnectionFailure

export type AuthenticateForFeeNegotiationStatus = {
  __typename?: 'AuthenticateForFeeNegotiationStatus'
  /** The authorization status of the provided credentials. */
  credentialStatus: CredentialStatus
  tfaOptions?: Maybe<TfaOptions>
  /** The two factor authentication status.  */
  tfaStatus: TfaStatus
  tfaType: TfaType
  tfaMethod?: Maybe<Scalars['String']>
  /** The current stage of authentication. */
  operationStage: OperationStage
  operationError?: Maybe<AutomationError>
}

export type AuthenticateInput = {
  email: Scalars['EmailAddress']
  password: Scalars['String']
  udid: Scalars['String']
  rememberMe?: Maybe<Scalars['Boolean']>
}

export type AuthenticateNegotiationStatusResult =
  | AuthenticateForFeeNegotiationStatus
  | LinkedAccountNotFound

/** auth results */
export type AuthenticateResult =
  | SmsAuthChallenge
  | EmailAuthChallenge
  | AuthSession
  | AuthenticatorUnavailableException
  | InvalidCredentialsException
  | UserSuspendedException
  | DeviceBlockedException
  | UserLockedException
  | LoginRateLimitedException
  | PhoneNumberOptedOutException
  | AuthChallengeAnswerIncorrectException
  | AuthChallengeAnswerAttemptsExhaustedException
  | AuthChallengeExpiredException
  | AuthenticatorTypeAlreadyRegisteredException

export type Authenticator = {
  id: Scalars['ID']
  name: Scalars['String']
  lastUsedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
}

export type AuthenticatorAlreadyDefaultException = {
  __typename?: 'AuthenticatorAlreadyDefaultException'
  message: Scalars['String']
}

export type AuthenticatorInfo = {
  __typename?: 'AuthenticatorInfo'
  id: Scalars['ID']
  type: AuthType
}

export type AuthenticatorNotFoundException = {
  __typename?: 'AuthenticatorNotFoundException'
  message: Scalars['String']
}

export type AuthenticatorTypeAlreadyRegisteredException = {
  __typename?: 'AuthenticatorTypeAlreadyRegisteredException'
  message: Scalars['String']
}

export type AuthenticatorUnavailableException = {
  __typename?: 'AuthenticatorUnavailableException'
  message: Scalars['String']
}

export type AuthorizationError = {
  __typename?: 'AuthorizationError'
  requestId: Scalars['ID']
}

/** types */
export type AuthProfile = {
  __typename?: 'AuthProfile'
  userId: Scalars['ID']
  email?: Maybe<Scalars['EmailAddress']>
  emailVerifiedAt?: Maybe<Scalars['DateTime']>
  phoneNumber?: Maybe<Scalars['String']>
  phoneNumberVerifiedAt?: Maybe<Scalars['DateTime']>
  requireLoginChallenge?: Maybe<Scalars['Boolean']>
  /** the Authenticator that will be used for challenges by default. */
  defaultAuthenticator?: Maybe<Authenticator>
}

export type AuthProfileAlreadyExistsException = {
  __typename?: 'AuthProfileAlreadyExistsException'
  message: Scalars['String']
}

export type AuthSession = {
  __typename?: 'AuthSession'
  id: Scalars['ID']
  token: Scalars['ID']
  refreshToken?: Maybe<Scalars['ID']>
  identityId: Scalars['ID']
  /** @deprecated No longer used */
  redirectUrl?: Maybe<Scalars['URL']>
}

export enum AuthType {
  Phone = 'PHONE',
  Email = 'EMAIL',
}

export type AutomationError = {
  __typename?: 'AutomationError'
  /** A description of the error. */
  error?: Maybe<Scalars['String']>
  /** The error code. */
  errorCode?: Maybe<AutomationErrorCode>
}

export enum AutomationErrorCode {
  TfaInv = 'TFA_INV',
  TfaSelInv = 'TFA_SEL_INV',
  /** The username and/or password are invalid. */
  LogInv = 'LOG_INV',
  /** Login was blocked. */
  LogBlk = 'LOG_BLK',
  /** Unexptected error in authorizing this bank connection. */
  LogEx = 'LOG_EX',
  /** Invalid TFA method. */
  SttRes = 'STT_RES',
  /** Unexpected error in completing TFA. */
  CttEx = 'CTT_EX',
  /** Unexpected error in selecting a tfa method. */
  SttEx = 'STT_EX',
  /** TFA is required for a Wells Fargo connection. Unable to proceeed. */
  WfTfa = 'WF_TFA',
}

export type BackgroundImage = {
  __typename?: 'BackgroundImage'
  horizontalFocalPoint?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['URL']>
  verticalFocalPoint?: Maybe<Scalars['String']>
}

export enum BadgeCategory {
  NewCustomer = 'NEW_CUSTOMER',
  Travel = 'TRAVEL',
}

export type BankAccount = {
  __typename?: 'BankAccount'
  id: Scalars['ID']
  balance: CurrencyAmount
  /** @deprecated Use balance */
  currentBalance: CurrencyAmount
  /**
   * Balance available for immediate withdrawal.
   *
   * Settling a transaction for a DDA account will typically credit the
   * availableBalance immediately. However, savings or FBO accounts may have
   * a "deposit hold time" or a "new customer hold time", meaning there could be
   * a length of time between when the transaction is settled and the corresponding
   * funds are made available for withdrawal.
   */
  availableBalance: CurrencyAmount
  /**
   * Balance of pending deposit transactions. When a pending deposit transaction
   * settles, it will debit this balance. Deposit transactions which settle
   * immediately will never affect this balance.
   */
  pendingBalance: CurrencyAmount
  number: Scalars['String']
  routingNumber: Scalars['String']
  type: BankAccountType
  referenceId: Scalars['ID']
  accountHolderReferenceId: Scalars['ID']
  createdAt: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
  closedAt?: Maybe<Scalars['DateTime']>
  isEligible: Scalars['Boolean']
  status: BankAccountStatus
  isLocked: Scalars['Boolean']
  lockReason?: Maybe<BankAccountLockReason>
  /**
   * True if an account closure has been initiated but
   * was unsuccessful in automatically closing.
   */
  isPendingClosure?: Maybe<Scalars['Boolean']>
  /**
   * The current status of the account and requirements
   * needed to be met to close the account
   */
  requirements: BankAccountRequirements
}

export enum BankAccountClosureReason {
  /** Not seeing the value */
  NotSeeingTheValue = 'NOT_SEEING_THE_VALUE',
  /** No longer use */
  NoLongerUse = 'NO_LONGER_USE',
  /** Going to a competitor */
  GoingToACompetitor = 'GOING_TO_A_COMPETITOR',
  /** Missing features I expect with a checking account */
  MissingFeaturesExpectedWithCheckingAccount = 'MISSING_FEATURES_EXPECTED_WITH_CHECKING_ACCOUNT',
  /** Had a bad experience */
  HadABadExperience = 'HAD_A_BAD_EXPERIENCE',
  /** Other */
  Other = 'OTHER',
}

export enum BankAccountLockReason {
  Unknown = 'Unknown',
  Fraud = 'Fraud',
  Administrative = 'Administrative',
  Temporary = 'Temporary',
  Frozen = 'Frozen',
}

export type BankAccountNotFoundError = {
  __typename?: 'BankAccountNotFoundError'
  message: Scalars['String']
}

/**
 * Defines a list of requirements that must be met before a bank account
 * can be closed
 */
export type BankAccountRequirement = {
  __typename?: 'BankAccountRequirement'
  actionable: Scalars['Boolean']
  description?: Maybe<Scalars['String']>
  status: BankAccountRequirementStatus
  type: BankAccountRequirementType
}

export type BankAccountRequirements = {
  __typename?: 'BankAccountRequirements'
  close: BankAccountRequirement[]
}

export enum BankAccountRequirementStatus {
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  Completed = 'COMPLETED',
}

export enum BankAccountRequirementType {
  FundingSource = 'FUNDING_SOURCE',
  VerifiedFundingSource = 'VERIFIED_FUNDING_SOURCE',
  NoPendingTransfers = 'NO_PENDING_TRANSFERS',
}

export enum BankAccountStatus {
  Open = 'open',
  Closed = 'closed',
  Locked = 'locked',
}

export enum BankAccountType {
  Spend = 'spend',
  Save = 'save',
}

export type BankCard = {
  __typename?: 'BankCard'
  id: Scalars['ID']
  cardNumberMasked?: Maybe<Scalars['CardNumberMasked']>
  createdAt: Scalars['DateTime']
  activatedAt?: Maybe<Scalars['DateTime']>
  expireMonth: Scalars['Int']
  expireYear: Scalars['Int']
  tier: BankCardTier
  type: BankCardType
  referenceId: Scalars['ID']
  lockReason?: Maybe<BankCardLockReason>
  lockTypeCode: BankCardLockTypeCode
  status: BankCardStatus
  paymentProcessor: BankCardPaymentProcessor
}

export enum BankCardLockReason {
  Unknown = 'unknown',
  Fraud = 'fraud',
  Damage = 'damage',
  Lost = 'lost',
  Temporary = 'temporary',
  Stolen = 'stolen',
  Admin = 'admin',
  PinRetriesExceeded = 'pinRetriesExceeded',
}

export enum BankCardLockTypeCode {
  Unlocked = 'unlocked',
  Customer = 'customer',
  System = 'system',
}

export type BankCardOrder = {
  __typename?: 'BankCardOrder'
  cardOrderStatus: BankCardOrderStatus
  addressVerification?: Maybe<BankCardOrderAddressVerification>
  identityVerification?: Maybe<BankCardOrderIdentityVerification>
  prefundVerification?: Maybe<BankCardOrderPrefundVerification>
  fundingSourceVerification?: Maybe<BankCardOrderFundingSourceVerification>
  failureReason?: Maybe<BankCardOrderFailureReason>
}

export type BankCardOrderAddressVerification = {
  __typename?: 'BankCardOrderAddressVerification'
  status: BankCardOrderVerificationStatus
  actionRequired?: Maybe<BankCardOrderAddressVerificationActions>
}

export enum BankCardOrderAddressVerificationActions {
  UploadDocuments = 'uploadDocuments',
}

export enum BankCardOrderFailureReason {
  Expired = 'EXPIRED',
  AddressFailure = 'ADDRESS_FAILURE',
  IdentityFailure = 'IDENTITY_FAILURE',
  PrefundFailure = 'PREFUND_FAILURE',
  FundingSourceFailure = 'FUNDING_SOURCE_FAILURE',
}

export type BankCardOrderFundingSourceVerification = {
  __typename?: 'BankCardOrderFundingSourceVerification'
  status: BankCardOrderVerificationStatus
  actionRequired?: Maybe<BankCardOrderFundingSourceVerificationActions>
  pendingReason?: Maybe<BankCardOrderFundingSourceVerificationPendingReason>
}

export enum BankCardOrderFundingSourceVerificationActions {
  SubmitRdVs = 'submitRDVs',
  UploadDocuments = 'uploadDocuments',
  LinkFundingSource = 'linkFundingSource',
  HandleFrozenFundingSource = 'handleFrozenFundingSource',
}

export enum BankCardOrderFundingSourceVerificationPendingReason {
  RdvsPending = 'rdvsPending',
  RdvsInitiated = 'rdvsInitiated',
  DocumentsUnderReview = 'documentsUnderReview',
}

export type BankCardOrderIdentityVerification = {
  __typename?: 'BankCardOrderIdentityVerification'
  status: BankCardOrderVerificationStatus
  actionRequired?: Maybe<BankCardOrderIdentityVerificationActions>
  documentUploadUrl?: Maybe<Scalars['String']>
}

export enum BankCardOrderIdentityVerificationActions {
  UploadDocuments = 'uploadDocuments',
}

export type BankCardOrderPrefundVerification = {
  __typename?: 'BankCardOrderPrefundVerification'
  status: BankCardOrderVerificationStatus
  actionRequired?: Maybe<BankCardOrderPrefundVerificationActions>
}

export enum BankCardOrderPrefundVerificationActions {
  CreateBankTransfer = 'createBankTransfer',
}

export enum BankCardOrderStatus {
  NotOrdered = 'notOrdered',
  Pending = 'pending',
  ActionRequired = 'actionRequired',
  Success = 'success',
  Failure = 'failure',
}

export enum BankCardOrderVerificationStatus {
  Pending = 'pending',
  ActionRequired = 'actionRequired',
  ActionRequiredDueToFailure = 'actionRequiredDueToFailure',
  Success = 'success',
  Failure = 'failure',
}

export enum BankCardPaymentProcessor {
  Dps = 'DPS',
  Shazam = 'SHAZAM',
}

export enum BankCardPermanentLockReason {
  Fraud = 'fraud',
  Lost = 'lost',
  Stolen = 'stolen',
}

export type BankCardPrefundTransfer = {
  /** Amount (either $0 or between $25, $500) to transfer after bank account is created. */
  amount: PositiveCurrencyAmountInput
}

export type BankCardReissue = {
  __typename?: 'BankCardReissue'
  bankCardRequest?: Maybe<BankCardRequest>
  reissueBankCardEligibility: ReissueBankCardEligibility
}

export type BankCardRequest = {
  __typename?: 'BankCardRequest'
  /** tag for new bank card */
  id: Scalars['ID']
  userId: Scalars['ID']
  requestedDate: Scalars['Date']
  status: BankCardRequestStatus
  /** Reason for requesting a new bank card */
  reason: BankCardRequestReason
  isReissue: Scalars['Boolean']
  /** Date associated with reason (Date lost, date stolen, etc) */
  reasonDate?: Maybe<Scalars['Date']>
  /** Additional information pertaining to the request */
  reasonComment?: Maybe<Scalars['String']>
  /** Issued date for new bank card */
  issuedDate?: Maybe<Scalars['Date']>
  /** True when new bank card has been activated */
  isActivated: Scalars['Boolean']
  previousBankCardId?: Maybe<Scalars['ID']>
  /** The mailing address used to ship the reissued card */
  mailingAddress?: Maybe<BankCardRequestMailingAddress>
}

export type BankCardRequestMailingAddress = {
  __typename?: 'BankCardRequestMailingAddress'
  city: Scalars['String']
  country: Scalars['String']
  state: Scalars['String']
  street1: Scalars['String']
  street2?: Maybe<Scalars['String']>
  zipCode: Scalars['String']
}

export type BankCardRequestMailingAddressInput = {
  city: Scalars['String']
  country: Scalars['String']
  street1: Scalars['String']
  street2?: Maybe<Scalars['String']>
  state: Scalars['String']
  zipCode: Scalars['String']
}

export enum BankCardRequestReason {
  NewAccount = 'NEW_ACCOUNT',
  Damaged = 'DAMAGED',
  Lost = 'LOST',
  Stolen = 'STOLEN',
  DeliveryIssue = 'DELIVERY_ISSUE',
  Other = 'OTHER',
}

export enum BankCardRequestStatus {
  Requested = 'REQUESTED',
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Issued = 'ISSUED',
}

export enum BankCardStatus {
  Initiated = 'initiated',
  Pending = 'pending',
  PendingVerification = 'pendingVerification',
  Verified = 'verified',
  Denied = 'denied',
  Expired = 'expired',
  Archived = 'archived',
  Reissued = 'reissued',
  Hotlisted = 'hotlisted',
}

export enum BankCardTemporaryLockReason {
  Unknown = 'unknown',
  Fraud = 'fraud',
  Damage = 'damage',
  Temporary = 'temporary',
}

export enum BankCardTier {
  Oak = 'oak',
  RoyalOak = 'royalOak',
}

export enum BankCardType {
  Debit = 'debit',
  Credit = 'credit',
}

export type BankDocument = {
  __typename?: 'BankDocument'
  url: Scalars['String']
  name: Scalars['String']
  type: Scalars['String']
}

/** Bank Document Requested Alert. */
export type BankDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'BankDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type BankFee = {
  __typename?: 'BankFee'
  amount: MonetaryAmount
  /** The name of the transaction. */
  name: Scalars['String']
  type: BankFeeType
  category: TransactionCategory
  linkedSubAccountId: Scalars['ID']
  linkedAccountId: Scalars['ID']
  transactionDate: Scalars['DateTime']
  status: FeeStatus
  submissionKey?: Maybe<Scalars['String']>
  accountName: Scalars['String']
  /** The last 4 digits of the account associated with this transaction. */
  digit: Scalars['String']
  /** The bank name, digit, and date of the fee. */
  subtitle?: Maybe<Scalars['String']>
}

export type BankFeeConnection = {
  __typename?: 'BankFeeConnection'
  /** The name of the bank associated with this connection. */
  bank: BankName
  /** The ID of the associated bank connection. */
  linkedAccountId: Scalars['ID']
  /** Whether the negotiation service is authenticated with this connection. */
  status: ConnectionStatus
  latestSubmission?: Maybe<Submission>
  submissions?: Maybe<Submission[]>
  /** True if this connection is eligible for authentication, False if not. */
  eligible: Scalars['Boolean']
}

export type BankFeeConnectionAlert = {
  __typename?: 'BankFeeConnectionAlert'
  /** The name of the bank connection. */
  bankName: BankName
  status: SubmissionStatus
  /** The ID of the bank connection. */
  linkedAccountId: Scalars['ID']
}

export type BankFeeNegotiationAlert = {
  __typename?: 'BankFeeNegotiationAlert'
  alertData?: Maybe<BankFeeConnectionAlert[]>
  /** Type of bank fee negotiation alert. */
  type: BankFeeNegotiationAlertType
  /** UserID */
  userId: Scalars['ID']
}

export enum BankFeeNegotiationAlertType {
  NegotiationError = 'NEGOTIATION_ERROR',
}

export type BankFeeSummary = {
  __typename?: 'BankFeeSummary'
  /** The total amount of fees which are currently negotiable. */
  totalNegotiableFees: MonetaryAmount
  /** The total amount of fees refunded by Harvest. */
  totalReimbursedFees: MonetaryAmount
  /** The total amount of fees Harvest has attempted to negotiate. */
  totalNegotiatedFees: MonetaryAmount
  /** Signifies whether a user is eligible for the WTDN card in the Action Feed. */
  eligible: Scalars['Boolean']
  /** The total number of cups of coffee a user could purchase with the amount they have paid in fees. */
  coffeeCount: Scalars['Int']
  /** The total number of fees this user has paid by status. */
  feesFound: FeeStatusSummary
  linkedAccounts: BankFeeConnection[]
}

export enum BankFeeType {
  OverdraftFee = 'OVERDRAFT_FEE',
  ForeignTransactionFee = 'FOREIGN_TRANSACTION_FEE',
  LateFee = 'LATE_FEE',
  WireTransferFee = 'WIRE_TRANSFER_FEE',
  AccountMaintenanceFee = 'ACCOUNT_MAINTENANCE_FEE',
  MonthlyServiceFee = 'MONTHLY_SERVICE_FEE',
  MinimumBalanceFee = 'MINIMUM_BALANCE_FEE',
  AtmFee = 'ATM_FEE',
  CreditCardInterestCharge = 'CREDIT_CARD_INTEREST_CHARGE',
  NsfFee = 'NSF_FEE',
  CashAdvance = 'CASH_ADVANCE',
  BalanceInquiryFee = 'BALANCE_INQUIRY_FEE',
  ExcessFee = 'EXCESS_FEE',
  CheckFee = 'CHECK_FEE',
  StopPaymentFee = 'STOP_PAYMENT_FEE',
  EarlyClosureFee = 'EARLY_CLOSURE_FEE',
  DormantFee = 'DORMANT_FEE',
  PaperStatementFee = 'PAPER_STATEMENT_FEE',
  ClosedAccountProcessingFee = 'CLOSED_ACCOUNT_PROCESSING_FEE',
  ExternalTransferFee = 'EXTERNAL_TRANSFER_FEE',
  CardSetupFee = 'CARD_SETUP_FEE',
}

export type BankMetadata = {
  __typename?: 'BankMetadata'
  totals?: Maybe<BankMetadataTotals>
}

export type BankMetadataTotals = {
  __typename?: 'BankMetadataTotals'
  oak: Scalars['Int']
  royalOak: Scalars['Int']
}

export enum BankName {
  Chase = 'CHASE',
  WellsFargo = 'WELLS_FARGO',
  TestBank = 'TEST_BANK',
}

export type BankStatement = {
  __typename?: 'BankStatement'
  type: BankStatementType
  createdAt: Scalars['DateTime']
  year: Scalars['String']
  month: Scalars['String']
  url: Scalars['String']
}

export enum BankStatementType {
  Monthly = 'monthly',
  Tax = 'tax',
}

export type BankTransaction = {
  __typename?: 'BankTransaction'
  id: Scalars['ID']
  /** The amount of funds the transaction represents. */
  amount: CurrencyAmount
  /** The exact date and time the transaction was created */
  createdAt: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
  /** The exact date and time the transaction was settled. */
  settledAt?: Maybe<Scalars['DateTime']>
  /** The exact date and time the funds associated with the transaction became available. */
  availableAt?: Maybe<Scalars['DateTime']>
  /** The exact date and time the transaction was voided. */
  voidedAt?: Maybe<Scalars['DateTime']>
  /** The status of the transaction */
  status: BankTransactionStatus
  /** The program-wide unique identifier generated for each transfer */
  tag?: Maybe<Scalars['String']>
  /**
   * The card that created the transaction. Will be null if this transaction is
   * not tied to a card
   */
  bankCard?: Maybe<BankCard>
  /**
   * Represents a client-specified description of the transaction.
   * If transaction was received from a NACHA file (typeCode is UNKWTH, UNKDEP, UNKRSV),
   * this property contains the description verbatim from the NACHA file. By law, this
   * description must be displayed to the end user. If transaction was received
   * from an ISO-8583 interface (i.e. debit card transaction), this property contains
   * description verbatim from DataElement 43 (Card Acceptor Name/Location) of
   * ISO-8583 interface plus details of any fees or surchages that may have been
   * incurred. By law, this description must be displayed to the end user
   * Otherwise, the transaction was received from a call to CorePro API or it was
   * line item in the Bulk Transfer File. This property contains the description
   * verbatim passed by the client code
   */
  description: Scalars['String']
  /**
   * Shorter version of description. Depending on type, may contain full description.
   * Ex. Purchase transactions contain merchant name without address.
   */
  summary: Scalars['String']
  typeCode: Scalars['String']
  type: BankTransactionType
}

export type BankTransactionConnection = {
  __typename?: 'BankTransactionConnection'
  edges: Array<Maybe<BankTransactionEdge>>
  pageInfo: PageInfo
}

export type BankTransactionEdge = {
  __typename?: 'BankTransactionEdge'
  node?: Maybe<BankTransaction>
  cursor: Scalars['ID']
}

export enum BankTransactionStatus {
  /** Transaction has been created but not yet put into a NACHA file */
  Initiated = 'initiated',
  /** Transaction has been created and put into a NACHA file */
  Pending = 'pending',
  /** Transaction has been posted to the account */
  Settled = 'settled',
  /** Transaction has been voided */
  Voided = 'voided',
}

export enum BankTransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
}

/** Acorns base Portfolio interface */
export type BasePortfolio = {
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation
  /** Description of the portfolio */
  description: Scalars['String']
  /** ID of the Portfolio */
  id: Scalars['ID']
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String']
  /** Securities that are associated with the portfolio */
  portfolioSecurities?: Maybe<PortfolioSecurity[]>
}

/** Returned result for a batchAddTierSubscriptions mutation */
export type BatchAddTierSubscriptions = {
  __typename?: 'BatchAddTierSubscriptions'
  addedIds: Array<Scalars['ID']>
  unaddedIds: Array<Scalars['ID']>
}

export type BatchAddTierSubscriptionsInput = {
  allowInactiveTier?: Maybe<Scalars['Boolean']>
  createdBy?: Maybe<TierSubscriptionCreatedBy>
  migrationId?: Maybe<Scalars['ID']>
  tierId: Scalars['ID']
  tierPriceId: Scalars['ID']
  userIds: Array<Scalars['ID']>
}

export type BatchAddTierSubscriptionsResult =
  | BatchAddTierSubscriptions
  | InvalidTier
  | InvalidTierPrice

/** A person who doesn't have an Acorns account, but may someday inherit one or funds from one. */
export type Beneficiary = TimestampsInterface & {
  __typename?: 'Beneficiary'
  /** List of addresses associated with beneficiary */
  addresses?: Maybe<Array<Maybe<Address>>>
  /** URL for the Beneficiary's avatar image */
  avatarUrl?: Maybe<Scalars['String']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Internal ID for user who this beneficiary belongs to */
  custodianId: Scalars['ID']
  /** Beneficiary's date of birth: */
  dateOfBirth: Scalars['String']
  /** Timestamp when the Beneficiary was deactivated */
  deactivatedAt?: Maybe<Scalars['DateTime']>
  /** Beneficiaries email id */
  email?: Maybe<Scalars['Email']>
  /** First name of beneficiary */
  firstName: Scalars['String']
  /** Internal ID for beneficiary */
  id: Scalars['ID']
  /** Last name of beneficiary */
  lastName: Scalars['String']
  /** List of phone numbers associated with the beneficiary */
  phoneNumbers?: Maybe<Array<Maybe<Phone>>>
  /** True if the beneficiary has an ssn false if not */
  ssnPresent: Scalars['Boolean']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  investmentAccount?: Maybe<InvestmentAccount>
}

/** Cannot open early account because the beneficiary account already exsists */
export type BeneficiaryAccountExistsException = {
  __typename?: 'BeneficiaryAccountExistsException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** A person with the supplied date of birth is too old to open a UTMA/UGMA account */
export type BeneficiaryExceedsAgeLimitException = {
  __typename?: 'BeneficiaryExceedsAgeLimitException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Changeable attributes for beneficiaries */
export type BeneficiaryInfoInput = {
  /** Beneficiary Phone number */
  phoneNumber?: Maybe<Scalars['String']>
  /** Beneficiary Email */
  email?: Maybe<Scalars['Email']>
  /** Mailing Address */
  mailingAddress?: Maybe<AddressInput>
}

/** Changeable attributes for beneficiaries */
export type BeneficiaryInput = {
  /** Beneficiary First Name */
  firstName: Scalars['String']
  /** Beneficiary Last Name */
  lastName: Scalars['String']
  /** Date of Birth */
  dateOfBirth: Scalars['String']
}

/** Beneficiary does not exist */
export type BeneficiaryNotFoundException = {
  __typename?: 'BeneficiaryNotFoundException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type BeneficiaryRequestedLaterAlert = Alert & {
  __typename?: 'BeneficiaryRequestedLaterAlert'
  type: Scalars['String']
  userId: Scalars['ID']
}

export enum BeneficiaryType {
  Individual = 'individual',
  Entity = 'entity',
}

export type BigCurrencyAmount = {
  __typename?: 'BigCurrencyAmount'
  currency: Currency
  value: Scalars['BigDecimal']
}

/** Attributes related to the billing cycle */
export type BillingCycle = TimestampsInterface & {
  __typename?: 'BillingCycle'
  active: Scalars['Boolean']
  amount?: Maybe<Scalars['Float']>
  amountCollected?: Maybe<Scalars['Float']>
  amountOwed?: Maybe<Scalars['Float']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  endDate: Scalars['String']
  extension: Scalars['String']
  fees: Array<Maybe<Fee>>
  id: Scalars['ID']
  invoiceDate: Scalars['String']
  startDate: Scalars['String']
  state: BillingCycleState
  tierSubscriptionId?: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
  tierSubscription?: Maybe<TierSubscription>
}

/** Attributes related to the billing cycle */
export type BillingCycleFeesArgs = {
  execution_methods?: Maybe<Array<Maybe<FeeExecutionMethod>>>
}

export enum BillingCycleState {
  /** Unpaid billing cycle */
  Unpaid = 'UNPAID',
  /** Assessed billing cycle */
  Assessed = 'ASSESSED',
  /** Billing cycle execution started */
  Executed = 'EXECUTED',
  /** Paid billing cycle */
  Paid = 'PAID',
  /** Failed billing cycle */
  Failed = 'FAILED',
  /** Initiate refund billing cycle */
  PendingRefund = 'PENDING_REFUND',
  /** Refunded billing cycle */
  Refunded = 'REFUNDED',
  /** Refund failed billing cycle */
  RefundFailed = 'REFUND_FAILED',
}

export enum BillingFrequency {
  Monthly = 'MONTHLY',
  Never = 'NEVER',
}

export type BlockDeviceInput = {
  deviceId: Scalars['ID']
}

/** blockDevice results */
export type BlockDeviceResult = Device | DeviceNotFoundException

export type BlockedEmailDomainException = {
  __typename?: 'BlockedEmailDomainException'
  message: Scalars['String']
}

export type BriefInsuranceSection = {
  __typename?: 'BriefInsuranceSection'
  cta: Cta
  image: Image
  insuranceType: Scalars['String']
  recommendType: Scalars['String']
  title: Scalars['String']
}

export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE',
}

/** The result of the cancelCheckPayment mutation */
export type CancelCheckPaymentResult =
  | CheckPayment
  | ResourceNotFoundError
  | UnableToCancelCheckError
  | AuthorizationError

/** Input to cancel existing account closure request */
export type CancelInvestmentAccountClosureRequestInput = {
  /** The ID of the investment account */
  investmentAccountId: Scalars['ID']
}

/** Cancel investment account request mutation response */
export type CancelInvestmentAccountClosureRequestResult =
  | AccountClosedException
  | AccountNotFoundException
  | ClosureRequestDoesNotExistException
  | InvestmentAccount

/** Input to cancel a pending investment */
export type CancelInvestmentInput = {
  /** The ID of the investment account */
  investmentAccountId: Scalars['ID']
  /** The ID of the pending investment associated with the investment account id */
  investmentId: Scalars['ID']
}

/** ID of canceled investment */
export type CancelInvestmentPayload = {
  __typename?: 'CancelInvestmentPayload'
  id: Scalars['ID']
}

/** Cancel investment mutation response */
export type CancelInvestmentResult =
  | CancelInvestmentPayload
  | InvestmentNotFoundException
  | InvestmentUncancellableException

export type CancelRecurringTransferResult =
  | RecurringTransfer
  | VersionMismatchException

export type CancelRequestedDocumentInput = {
  documentRequestId: Scalars['ID']
  reviewerId: Scalars['ID']
}

export type CancelTransferPayload = {
  __typename?: 'CancelTransferPayload'
  transactionId: Scalars['ID']
}

/** Card delivery status */
export type CardDeliveryStatus = {
  __typename?: 'CardDeliveryStatus'
  /** Current Tracking Status Description */
  description?: Maybe<Scalars['String']>
  /** USPS Tracking Number */
  picNumber?: Maybe<Scalars['String']>
  /** Reference ID */
  referenceId: Scalars['String']
  /** Status enum */
  status: PackageStatus
}

export type CarouselOffer = {
  __typename?: 'CarouselOffer'
  campaignId: Scalars['ID']
  cta: Cta
  fastQuote: Scalars['Boolean']
  logo: Image
  offerId: Scalars['ID']
  ownerId: Scalars['ID']
  tip?: Maybe<Scalars['String']>
  title: Scalars['String']
}

export enum CarouselType {
  Standard = 'STANDARD',
  Banner = 'BANNER',
}

export type ChallengeAnswerInput = {
  challengeId: Scalars['ID']
  challengeAnswer: Scalars['String']
}

/** enums */
export enum ChallengeDeliveryType {
  Sms = 'SMS',
}

export type ChallengePointsEarned = {
  __typename?: 'ChallengePointsEarned'
  challengeID: Scalars['ID']
  /** legal copy about how points are earned */
  details: Scalars['String']
  /** how many points earned out of how many possible */
  earningProgress: DiscreteMilestoneProgress
  /** summarized information about how points are earned */
  summary?: Maybe<Scalars['String']>
}

/** Input to change the amount of an outside contribution */
export type ChangeOutsideContributionAmountInput = {
  /** Stripe payment intent id */
  paymentIntentId: Scalars['ID']
  /** investment amount for the outside contribution */
  investmentAmount: Scalars['String']
}

/** Change outside contribution amount response */
export type ChangeOutsideContributionAmountResult =
  | ContributionAmountAboveThresholdError
  | ContributionAmountBelowThresholdError
  | OutsideContributionCheckoutCart

/** Represents the check to be uploaded. */
export type CheckImage = {
  type: ImageType
  /** Image based-64 encoded. */
  image: Scalars['String']
}

export enum CheckoutCartStatus {
  /** Initial state, before a payment method is attached */
  RequiresPaymentMethod = 'REQUIRES_PAYMENT_METHOD',
  /** Payment intent needs confirming */
  RequiresConfirmation = 'REQUIRES_CONFIRMATION',
  /** Payment intent needs further action by frontend */
  RequiresAction = 'REQUIRES_ACTION',
  /** State a payment intent is in after actions are handled */
  Processing = 'PROCESSING',
  /** Payment intent needs capturing */
  RequiresCapture = 'REQUIRES_CAPTURE',
  /** Terminal state, canceled payment intent */
  Canceled = 'CANCELED',
  /** Terminal state, succeeded payment intent */
  Succeeded = 'SUCCEEDED',
}

export type CheckPayment = {
  __typename?: 'CheckPayment'
  fromAccountId: Scalars['String']
  recipientName: Scalars['String']
  recipientAddress: CheckPaymentAddress
  createdAt: Scalars['DateTime']
  memo?: Maybe<Scalars['String']>
  estimatedArrivalAt: Scalars['DateTime']
  status: CheckPaymentStatus
  checkNumber?: Maybe<Scalars['String']>
  trackingNumber?: Maybe<Scalars['String']>
  amount: CurrencyAmount
  failedAt?: Maybe<Scalars['DateTime']>
  failureReason?: Maybe<CheckPaymentFailureReason>
  canceledAt?: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
}

export type CheckPaymentAddress = {
  __typename?: 'CheckPaymentAddress'
  city: Scalars['String']
  country: Scalars['String']
  state: Scalars['String']
  street1: Scalars['String']
  street2?: Maybe<Scalars['String']>
  zipCode: Scalars['String']
}

export type CheckPaymentAddressInput = {
  city: Scalars['String']
  country: Scalars['String']
  state: Scalars['String']
  street1: Scalars['String']
  street2?: Maybe<Scalars['String']>
  zipCode: Scalars['String']
}

export type CheckPaymentConnection = {
  __typename?: 'CheckPaymentConnection'
  edges: CheckPaymentEdge[]
  pageInfo: PageInfo
}

export type CheckPaymentEdge = {
  __typename?: 'CheckPaymentEdge'
  node: CheckPayment
  cursor: Scalars['ID']
}

export enum CheckPaymentFailureReason {
  InsufficientFunds = 'insufficientFunds',
}

export type CheckPaymentRecipient = {
  __typename?: 'CheckPaymentRecipient'
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  businessName?: Maybe<Scalars['String']>
}

export type CheckPaymentRecipientAddressType = {
  __typename?: 'CheckPaymentRecipientAddressType'
  recipient: CheckPaymentRecipient
  recipientAddress: CheckPaymentAddress
}

export type CheckPaymentRecipientInput = {
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  businessName?: Maybe<Scalars['String']>
}

export enum CheckPaymentStatus {
  Canceled = 'canceled',
  Failed = 'failed',
  Shipped = 'shipped',
  Pending = 'pending',
}

/** Represents the client info passed into startCheckDeposit */
export type ClientInfo = {
  /** iphone, android, or web */
  platform: Scalars['String']
  /** Operating System, e.g. iOS, Android, Windows, Mac OS */
  os: Scalars['String']
  /** Operating System version, e.g. 8.0.10211, KITKAT, LOLLIPOP etc. */
  osVersion: Scalars['String']
  /** App version */
  appVersion: Scalars['String']
  /** Make of the device, e.g. Samsung, Apple, LG, etc */
  manufacturer: Scalars['String']
  /** Device model, e.g. iPhone 7, AsusPad 2 etc. */
  model: Scalars['String']
}

export type CloseAccountReason = {
  __typename?: 'CloseAccountReason'
  key: Scalars['String']
  label: Scalars['String']
}

export type CloseBankAccountInput = {
  accountId: Scalars['ID']
  bankAccountClosureReason?: Maybe<BankAccountClosureReason>
  feedback?: Maybe<Scalars['String']>
}

export type CloseBankAccountResult = BankAccount | BankAccountNotFoundError

/** Investment account closure request */
export type CloseInvestmentAccountInput = {
  /** The ID of the investment account to be closed */
  investmentAccountId: Scalars['ID']
  /** List of closure reason keys */
  accountClosureReasons?: Maybe<Array<Scalars['String']>>
  /** Any closure reason comments the user may have */
  comments?: Maybe<Scalars['String']>
}

/** Investment Account Closure Response */
export type CloseInvestmentAccountResult =
  | AccountNotFoundException
  | InvestmentAccount
  | InvestmentAccountAlreadyClosed
  | InvestmentAccountClosureInProgress
  | NonBasicAccountOpenException

/** Close User Account Response */
export type CloseUserAccountResult =
  | OpenAccountsException
  | UserNotFoundException
  | User_V2

/** No account closure request exists for the given investment account */
export type ClosureRequestDoesNotExistException = {
  __typename?: 'ClosureRequestDoesNotExistException'
  /** message */
  errorMessage?: Maybe<Scalars['String']>
}

/** An account closure request already exists for this account */
export type ClosureRequestExistsException = {
  __typename?: 'ClosureRequestExistsException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type CohortEligibility = {
  __typename?: 'CohortEligibility'
  /** key referencing if the user is eligible or not */
  eligible: Scalars['Boolean']
  /** key referencing the cohort eligibility scope */
  type: CohortEligibilityScope
}

export enum CohortEligibilityScope {
  /** Mobile Remote Deposit Checks Feature Cohort */
  Mrdc = 'MRDC',
  /** Send Check Cohort */
  SendCheck = 'SEND_CHECK',
  /** Personalized Found Money on Present Cohort */
  PersonalizedFoundMoneyOnPresent = 'PERSONALIZED_FOUND_MONEY_ON_PRESENT',
}

/** Collapsed view which only shows the recommended amount */
export type CollapsedLifeRecommendation = {
  __typename?: 'CollapsedLifeRecommendation'
  cta: Cta
  recommendedCoverage: Scalars['Int']
  title: Scalars['String']
}

export type CompleteCheckDepositInput = {
  amount: CurrencyAmountInput
  /** The session to complete. */
  sessionToken: Scalars['String']
}

/** Response from completing a deposit. */
export type CompleteCheckDepositPayload = {
  __typename?: 'CompleteCheckDepositPayload'
  /** The session that was completed. */
  sessionToken: Scalars['String']
}

export type CondensedSocialCopies = {
  __typename?: 'CondensedSocialCopies'
  sms?: Maybe<Scalars['String']>
  twitter?: Maybe<Scalars['String']>
  all?: Maybe<Scalars['String']>
}

export type ConfigureSettingsInput = {
  employerHidden?: Maybe<Scalars['Boolean']>
  employerName: Scalars['String']
  splitPercent: Scalars['String']
  splitType: DistributionType
}

export type ConfigureSplitDepositDirectDepositIntentGenericError = {
  __typename?: 'ConfigureSplitDepositDirectDepositIntentGenericError'
  requestId: Scalars['String']
}

export type ConfigureSplitDepositDirectDepositIntentPayload = {
  __typename?: 'ConfigureSplitDepositDirectDepositIntentPayload'
  intent: SplitDepositDirectDepositIntentSetting
}

export type ConfigureSplitDepositDirectDepositIntentSettingInput = {
  allocations: SplitDepositAllocationInput[]
  estimatedPaycheckAmount: CurrencyAmountInput
  id?: Maybe<Scalars['ID']>
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
}

export type ConfigureSplitDepositDirectDepositIntentSettingResult =
  | ConfigureSplitDepositDirectDepositIntentPayload
  | ConfigureSplitDepositDirectDepositIntentGenericError

export type ConfigureSplitDepositDirectDepositSettingGenericError = {
  __typename?: 'ConfigureSplitDepositDirectDepositSettingGenericError'
  requestId: Scalars['String']
}

export type ConfigureSplitDepositDirectDepositSettingInput = {
  allocations: SplitDepositAllocationInput[]
  directDepositIntentSettingId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
}

export type ConfigureSplitDepositDirectDepositSettingPayload = {
  __typename?: 'ConfigureSplitDepositDirectDepositSettingPayload'
  setting: SplitDepositDirectDepositSetting
}

export type ConfigureSplitDepositDirectDepositSettingResult =
  | ConfigureSplitDepositDirectDepositSettingPayload
  | ConfigureSplitDepositDirectDepositSettingGenericError

export type ConnectAchAccountInput = {
  routing: Scalars['RoutingNumber']
  account: Scalars['AccountNumber']
}

export type ConnectAchAccountResult =
  | InstitutionNotSupportedError
  | ConnectAchAccountSucceeded

export type ConnectAchAccountSucceeded = {
  __typename?: 'ConnectACHAccountSucceeded'
  message: Scalars['String']
}

export enum ConnectionStatus {
  /** This connection is currently authorized with Harvest's negotiation service. */
  Authorized = 'AUTHORIZED',
  /**
   * This connection is NOT currently authorized with Harvest's negotiation
   * service. Please make a AuthenticateForFeeNegotiation mutation to begin the
   * authorization process.
   */
  Unauthorized = 'UNAUTHORIZED',
  /** Please make a AuthenticateForFeeNegotiation mutation with reconnect=true to complete the TFA process for this connection. */
  TfaRequired = 'TFA_REQUIRED',
}

export type ContactCategory = {
  __typename?: 'ContactCategory'
  id: Scalars['ID']
  value: Scalars['String']
  label: Scalars['String']
  subcategories?: Maybe<ContactSubcategory[]>
}

export type ContactFaq = {
  __typename?: 'ContactFaq'
  answer: Scalars['String']
  href: Scalars['String']
  id: Scalars['ID']
  question: Scalars['String']
}

export type ContactFormAlert = {
  __typename?: 'ContactFormAlert'
  message?: Maybe<Scalars['String']>
}

export type ContactInfoInput = {
  address1?: Maybe<Scalars['String']>
  address2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  zip?: Maybe<Scalars['String']>
}

export type ContactSubcategory = {
  __typename?: 'ContactSubcategory'
  id: Scalars['ID']
  value: Scalars['String']
  label: Scalars['String']
  faqs: ContactFaq[]
  chatEnabled: Scalars['Boolean']
  emailEnabled: Scalars['Boolean']
  phoneEnabled: Scalars['Boolean']
  message?: Maybe<SubcategoryMessage>
}

export type ContributionAbility = {
  __typename?: 'ContributionAbility'
  /**  flag indicating if the user can contribute to this tax year */
  canContribute?: Maybe<Scalars['Boolean']>
  /**  maximum legally allowed amount for contributions */
  planLimit?: Maybe<Scalars['Int']>
  /**  available contribution amount */
  remaining?: Maybe<Scalars['Float']>
  /**  tax year of aggregated contributions */
  taxYear: Scalars['Int']
  /**  total current contributions in tax year */
  yearToDate?: Maybe<Scalars['Float']>
}

export type ContributionAbilityByYear = {
  __typename?: 'ContributionAbilityByYear'
  contributionAbilities?: Maybe<ContributionAbility[]>
}

/** Contribution cannot be created because an additional action needs to be taken first */
export type ContributionActionRequiredError = {
  __typename?: 'ContributionActionRequiredError'
  /** The payment_intent_id that the contribution was attempted to be made for */
  paymentIntentId: Scalars['ID']
  /** The url that the frontend needs to redirect the user to for 3DS. Only available for REDIRECT_TO_URL action */
  redirectUrl?: Maybe<Scalars['String']>
  /** The action that needs to be taken in order to create transaction */
  requiredAction: ContributionRequiredAction
}

/** Contribution amount must be below the maximum threshold */
export type ContributionAmountAboveThresholdError = {
  __typename?: 'ContributionAmountAboveThresholdError'
  maximumThresholdAmount: Scalars['String']
}

/** Contribution amount must be above the minimum threshold */
export type ContributionAmountBelowThresholdError = {
  __typename?: 'ContributionAmountBelowThresholdError'
  minimumThresholdAmount: Scalars['String']
}

/** Contribution cannot be created because the card was declined */
export type ContributionCardDeclinedError = {
  __typename?: 'ContributionCardDeclinedError'
  /** The payment_intent_id that the contribution was attempted to be made for */
  paymentIntentId: Scalars['ID']
}

export type ContributionHistoryItem = {
  __typename?: 'ContributionHistoryItem'
  year: Scalars['Int']
}

/** Invalid owner email. */
export type ContributionInvalidOwnerEmailError = {
  __typename?: 'ContributionInvalidOwnerEmailError'
  /** The invalid email provided. */
  providedEmail: Scalars['String']
}

export enum ContributionRequiredAction {
  /** Stripe is expecting the app to redirect the user (not part of our flow and should not happen) */
  RedirectToUrl = 'REDIRECT_TO_URL',
  /** The frontend is responsible for sending this payment intent to Stripe for 3DS verification */
  UseStripeSdk = 'USE_STRIPE_SDK',
}

export enum ContributionState {
  /** Initial state, pending contribution */
  Pending = 'PENDING',
  /** Terminal state, successful contribution */
  Success = 'SUCCESS',
  /** Terminal state, failed contribution */
  Failed = 'FAILED',
}

/** A Core account already exists for this user */
export type CoreAccountAlreadyExistsException = {
  __typename?: 'CoreAccountAlreadyExistsException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Custodian's Core account must be open in order to open an Early Account */
export type CoreAccountClosedException = {
  __typename?: 'CoreAccountClosedException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Pulls from funding source */
export type CoreAchSubscriptionFeeItem = PastItem & {
  __typename?: 'CoreACHSubscriptionFeeItem'
  /** Past Item ID */
  id: Scalars['ID']
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
  /** The title of the item */
  title: Scalars['String']
  /** The current state of the item */
  status: PastItemStatus
  /**
   * The amount paid for the subscription. Note that this is intentionally positive
   * because it does not represent removing balance from the account.
   */
  amount: CurrencyAmount
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
}

/** Legacy type we need to account for Credit (Found Money Credits + Employee Contribution) */
export type CoreAdjustmentItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreAdjustmentItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount?: Maybe<CurrencyAmount>
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

export type CoreCashForwardItem = PastItem & {
  __typename?: 'CoreCashForwardItem'
  /** Past Item ID */
  id: Scalars['ID']
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
  /** The title of the item */
  title: Scalars['String']
  /** The current state of the item */
  status: PastItemStatus
  amount: CurrencyAmount
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** Format: 2017-02 */
  relatedMonth: Scalars['String']
}

/** You owe us money */
export type CoreCollectionItem = PastItem & {
  __typename?: 'CoreCollectionItem'
  /** Past Item ID */
  id: Scalars['ID']
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
  /** The title of the item */
  title: Scalars['String']
  /** The current state of the item */
  status: PastItemStatus
  /** The amount owed. */
  amount: CurrencyAmount
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
}

export type CoreDividendsItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreDividendsItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    etfCategory: Scalars['String']
    etfTicker: Scalars['String']
  }

export type CoreEmployeeCreditItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreEmployeeCreditItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    employerName: Scalars['String']
  }

/** Sell shares for the fee. This happens for Paypal users or if users never accepted the new EFT */
export type CoreFeeInvestmentItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreFeeInvestmentItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

export type CoreFoundMoneyRewardItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreFoundMoneyRewardItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    merchantName?: Maybe<Scalars['String']>
    partnerLogoUrl?: Maybe<Scalars['URL']>
  }

export type CoreGiftCardCreditRedemptionItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreGiftCardCreditRedemptionItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

/** Holding transfer transfered in from Age of Transfer beneficiary investment account */
export type CoreHoldingsTransferInItem = PastItem & {
  __typename?: 'CoreHoldingsTransferInItem'
  /** Past Item ID */
  id: Scalars['ID']
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
  /** The title of the item */
  title: Scalars['String']
  /** The current state of the item */
  status: PastItemStatus
  amount: CurrencyAmount
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
}

/** An investment in to the Core account */
export type CoreInvestmentItem = PastItem &
  PastCoreCombinedItem &
  PastCoreTradedItem & {
    __typename?: 'CoreInvestmentItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    isCombinedInvestment: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

export type CoreLocalFoundMoneyItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreLocalFoundMoneyItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    merchantName?: Maybe<Scalars['String']>
    partnerLogoUrl?: Maybe<Scalars['URL']>
  }

export type CorePartnerRewardItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CorePartnerRewardItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    merchantName?: Maybe<Scalars['String']>
    partnerLogoUrl?: Maybe<Scalars['URL']>
  }

export type CoreRebalanceItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreRebalanceItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount?: Maybe<CurrencyAmount>
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

export type CoreReferralRewardItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreReferralRewardItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

/** Instant and regular round ups */
export type CoreRoundUpsItem = PastItem &
  PastCoreCombinedItem &
  PastCoreTradedItem & {
    __typename?: 'CoreRoundUpsItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    /** The investment amount after being multiplied. */
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    isCombinedInvestment: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    type: RoundUpType
    /** The investment amount prior to being multiplied */
    initialAmount: CurrencyAmount
    multiplier: Scalars['Int']
    merchantName?: Maybe<Scalars['String']>
    /**
     * The amount of the transaction that caused this round up. TransactionAmount
     * will be null if this is a combined round up investment.
     */
    transactionAmount?: Maybe<CurrencyAmount>
  }

export type CoreWithdrawalItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'CoreWithdrawalItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

export type CoverageAsk = {
  __typename?: 'CoverageAsk'
  body: Scalars['String']
  image: Image
  noCta: Cta
  title: Scalars['String']
  yesCta: Cta
}

export type CoverageCalculator = {
  __typename?: 'CoverageCalculator'
  body: Scalars['String']
  cta: Cta
  headline: Scalars['String']
  image: Image
  recommendedCoverage?: Maybe<Scalars['Int']>
  title: Scalars['String']
}

export type CoverageGrow = {
  __typename?: 'CoverageGrow'
  body: Scalars['String']
  cta: Cta
  image: Image
  title: Scalars['String']
}

export type CoverageKnown = {
  __typename?: 'CoverageKnown'
  body: Scalars['String']
  cta: Cta
  educationSection: EducationSection
  image: Image
  subtitle: Scalars['String']
  title: Scalars['String']
}

/** A user response for coverage */
export type CoverageResponse = {
  /** Insurance type */
  insuranceType: InsuranceType
  /** Coverage provider id */
  providerId?: Maybe<Scalars['ID']>
  /** Coverage provider name */
  provider?: Maybe<Scalars['String']>
  /** Covered? */
  covered: Scalars['Boolean']
}

export type CoverageShop = {
  __typename?: 'CoverageShop'
  body: Scalars['String']
  id: Scalars['ID']
  legalDisclaimer: Disclaimer
  modals: Modal[]
  partnerDisclaimer: Disclaimer
  title: Scalars['String']
  widgets: CoverageShopWidget[]
}

export type CoverageShopWidget =
  | FeaturedOffers
  | InsuranceCarousel
  | PartnerChoices

export type CoverageUnknown = {
  __typename?: 'CoverageUnknown'
  body?: Maybe<Scalars['String']>
  cta: Cta
  educationSection: EducationSection
  icon: Image
  image: Image
  subtitle: Scalars['String']
  title: Scalars['String']
}

export type CreateAccountPointsRuleInput = {
  /** detailed explanation about how points are earned */
  details: Scalars['String']
  milestoneID: Scalars['ID']
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']
  /** summarized explanation about how points are earned */
  summary?: Maybe<Scalars['String']>
}

export type CreateAccountPointsRuleResult =
  | RecordAlreadyExistsError
  | RecordDoesNotExistError
  | AccountPointsRule

export type CreateAuthProfileInput = {
  email?: Maybe<Scalars['EmailAddress']>
  phoneNumber?: Maybe<Scalars['PhoneNumber']>
}

/** authProfile results */
export type CreateAuthProfileResult =
  | AuthProfile
  | AuthProfileAlreadyExistsException

export type CreateBankAccountInput = {
  type: BankAccountType
  tag?: Maybe<Scalars['String']>
  accountName?: Maybe<Scalars['String']>
  isDocumentsAccepted: Scalars['Boolean']
}

export type CreateBankAccountPayload = {
  __typename?: 'CreateBankAccountPayload'
  bankAccount?: Maybe<BankAccount>
}

/** Response to a beneficiary creation attempt */
export type CreateBeneficiaryResult =
  | Beneficiary
  | BeneficiaryExceedsAgeLimitException
  | InternalErrorException
  | InvalidDateOfBirthException
  | InvalidFirstNameException
  | InvalidLastNameException

export type CreateCustomSupportTicketInput = {
  attachments?: Maybe<Array<Maybe<Scalars['String']>>>
  ticketFormId?: Maybe<Scalars['String']>
  category?: Maybe<Scalars['String']>
  dateOfBirth: Scalars['String']
  description: Scalars['String']
  email: Scalars['String']
  phoneNumber: Scalars['String']
  customFields?: Maybe<Array<Maybe<Scalars['String']>>>
  subject: Scalars['String']
}

/** Pinwheel Token Return Results */
export type CreateDirectDepositLinkInfoFailure = {
  __typename?: 'CreateDirectDepositLinkInfoFailure'
  failureMessage: Scalars['String']
}

/** Mutation attributes for retrieving a Pinwheel link token */
export type CreateDirectDepositLinkInfoInput = {
  /** User ID */
  userId: Scalars['ID']
  /** Account ID */
  accountId: Scalars['ID']
  /** Required Job */
  requiredJobs: PinwheelLinkTokenRequiredJobs[]
  /** Vendor */
  vendor?: Maybe<DirectDepositVendor>
}

/** Pinwheel Token Return Results */
export type CreateDirectDepositLinkInfoPayload = {
  __typename?: 'CreateDirectDepositLinkInfoPayload'
  results: CreatePinwheelLinkToken
  vendor: Scalars['String']
}

/** Describes the create direct deposit info return type. */
export type CreateDirectDepositLinkInfoSwitch =
  | CreateDirectDepositLinkInfoFailure
  | CreateDirectDepositLinkInfoPayload

export type CreateDocumentUpload = {
  __typename?: 'CreateDocumentUpload'
  expiresAt: Scalars['DateTime']
  createdAt: Scalars['DateTime']
  uploadUrl: Scalars['URL']
  requestedDocumentId: Scalars['ID']
}

export type CreateDocumentUploadInput = {
  documentType: DocumentType
  contentType: Scalars['String']
}

export type CreateInvestmentAccountResponse = {
  __typename?: 'CreateInvestmentAccountResponse'
  id: Scalars['ID']
  userUuid: Scalars['ID']
  iraType: InvestmentAccountTypes
}

export type CreateJobAlertResult = JobAlert

export type CreateMilestoneAccountLevelDefinitionInput = {
  /** what is the background image when active */
  activeBackgroundUrl: Scalars['String']
  /** what is the foreground image when active */
  activeForegroundUrl: Scalars['String']
  /** level id, e.g. 3 */
  id: Scalars['Int']
  /** what is the background image when inactive */
  inactiveBackgroundUrl: Scalars['String']
  /** max points for the level. If min and max are the same value, there is no higher level */
  max: Scalars['Int']
  /** minimum points needed for the level */
  min: Scalars['Int']
}

export type CreateMilestoneAccountLevelDefinitionResult =
  | RecordAlreadyExistsError
  | MilestoneAccountLevelDefinition

export type CreateMilestoneAchievementActionRuleInput = {
  /** list of side-effects the milestone can trigger when it is completed */
  actions: MilestoneAchievementActionType[]
  milestoneID: Scalars['ID']
}

export type CreateMilestoneAchievementActionRuleResult =
  | MilestoneAchievementActionRule
  | RecordAlreadyExistsError
  | RecordDoesNotExistError

export type CreateMilestoneChallengeDefinitionInput = {
  /** additional information about this challenge */
  details?: Maybe<Scalars['String']>
  /** what time the challenge becomes inactive */
  endsAt: Scalars['DateTime']
  id: Scalars['ID']
  logo?: Maybe<ImageInput>
  /** the list of milestones this challenge is dependent on */
  milestonesIds: Array<Scalars['ID']>
  /** descriptive identifier */
  name?: Maybe<Scalars['String']>
  /** what time the challenge becomes active */
  startsAt: Scalars['DateTime']
}

export type CreateMilestoneChallengeDefinitionResult =
  | MilestoneChallengeDefinition
  | RecordAlreadyExistsError
  | RecordDoesNotExistError

export type CreateMilestoneChallengePointsRuleInput = {
  challengeID: Scalars['ID']
  /** legal copy about how points are earned */
  earningDetails: Scalars['String']
  /** summarized information about how points are earned */
  earningSummary?: Maybe<Scalars['String']>
  /** specifies the max points that can be earned if the milestone is completed more than once */
  maxPointsAllowed: Scalars['Int']
  milestoneID: Scalars['ID']
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']
}

export type CreateMilestoneChallengePointsRuleResult =
  | MilestoneChallengePointsRule
  | RecordAlreadyExistsError
  | RecordDoesNotExistError

export type CreateMilestoneDefinitionInput = {
  /** the DateTime value argument */
  arg1DateTime?: Maybe<Scalars['DateTime']>
  /** the integer value argument */
  arg1Int?: Maybe<Scalars['Int']>
  /** an optional logo used for inactive milestone states (e.g. LOCKED, NOT_STARTED) */
  inactiveLogo?: Maybe<ImageInput>
  /** denotes if this milestone can be completed more than once */
  isRepeatable: Scalars['Boolean']
  /** default logo */
  logo: ImageInput
  /** descriptive identifier */
  name: Scalars['String']
  /** the rule that determines how this milestone changes status */
  ruleId: Scalars['ID']
  /** the milestone category */
  theme: MilestoneTheme
}

export type CreateMilestoneDefinitionResult =
  | MilestoneDefinition
  | RecordAlreadyExistsError
  | RecordDoesNotExistError

export type CreateMilestoneRuleInput = {
  /** denotes if an argument input needs to be provided for the creation of a MilestoneDefinition */
  argInput: MilestoneRuleArgInput
  id: Scalars['ID']
  /** the rule name */
  name: Scalars['String']
  /** eligible milestones themes */
  themes: MilestoneTheme[]
}

export type CreateMilestoneRuleResult = MilestoneRule | RecordAlreadyExistsError

export type CreateOfferInput = {
  availableTo: OfferAvailability
  expiresAt?: Maybe<Scalars['DateTime']>
  offerType: OfferType
  price: OfferPriceInput
}

export type CreateOfferResult = Offer

/** Input to create a new outside contribution checkout cart */
export type CreateOutsideContributionCheckoutCartInput = {
  /** Outside contribution code */
  code: Scalars['String']
  /** investment amount for the outside contribution */
  investmentAmount: Scalars['String']
}

/** Create Outside Contribution checkout cart response */
export type CreateOutsideContributionCheckoutCartResult =
  | ContributionAmountAboveThresholdError
  | ContributionAmountBelowThresholdError
  | OutsideContributionCheckoutCart

/** Input to create a new outside contribution */
export type CreateOutsideContributionInput = {
  /** The note from the outside contributor */
  note?: Maybe<Scalars['String']>
  /** The name from the note of the contributor */
  noteAuthor?: Maybe<Scalars['String']>
  /** Stripe payment_intent_id */
  paymentIntentId: Scalars['ID']
  /** Stripe payment_method_id */
  paymentMethodId: Scalars['ID']
  /** The last 4 digits of the debit card number */
  cardNumberLast4: Scalars['String']
  /** The outside contributor email address */
  contributorEmail: Scalars['String']
  /** The provider of the debit card ie visa, mastercard etc */
  cardProvider: Scalars['String']
  /** The first name of the outside contributor */
  contributorFirstName: Scalars['String']
  /** The last name of the outside contributor */
  contributorLastName: Scalars['String']
}

/** Create Outside Contribution mutation response */
export type CreateOutsideContributionResult =
  | ContributionActionRequiredError
  | ContributionCardDeclinedError
  | ContributionInvalidOwnerEmailError
  | OutsideContribution

export type CreatePinwheelLinkToken = {
  __typename?: 'CreatePinwheelLinkToken'
  /** Pinwheel Token expiration date/time */
  expires: Scalars['DateTime']
  /** UUID of the link token */
  id: Scalars['String']
  /** Pinwheel token Environment */
  mode: Scalars['String']
  /** Short lived token that is used to initialize Pinwheel Link */
  token: Scalars['String']
}

/** Attributes for a linked account created through Plaid Link */
export type CreatePlaidLinkedAccountInput = {
  /** Plaid link session id */
  linkSessionId: Scalars['String']
  /** Plaid's Financial Institution ID */
  externalInstitutionId?: Maybe<Scalars['String']>
  /** Should the related round up account be disabled */
  disableRoundUps?: Maybe<Scalars['Boolean']>
}

/** Input for creating a prospect user */
export type CreateProspectUserInput = {
  /** Email address of the prospect user */
  email: Scalars['String']
  /** Prospect Type */
  type: ProspectType
}

/** Create Prospect User Response */
export type CreateProspectUserResult =
  | GrowProspect
  | InternalErrorException
  | LaterWaitlistProspect
  | OutsideContributionProspect
  | User_V2

export type CreateSubscriptionMigrationInput = {
  description: Scalars['String']
  effectiveAt: Scalars['DateTime']
  fromTierId: Scalars['ID']
  toTierId: Scalars['ID']
}

export type CreateSubscriptionMigrationResult = SubscriptionMigration

export type CreateSupportTicketInput = {
  category?: Maybe<Scalars['String']>
  dob: Scalars['String']
  email: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  message: Scalars['String']
  phone: Scalars['String']
  recaptchaToken?: Maybe<Scalars['String']>
  subcategory?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
}

export type CreateUserInput = {
  acceptanceDocumentVersionUuids?: Maybe<Array<Maybe<Scalars['String']>>>
  authorizationAccessToken?: Maybe<Scalars['String']>
  authorizationExpiresAt?: Maybe<Scalars['DateTime']>
  authorizationProvider?: Maybe<Scalars['String']>
  authorizationRefreshToken?: Maybe<Scalars['String']>
  authorizationUid?: Maybe<Scalars['String']>
  captchaToken?: Maybe<Scalars['String']>
  clientCredentialsToken?: Maybe<Scalars['String']>
  codeGroup?: Maybe<Scalars['String']>
  email: Scalars['String']
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  invitationCode?: Maybe<Scalars['String']>
  password: Scalars['String']
  sourceAttributes?: Maybe<Scalars['JSON']>
  sourceId?: Maybe<Scalars['String']>
  udid: Scalars['String']
  usResident?: Maybe<Scalars['Boolean']>
  withBasicAccount?: Maybe<Scalars['Boolean']>
}

export type Credentials = {
  __typename?: 'Credentials'
  userId: Scalars['ID']
  email: Scalars['EmailAddress']
}

export enum CredentialStatus {
  /** The provided credentials were valid. */
  Valid = 'VALID',
  /** The provided credentials were invalid. */
  Invalid = 'INVALID',
  /** Waiting for a AuthenticateForFeeNegotiation mutation to begin the authorization process. */
  Pending = 'PENDING',
}

export type Cta = {
  __typename?: 'Cta'
  id: Scalars['ID']
  image?: Maybe<Image>
  title?: Maybe<Scalars['String']>
  type: CtaType
}

export type CtaDetails = {
  __typename?: 'CtaDetails'
  android?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  ios?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  web?: Maybe<Scalars['String']>
  buttonUrl?: Maybe<Scalars['String']>
  userMetadata?: Maybe<Scalars['String']>
  /** indicates whether clients should display and handle offer as an in-app experience */
  internallyRouted?: Maybe<Scalars['Boolean']>
}

export enum CtaType {
  Link = 'link',
  ProtectLink = 'protect_link',
  GrowArticle = 'grow_article',
  Video = 'video',
  Disclaimer = 'disclaimer',
  Action = 'action',
}

export enum Currency {
  Usd = 'USD',
}

export type CurrencyAmount = {
  __typename?: 'CurrencyAmount'
  currency: Currency
  value: Scalars['Float']
}

export type CurrencyAmountInput = {
  currency: Currency
  value: Scalars['Float']
}

export type CurrencyMilestoneProgress = {
  __typename?: 'CurrencyMilestoneProgress'
  /** the type of currency */
  currency: Currency
  /** the current value */
  currentAmount: Scalars['Float']
  /** the value needed for completion */
  targetAmount: Scalars['Float']
}

/** A bank statement showing ownership of the current funding source has not been provided */
export type CurrentBankStatementNotProvided = {
  __typename?: 'CurrentBankStatementNotProvided'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

export type CustodianAddressInput = {
  line1: Scalars['String']
  line2?: Maybe<Scalars['String']>
  city: Scalars['String']
  state: StateCode
  zipCode: Scalars['String']
  country: Scalars['String']
}

export type CustodianCompany = {
  __typename?: 'CustodianCompany'
  companyId: Scalars['String']
  name: Scalars['String']
}

export type CustomFieldOption = {
  __typename?: 'CustomFieldOption'
  id?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  value?: Maybe<Scalars['String']>
  raw_name?: Maybe<Scalars['String']>
  default?: Maybe<Scalars['Boolean']>
  label?: Maybe<Scalars['String']>
}

export enum DayOfWeek {
  Sun = 'SUN',
  Mon = 'MON',
  Tue = 'TUE',
  Wed = 'WED',
  Thu = 'THU',
  Fri = 'FRI',
  Sat = 'SAT',
}

/** Response to a beneficiary ssn update */
export type DeactivateBeneficiaryResult =
  | Beneficiary
  | BeneficiaryNotFoundException
  | InternalErrorException

export type DeactivateTierSubscriptionInput = {
  feedback?: Maybe<Scalars['String']>
  subscriptionDeactivationReason: TierSubscriptionDeactivationReason
  userId: Scalars['ID']
}

export type DeactivateTierSubscriptionResult =
  | TierSubscription
  | TierSubscriptionAlreadyDeactivated

export enum DealType {
  TapAndGet = 'TAP_AND_GET',
  SimplySpend = 'SIMPLY_SPEND',
  UniquePricePoint = 'UNIQUE_PRICE_POINT',
  VerifiedReferral = 'VERIFIED_REFERRAL',
  PartnerLink = 'PARTNER_LINK',
}

export type DeleteExpiredBankCardOrderNotExpiredError = {
  __typename?: 'DeleteExpiredBankCardOrderNotExpiredError'
  expiresAt: Scalars['DateTime']
}

export type DeleteExpiredBankCardOrderNotFoundError = {
  __typename?: 'DeleteExpiredBankCardOrderNotFoundError'
  userId: Scalars['ID']
}

export type DeleteExpiredBankCardOrderResult =
  | BankCardOrder
  | DeleteExpiredBankCardOrderNotFoundError
  | DeleteExpiredBankCardOrderNotExpiredError

export enum DepositField {
  AccountNumber = 'accountNumber',
  AccountHolderName = 'accountHolderName',
  InstitutionName = 'institutionName',
  CheckNumber = 'checkNumber',
  PayeeName = 'payeeName',
  CourtesyAmount = 'courtesyAmount',
  LegalAmount = 'legalAmount',
  FrontSignature = 'frontSignature',
  AuxOnUs = 'auxOnUs',
  Epc = 'epc',
  Routing = 'routing',
  OnUs = 'onUs',
  EncodedAmount = 'encodedAmount',
  Codeline = 'codeline',
  FractionCode = 'fractionCode',
  CheckDate = 'checkDate',
  BackEndorsement = 'backEndorsement',
  BackImage = 'backImage',
  FrontImage = 'frontImage',
  CustomerSuppliedAmount = 'customerSuppliedAmount',
  InstrumentType = 'instrumentType',
}

/** Represents a risk that could prevent the deposit from completing */
export type DepositRiskFactor = {
  __typename?: 'DepositRiskFactor'
  fields: DepositField[]
  /** Description of risk */
  description: Scalars['String']
  /**
   * Risk Statuses:
   *     fixable: fixable = true
   *     confirmable: confirmable = true
   *     hard_reject: fixable = false, confirmable = false, severity level reject
   */
  status: RiskStatus
}

export type DeregisterAuthenticatorInput = {
  id: Scalars['ID']
}

export type DeregisterAuthenticatorResult =
  | PhoneAuthenticator
  | EmailAuthenticator
  | AuthenticatorNotFoundException

export type Destination = {
  __typename?: 'Destination'
  /** deep link to milestone action destination */
  deepLink: Scalars['URL']
  /** key that maps to client-defined destination label */
  labelKey: Scalars['StringKey']
}

export type Device = {
  __typename?: 'Device'
  id: Scalars['ID']
  lastLoginAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  userId: Scalars['ID']
  updatedAt: Scalars['DateTime']
  isBlocked: Scalars['Boolean']
  firstLoginAt?: Maybe<Scalars['DateTime']>
  appVersion?: Maybe<Scalars['String']>
  userAgent?: Maybe<Scalars['String']>
}

export type DeviceBlockedException = {
  __typename?: 'DeviceBlockedException'
  message: Scalars['String']
}

export type DeviceNotFoundException = {
  __typename?: 'DeviceNotFoundException'
  message: Scalars['String']
}

export enum DirectDepositDistribution {
  /** Entire Paycheck */
  FullAmount = 'FULL_AMOUNT',
  /** Amount of Paycheck */
  FixedAmount = 'FIXED_AMOUNT',
  /** Percentage of Paycheck */
  PercentageAmount = 'PERCENTAGE_AMOUNT',
}

/** Describes a user state for all its direct deposit switches. */
export type DirectDepositState = {
  __typename?: 'DirectDepositState'
  /** Creation Date */
  createdAt?: Maybe<Scalars['DateTime']>
  /** Switch Method */
  switchMethod: SwitchMethod
  /** Switch State */
  switchState: SwitchState
  /** Last Updated Date */
  updatedAt?: Maybe<Scalars['DateTime']>
}

/** Direct Deposit User State */
export type DirectDepositStatePayload = {
  __typename?: 'DirectDepositStatePayload'
  /** Direct Deposit State */
  state?: Maybe<DirectDepositState>
}

export enum DirectDepositVendor {
  Pinwheel = 'Pinwheel',
}

/** legal disclaimer */
export type Disclaimer = {
  __typename?: 'Disclaimer'
  /** body text */
  body: Scalars['String']
  /** call to action */
  cta?: Maybe<Cta>
  /** disclaimer image */
  image?: Maybe<Image>
  /** title text */
  title?: Maybe<Scalars['String']>
}

export type DiscreteMilestoneProgress = {
  __typename?: 'DiscreteMilestoneProgress'
  /** the current value */
  currentInt: Scalars['Int']
  /** the value needed for completion */
  targetInt: Scalars['Int']
}

export type DistributionAmounts = {
  __typename?: 'DistributionAmounts'
  investment: Scalars['String']
  retirement: Scalars['String']
  savings: Scalars['String']
}

export enum DistributionType {
  LongTerm = 'LONG_TERM',
  LongWeighted = 'LONG_WEIGHTED',
  Balanced = 'BALANCED',
  MediumWeighted = 'MEDIUM_WEIGHTED',
  MediumTerm = 'MEDIUM_TERM',
}

export type Document = {
  __typename?: 'Document'
  uploadedAt: Scalars['DateTime']
  url: Scalars['URL']
}

export type DocumentInput = {
  uploadedAt: Scalars['DateTime']
  url: Scalars['URL']
}

/** No document for the given document_type and version */
export type DocumentNotFound = {
  __typename?: 'DocumentNotFound'
  /** The type of document to sign */
  documentType: AcceptanceDocumentType
  /** The version of the document to sign */
  documentVersion: Scalars['String']
}

export enum DocumentQueryType {
  Address = 'address',
  All = 'all',
  BeneficiarySsn = 'beneficiarySsn',
  CurrentBankStatement = 'currentBankStatement',
  SpendFundingSource = 'spendFundingSource',
  TraditionalFundingSource = 'traditionalFundingSource',
  PaypalFundingSource = 'paypalFundingSource',
  EarlyQuarantinePromotion = 'earlyQuarantinePromotion',
  FutureBankStatement = 'futureBankStatement',
  Id = 'id',
  Miscellaneous = 'miscellaneous',
  SpendAddress = 'spendAddress',
  SpendId = 'spendId',
  Ssn = 'ssn',
  W9 = 'w9',
  MilitaryId = 'militaryId',
}

export type DocumentRequest = {
  __typename?: 'DocumentRequest'
  acceptedAt?: Maybe<Scalars['DateTime']>
  canceledAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  documents?: Maybe<Document[]>
  documentType: DocumentType
  externalId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  parentRequest?: Maybe<DocumentRequest>
  parentRequestId?: Maybe<Scalars['ID']>
  rejectedAt?: Maybe<Scalars['DateTime']>
  rejectedNote?: Maybe<Scalars['String']>
  rejectedReason?: Maybe<RejectedReason>
  requestedFileCount?: Maybe<Scalars['Int']>
  requesterId?: Maybe<Scalars['ID']>
  /** Idempotency key for ensuring that duplicate requests are not made or to store additional data */
  requestKey?: Maybe<Scalars['String']>
  reviewerId?: Maybe<Scalars['String']>
  status: DocumentStatus
  userId: Scalars['ID']
}

export type DocumentRequestEdge = {
  __typename?: 'DocumentRequestEdge'
  node?: Maybe<DocumentRequest>
}

export type DocumentRequestInput = {
  documentRequestId: Scalars['ID']
}

export type DocumentRequestsConnection = {
  __typename?: 'DocumentRequestsConnection'
  edges?: Maybe<DocumentRequestEdge[]>
  pageInfo: DocumentRequestsPageInfo
}

export type DocumentRequestsInput = {
  pageInput?: Maybe<DocumentRequestsPageInput>
  status?: Maybe<DocumentStatus>
  type: DocumentQueryType
  /** Deprecated: use `status` field */
  uploaded?: Maybe<Scalars['Boolean']>
}

export type DocumentRequestsPageInfo = {
  __typename?: 'DocumentRequestsPageInfo'
  hasNext: Scalars['Boolean']
  cursor?: Maybe<Scalars['String']>
}

export type DocumentRequestsPageInput = {
  ascending?: Maybe<Scalars['Boolean']>
  limit?: Maybe<Scalars['Int']>
  cursor?: Maybe<Scalars['String']>
}

export enum DocumentStatus {
  Accepted = 'accepted',
  Canceled = 'canceled',
  Rejected = 'rejected',
  Requested = 'requested',
  Uploaded = 'uploaded',
}

export enum DocumentType {
  Address = 'address',
  BeneficiarySsn = 'beneficiarySsn',
  CurrentBankStatement = 'currentBankStatement',
  SpendFundingSource = 'spendFundingSource',
  TraditionalFundingSource = 'traditionalFundingSource',
  PaypalFundingSource = 'paypalFundingSource',
  EarlyQuarantinePromotion = 'earlyQuarantinePromotion',
  FutureBankStatement = 'futureBankStatement',
  Id = 'id',
  Miscellaneous = 'miscellaneous',
  SpendAddress = 'spendAddress',
  SpendId = 'spendId',
  Ssn = 'ssn',
  W9 = 'w9',
  MilitaryId = 'militaryId',
}

export type DuplicateActionError = {
  __typename?: 'DuplicateActionError'
  requestId: Scalars['ID']
}

/** State Laws Regarding UGMA/UTMA account types and termination ages */
export type EarlyAccountStateRegulation = {
  __typename?: 'EarlyAccountStateRegulation'
  /** Whether UGMA/UTMA account is offered in the given state */
  accountType: EarlyInvestmentAccountType
  /** Default age of termination for the given state */
  defaultAge: Scalars['Int']
  /** Maximum age of termination for the given state */
  maxAge?: Maybe<Scalars['Int']>
  /** Minimum age of termination for the given state */
  minAge?: Maybe<Scalars['Int']>
  /** Full State/Territory name */
  state: Scalars['String']
  /** State/Territory abbreviation */
  stateCode: Scalars['String']
}

/** Result for Early Account state regulations */
export type EarlyAccountStateRegulationResult =
  | EarlyAccountStateRegulation
  | InternalErrorException
  | InvalidStateException
  | UserNotFoundException

/** DEPRECATED - Use InvestmentAccountTransferability instead */
export type EarlyAccountTransferInfo = {
  __typename?: 'EarlyAccountTransferInfo'
  /** The beneficiary investment account's state of residence */
  stateCode: Scalars['String']
  /** The beneficiary investment account's age of transfer */
  terminationAge: Scalars['Int']
  /** The beneficiary investment account's date of transfer */
  terminationDate: Scalars['Date']
}

export type EarlyDividendsItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'EarlyDividendsItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    etfCategory: Scalars['String']
    etfTicker: Scalars['String']
  }

/** Sell shares for the fee. */
export type EarlyFeeInvestmentItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'EarlyFeeInvestmentItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

/** A gift investment line item for the Early account */
export type EarlyGiftItem = PastItem &
  PastCoreTradedItem &
  PastAnnotatedItem & {
    __typename?: 'EarlyGiftItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    /** Annotation on the item */
    note?: Maybe<Scalars['String']>
    /** Author of the note */
    noteAuthor?: Maybe<Scalars['String']>
  }

export enum EarlyInvestmentAccountType {
  /** Uniform Gift to Minors Act Custodial Investment Account */
  Ugma = 'UGMA',
  /** Uniform Transfer to Minors Act Custodial Investment Account */
  Utma = 'UTMA',
}

/** A generic money movement line item for the Early account */
export type EarlyInvestmentItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'EarlyInvestmentItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount?: Maybe<CurrencyAmount>
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

export type EarlyWithdrawalItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'EarlyWithdrawalItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

export type EarnCtaRecord = {
  __typename?: 'EarnCTARecord'
  userId: Scalars['ID']
  partnerName?: Maybe<Scalars['String']>
  ctaDates?: Maybe<Array<Maybe<Scalars['Date']>>>
  devicePlatform?: Maybe<Scalars['String']>
}

export type EarnOffer = {
  __typename?: 'EarnOffer'
  /** The list of applicable categories for affiliates */
  affiliateCategoryList?: Maybe<Array<Scalars['String']>>
  /** Whether affiliateCategoryList is inclusionary or exclusionary  */
  affiliateCategoryType?: Maybe<Scalars['String']>
  /** For use with colorBackgroundLogoImageUrl */
  backgroundColorHex: Scalars['String']
  /** Non-logo background image */
  backgroundImageUrl: Scalars['URL']
  /** Offer's Badge Category */
  badgeCategory?: Maybe<BadgeCategory>
  /** Long description of what is needed to qualify for offer */
  campaignDescription: Scalars['String']
  campaignId: Scalars['ID']
  campaignOfferId: Scalars['ID']
  /** Transparent logo used with backgroundColorHex overlaid on background */
  colorBackgroundLogoImageUrl: Scalars['URL']
  /** @deprecated Use colorBackgroundLogoImageUrl instead */
  colorImageUrl: Scalars['URL']
  ctaDetails: EarnOfferCtaDetails
  /** Offer's Deal Type */
  dealType?: Maybe<DealType>
  /** Desktop Background/featured image url */
  desktopBackgroundImageUrl?: Maybe<Scalars['URL']>
  /** Offer Details Information */
  details: Array<Scalars['String']>
  /** List of device platforms the campaign offer is eligible for */
  devicePlatforms: Array<Scalars['String']>
  /** The main campaign text used image overlay text */
  displayBody?: Maybe<Scalars['String']>
  /** The ending date of a campaign */
  displayEndDate?: Maybe<Scalars['String']>
  /** The main campaign name used on tiles and on details */
  displayName: Scalars['String']
  /** The starting date of a campaign */
  displayStartDate?: Maybe<Scalars['String']>
  /** Summary of qualification, e.g. "For new customers only" */
  displaySubtitle?: Maybe<Scalars['String']>
  /** Display Title for the amount invested, e.g. "Earn 2%" or "Earn $10" */
  displayTitle: Scalars['String']
  /** Offer Exclusion Information */
  exclusions: Array<Scalars['String']>
  /** Denotes the favorite order rank by most recently added */
  favoriteRank: Scalars['Int']
  /** Used for the banner on the categories page */
  featuredCategoryOffer: Scalars['Boolean']
  /** Used for the banner on the categories page */
  featuredCategoryOfferRank: Scalars['Int']
  /** Amount invested, e.g. "2%" or "$10" */
  incentiveSummary: Scalars['String']
  /** Denotes a favorite offer for the current user */
  isFavorite: Scalars['Boolean']
  /** Offer's Keyphrase Categories Names */
  keyphraseCategoryNames?: Maybe<Array<Scalars['String']>>
  /** External merchantId associated with owner */
  merchantId?: Maybe<Scalars['String']>
  /** Description of the brand */
  ownerDescription: Scalars['String']
  ownerId: Scalars['ID']
  /** Used for the banner on web */
  promoted: Scalars['Boolean']
  /** Used for the banner on web */
  promotionRank: Scalars['Int']
  /** Identifying slug on the owner level */
  slug: Scalars['String']
  termsAndConditionsUrl: Scalars['String']
  /** The ending time for a campaign */
  visibilityEndTime?: Maybe<Scalars['String']>
  /** The starting time for a campaign */
  visibilityStartTime?: Maybe<Scalars['String']>
  /** Manages how we launch offers on mobile */
  webviewEnabled: Scalars['Boolean']
}

export type EarnOfferCtaDetails = {
  __typename?: 'EarnOfferCtaDetails'
  android?: Maybe<Scalars['String']>
  buttonUrl?: Maybe<Scalars['String']>
  chromeExt?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  internallyRouted: Scalars['Boolean']
  ios?: Maybe<Scalars['String']>
  notificationTitle: Scalars['String']
  notificationUrl: Scalars['URL']
  repeatTitle: Scalars['String']
  title: Scalars['String']
  type: Scalars['String']
  userMetadata?: Maybe<Scalars['String']>
  web?: Maybe<Scalars['String']>
}

export type EarnOfferQueryPage = {
  __typename?: 'EarnOfferQueryPage'
  earnOffers: EarnOffer[]
  pageInfo: EarnPageInfo
}

export type EarnPageInfo = {
  __typename?: 'EarnPageInfo'
  /**
   * This value is passed back as the 'cursor' parameter to continue pagination.
   * An empty string indicates there are no more pages to fetch.
   */
  endCursor: Scalars['String']
}

export type Education = {
  __typename?: 'Education'
  articles: Article[]
}

export type EducationSection = {
  __typename?: 'EducationSection'
  body: Scalars['String']
  title: Scalars['String']
}

export type EducationTip = {
  __typename?: 'EducationTip'
  /** key that maps to client-defined education tip details */
  detailsKey: Scalars['StringKey']
  /** key that maps to client-defined education tip summary */
  summaryKey: Scalars['StringKey']
}

export type Eligibility = {
  __typename?: 'Eligibility'
  eligible: Scalars['Boolean']
}

export enum EligibilityScope {
  Spend = 'spend',
  RoundUps = 'roundUps',
  Mrdc = 'mrdc',
  FundSpendInActivation = 'fundSpendInActivation',
  SendCheck = 'sendCheck',
  PersonalizedFoundMoneyOnPresent = 'personalizedFoundMoneyOnPresent',
  SpendRecurringTransfers = 'spendRecurringTransfers',
}

export type EmailAuthChallenge = AuthChallenge & {
  __typename?: 'EmailAuthChallenge'
  id: Scalars['ID']
  maskedEmail: Scalars['String']
  alternateAuthenticators: AuthenticatorInfo[]
}

export type EmailAuthenticator = Authenticator & {
  __typename?: 'EmailAuthenticator'
  id: Scalars['ID']
  name: Scalars['String']
  lastUsedAt?: Maybe<Scalars['DateTime']>
  email: Scalars['EmailAddress']
  deviceId: Scalars['ID']
  createdAt: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
}

export type EmailTakenException = {
  __typename?: 'EmailTakenException'
  message: Scalars['String']
}

export enum Employees {
  /** User has no employees under their company */
  None = 'none',
  /** User has full or part time employees under their company */
  FullOrPart = 'fullOrPart',
}

/** Employer */
export type Employer = {
  __typename?: 'Employer'
  /**
   * Clickswitch Target ID
   * @deprecated Use SwitchInterface.vendorTargetId instead
   */
  clickSwitchTargetId?: Maybe<Scalars['ID']>
  /** DUNS Name */
  dunsName?: Maybe<Scalars['String']>
  /** Duns Number */
  dunsNumber?: Maybe<Scalars['ID']>
  /** Employer Name */
  employerName: Scalars['String']
  /** Employer ID */
  id: Scalars['ID']
  /** Employer Logo URL */
  logoUrl?: Maybe<Scalars['String']>
  /** Switch Type specific information. */
  switch: AbstractSwitch
  /** Switch Type */
  switchType: SwitchType
  /**
   * Employer URL
   * @deprecated Use OnlineSwitch.url instead
   */
  url?: Maybe<Scalars['String']>
}

export type EmploymentInput = {
  employer?: Maybe<Scalars['String']>
  occupation?: Maybe<Scalars['String']>
  suitability?: Maybe<Array<Maybe<SuitabilityInput>>>
}

export enum EmploymentStatus {
  /** User is a full time employee or contractor */
  FullTime = 'fullTime',
  /** User owns their own business or is self employed */
  SelfEmployed = 'selfEmployed',
  /** User is a part time employee or contractor */
  PartTime = 'partTime',
  /** User is enrolled full time in school */
  Student = 'student',
  /** User currently is not employed */
  Unemployed = 'unemployed',
  /** User is retired and does not work */
  Retired = 'retired',
}

export type EnterEventInput = {
  /** ID specific to the particular event the user is entering. */
  eventId: Scalars['ID']
  firstName: Scalars['String']
  lastName: Scalars['String']
  optedIn: Scalars['Boolean']
  email: Scalars['EmailAddress']
  hasAccount: Scalars['Boolean']
  comment?: Maybe<Scalars['String']>
}

export type EnterEventResult = EventSubmission

export type EnterSweepstakesInput = {
  /** ID specific to the particular sweepstakes the user is entering. */
  sweepstakesId: Scalars['String']
  name: Scalars['String']
  email: Scalars['EmailAddress']
  reason?: Maybe<Scalars['String']>
}

export type EnterSweepstakesResult = Sweepstake | Error

export type Error = {
  __typename?: 'Error'
  message: Scalars['String']
}

export type EstimatedCheckPaymentDates = {
  __typename?: 'EstimatedCheckPaymentDates'
  estimatedTransferAtText: Scalars['String']
  estimatedShippingAt: Scalars['DateTime']
  estimatedArrivalAt: Scalars['DateTime']
}

/** Input to get estimated dates for a transfer */
export type EstimatedTransferDatesInput = {
  /** Type of account to move money from */
  fromAccountType: TransferableAccountTypeEnum
  /** Type of account to move money into */
  toAccountType: TransferableAccountTypeEnum
  /** UTC datetime when the transfer was/will be created. If omitted, the current datetime will be used */
  transferCreatedAt?: Maybe<Scalars['DateTime']>
}

/** Estimated dates for a transfer */
export type EstimatedTransferDatesPayload = {
  __typename?: 'EstimatedTransferDatesPayload'
  /** Estimated UTC datetime when the transfer will be completed by */
  estimatedTransferCompletedAt: Scalars['DateTime']
}

/** ETF */
export type Etf = {
  __typename?: 'ETF'
  /** Indicates the amount of every dollar that will go towards buying a share of the ETF */
  amount?: Maybe<Scalars['Int']>
  /** ETF high price over trailing 12 month period */
  annualHigh?: Maybe<Scalars['Float']>
  /** ETF low price over trailing 12 month period */
  annualLow?: Maybe<Scalars['Float']>
  /** Indicates the current per/share price */
  currentPrice?: Maybe<Scalars['Float']>
  /** The Acorns-designated display name of the ETF */
  displayName: Scalars['String']
  /** Indicates the individual stocks that make up the ETF */
  holdings?: Maybe<Holding[]>
  /** Indicates the investment category for the ETF */
  investmentCategories: InvestmentCategory
  /** Indicates the last market day's close per/share price */
  lastClosePrice?: Maybe<Scalars['Float']>
  /** The Acorns-designated name of the ETF */
  name: Scalars['String']
  /** Indicates the total worth of the ETF as a whole */
  netAssets?: Maybe<Scalars['String']>
  /** Indicates the day's open per/share price */
  openPrice?: Maybe<Scalars['Float']>
  /** Indicates the number of shares the user owns */
  ownedShares?: Maybe<Scalars['Float']>
  /** Indicates the percent of every dollar that will go towards buying a share of the ETF */
  percent?: Maybe<Scalars['Float']>
  /** Get price values of the ETF over a time range */
  performance: EtfPerformance
  /** Indicates the position of the ETF */
  position?: Maybe<Scalars['Int']>
  /** Indicates the per/share price range over the current week */
  priceRangeOverWeek?: Maybe<Scalars['String']>
  /** The market exchange symbol of the ETF */
  symbol: Scalars['String']
  /** Indicates the total number of shares in the market */
  volume?: Maybe<Scalars['Int']>
  /** Indicates the year-to-date return of the ETF */
  ytdReturn?: Maybe<Scalars['Float']>
}

/** ETF */
export type EtfPerformanceArgs = {
  timescale: EtfTimescale
  timespan: Scalars['Int']
  points?: Maybe<Scalars['Int']>
}

/** Amount and Percentage of ETF Gain */
export type EtfGain = {
  __typename?: 'ETFGain'
  amount: Scalars['Float']
  percentage: Scalars['Float']
}

/** Gain and Prices of ETF */
export type EtfPerformance = {
  __typename?: 'ETFPerformance'
  gain?: Maybe<EtfGain>
  prices?: Maybe<EtfPrice[]>
}

/** Price of ETF */
export type EtfPrice = {
  __typename?: 'ETFPrice'
  amount: Scalars['Float']
  timestamp: Scalars['DateTime']
}

export enum EtfTimescale {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Year = 'year',
}

/** Evaluates check deposit session to determine if it is submittable. */
export type EvaluateCheckDepositInput = {
  amount: CurrencyAmountInput
  /** The session to evaluate. */
  sessionToken: Scalars['String']
}

/** Evaluates if a check can be submitted. */
export type EvaluateCheckDepositPayload = {
  __typename?: 'EvaluateCheckDepositPayload'
  /** Recognized amount from check image. */
  ocrAmount: CurrencyAmount
  riskFactors: DepositRiskFactor[]
}

export type EventSubmission = {
  __typename?: 'EventSubmission'
  eventId: Scalars['ID']
  firstName: Scalars['String']
  lastName: Scalars['String']
  optedIn: Scalars['Boolean']
  email: Scalars['EmailAddress']
  hasAccount: Scalars['Boolean']
  comment?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
}

export type ExistingEmailVerifiedException = {
  __typename?: 'ExistingEmailVerifiedException'
  message: Scalars['String']
}

export type ExistingPhoneVerifiedException = {
  __typename?: 'ExistingPhoneVerifiedException'
  message: Scalars['String']
}

/** A reopen request for this investment account already exists and is pending review */
export type ExistingRequestPendingReview = {
  __typename?: 'ExistingRequestPendingReview'
  /** Reopen request for investment account */
  reopenRequest: InvestmentAccountReopenRequest
}

/** A reopen request for this investment account already exists and is pending user action */
export type ExistingRequestPendingUserAction = {
  __typename?: 'ExistingRequestPendingUserAction'
  /** Reopen request for investment account */
  reopenRequest: InvestmentAccountReopenRequest
}

/** Expanded view that includes the recommended coverage breakdown */
export type ExpandedLifeRecommendation = {
  __typename?: 'ExpandedLifeRecommendation'
  coverageBreakdown: LifeCoverageBreakdown
  cta: Cta
  title: Scalars['String']
}

/** The content that supports and drives the user experience */
export type ExperienceContent = {
  __typename?: 'ExperienceContent'
  /** JSON Content for rendering the referrer experience */
  rawContent: Scalars['String']
  /** Campaign ID for the referrer's active campaign */
  campaignId: Scalars['ID']
}

export type ExploreCarousel = {
  __typename?: 'ExploreCarousel'
  title: Scalars['String']
  widgets: InsuranceSection[]
}

export type ExtensionCampaign = {
  __typename?: 'ExtensionCampaign'
  id: Scalars['ID']
  name: Scalars['String']
  displayTitle?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  backgroundImage?: Maybe<ExtensionCampaignBackgroundImage>
  backgroundImageUrl?: Maybe<Scalars['URL']>
  backgroundColorHex?: Maybe<Scalars['String']>
  ctaTitle?: Maybe<Scalars['String']>
  ctaDetails: ExtensionCampaignCtaDetails
  stores?: Maybe<Array<Maybe<ExtensionCampaignStore>>>
  rank?: Maybe<Scalars['Int']>
  termsAndConditionsUrl?: Maybe<Scalars['String']>
  incentiveSummary?: Maybe<Scalars['String']>
  displayEndDate?: Maybe<Scalars['DateTime']>
}

export type ExtensionCampaignBackgroundImage = {
  __typename?: 'ExtensionCampaignBackgroundImage'
  url?: Maybe<Scalars['String']>
  horizontalFocalPoint?: Maybe<Scalars['String']>
  verticalFocalPoint?: Maybe<Scalars['String']>
}

export type ExtensionCampaignCtaDetails = {
  __typename?: 'ExtensionCampaignCtaDetails'
  type?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  repeatTitle?: Maybe<Scalars['String']>
  notificationTitle?: Maybe<Scalars['String']>
  chromeExt?: Maybe<Scalars['URL']>
  userAttribution?: Maybe<Scalars['String']>
  notificationUrl?: Maybe<Scalars['URL']>
}

export type ExtensionCampaignStore = {
  __typename?: 'ExtensionCampaignStore'
  id?: Maybe<Scalars['ID']>
  domain: Scalars['URL']
  enabled: Scalars['Boolean']
  checkoutMatchType: Scalars['String']
  checkoutMatchRegex: Scalars['String']
  checkoutTotalAmountSelector?: Maybe<Scalars['String']>
  conversionMatchType: Scalars['String']
  conversionMatchRegex: Scalars['String']
  conversionTotalAmountSelector?: Maybe<Scalars['String']>
}

export type ExtensionOwner = {
  __typename?: 'ExtensionOwner'
  id: Scalars['ID']
  name: Scalars['String']
  slug: Scalars['String']
  imageUrl?: Maybe<Scalars['URL']>
  description?: Maybe<Scalars['String']>
  monochromeImageUrl?: Maybe<Scalars['URL']>
  colorBackgroundLogoImageUrl?: Maybe<Scalars['URL']>
  greyLogoImageUrl?: Maybe<Scalars['URL']>
  twitterHandle?: Maybe<Scalars['String']>
  campaigns?: Maybe<Array<Maybe<ExtensionCampaign>>>
}

export type ExtensionRewardsSummary = {
  __typename?: 'ExtensionRewardsSummary'
  totalRewardsDollarValue: RewardSummary
  totalPendingRewardsDollarValue: RewardSummary
  totalFulfilledRewardsDollarValue: RewardSummary
}

export type ExtensionTransaction = {
  __typename?: 'ExtensionTransaction'
  id: Scalars['ID']
  campaignId?: Maybe<Scalars['ID']>
  salesAmount?: Maybe<Scalars['Float']>
  status?: Maybe<Scalars['String']>
  createdAt: Scalars['String']
  activatedAt?: Maybe<Scalars['String']>
  convertedAt?: Maybe<Scalars['String']>
  confirmedAt?: Maybe<Scalars['String']>
  lockedAt?: Maybe<Scalars['String']>
  userUuid?: Maybe<Scalars['ID']>
}

export enum ExternalSource {
  Plaid = 'plaid',
  Spend = 'spend',
  Paypal = 'paypal',
  Manual = 'manual',
  DirectBank = 'direct_bank',
}

export type FavoritePartnerOfferGroup = {
  __typename?: 'FavoritePartnerOfferGroup'
  /** list of offers in the favorite group */
  offers: PartnerOfferGroupItem[]
}

/** Used to customize favorite offer group contents */
export type FavoritePartnerOfferInput = {
  ids: Array<Scalars['String']>
}

export type FeaturedMilestones = {
  __typename?: 'FeaturedMilestones'
  /** list of featured milestones to show on widget */
  milestones: Milestone[]
}

export type FeaturedOffer = {
  __typename?: 'FeaturedOffer'
  campaignId: Scalars['ID']
  cta: Cta
  fastQuote: Scalars['Boolean']
  image?: Maybe<Image>
  logo: Image
  offerId: Scalars['ID']
  ownerId: Scalars['ID']
  subtitle?: Maybe<Scalars['String']>
  tip?: Maybe<Scalars['String']>
  title: Scalars['String']
}

export type FeaturedOffers = {
  __typename?: 'FeaturedOffers'
  body?: Maybe<Scalars['String']>
  offers: FeaturedOffer[]
  title: Scalars['String']
}

/** Fee information */
export type Fee = TimestampsInterface & {
  __typename?: 'Fee'
  accountId?: Maybe<Scalars['ID']>
  amount: Scalars['Float']
  assessedAt?: Maybe<Scalars['String']>
  balance?: Maybe<Scalars['Float']>
  billingCycle: BillingCycle
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  discount?: Maybe<Scalars['Float']>
  discountedAmount?: Maybe<Scalars['Float']>
  feeCategoryId: Scalars['String']
  feeExecutions: Array<Maybe<FeeExecution>>
  feeType: FeeType
  id: Scalars['ID']
  state: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId?: Maybe<Scalars['ID']>
}

export enum FeedContext {
  /** a3 core */
  A3Core = 'a3_core',
  /** a3 present */
  A3Present = 'a3_present',
  /** a3 spend */
  A3Spend = 'a3_spend',
  /** a3 later */
  A3Later = 'a3_later',
  /** a3 present_later */
  A3PresentLater = 'a3_present_later',
  /** a3 present_spend */
  A3PresentSpend = 'a3_present_spend',
  /** a4 invest */
  A4Invest = 'a4_invest',
  /** a4 home/present */
  A4Home = 'a4_home',
  /** a4 spend */
  A4Spend = 'a4_spend',
  /** a4 later */
  A4Later = 'a4_later',
  /** a4 early */
  A4Early = 'a4_early',
  /** a4 early details */
  A4EarlyDetails = 'a4_early_details',
}

/** Fee execution information */
export type FeeExecution = TimestampsInterface & {
  __typename?: 'FeeExecution'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  executionMethod: Scalars['String']
  externalId?: Maybe<Scalars['ID']>
  fundingAccountId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  reason?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export enum FeeExecutionMethod {
  /** Executed fee by direct ACH */
  Direct = 'DIRECT',
  /** Executed fee by selling shares */
  LiquidateSecurities = 'LIQUIDATE_SECURITIES',
  /** Waived fee execution */
  Waive = 'WAIVE',
  /** Skipped fee execution */
  Skip = 'SKIP',
  /** Executed by direct ACH from Spend funding source */
  SpendDirect = 'SPEND_DIRECT',
  /** Pre-emptively failed execution due to a known failure reason */
  PreemptiveFailure = 'PREEMPTIVE_FAILURE',
}

export enum FeeStatus {
  Negotiable = 'NEGOTIABLE',
  Processing = 'PROCESSING',
  Negotiated = 'NEGOTIATED',
  Unnegotiable = 'UNNEGOTIABLE',
}

export enum FeeStatusFilter {
  Negotiable = 'NEGOTIABLE',
  Processing = 'PROCESSING',
  Negotiated = 'NEGOTIATED',
  Unnegotiable = 'UNNEGOTIABLE',
}

export type FeeStatusSummary = {
  __typename?: 'FeeStatusSummary'
  total: Scalars['Int']
  negotiable: Scalars['Int']
  processing: Scalars['Int']
  negotiated: Scalars['Int']
  unnegotiable: Scalars['Int']
}

export enum FeeType {
  /** ADVISORY fee */
  Advisory = 'ADVISORY',
  /** SUBSCRIPTION fee */
  Subscription = 'SUBSCRIPTION',
}

export type File = {
  __typename?: 'File'
  documentRequestId: Scalars['ID']
  encoding: Scalars['String']
  filename: Scalars['String']
  mimetype: Scalars['String']
  url: Scalars['URL']
}

export type FileOrException = File | FileSizeError | UploadFailedError

export type FileSizeError = {
  __typename?: 'FileSizeError'
  message: Scalars['String']
}

/** The file uploaded exceeds the max allowed byte size */
export type FileTooLarge = {
  __typename?: 'FileTooLarge'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

export enum FilingType {
  /** User files taxes living with spouse part of the year */
  SeparatePartYear = 'separatePartYear',
  /** User files taxes living apart from spouse all year */
  SeparateWholeYear = 'separateWholeYear',
  /** User files taxes with their spouse */
  Joint = 'joint',
}

/** Miscellaneous attributes about a Financial Institution */
export type FinancialInstitution = TimestampsInterface & {
  __typename?: 'FinancialInstitution'
  /** Is this Financial Institution blacklisted within Acorns */
  blacklisted: Scalars['Boolean']
  /** Inorganic ordering for Financial Institutions */
  boost: Scalars['Int']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Is this Financial Institution removed from Plaid's list */
  deleted: Scalars['Boolean']
  /** Is this Financial Institution a Direct Bank type */
  directBank: Scalars['Boolean']
  /** Plaid Financial Institution ID */
  externalId: Scalars['String']
  /** Does this Financial Institution have multi-factor authentication? */
  hasMfa: Scalars['Boolean']
  /** Internal Acorns UUID representing Financial Institution */
  id: Scalars['ID']
  /** The link provider type of the financial institution */
  linkProviderType?: Maybe<LinkProviderType>
  /** Location of logo for a Financial Institution */
  logoUrl: Scalars['String']
  /** Name of Financial Institution */
  name: Scalars['String']
  /** URL for signing in with Direct Bank Integration */
  oauthUrl?: Maybe<Scalars['String']>
  /** Plaid products this Financial Institution supports */
  products: Array<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** URL of the Financial Institution */
  url?: Maybe<Scalars['String']>
}

/** An individual edge within the paginated list of FinancialInstitutionType */
export type FinancialInstitutionTypeEdge = {
  __typename?: 'FinancialInstitutionTypeEdge'
  /** The unique key used for pagination */
  cursor: Scalars['ID']
  /** The FinancialInstitutionType record in the edge */
  node: FinancialInstitution
}

/** Relay style pagination information for FinancialInstitutionType */
export type FinancialInstitutionTypePagination = {
  __typename?: 'FinancialInstitutionTypePagination'
  edges: FinancialInstitutionTypeEdge[]
  pageInfo: PageInfo
}

export type FinishSetup = {
  __typename?: 'FinishSetup'
  eyebrow: Scalars['String']
  tips: SetUpTip[]
}

/** Details for footer */
export type Footer = {
  __typename?: 'Footer'
  image?: Maybe<Image>
  title?: Maybe<Scalars['String']>
}

export type FormattedMonetaryAmount = {
  __typename?: 'FormattedMonetaryAmount'
  currency: Currency
  value: Scalars['String']
}

export enum FormType {
  Form1099 = 'form1099',
  Form1099R = 'form1099R',
  Form1099R1 = 'form1099R1',
  Form1099R2 = 'form1099R2',
  Form1099R4 = 'form1099R4',
  Form1099R7 = 'form1099R7',
  Form1099R8 = 'form1099R8',
  Form1099Rj = 'form1099RJ',
  Form1099Rq = 'form1099RQ',
  Form1099Rt = 'form1099RT',
  Form5498 = 'form5498',
  Form1099Misc = 'form1099MISC',
  Form1099Bdiv = 'form1099BDIV',
}

export type FoundMoneyCampaign = {
  __typename?: 'FoundMoneyCampaign'
  id: Scalars['ID']
  name: Scalars['String']
  ownerName: Scalars['String']
  backgroundImageUrl?: Maybe<Scalars['URL']>
  ownerImageUrl?: Maybe<Scalars['URL']>
  offers: FoundMoneyOffer[]
}

export type FoundMoneyCampaignOfferV2 = {
  __typename?: 'FoundMoneyCampaignOfferV2'
  id: Scalars['ID']
  incentiveSummary: Scalars['String']
}

export type FoundMoneyCampaignV2 = {
  __typename?: 'FoundMoneyCampaignV2'
  id: Scalars['ID']
  cohortSlug: Scalars['String']
  imageUrl: Scalars['URL']
  backgroundImageUrl: Scalars['URL']
  backgroundColorHex: Scalars['String']
  colorBackgroundLogoImageUrl?: Maybe<Scalars['URL']>
  colorImageUrl: Scalars['URL']
  ownerId: Scalars['ID']
  displayName: Scalars['String']
  offers: FoundMoneyCampaignOfferV2[]
}

export type FoundMoneyOffer = {
  __typename?: 'FoundMoneyOffer'
  active?: Maybe<Scalars['Boolean']>
  backgroundColorHex?: Maybe<Scalars['String']>
  backgroundImage?: Maybe<BackgroundImage>
  backgroundImageUrl?: Maybe<Scalars['URL']>
  colorBackgroundLogoImageUrl?: Maybe<Scalars['URL']>
  campaignId?: Maybe<Scalars['ID']>
  ctaDetails?: Maybe<CtaDetails>
  ctaTitle?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  dealType?: Maybe<DealType>
  devicePlatforms?: Maybe<Array<Maybe<Scalars['String']>>>
  displayEndDate?: Maybe<Scalars['String']>
  displayStartDate?: Maybe<Scalars['String']>
  displayTitle?: Maybe<Scalars['String']>
  displaySubtitle?: Maybe<Scalars['String']>
  id: Scalars['ID']
  owner?: Maybe<Owner>
  promoted?: Maybe<Scalars['Boolean']>
  promotionRank?: Maybe<Scalars['Int']>
  rank?: Maybe<Scalars['Int']>
  redemptionAction?: Maybe<Scalars['String']>
  /** @deprecated use condensedSocialCopies field instead. */
  socialCopies?: Maybe<Array<Maybe<SocialCopies>>>
  condensedSocialCopies?: Maybe<CondensedSocialCopies>
  termsAndConditionsUrl?: Maybe<Scalars['URL']>
  webviewEnabled?: Maybe<Scalars['Boolean']>
}

export type FoundMoneyOfferCategory = {
  __typename?: 'FoundMoneyOfferCategory'
  featuredOffer?: Maybe<FoundMoneyOffer>
  iconUrl?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  offers?: Maybe<Array<Maybe<FoundMoneyOffer>>>
}

export type FoundMoneyReward = {
  __typename?: 'FoundMoneyReward'
  id: Scalars['ID']
  campaignOwnerName?: Maybe<Scalars['String']>
  /** @deprecated Field is deprecated, use colorBackgroundLogoImageUrl instead */
  campaignOwnerImageUrl?: Maybe<Scalars['URL']>
  colorBackgroundLogoImageUrl?: Maybe<Scalars['URL']>
  categoryIcon?: Maybe<Scalars['String']>
  dollarValue?: Maybe<MonetaryAmount>
  status?: Maybe<Scalars['String']>
  daysFulfilledWithin?: Maybe<Scalars['Int']>
  originationDate?: Maybe<Scalars['String']>
  fulfillmentDate?: Maybe<Scalars['String']>
  isFoundMoneyPlus?: Maybe<Scalars['Boolean']>
}

export type FoundMoneySummary = {
  __typename?: 'FoundMoneySummary'
  totalRewardsDollarValue?: Maybe<MonetaryAmount>
  totalPendingRewardsDollarValue?: Maybe<MonetaryAmount>
  totalFulfilledRewardsDollarValue?: Maybe<MonetaryAmount>
}

/** A user who was referred by an existing Acorns User */
export type Friend = {
  __typename?: 'Friend'
  userId?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  email: Scalars['String']
  /**
   * If the Friend object resolved via the Advocate query, advocateUserId
   * corresponds to the argument passed in at the root level.
   * If Friend object resolved via the Friend query, advocateUserId is the
   * first advocate that is returned by Extole.
   */
  advocateUserId?: Maybe<Scalars['ID']>
  /** A list of all campaigns that the friend is participating in */
  campaigns?: Maybe<ReferralCampaign[]>
  /** Status based on activity of friend */
  status?: Maybe<FriendStatus>
  friendExperienceContent?: Maybe<FriendExperienceContent>
}

/** The content that supports user experience */
export type FriendExperienceContent = {
  __typename?: 'FriendExperienceContent'
  /** The first name of the referred user's advocate */
  advocateFirstName?: Maybe<Scalars['String']>
  /** The last name of the referred user's advocate */
  advocateLastName?: Maybe<Scalars['String']>
  /** The baseline advocate incentive they will earn if friend converts */
  advocateMinimumIncentive?: Maybe<Scalars['String']>
}

/** Status of friend */
export enum FriendStatus {
  /** Advocate sent invite but user has not completed any steps */
  Sent = 'SENT',
  /** Friend has registered */
  Pending = 'PENDING',
  /** Friend has finished required steps to qualify for reward */
  Complete = 'COMPLETE',
  /** Reward has been given to Friend/Advocate */
  Fulfilled = 'FULFILLED',
  /** Friend did not complete required steps in allotted time frame */
  Expired = 'EXPIRED',
}

/** A summary of information around a referred user */
export type FriendSummary = {
  __typename?: 'FriendSummary'
  /** First name of the referred user */
  name?: Maybe<Scalars['String']>
  /** High level status indicating referred user reward status */
  status?: Maybe<FriendStatus>
  /** Campaign identifier that the referred user signed up under */
  campaignId: Scalars['ID']
  userId: Scalars['ID']
}

export type Fund = Security & {
  __typename?: 'Fund'
  symbol: Scalars['TickerSymbol']
  type: SecurityType
  week52High: BigCurrencyAmount
  week52Low: BigCurrencyAmount
  lastClosePrice: BigCurrencyAmount
  openPrice: BigCurrencyAmount
  shortName: Scalars['String']
  longName: Scalars['String']
  displayName: Scalars['String']
  volume: Scalars['BigDecimal']
  marketCap: Scalars['BigDecimal']
  securityProfile: SecurityProfile
  securityHeadlines: SecurityHeadline[]
  topHoldings: TopHolding[]
  lastUpdatedAt: Scalars['DateTime']
  earliestPriceDate: Scalars['Date']
}

export type FundingSource = {
  __typename?: 'FundingSource'
  type: Scalars['String']
  fundingType: Scalars['String']
  name: Scalars['String']
  last4?: Maybe<Scalars['String']>
  verificationStatus?: Maybe<Scalars['Int']>
  verified?: Maybe<Scalars['Boolean']>
  icon?: Maybe<Scalars['URL']>
  alert?: Maybe<Scalars['JSON']>
  rdvSettledAt?: Maybe<Scalars['DateTime']>
  rdvTriggeredAt?: Maybe<Scalars['DateTime']>
}

/** A Funding Source for the acorns user */
export type FundingSourceAccount = TimestampsInterface & {
  __typename?: 'FundingSourceAccount'
  accountName: Scalars['String']
  alert?: Maybe<Scalars['JSON']>
  balance?: Maybe<Scalars['Float']>
  bankRoutingNumber?: Maybe<Scalars['String']>
  canCancel: Scalars['Boolean']
  canTriggerRdv: Scalars['Boolean']
  /** Indicates whether the user is allowed to verify RDV */
  canVerifyRdv?: Maybe<Scalars['Boolean']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  deleted: Scalars['Boolean']
  frozen: Scalars['Boolean']
  /** The type of the funding source. */
  fundType: FundingSourceType
  /** The bank icon of the funding source */
  icon?: Maybe<Scalars['String']>
  id: Scalars['Int']
  institutionName: Scalars['String']
  insufficientFunds?: Maybe<Scalars['Boolean']>
  last4?: Maybe<Scalars['String']>
  linked: Scalars['Boolean']
  linkedSubaccountId?: Maybe<Scalars['ID']>
  /** The logo url from Linked Accounts Service */
  logoUrl?: Maybe<Scalars['String']>
  name: Scalars['String']
  rdvSettledAt?: Maybe<Scalars['DateTime']>
  rdvTriggeredAt?: Maybe<Scalars['DateTime']>
  /** The role of the funding source. */
  role?: Maybe<FundingSourceRoleEnum>
  /** The status of the funding source. */
  status: FundingSourceStatus
  transfersApproved: Scalars['Boolean']
  /** Deprecated - use fundType instead. */
  type: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  uuid?: Maybe<Scalars['ID']>
  verificationStatus: Scalars['Int']
  verified?: Maybe<Scalars['Boolean']>
}

/** Funding Source with account and routing already exists for user */
export type FundingSourceAlreadyExists = {
  __typename?: 'FundingSourceAlreadyExists'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

export type FundingSourceInfo = {
  __typename?: 'FundingSourceInfo'
  type?: Maybe<FundingSourceType>
  name: Scalars['String']
  verificationStatus?: Maybe<Scalars['Int']>
  verified?: Maybe<Scalars['Boolean']>
  icon?: Maybe<Scalars['URL']>
  alert?: Maybe<Scalars['JSON']>
  rdvSettledAt?: Maybe<Scalars['DateTime']>
  rdvTriggeredAt?: Maybe<Scalars['DateTime']>
  accountNumberLastFour?: Maybe<Scalars['String']>
  balance?: Maybe<Scalars['Float']>
  /** @deprecated Will move in the future */
  canChange: Scalars['Boolean']
  /** @deprecated Will move in the future */
  changeRequiresApproval: Scalars['Boolean']
  linkedSubaccountId?: Maybe<Scalars['ID']>
}

/** The user needs to verify their RDVs to close their early account */
export type FundingSourceRequiresRdvException = {
  __typename?: 'FundingSourceRequiresRdvException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export enum FundingSourceRoleEnum {
  /** The subaccount is the primary funding source of the user */
  PrimaryFunding = 'primaryFunding',
  /** The subaccount is the secondary funding source of the user */
  SecondaryFunding = 'secondaryFunding',
}

export enum FundingSourceStatus {
  /** Funding Source is waiting on RDV triggers. */
  Pending = 'pending',
  /** RDVs have been sent and are awaiting settlement. */
  RdvsInitiated = 'rdvsInitiated',
  /** RDVs have settled in the user's funding source. User must verify amounts. */
  RdvsSettled = 'rdvsSettled',
  /** RDV verification attempts exhausted. */
  Frozen = 'frozen',
  /** Documents have been requested to verify the funding source. */
  DocsRequired = 'docsRequired',
  /** Awaiting admin approval. No user action is required. */
  Unapproved = 'unapproved',
  /** Funding Source is verified. No user action is required. */
  Success = 'success',
}

export enum FundingSourceStatusEnum {
  /** Funding Source is waiting on RDV triggers. */
  Pending = 'pending',
  /** RDVs have been sent and are awaiting settlement. */
  RdvsInitiated = 'rdvsInitiated',
  /** RDVs have settled in the user's funding source. User must verify amounts. */
  RdvsSettled = 'rdvsSettled',
  /** RDV verification attempts exhausted. */
  Frozen = 'frozen',
  /** Documents have been requested to verify the funding source. */
  DocsRequired = 'docsRequired',
  /** Awaiting admin approval. No user action is required. */
  Unapproved = 'unapproved',
  /** Funding Source is verified. No user action is required. */
  Success = 'success',
}

export enum FundingSourceType {
  Ach = 'ach',
  Paypal = 'paypal',
  Spend = 'spend',
}

export enum FundsAvailability {
  /** User wants easy access to cash in an emergency */
  Emergency = 'emergency',
  /** User is planning to save and not withdraw until retirement */
  Retirement = 'retirement',
}

export enum Funnel {
  /** Core funnel */
  Core = 'core',
  /** Later funnel */
  Later = 'later',
  /** Spend funnel */
  Spend = 'spend',
  /** Early funnel */
  Early = 'early',
  /** Tiered registration funnel */
  TieredReg = 'tiered_reg',
  /** Simple registration funnel */
  SimpleReg = 'simple_reg',
  /** Direct to mobile funnel */
  DirectToMobile = 'direct_to_mobile',
}

/** Attributes for generating a linked account session. */
export type GenerateLinkSessionInput = {
  /** Acorns Financial Institution ID */
  institutionId: Scalars['ID']
  /** The URL to redirect the client to after customer has finished linking account. */
  redirectUrl?: Maybe<Scalars['URL']>
  /** Flag indicating a web view client default is true */
  isWebview?: Maybe<Scalars['Boolean']>
  /** ISO 639-1 code representing the language. default is 'EN' */
  language?: Maybe<LinkSessionLanguage>
  /** Linked Account ID for Linked Account to relink */
  linkedAccountId?: Maybe<Scalars['ID']>
}

/** Returns Base 64 encoded string of PDF for Front-end */
export type GenerateUpdatedPdfPayload = {
  __typename?: 'GenerateUpdatedPdfPayload'
  /** Base 64 Encoded String of PDF */
  pdf: Scalars['String']
}

/** Object representing a grow prospect */
export type GrowProspect = Prospect & {
  __typename?: 'GrowProspect'
  email: Scalars['String']
  id: Scalars['ID']
}

/** text over background image */
export type Header = {
  __typename?: 'Header'
  image: Image
  title: Scalars['String']
}

export type HelpFormContent = {
  __typename?: 'HelpFormContent'
  body?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
}

export enum HelpFormType {
  Contact = 'CONTACT',
  EarnMissingCredit = 'EARN_MISSING_CREDIT',
  SpendDispute = 'SPEND_DISPUTE',
}

/** The Individual Security on the ETF */
export type Holding = {
  __typename?: 'Holding'
  /** Indicates the amount of every dollar that will go towards buying a share of the stock */
  amount: Scalars['Float']
  /** The name of the stock */
  name: Scalars['String']
  /** Indicates the percent of every dollar that will go towards buying a share of the stock */
  percent: Scalars['Float']
  /** The Symbol of the stock */
  symbol: Scalars['String']
}

export type HomeIcon = {
  __typename?: 'HomeIcon'
  body: Scalars['String']
  cta: Cta
  icon: Image
  title?: Maybe<Scalars['String']>
}

export type HomeIcons = {
  __typename?: 'HomeIcons'
  icons: HomeIcon[]
}

/** Identity Document Requested Alert. */
export type IdentityDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'IdentityDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type Image = {
  __typename?: 'Image'
  url: Scalars['String']
}

export type ImageInput = {
  url: Scalars['String']
}

export enum ImageType {
  Front = 'front',
  Back = 'back',
}

/**
 * An abstract representation of some reward a subscriber will be afforded
 * upon subscription to some Offer.
 */
export type Incentive = {
  /**
   * Arbitrary human-readable identifier that can be used by clients
   * to localize related copy.
   */
  copyKey?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  /** Description of what the incentive provides the subscriber. */
  description: Scalars['String']
  id: Scalars['ID']
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type IncorrectOldPasswordException = {
  __typename?: 'IncorrectOldPasswordException'
  message: Scalars['String']
}

export type IneligibilityLander = {
  __typename?: 'IneligibilityLander'
  alternatePartners?: Maybe<InsuranceCarousel>
  body: Scalars['String']
  cta: Cta
  disclaimer?: Maybe<Disclaimer>
  id: Scalars['ID']
  logo: Image
  title: Scalars['String']
}

export type InitiateEmailChallengeInput = {
  email: Scalars['EmailAddress']
}

export type InitiateEmailChallengeResult =
  | EmailAuthChallenge
  | ExistingEmailVerifiedException

/** inputs */
export type InitiateSmsChallengeInput = {
  phoneNumber: Scalars['PhoneNumber']
}

/** challenge results */
export type InitiateSmsChallengeResult =
  | SmsAuthChallenge
  | InvalidPhoneNumberException

export type InitiateTransferInput = {
  /** UUID of account to move money from */
  fromAccountId: Scalars['ID']
  /** UUID of account to move money into */
  toAccountId: Scalars['ID']
  /** Amount of currency to transfer */
  amount: CurrencyAmountInput
  /** Idempotency key for customer request */
  nonce?: Maybe<Scalars['ID']>
}

export type InitiateTransferPayload = {
  __typename?: 'InitiateTransferPayload'
  transfer?: Maybe<Transfer>
}

export type InstitutionNotSupportedError = {
  __typename?: 'InstitutionNotSupportedError'
  message: Scalars['String']
}

/** Insufficient Funds user alert. */
export type InsufficientFundsUserAlert = UserAlertsItem & {
  __typename?: 'InsufficientFundsUserAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type InsuranceCarousel = {
  __typename?: 'InsuranceCarousel'
  body?: Maybe<Scalars['String']>
  insuranceType: InsuranceType
  offers: CarouselOffer[]
  title: Scalars['String']
}

export type InsuranceHome = {
  __typename?: 'InsuranceHome'
  body: Scalars['String']
  disclaimerBody: Scalars['String']
  disclaimerCta: Cta
  image: Image
  insuranceType: InsuranceType
  modals: Modal[]
  subtitle: Scalars['String']
  title: Scalars['String']
  widgets: InsuranceHomeWidget[]
}

export type InsuranceHomeWidget =
  | CoverageAsk
  | CoverageCalculator
  | CoverageGrow
  | CoverageKnown
  | CoverageUnknown
  | InsuranceCarousel

export type InsuranceSection = {
  __typename?: 'InsuranceSection'
  body: Scalars['String']
  cta: Cta
  image: Image
  insuranceType: Scalars['String']
  recommendType: Scalars['String']
  title: Scalars['String']
}

export enum InsuranceType {
  /** Auto Insurance */
  Auto = 'auto',
  /** Life Insurance */
  Life = 'life',
  /** Renters Insurance */
  Renters = 'renters',
  /** Homeowners Insurance */
  Home = 'home',
  /** Pet Insurance */
  Pet = 'pet',
}

/** Internal Error */
export type InternalErrorException = {
  __typename?: 'InternalErrorException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** The account number is invalid */
export type InvalidAccountNumber = {
  __typename?: 'InvalidAccountNumber'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

/** The supplied account token is invalid */
export type InvalidAccountToken = {
  __typename?: 'InvalidAccountToken'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

/** Investment Account must be a Custodial account */
export type InvalidAccountTypeException = {
  __typename?: 'InvalidAccountTypeException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Risk Level cannot be changed on Later and Early accounts */
export type InvalidActionOnAccount = {
  __typename?: 'InvalidActionOnAccount'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type InvalidAddressError = {
  __typename?: 'InvalidAddressError'
  /** Error details. Not for user display. */
  errorMessage?: Maybe<Scalars['String']>
  requestId: Scalars['ID']
}

/** Invalid Address */
export type InvalidAddressException = {
  __typename?: 'InvalidAddressException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Allocations exceed max threshold for non managed portfolios */
export type InvalidAllocationPercentError = {
  __typename?: 'InvalidAllocationPercentError'
  /** Maximum allocation percent for the given portfolio Type */
  maxAllocationPercent: Scalars['Int']
}

export type InvalidCredentialsException = {
  __typename?: 'InvalidCredentialsException'
  message: Scalars['String']
}

/** Date of birth does not meet validity criteria */
export type InvalidDateOfBirthException = {
  __typename?: 'InvalidDateOfBirthException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Invalid email id */
export type InvalidEmailException = {
  __typename?: 'InvalidEmailException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** The file uploaded does not have an allowed file extension */
export type InvalidFile = {
  __typename?: 'InvalidFile'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

/** First Name does not meet validity criteria */
export type InvalidFirstNameException = {
  __typename?: 'InvalidFirstNameException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Last Name does not meet validity criteria */
export type InvalidLastNameException = {
  __typename?: 'InvalidLastNameException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type InvalidLaterInput = LaterTypedException & {
  __typename?: 'InvalidLaterInput'
  id: Scalars['ID']
  message: Scalars['String']
}

/** This account is not supported */
export type InvalidManualLink = {
  __typename?: 'InvalidManualLink'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

export type InvalidPasswordException = {
  __typename?: 'InvalidPasswordException'
  message: Scalars['String']
}

/** Invalid Phone Number */
export type InvalidPhoneException = {
  __typename?: 'InvalidPhoneException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type InvalidPhoneNumberException = {
  __typename?: 'InvalidPhoneNumberException'
  message: Scalars['String']
}

export type InvalidPinException = {
  __typename?: 'InvalidPinException'
  message: Scalars['String']
}

/** Portfolio ID must be valid */
export type InvalidPortfolioIdException = {
  __typename?: 'InvalidPortfolioIdException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** The routing number provided is unsupported or invalid */
export type InvalidRoutingNumber = {
  __typename?: 'InvalidRoutingNumber'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

/** The provided security is not valid for allocation */
export type InvalidSecurityError = {
  __typename?: 'InvalidSecurityError'
  /** ID of the invalid security */
  securityId: Scalars['ID']
}

export type InvalidSsnError = {
  __typename?: 'InvalidSSNError'
  message: Scalars['String']
}

/** SSN does not meet validity criteria */
export type InvalidSsnException = {
  __typename?: 'InvalidSsnException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Custodian is not able to open an account based on their residential address */
export type InvalidStateException = {
  __typename?: 'InvalidStateException'
  /** message */
  message?: Maybe<Scalars['String']>
  /** Custodian's State */
  state?: Maybe<Scalars['String']>
}

/** User is not in the correct subscription tier for the requested investment account */
export type InvalidSubscriptionTierException = {
  __typename?: 'InvalidSubscriptionTierException'
  /** User current subscription tier */
  currentUserTierKey?: Maybe<Scalars['String']>
}

/** The given termination age is not valid for the custodian's state */
export type InvalidTerminationAgeException = {
  __typename?: 'InvalidTerminationAgeException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type InvalidTier = {
  __typename?: 'InvalidTier'
  message: Scalars['String']
  validTiers: Tier[]
}

export type InvalidTierForMigrationError = {
  __typename?: 'InvalidTierForMigrationError'
  message: Scalars['String']
}

export type InvalidTierPrice = {
  __typename?: 'InvalidTierPrice'
  message: Scalars['String']
  validTierPrices: TierPrice[]
}

export type InvalidTierPriceCombination = {
  __typename?: 'InvalidTierPriceCombination'
  message: Scalars['String']
  tier: Tier
}

/** Returned if there is no available tier based on the provided tierPriceId */
export type InvalidTierPriceId = {
  __typename?: 'InvalidTierPriceId'
  message: Scalars['String']
}

export type Investment = {
  __typename?: 'Investment'
  id: Scalars['ID']
  createdAt: Scalars['DateTime']
  type: Scalars['String']
  typeHelp?: Maybe<Scalars['String']>
  status: InvestmentStatus
  pending?: Maybe<Scalars['Boolean']>
  reversible: Scalars['Boolean']
  amount: Scalars['Float']
  executionDate?: Maybe<Scalars['DateTime']>
  receivedAt?: Maybe<Scalars['DateTime']>
  shares?: Maybe<Scalars['Int']>
  description?: Maybe<Scalars['String']>
  details?: Maybe<Scalars['JSON']>
  allocations?: Maybe<Array<Maybe<InvestmentAllocation>>>
}

/** Investment Account Object */
export type InvestmentAccount = TimestampsInterface & {
  __typename?: 'InvestmentAccount'
  /** Internal ID of the beneficiary */
  beneficiaryId?: Maybe<Scalars['ID']>
  cashBalance: MonetaryAmount
  closedAt?: Maybe<Scalars['DateTime']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  currentBalance?: Maybe<MonetaryAmount>
  currentBalanceWithPending: MonetaryAmount
  /** Whether or not the user has made their first investment on this account. */
  hasInvested: Scalars['Boolean']
  /** Internal UUID of the Investment Account */
  id: Scalars['ID']
  investmentAccountType: InvestmentAccountType
  /** Name of the Investment Account */
  name: Scalars['String']
  /** The net investments in this investment account. */
  netInvestments: MonetaryAmount
  pendingBalance: MonetaryAmount
  pendingWithdrawals: Withdrawal[]
  performance?: Maybe<Performance>
  portfolio?: Maybe<Portfolio>
  portfolios?: Maybe<BasePortfolio[]>
  product: InvestmentProduct
  recommendedPortfolio?: Maybe<Portfolio>
  recurringInvestmentSettings?: Maybe<RecurringInvestmentSettings>
  /** The current status of the account */
  requirements: AccountRequirements
  status: InvestmentAccountStatus
  summary: InvestmentAccountSummary
  /** The total amount that is invested in bonds in this investment account. */
  totalBonds: MonetaryAmount
  /** The total amount that is invested in equities in this investment account. */
  totalEquities: MonetaryAmount
  transferability?: Maybe<InvestmentAccountTransferability>
  type: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** UUID for the user */
  userId: Scalars['ID']
  /** @deprecated Use id instead. */
  uuid: Scalars['ID']
  yearToDateReturn?: Maybe<MarketReturn>
  beneficiary?: Maybe<Beneficiary>
}

/** Investment Account Object */
export type InvestmentAccountPerformanceArgs = {
  days: Scalars['Int']
}

/** Investment Account Object */
export type InvestmentAccountSummaryArgs = {
  startPeriod: Scalars['Date']
  endPeriod: Scalars['Date']
}

export type InvestmentAccountAlreadyClosed = {
  __typename?: 'InvestmentAccountAlreadyClosed'
  /** Date and Time of account closure if account is already closed */
  accountClosedAt: Scalars['DateTime']
}

export type InvestmentAccountClosureInProgress = {
  __typename?: 'InvestmentAccountClosureInProgress'
  /** Message displayed to customer when closure is already in progress */
  clientMessage: Scalars['String']
}

export enum InvestmentAccountClosureReason {
  /** Not seeing the value */
  NotSeeingTheValue = 'NOT_SEEING_THE_VALUE',
  /** Can't afford at this time */
  CantAffordAtThisTime = 'CANT_AFFORD_AT_THIS_TIME',
  /** Going to a competitor */
  GoingToACompetitor = 'GOING_TO_A_COMPETITOR',
  /** No longer use */
  NoLongerUse = 'NO_LONGER_USE',
  /** Using funds for another purpose */
  UsingFundsForAnotherPurpose = 'USING_FUNDS_FOR_ANOTHER_PURPOSE',
  /** Had a bad experience */
  HadABadExperience = 'HAD_A_BAD_EXPERIENCE',
  /** Other */
  Other = 'OTHER',
  /** Switching to another savings plan */
  SwitchingToAnotherSavingsPlan = 'SWITCHING_TO_ANOTHER_SAVINGS_PLAN',
  /** Using funds for the good of the child */
  WithdrawalForChild = 'WITHDRAWAL_FOR_CHILD',
  /** Change age of transfer */
  ChangeAgeOfTransfer = 'CHANGE_AGE_OF_TRANSFER',
  /** Rolling over to another ira */
  RollingOverToAnotherIra = 'ROLLING_OVER_TO_ANOTHER_IRA',
}

/** Generic Error */
export type InvestmentAccountCreationException = {
  __typename?: 'InvestmentAccountCreationException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Investment account must transfer funds before closure */
export type InvestmentAccountNeedsTransferException = {
  __typename?: 'InvestmentAccountNeedsTransferException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** The investment account is still open. */
export type InvestmentAccountNotClosedException = {
  __typename?: 'InvestmentAccountNotClosedException'
  /** Type of investment account */
  accountType?: Maybe<InvestmentAccountType>
}

/** Investment Account Not Found */
export type InvestmentAccountNotFoundException = {
  __typename?: 'InvestmentAccountNotFoundException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export enum InvestmentAccountReopenCheck {
  /** Backup withholding check */
  BackupWithholdingCheck = 'BACKUP_WITHHOLDING_CHECK',
  /** Underage check */
  UnderageCheck = 'UNDERAGE_CHECK',
  /** Account locked check */
  AccountLockedCheck = 'ACCOUNT_LOCKED_CHECK',
  /** Account suspended check */
  AccountSuspendedCheck = 'ACCOUNT_SUSPENDED_CHECK',
  /** Investment collections check */
  InvestmentCollectionsCheck = 'INVESTMENT_COLLECTIONS_CHECK',
  /** Spend collections check */
  SpendCollectionsCheck = 'SPEND_COLLECTIONS_CHECK',
}

/** An investment account reopen request */
export type InvestmentAccountReopenRequest = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequest'
  /** A list of actions performed on this account reopen request */
  adminActions: InvestmentAccountReopenRequestAction[]
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** The ID of the reopen request */
  id: Scalars['Int']
  /** The investment account for which this reopen request was made */
  investmentAccount: InvestmentAccount
  /** The UUID of the investment account for which this request was made */
  investmentAccountId: Scalars['ID']
  /** A list of update notes for this investment account reopen request */
  notes: InvestmentAccountReopenRequestNote[]
  /** A list of reopen checks for this investment account reopen request */
  reopenChecks: UserInvestmentAccountReopenCheck[]
  /** The state of the investment account reopen request */
  state: InvestmentAccountReopenRequestState
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** The owner of the investment account associated with the reopen_request */
  user: User_V2
  /** The ID of the user to whom the investment account the request was made for belongs */
  userId: Scalars['Int']
}

/** An admin action performed on an investment account reopen request */
export type InvestmentAccountReopenRequestAction = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequestAction'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** The starting state of the reopen request */
  fromState: Scalars['String']
  /** The UUID of the reopen request admin action */
  id: Scalars['ID']
  /** The investment account for the corresponding reopen request */
  investmentAccount: InvestmentAccount
  /** A note associated with this action */
  note?: Maybe<InvestmentAccountReopenRequestNote>
  /** The associated reopen request */
  reopenRequest: InvestmentAccountReopenRequest
  /** The end state of the reopen request */
  toState: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** A note sent to the user regarding an investment account reopen request */
export type InvestmentAccountReopenRequestNote = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequestNote'
  /** The action associated with this note */
  adminAction: InvestmentAccountReopenRequestAction
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** A boolean indicating if an email has been sent for this note */
  emailSent: Scalars['Boolean']
  /** The UUID of the reopen request note */
  id: Scalars['ID']
  /** The note text */
  note: Scalars['String']
  /** The associated reopen request */
  reopenRequest: InvestmentAccountReopenRequest
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export enum InvestmentAccountReopenRequestState {
  /** Indicates that the request has been made but not yet processed */
  Requested = 'REQUESTED',
  /** Indicates that the request must be reviewed by invest ops */
  PendingReview = 'PENDING_REVIEW',
  /** Indicates that the request is pending user action */
  PendingUserAction = 'PENDING_USER_ACTION',
  /** Indicates that the request has been approved */
  Approved = 'APPROVED',
  /** Indicates that the request has been rejected */
  Rejected = 'REJECTED',
}

/** Filter for InvestmentAccountsByUserId query */
export type InvestmentAccountsByUserIdFilter = {
  /** Investment Account Product Name */
  product?: Maybe<InvestmentProduct>
  /** Optionally filter by account status */
  accountStatus?: Maybe<InvestmentAccountStatus>
}

export enum InvestmentAccountStatus {
  /** Investment account is open */
  Open = 'OPEN',
  /** Account has started account closure process */
  PendingClosure = 'PENDING_CLOSURE',
  /** Account has started account reopen process */
  PendingReopen = 'PENDING_REOPEN',
  /** Investment account is closed */
  Closed = 'CLOSED',
  /** Investment account has reached transfer age */
  LockedForTransfer = 'LOCKED_FOR_TRANSFER',
}

/** Investment account summary data */
export type InvestmentAccountSummary = {
  __typename?: 'InvestmentAccountSummary'
  /** The date of the user's first investment into this account */
  firstInvestmentDate?: Maybe<Scalars['DateTime']>
  /** The date of the user's most recent one-time investment into this account */
  mostRecentOneTimeInvestmentDate?: Maybe<Scalars['DateTime']>
  /** The total credits credited to this account. */
  totalCredits: Scalars['Float']
  /** The total dividends invested in this account. */
  totalDividends: Scalars['Float']
  /** The total found money rewards allocated to this account */
  totalFoundMoneyRewards: Scalars['Float']
  /** The total amount invested into this account. */
  totalInvested: Scalars['Float']
  /** The total one time investments made in this account. */
  totalOneTime: Scalars['Float']
  /** The total outside contributions to this account. */
  totalOutsideContributions: Scalars['Float']
  /** The total plan investments invested with this account. */
  totalPlan: Scalars['Float']
  /** The recurring investment total invested in this account. */
  totalRecurring: Scalars['Float']
  /** The total referral rewards to this account. */
  totalReferralRewards: Scalars['Float']
  /** The total round ups contributed to this account. */
  totalRoundUps: Scalars['Float']
  /** The total real time round ups contributed to this account. */
  totalRtru: Scalars['Float']
}

/** Transfer information for the given investment account */
export type InvestmentAccountTransferability = {
  __typename?: 'InvestmentAccountTransferability'
  /** The beneficiary investment account's age of transfer */
  transferAge: Scalars['Int']
  /** The beneficiary investment account's date of transfer */
  transferDate: Scalars['Date']
  /** The beneficiary investment account's age of transfer reached */
  transferReached: Scalars['Boolean']
  /** The beneficiary investment account's state of residence */
  transferStateCode: UsStateCodes
}

export enum InvestmentAccountType {
  /** Basic investment account */
  BasicInvestment = 'BASIC_INVESTMENT',
  /** Roth IRA investment account */
  RothIra = 'ROTH_IRA',
  /** Traditional IRA investment account */
  TraditionalIra = 'TRADITIONAL_IRA',
  /** Simplified Employee Pension investment account */
  SimplifiedEmployeePension = 'SIMPLIFIED_EMPLOYEE_PENSION',
  /** Uniform Gift to Minors Act Custodial Investment Account */
  Ugma = 'UGMA',
  /** Uniform Transfer to Minors Act Custodial Investment Account */
  Utma = 'UTMA',
  AcornsInvestingAccount = 'acornsInvestingAccount',
  TraditionalIra = 'traditionalIRA',
  RothIra = 'rothIRA',
  SimplifiedEmployeePension = 'simplifiedEmployeePension',
}

export enum InvestmentAccountTypes {
  RothIra = 'RothIRA',
  SimplifiedEmployeePension = 'SimplifiedEmployeePension',
  TraditionalIra = 'TraditionalIRA',
}

export type InvestmentAllocation = {
  __typename?: 'InvestmentAllocation'
  amount: Scalars['Float']
  shares: Scalars['Float']
  symbol: Scalars['String']
}

export type InvestmentCategory = {
  __typename?: 'InvestmentCategory'
  bond: Scalars['Float']
  equity: Scalars['Float']
  realEstate: Scalars['Float']
}

export type InvestmentFilter = {
  type?: Maybe<InvestmentType>
  operation?: Maybe<InvestmentOperation>
  status?: Maybe<InvestmentStatus>
}

export enum InvestmentFrequency {
  Daily = 'daily',
  Monthly = 'monthly',
  Weekly = 'weekly',
}

/** When investment id and investment account id do not match */
export type InvestmentNotFoundException = {
  __typename?: 'InvestmentNotFoundException'
  /** ID */
  id?: Maybe<Scalars['ID']>
}

export enum InvestmentOperation {
  Credit = 'credit',
  Debit = 'debit',
  Dividend = 'dividend',
}

export enum InvestmentProduct {
  /** Invest investment product */
  Invest = 'INVEST',
  /** Later investment product */
  Later = 'LATER',
  /** Early investment product */
  Early = 'EARLY',
}

/** Investments Paused user alert. */
export type InvestmentsPausedUserAlert = UserAlertsItem & {
  __typename?: 'InvestmentsPausedUserAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export enum InvestmentStatus {
  All = 'all',
  Finished = 'finished',
  Unfinished = 'unfinished',
}

export enum InvestmentType {
  RoundUp = 'RoundUp',
  LumpSum = 'LumpSum',
  Dividend = 'Dividend',
  BonusRoundup = 'BonusRoundup',
}

export enum InvestmentTypes {
  Credit = 'credit',
  Debit = 'debit',
}

/** Investment cannot be cancelled */
export type InvestmentUncancellableException = {
  __typename?: 'InvestmentUncancellableException'
  /** ID */
  id?: Maybe<Scalars['ID']>
}

export type InvestorQuestionsInput = {
  employedAffiliatedWithBrokerDealer?: Maybe<Scalars['Boolean']>
  shareholderOrDirector?: Maybe<Scalars['Boolean']>
  subjectToBackupWithholding?: Maybe<Scalars['Boolean']>
}

/** Job alert display info */
export type JobAlert = {
  __typename?: 'JobAlert'
  id: Scalars['ID']
  /** desired job description */
  keyPhrase: Scalars['String']
  /** desired job location */
  location: Scalars['String']
}

/** Specifies the alert criteria */
export type JobAlertCriteriaInput = {
  filters: JobSearchFilterInput[]
  location: JobLocationInput
}

export type JobLocation = {
  __typename?: 'JobLocation'
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  value?: Maybe<Scalars['String']>
}

export type JobLocationInput = {
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  /** flexible text field to input location as a single string (e.g. "New York, NY 10010" */
  value?: Maybe<Scalars['String']>
}

export type JobOffer = {
  __typename?: 'JobOffer'
  /** Company logo or generic default */
  companyLogo: Image
  /** Hiring company */
  companyName: Scalars['String']
  id: Scalars['ID']
  /** Relevant job industry */
  industryName?: Maybe<Scalars['String']>
  /** Job role */
  jobName: Scalars['String']
  /** Job location */
  location: OfferLocation
  /** Salary details */
  salary?: Maybe<JobOfferSalary>
  /** List of tags to display */
  tags: Array<Scalars['String']>
  /** Redirect URL for job posting */
  url: Scalars['URL']
}

export type JobOfferSalary = {
  __typename?: 'JobOfferSalary'
  interval: SalaryInterval
  maxValue: Scalars['Float']
  minValue: Scalars['Float']
}

export type Jobs_Article = {
  __typename?: 'jobs_Article'
  body: Scalars['String']
  cta?: Maybe<Cta>
  eyebrow: Scalars['String']
  id: Scalars['ID']
  image?: Maybe<Image>
  title: Scalars['String']
}

export type Jobs_Education = {
  __typename?: 'jobs_Education'
  articles: Jobs_Article[]
  id: Scalars['ID']
  title: Scalars['String']
}

export type Jobs_Offer = {
  __typename?: 'jobs_Offer'
  /** Company logo or generic default */
  companyLogo: Image
  /** Hiring company */
  companyName: Scalars['String']
  id: Scalars['ID']
  /** Relevant job industry */
  industryName?: Maybe<Scalars['String']>
  /** Job role */
  jobName: Scalars['String']
  /** Job location */
  location: JobLocation
  /** Salary details */
  salary?: Maybe<Jobs_OfferSalary>
  /** List of tags to display */
  tags: Array<Scalars['String']>
  /** Redirect URL for job posting */
  url: Scalars['URL']
}

/** Specifies a Job Offer Connection */
export type Jobs_OfferConnection = {
  __typename?: 'jobs_OfferConnection'
  edges: Jobs_OfferEdge[]
  pageInfo: PageInfo
}

/** Specifies a Job Offer Edge */
export type Jobs_OfferEdge = {
  __typename?: 'jobs_OfferEdge'
  cursor: Scalars['ID']
  node: Jobs_Offer
}

export type Jobs_OfferSalary = {
  __typename?: 'jobs_OfferSalary'
  interval: SalaryInterval
  maxValue: Scalars['Float']
  minValue: Scalars['Float']
}

/** Specifies the search criteria */
export type JobSearchCriteria = {
  __typename?: 'JobSearchCriteria'
  filters: JobSearchFilter[]
  location: JobLocation
  /** Specifies the search radius in miles */
  searchRadius?: Maybe<Scalars['Int']>
}

/** Specifies the search criteria */
export type JobSearchCriteriaInput = {
  filters: JobSearchFilterInput[]
  location: JobLocationInput
  searchRadius?: Maybe<Scalars['Int']>
}

/** Specifies which values to filter jobs by */
export type JobSearchFilter = {
  __typename?: 'JobSearchFilter'
  key: JobSearchFilterKey
  value: Scalars['String']
}

/** Specifies which values to filter jobs by */
export type JobSearchFilterInput = {
  key: JobSearchFilterKey
  value: Scalars['String']
}

/** Supported types of search criteria */
export enum JobSearchFilterKey {
  /** finds jobs that have metadata matching this phrase */
  KeyPhrase = 'KEY_PHRASE',
  /** finds jobs with exact match for company name */
  Company = 'COMPANY',
}

/** Display wrapper for featured job searches */
export type JobSearchOffer = {
  __typename?: 'JobSearchOffer'
  /** Background/featured image */
  backgroundImage: Image
  /** Display body for the offer */
  body?: Maybe<Scalars['String']>
  /** Desktop Background/featured image */
  desktopBackgroundImage: Image
  id: Scalars['ID']
  /** Company/partner logo */
  logo?: Maybe<Image>
  /** List of filters used when searching for jobs */
  searchFilters: JobSearchFilter[]
  /** Display subtitle for the offer */
  subtitle?: Maybe<Scalars['String']>
  /** Display title for the offer */
  title: Scalars['String']
}

export type JobSearchPage = {
  __typename?: 'JobSearchPage'
  recentSearches: JobSearchCriteria[]
}

export type LadderLinkResponse = {
  __typename?: 'LadderLinkResponse'
  id: Scalars['ID']
  url: Scalars['String']
  urlExpires: Scalars['Int']
}

export type LadderQuote = {
  __typename?: 'LadderQuote'
  coverage?: Maybe<Scalars['Int']>
  term?: Maybe<Scalars['Int']>
  monthlyPremium?: Maybe<Scalars['Float']>
}

export type LadderQuoteStatus = {
  __typename?: 'LadderQuoteStatus'
  valid?: Maybe<Scalars['Boolean']>
  complete?: Maybe<Scalars['Boolean']>
  eligible?: Maybe<Scalars['Boolean']>
}

export type LadderResponse = {
  __typename?: 'LadderResponse'
  id: Scalars['String']
  quoteStatus?: Maybe<LadderQuoteStatus>
  quotes: Array<Maybe<LadderQuote>>
}

export type LaterAccount = {
  __typename?: 'LaterAccount'
  accountId: Scalars['ID']
  accountNumber?: Maybe<Scalars['String']>
  name: Scalars['String']
  code: LaterAccountCodes
  portfolioId: Scalars['ID']
  portfolioName: Scalars['String']
  amount: Scalars['Float']
  performance?: Maybe<LaterPortfolioPerformance>
  recurringSettings?: Maybe<RecurringInvestmentSettings>
  contributionLimit: Scalars['Float']
  status?: Maybe<LaterAccountStatus>
}

export type LaterAccountAlreadyVerified = LaterTypedException & {
  __typename?: 'LaterAccountAlreadyVerified'
  id: Scalars['ID']
  message: Scalars['String']
}

export enum LaterAccountCodes {
  Sep = 'SEP',
  Roth = 'ROTH',
  Traditional = 'TRADITIONAL',
}

export type LaterAccountIneligibleForVerification = LaterTypedException & {
  __typename?: 'LaterAccountIneligibleForVerification'
  id: Scalars['ID']
  message: Scalars['String']
}

export type LaterAccountInfo = {
  __typename?: 'LaterAccountInfo'
  investmentAccountId: Scalars['ID']
  plan: InvestmentAccountTypes
  status: LaterAccountStatus
  userId: Scalars['ID']
}

export type LaterAccountInfoOrError =
  | LaterAccountAlreadyVerified
  | LaterAccountIneligibleForVerification
  | LaterAccountInfo
  | LaterAccountNotFound

export type LaterAccountNotFound = LaterTypedException & {
  __typename?: 'LaterAccountNotFound'
  id: Scalars['ID']
  message: Scalars['String']
}

export enum LaterAccountStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  FailedToCreate = 'FAILED_TO_CREATE',
  Hidden = 'HIDDEN',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
}

export type LaterBeneficiary = {
  type?: Maybe<BeneficiaryType>
  accountId: Scalars['String']
  percentageShare?: Maybe<Scalars['Float']>
  beneficiaryId?: Maybe<Scalars['ID']>
}

export type LaterContributionAbilityResult = ContributionAbilityByYear

export type LaterContributionLimitMet = {
  __typename?: 'LaterContributionLimitMet'
  year: Scalars['Int']
}

export type LaterDeposit = LaterHistoryItem & {
  __typename?: 'LaterDeposit'
  name: Scalars['String']
  type?: Maybe<LaterHistoryItemType>
  depositId: Scalars['ID']
  depositType?: Maybe<LaterDepositType>
  taxYear: Scalars['Int']
  amount: Scalars['Float']
  status: Scalars['String']
  date: Scalars['DateTime']
  reversible?: Maybe<Scalars['Boolean']>
  tradeConfirmUrl?: Maybe<Scalars['String']>
  pending?: Maybe<Scalars['Boolean']>
}

export enum LaterDepositType {
  Contribution = 'Contribution',
  EmployerContribution = 'EmployerContribution',
  EmployeeContribution = 'EmployeeContribution',
  SpousalContribution = 'SpousalContribution',
  PostponedContribution = 'PostponedContribution',
  RepaymentContribution = 'RepaymentContribution',
  Dividend = 'Dividend',
  Fees = 'Fees',
  Interest = 'Interest',
  NonQualified = 'NonQualified',
  Payment = 'Payment',
  Payoff = 'Payoff',
  Payout = 'Payout',
  Rent = 'Rent',
  Rollover = 'Rollover',
  Royalty = 'Royalty',
  Settlement = 'Settlement',
  Other = 'Other',
  Unspecified = 'Unspecified',
}

export type LaterDividendsItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'LaterDividendsItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    etfCategory: Scalars['String']
    etfTicker: Scalars['String']
  }

export type LaterEntityBeneficiary = LaterBeneficiary & {
  __typename?: 'LaterEntityBeneficiary'
  beneficiaryId?: Maybe<Scalars['ID']>
  name: Scalars['String']
  type?: Maybe<BeneficiaryType>
  accountId: Scalars['String']
  percentageShare?: Maybe<Scalars['Float']>
}

/** Sell shares for the fee. This happens for Paypal users or if users never accepted the new EFT */
export type LaterFeeInvestmentItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'LaterFeeInvestmentItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

export type LaterFullContributionSuccess = {
  __typename?: 'LaterFullContributionSuccess'
  year: Scalars['Int']
}

export type LaterHistoryItem = {
  type?: Maybe<LaterHistoryItemType>
  taxYear: Scalars['Int']
  status: Scalars['String']
  amount: Scalars['Float']
  date: Scalars['DateTime']
  reversible?: Maybe<Scalars['Boolean']>
  tradeConfirmUrl?: Maybe<Scalars['String']>
  pending?: Maybe<Scalars['Boolean']>
}

export enum LaterHistoryItemType {
  Withdrawal = 'withdrawal',
  Rollover = 'rollover',
  Transfer = 'transfer',
  Deposit = 'deposit',
}

export type LaterIndividualBeneficiary = LaterBeneficiary & {
  __typename?: 'LaterIndividualBeneficiary'
  beneficiaryId?: Maybe<Scalars['ID']>
  firstName: Scalars['String']
  lastName: Scalars['String']
  birthDate: Scalars['DateTime']
  relationship: Scalars['String']
  percentageShare?: Maybe<Scalars['Float']>
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  zip?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  type?: Maybe<BeneficiaryType>
  accountId: Scalars['String']
}

export type LaterIndividualBeneficiaryResponse = {
  __typename?: 'LaterIndividualBeneficiaryResponse'
  accountId: Scalars['ID']
  beneficiaryId: Scalars['ID']
  firstName: Scalars['String']
  lastName: Scalars['String']
  percentageShare?: Maybe<Scalars['Float']>
  birthDate?: Maybe<Scalars['DateTime']>
  relationship: Scalars['String']
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  zip?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
}

/** A generic money movement line item for the Later account */
export type LaterInvestmentItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'LaterInvestmentItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount?: Maybe<CurrencyAmount>
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The percentage that the user elected for withholding */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

export type LaterPartialContributionSuccess = {
  __typename?: 'LaterPartialContributionSuccess'
  acceptedAmount: CurrencyAmount
  year: Scalars['Int']
}

export type LaterPortfolioPerformance = {
  __typename?: 'LaterPortfolioPerformance'
  periodMarketChange: Scalars['Float']
  periodMarketChangePercent: Scalars['Float']
  periodMarketChangeWithoutFees: Scalars['Float']
  periodMarketChangePercentWithoutFees: Scalars['Float']
}

export type LaterProgramAccountContributionInput = {
  amount: CurrencyAmountInput
  nonce: Scalars['ID']
  programAccountType: ProgramAccountType
  year?: Maybe<Scalars['Int']>
}

export type LaterProgramAccountContributionResult =
  | LaterContributionLimitMet
  | LaterFullContributionSuccess
  | LaterPartialContributionSuccess

export type LaterRebalanceItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'LaterRebalanceItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount?: Maybe<CurrencyAmount>
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
  }

export type LaterTotalLiquidationInput = {
  federalTaxes: Scalars['Float']
  stateTaxes: Scalars['Float']
  withdrawalType?: Maybe<LaterWithdrawalType>
  taxYear: Scalars['Int']
  earlyDistributionTaxExceptionReason?: Maybe<Scalars['String']>
  reason?: Maybe<LaterWithdrawalReason>
}

export type LaterTypedException = {
  id: Scalars['ID']
  message: Scalars['String']
}

/** Object representing an outside contribution prospect */
export type LaterWaitlistProspect = Prospect & {
  __typename?: 'LaterWaitlistProspect'
  email: Scalars['String']
  id: Scalars['ID']
}

export type LaterWithdrawal = LaterHistoryItem & {
  __typename?: 'LaterWithdrawal'
  name: Scalars['String']
  withdrawalId: Scalars['ID']
  type?: Maybe<LaterHistoryItemType>
  withdrawalType?: Maybe<LaterWithdrawalType>
  taxYear: Scalars['Int']
  federalTaxes?: Maybe<Scalars['Float']>
  stateTaxes?: Maybe<Scalars['Float']>
  earlyDistributionTaxExceptionReason?: Maybe<Scalars['String']>
  amount: Scalars['Float']
  status: Scalars['String']
  date: Scalars['DateTime']
  reversible?: Maybe<Scalars['Boolean']>
  tradeConfirmUrl?: Maybe<Scalars['String']>
  pending?: Maybe<Scalars['Boolean']>
}

export type LaterWithdrawalItem = PastItem &
  PastCoreTradedItem & {
    __typename?: 'LaterWithdrawalItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl?: Maybe<Scalars['URL']>
    federalWithholdings?: Maybe<LaterWithholdingValues>
    stateWithholdings?: Maybe<LaterWithholdingValues>
  }

/**  Reason for withdrawing from a later account */
export enum LaterWithdrawalReason {
  DirectTransfer = 'direct_transfer',
  EarlyWithdrawal = 'early_withdrawal',
  OverContribution = 'over_contribution',
  Retirement = 'retirement',
  Rollover = 'rollover',
}

/**
 * Reason for withdrawing from a later account
 * Deprecated - this can be derived from the LaterWithdrawalReason below
 */
export enum LaterWithdrawalType {
  EarlyDistribution = 'EarlyDistribution',
  IneligibleContribution = 'IneligibleContribution',
  NormalDistribution = 'NormalDistribution',
}

/** Tuple of fields related to withholdings elected at either the state or federal level */
export type LaterWithholdingValues = {
  __typename?: 'LaterWithholdingValues'
  amount: CurrencyAmount
  /** The percentage that the user elected for withholding */
  percentage: Scalars['Float']
}

/** An upload from backend */
export type LegacyUploadDocument = {
  __typename?: 'LegacyUploadDocument'
  documentType: DocumentType
  id: Scalars['ID']
  userId: Scalars['ID']
}

/** Input for creating a legacy document upload */
export type LegacyUploadDocumentInput = {
  /** the type of document being uploaded */
  documentType: DocumentType
  /** the multipart document upload file */
  upload: Scalars['Upload']
}

/** LegacyUploadDocumentResult */
export type LegacyUploadDocumentResult =
  | FileTooLarge
  | InvalidFile
  | LegacyUploadDocument

/** A user's insurance calculation response */
export type LifeCalculatorInput = {
  /** annual income (after taxes) */
  netIncome: LifeCalculatorUserResponse
  /** total savings */
  savings?: Maybe<LifeCalculatorUserResponse>
  /** mortgage balance (if any) */
  mortgage?: Maybe<LifeCalculatorUserResponse>
  /** number of children */
  numberOfChildren?: Maybe<LifeCalculatorUserResponse>
  /** total debt (excluding mortgage) */
  debt?: Maybe<LifeCalculatorUserResponse>
  /** number of years to pay beneficiaries */
  payoutYears: LifeCalculatorUserResponse
  /** age in years (use 0 for infant) */
  youngestChildAge?: Maybe<LifeCalculatorUserResponse>
}

/** Insurance onboarding question */
export type LifeCalculatorQuestion = {
  __typename?: 'LifeCalculatorQuestion'
  /** order within corresponding row */
  column: Scalars['Int']
  /** Internal question ID */
  id: Scalars['ID']
  /** maximum number of digits allowed */
  maxDigits?: Maybe<Scalars['Int']>
  /** maximum input value allowed */
  maxValue?: Maybe<Scalars['Int']>
  /** minimum input value allowed */
  minValue?: Maybe<Scalars['Int']>
  /** question name identifier */
  name: Scalars['String']
  /** question placeholder text */
  placeholder: Scalars['String']
  /** corresponding survey row */
  row: Scalars['Int']
  /** question tooltip */
  tip?: Maybe<Tip>
  /** question title text */
  title: Scalars['String']
  /** life calculator question type */
  type: LifeCalculatorQuestionType
  /** previously given answer (if available) */
  value?: Maybe<Scalars['Int']>
}

export enum LifeCalculatorQuestionType {
  /** numerical keyboard input for discrete quantities */
  IntegerInput = 'integer_input',
  /** numerical keyboard input for monetary amounts */
  CurrencyInput = 'currency_input',
  /** dropdown number picker */
  NumberPicker = 'number_picker',
}

/** Content for the life calculator form */
export type LifeCalculatorSurvey = {
  __typename?: 'LifeCalculatorSurvey'
  body: Scalars['String']
  cta: Cta
  id: Scalars['ID']
  modals: Modal[]
  questions: LifeCalculatorQuestion[]
  tip: Tip
  title: Scalars['String']
  tutorialTitle: Scalars['String']
}

/** A user's response to a life insurance calculator question */
export type LifeCalculatorUserResponse = {
  /** Internal question ID */
  id: Scalars['ID']
  /** user response */
  value: Scalars['Int']
}

/** Breakdown for recommended life insurance coverage */
export type LifeCoverageBreakdown = {
  __typename?: 'LifeCoverageBreakdown'
  /** total debt including mortgage */
  debt: LifeCoverageBreakdownCategory
  /** estimated college costs for all children */
  education: LifeCoverageBreakdownCategory
  /** total income being replaced */
  expenses: LifeCoverageBreakdownCategory
  /** matching coverage level offered by provider */
  nearestCoverage: LifeCoverageBreakdownCategory
  /** total savings to offset from money needed */
  savings: LifeCoverageBreakdownCategory
  /** total costs for insurance to cover */
  totalNeeds: LifeCoverageBreakdownCategory
}

/** Recommended life coverage breakdown category */
export type LifeCoverageBreakdownCategory = {
  __typename?: 'LifeCoverageBreakdownCategory'
  tip?: Maybe<Scalars['String']>
  title: Scalars['String']
  value: Scalars['Int']
}

/** A user's life quote  apply input */
export type LifeQuoteApplyInput = {
  /** Provider name */
  providerName: ProviderName
  /** coverage amount */
  coverageAmount: Scalars['Int']
  /** policy term length */
  termLength: Scalars['Int']
}

/** A user's life quote input */
export type LifeQuoteInput = {
  /** Provider name */
  providerName: ProviderName
  /** date of birth */
  dateOfBirth: Scalars['String']
  /** family health history */
  familyHistory: Scalars['Boolean']
  /** gender  */
  gender: Scalars['String']
  /** height in inches */
  heightInches: Scalars['Int']
  /** income */
  householdIncome: Scalars['Int']
  /** smoker */
  smoker: Scalars['Boolean']
  /** weight in pounds */
  weightPounds: Scalars['Int']
  /** zip code */
  zipCode: Scalars['String']
  /** User's metadata */
  userMetadata: QuoteUserMetadata
}

/** Quote Insurance question */
export type LifeQuoteQuestion = {
  __typename?: 'LifeQuoteQuestion'
  /** Possible answers to be selected for the related question */
  answers?: Maybe<QuestionAnswer[]>
  /** Internal question ID */
  id: Scalars['ID']
  /** max height amount in feet for question is type 'height_picker' */
  maxValue?: Maybe<Scalars['String']>
  /** minimum height amount in feet for question is type 'height_picker' */
  minValue?: Maybe<Scalars['String']>
  /** question name identifier */
  name: Scalars['String']
  /** question placeholder text */
  placeholder: Scalars['String']
  /** question placeholder text */
  required: Scalars['String']
  /** question tooltip */
  tip?: Maybe<Tip>
  /** question title text */
  title: Scalars['String']
  /** life quote question type */
  type: LifeQuoteQuestionType
  /** question value text */
  value?: Maybe<Scalars['String']>
}

export enum LifeQuoteQuestionType {
  /** date calendar selection */
  Date = 'date',
  /** single choice selection */
  SingleChoice = 'single_choice',
  /** height number picker */
  HeightPicker = 'height_picker',
  /** numerical keyboard input for monetary amounts */
  CurrencyInput = 'currency_input',
  /** weight number picker */
  WeightPicker = 'weight_picker',
  /** numerical keyboard input for discrete quantities */
  IntegerInput = 'integer_input',
  /** boolean selection of yes/no */
  Boolean = 'boolean',
  /** lower to upper bound amounts */
  Scale = 'scale',
}

/** Return type for LifeQuoteResponse mutation */
export type LifeQuoteResponse = {
  __typename?: 'LifeQuoteResponse'
  success: Scalars['Boolean']
}

/** One possible return type for the protectLifeQuotePremiums query */
export type LifeQuoteResultSliders = {
  __typename?: 'LifeQuoteResultSliders'
  cta: Cta
  footer: Footer
  header: Header
  id: Scalars['ID']
  modals: Modal[]
  navBody: Scalars['String']
  navTitle: Scalars['String']
  partnerBody: Scalars['String']
  partnerTitle: Scalars['String']
  partnerUrl: Scalars['String']
  premiums?: Maybe<Premium[]>
  requestedCoverage?: Maybe<Scalars['Int']>
  sliders: QuoteSlider[]
}

/** Life Quote Step */
export type LifeQuoteStep = {
  __typename?: 'LifeQuoteStep'
  body?: Maybe<Scalars['String']>
  cta?: Maybe<Cta>
  footer?: Maybe<Footer>
  navBody?: Maybe<Scalars['String']>
  navTitle?: Maybe<Scalars['String']>
  questions: LifeQuoteQuestion[]
  tip?: Maybe<Tip>
  title?: Maybe<Scalars['String']>
}

/** Content for the life quote survey */
export type LifeQuoteSurvey = {
  __typename?: 'LifeQuoteSurvey'
  id: Scalars['ID']
  modals: Modal[]
  steps: LifeQuoteStep[]
}

/** Miscellaneous attributes about a Linked Account */
export type LinkedAccount = TimestampsInterface & {
  __typename?: 'LinkedAccount'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Error code attached to operation done on account */
  errorCode?: Maybe<Scalars['String']>
  /** Plaid account ID */
  externalId?: Maybe<Scalars['ID']>
  /** Source of linked account (plaid or spend) */
  externalSource: LinkedAccountExternalSourceEnum
  financialInstitution?: Maybe<FinancialInstitution>
  /** ID of the financial institution this linked account is for */
  financialInstitutionId?: Maybe<Scalars['ID']>
  /** Linked Account ID */
  id: Scalars['ID']
  /** Name of the associated institution this linked account is for */
  institutionName?: Maybe<Scalars['String']>
  /** Is the account linked? */
  linked: Scalars['Boolean']
  linkedSubaccounts: LinkedSubaccount[]
  /** The logo url for the institution associated with the account */
  logoUrl: Scalars['String']
  /** This field should only be fetched for initializing a Plaid Link session */
  publicToken?: Maybe<Scalars['String']>
  /** Status indicating potential user action required */
  status: LinkedAccountStatusEnum
  /** DateTime of when Transactions were last synced for financial institution */
  transactionsLastSyncedAt?: Maybe<Scalars['DateTime']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Correlated User UUID */
  userId: Scalars['ID']
}

/** A Linked Account Alert. */
export type LinkedAccountAlert = UserAlertsItem & {
  __typename?: 'LinkedAccountAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Response from linked account alert query */
export type LinkedAccountAlertsResponse =
  | LinkedAccountAlert
  | RelinkLinkedAccountAlert

export enum LinkedAccountExternalSourceEnum {
  /** The link was created through Plaid and represents an external financial institution */
  Plaid = 'plaid',
  /** The link was created directly between the corresponding bank's API and Acorns */
  DirectBank = 'direct_bank',
  /** This account has an internal Acorns spend account associated with it */
  Spend = 'spend',
  /** The user linked by manually entering an account & routing number */
  Manual = 'manual',
  /** PayPal direct connection was used to link this account */
  Paypal = 'paypal',
}

export enum LinkedAccountLinkingErrorsEnum {
  /** Error with incorrect institution security questions */
  InvalidMfa = 'INVALID_MFA',
  /** Online banking credentials have been updated */
  InvalidUpdatedUsername = 'INVALID_UPDATED_USERNAME',
  /** Online banking account is locked */
  ItemLocked = 'ITEM_LOCKED',
  /** Error with institution security settings */
  ItemNotSupported = 'ITEM_NOT_SUPPORTED',
  /** Online banking account is not fully set up */
  UserSetupRequired = 'USER_SETUP_REQUIRED',
  /** Error with institution security questions */
  MfaNotSupported = 'MFA_NOT_SUPPORTED',
  /** Online banking system is down */
  InstitutionDown = 'INSTITUTION_DOWN',
  /** Online banking system is unresponsive */
  InstitutionNotResponding = 'INSTITUTION_NOT_RESPONDING',
  /** Online banking system is unresponsive */
  InstitutionNotAvailable = 'INSTITUTION_NOT_AVAILABLE',
  /** Online banking system is not supported anymore */
  InstitutionNoLongerSupported = 'INSTITUTION_NO_LONGER_SUPPORTED',
  /** Server error */
  InternalServerError = 'INTERNAL_SERVER_ERROR',
}

export type LinkedAccountNotFound = {
  __typename?: 'LinkedAccountNotFound'
  message: Scalars['String']
}

export enum LinkedAccountStatusEnum {
  /** The linked account is working and requires no action */
  Success = 'success',
  /** The user must relink and update their linked account to continue functioning */
  Relink = 'relink',
  /** The user must take action with their financial institution to fix the issue */
  ExternalAction = 'externalAction',
  /** The linked account or financial institution is no longer supported and can be unlinked */
  Unsupported = 'unsupported',
}

/** An individual account between an individual user and financial institution */
export type LinkedSubaccount = TimestampsInterface & {
  __typename?: 'LinkedSubaccount'
  /** Last 4 Digits of Account Number */
  accountNumberLastFour?: Maybe<Scalars['String']>
  /** Roles this linked account can be assigned to */
  allowedRoles: LinkedSubaccountRoleEnum[]
  /** Balance available (via Plaid/Spend) */
  balanceAvailable?: Maybe<Scalars['Float']>
  /** Current balance of subaccount (via Plaid/Spend) */
  balanceCurrent?: Maybe<Scalars['Float']>
  /** Spending limit of balance */
  balanceLimit?: Maybe<Scalars['Float']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Plaid ID for linked subaccount */
  externalId?: Maybe<Scalars['String']>
  /** External source of subaccount (plaid, spend, paypal, manual) */
  externalSource?: Maybe<Scalars['String']>
  /** Internal ID for linked subaccount */
  id: Scalars['ID']
  /** Subaccount Linked? */
  linked: Scalars['Boolean']
  linkedAccount: LinkedAccount
  /** Internal ID for the corresponding linked account */
  linkedAccountId: Scalars['ID']
  /** Name of linked subaccount (Department) */
  name: Scalars['String']
  /** Official name (verbose) */
  officialName?: Maybe<Scalars['String']>
  paymentEngines: LinkedSubaccountPaymentEngineEnum[]
  /** The role of the linked subaccount */
  role?: Maybe<LinkedSubaccountRoleEnum>
  /** Financial institution routing number. */
  routingNumber?: Maybe<Scalars['String']>
  /** The status of the linked subaccount */
  status?: Maybe<FundingSourceStatusEnum>
  /** Subtype (ie checking) */
  subaccountSubtype: Scalars['String']
  /** Type (depository, credit) */
  subaccountType: Scalars['String']
  /** Transactions count */
  transactionsLastSyncedCount: Scalars['Int']
  /** RDVs and docs have been verified and approved for this account */
  transfersApproved?: Maybe<Scalars['Boolean']>
  /** Is the account at risk or does it have insufficient funds? */
  transfersAtRisk?: Maybe<Scalars['Boolean']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /**
   * Subaccount Verified?
   * @deprecated This will be removed in favor of "transfersApproved"
   */
  verified?: Maybe<Scalars['Boolean']>
}

export enum LinkedSubaccountPaymentEngineEnum {
  /** The linked subaccount is linked in ProfitStars */
  ProfitStars = 'profitStars',
}

export enum LinkedSubaccountRoleEnum {
  /** The subaccount is the primary funding source of the user */
  PrimaryFunding = 'primaryFunding',
  /** The subaccount is the secondary funding source of the user */
  SecondaryFunding = 'secondaryFunding',
}

/** Input for creating a manual, ACH funding source */
export type LinkManualFundingSourceInput = {
  /** the account number of the funding source being linked */
  accountNumber: Scalars['String']
  /** the routing number of the funding source being linked */
  routingNumber: Scalars['RoutingNumber']
}

/** LinkManualFundingSourceResult */
export type LinkManualFundingSourceResult =
  | CurrentBankStatementNotProvided
  | FundingSourceAccount
  | FundingSourceAlreadyExists
  | InvalidAccountNumber
  | InvalidManualLink
  | InvalidRoutingNumber
  | PreviousFundingSourcePending
  | RdvVerificationRequired

export enum LinkProviderType {
  /** Spend provider type. */
  Spend = 'SPEND',
  /** Plaid provider type */
  Plaid = 'PLAID',
  /** Direct bank provider type. */
  DirectBank = 'DIRECT_BANK',
}

/** Attributes for a linked account created through Plaid Link */
export type LinkSessionInput = {
  /** The Authorization Code returned from the Authorization Server */
  authorizationCode: Scalars['String']
  /** Vendor session correlation id */
  linkSessionId?: Maybe<Scalars['String']>
  /** Financial Institution ID */
  financialInstitutionId: Scalars['String']
  /** Linked Account ID */
  linkedAccountId?: Maybe<Scalars['String']>
  /** Flag to determine if round-ups should be disabled */
  disableRoundUps?: Maybe<Scalars['Boolean']>
}

export enum LinkSessionLanguage {
  /** English */
  En = 'EN',
  /** Spanish */
  Es = 'ES',
  /** French */
  Fr = 'FR',
  /** Dutch */
  Nl = 'NL',
}

/** Returns a Link Token or Link URL for use with Account Linking. */
export type LinkSessionResult =
  | RawLinkSession
  | UnrecoverableLinkedAccountError
  | WebviewLinkSession

export type LockBankCardInput = {
  lockReason: BankCardTemporaryLockReason
}

export type LockBankCardPayload = {
  __typename?: 'LockBankCardPayload'
  bankCard?: Maybe<BankCard>
}

export type LoginRateLimitedException = {
  __typename?: 'LoginRateLimitedException'
  message: Scalars['String']
}

export type MakeInvestmentInput = {
  /** The amount of the investment */
  amount: Scalars['Float']
  /**
   * The type of the investment:
   * - `credit` if transferring from the funding source -> investment account
   * - `debit` if transferring from the investment account -> funding source
   */
  type: InvestmentTypes
  /**
   * ID of the investment account
   * If omitted, the user's basic investment account is used
   */
  investmentAccountId?: Maybe<Scalars['ID']>
  /**
   * ID of the funding source to fund the investment
   * If omitted, the user's primary funding source is used
   */
  fundingSourceId?: Maybe<Scalars['ID']>
}

export type MakeInvestmentPayload = {
  __typename?: 'MakeInvestmentPayload'
  id: Scalars['ID']
}

export type MalformedRecurringTransferException = {
  __typename?: 'MalformedRecurringTransferException'
  pathExceptions: RecurringTransferPathException[]
}

export enum MaritalStatus {
  /** User has never been married */
  Single = 'single',
  /** User is married currently */
  Married = 'married',
  /** User is no longer married due to legal separation */
  Divorced = 'divorced',
  /** User is no longer married due to death of spouse */
  Widowed = 'widowed',
}

export enum MaritalStatusType {
  Single = 'single',
  Married = 'married',
  Divorced = 'divorced',
  Widowed = 'widowed',
}

export type Market = {
  __typename?: 'Market'
  isOpen: Scalars['Boolean']
}

export type MarketReturn = {
  __typename?: 'MarketReturn'
  marketValue: MonetaryAmount
  percent: Scalars['Float']
}

/** Cannot open early account because the custodian is already at max */
export type MaxAccountsCreatedException = {
  __typename?: 'MaxAccountsCreatedException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type MfaMissingAuthAlert = AuthAlert & {
  __typename?: 'MfaMissingAuthAlert'
  userId: Scalars['ID']
  type: Scalars['String']
}

export type Milestone = {
  __typename?: 'Milestone'
  /** key that maps to client-defined milestone description */
  descriptionKey: Scalars['StringKey']
  /** optional destination label and deep link for milestone action */
  destination?: Maybe<Destination>
  /** key that maps to client-defined milestone details */
  detailsKey?: Maybe<Scalars['StringKey']>
  /** milestone education tip content */
  educationTip: EducationTip
  /** the first time the user completed the milestone */
  firstCompletedAt?: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  /** @deprecated No longer needed since the logo will be dynamically set based on milestone status. Use 'logo' instead */
  inactiveLogo?: Maybe<Image>
  /** the most recent time the user completed the milestone */
  lastCompletedAt?: Maybe<Scalars['DateTime']>
  /** logo that matches the milestone status */
  logo: Image
  /** descriptive identifier */
  name: Scalars['String']
  /** information the user's progress towards completion */
  progress: MilestoneProgress
  /** the user-specific status */
  status: MilestoneStatus
  /** the milestone category */
  theme: MilestoneTheme
  /** how many times the user completed this milestone */
  timesCompleted: Scalars['Int']
  /** how many account points the user has earned for this milestone so far */
  accountPoints: AccountPoints
  /** how many challenge points the user has earned for completing this milestone. The specific challenge is indicated by the ID */
  challengePoints?: Maybe<ChallengePointsEarned>
  /** whether or not this milestone can be completed more than once */
  isRepeatable: Scalars['Boolean']
  /** milestone rule enum which can be used for grouping and fetch string mappings */
  rule: MilestoneRuleType
}

export type MilestoneChallengePointsArgs = {
  challengeId: Scalars['ID']
}

export type MilestoneAccountLevelDefinition = {
  __typename?: 'MilestoneAccountLevelDefinition'
  /** image to display as the background when the level is active */
  activeBackground: Image
  /** image to display as the foreground when the level is active */
  activeForeground: Image
  /** level id, e.g. 3 */
  id: Scalars['Int']
  /** image to display as the background when the level is inactive */
  inactiveBackground: Image
  /** max points for the level. If min and max are the same value, there is no higher level */
  max: Scalars['Int']
  /** minimum points needed for the level */
  min: Scalars['Int']
}

export type MilestoneAchievementActionRule = {
  __typename?: 'MilestoneAchievementActionRule'
  actions: MilestoneAchievementActionType[]
  milestoneID: Scalars['ID']
}

export enum MilestoneAchievementActionType {
  ChallengePoints = 'CHALLENGE_POINTS',
  AnalyticsEvent = 'ANALYTICS_EVENT',
}

export type MilestoneByThemeFilterInput = {
  challengeId?: Maybe<Scalars['ID']>
  rule?: Maybe<MilestoneRuleType>
}

export type MilestoneChallenge = {
  __typename?: 'MilestoneChallenge'
  /** Static date label for when the challenge becomes inactive (NOTE: is relative to PST) */
  closingAt: Scalars['String']
  /** additional information about this challenge */
  details?: Maybe<Scalars['String']>
  /** Internal UTC timestamp. For display, use 'closingAt'instead */
  endsAt: Scalars['DateTime']
  /** optional deeplink to challenge FAQ */
  faqDeepLink?: Maybe<Scalars['URL']>
  id: Scalars['ID']
  /** optional logo for the challenge */
  logo?: Maybe<Image>
  /** number of milestones the user has completed for the challenge */
  milestonesCompleted: DiscreteMilestoneProgress
  /** descriptive identifier */
  name: Scalars['String']
  /** number of points the user has earned for the challenge. May be null if not applicable to the current challenge */
  pointsEarned?: Maybe<DiscreteMilestoneProgress>
  /** optional deeplink to official challenge rules */
  rulesDeepLink?: Maybe<Scalars['URL']>
  /** list of user milestones, grouped and ordered */
  groupedMilestones: MilestoneGroup[]
}

export type MilestoneChallengeDefinition = {
  __typename?: 'MilestoneChallengeDefinition'
  /** additional information about this challenge */
  details?: Maybe<Scalars['String']>
  /** what time the challenge becomes inactive */
  endsAt: Scalars['DateTime']
  id: Scalars['ID']
  /** optional logo for the challenge */
  logo?: Maybe<Image>
  /** the list of milestones this challenge is dependent on */
  milestones: MilestoneDefinition[]
  /** descriptive identifier */
  name: Scalars['String']
  /** what time the challenge becomes active */
  startsAt: Scalars['DateTime']
}

export type MilestoneChallengePointsRule = {
  __typename?: 'MilestoneChallengePointsRule'
  challengeID: Scalars['ID']
  /** legal copy about how points are earned */
  details: Scalars['String']
  /** specifies the max points that can be earned if the milestone is completed more than once */
  maxPointsAllowed: Scalars['Int']
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']
  /** summarized information about how points are earned */
  summary?: Maybe<Scalars['String']>
}

export type MilestoneDefinition = {
  __typename?: 'MilestoneDefinition'
  /** optional datetime arg required for some milestone rules (e.g. ACTIVE_CUSTOMER) */
  arg1DateTime?: Maybe<Scalars['DateTime']>
  /** optional integer arg required for some milestone rules (e.g. BALANCED_REACHED) */
  arg1Int?: Maybe<Scalars['Int']>
  id: Scalars['ID']
  /** optional logo used for inactive milestone states (e.g. LOCKED, NOT_STARTED) */
  inactiveLogo?: Maybe<Image>
  /** whether or not this milestone can be completed more than once */
  isRepeatable: Scalars['Boolean']
  /** default logo */
  logo: Image
  /** descriptive identifier */
  name: Scalars['String']
  /** the rule that determines how this milestone changes status */
  rule: MilestoneRule
  /** the milestone category */
  theme: MilestoneTheme
  accountPointsRule?: Maybe<AccountPointsRule>
  challengePointsRule?: Maybe<MilestoneChallengePointsRule>
}

export type MilestoneDefinitionChallengePointsRuleArgs = {
  challengeId: Scalars['ID']
}

export type MilestoneGroup = MilestoneRuleGroup | MilestoneThemeGroup

export type MilestoneHub = {
  __typename?: 'MilestoneHub'
  /** static list of min and max values for each account level */
  levelDefinitions: MilestoneAccountLevelDefinition[]
  userAccount: MilestoneHubAccount
  /** list of user milestones, grouped and ordered */
  groupedMilestones: MilestoneGroup[]
}

export type MilestoneHubAccount = {
  __typename?: 'MilestoneHubAccount'
  /**
   * shows progress of points earned vs points needed to move to the next level.
   * NOTE: the currentInt can exceed the targetInt if the user is at the highest level
   */
  accountPointsProgress: DiscreteMilestoneProgress
  /** current level achieved */
  currentLevel: Scalars['Int']
  /** shows progress of milestones completed vs milestones available */
  milestoneProgress: DiscreteMilestoneProgress
}

export type MilestoneProgress =
  | CurrencyMilestoneProgress
  | DiscreteMilestoneProgress

/** defines how a milestone is completed */
export type MilestoneRule = {
  __typename?: 'MilestoneRule'
  /** denotes if an argument input needs to be provided for the creation of a MilestoneDefinition */
  argInput: MilestoneRuleArgInput
  id: Scalars['ID']
  /** the rule name */
  name: Scalars['String']
  /** the milestone supported themes */
  themes: MilestoneTheme[]
}

export enum MilestoneRuleArgInput {
  Int = 'INT',
  Datetime = 'DATETIME',
  None = 'NONE',
}

export type MilestoneRuleGroup = {
  __typename?: 'MilestoneRuleGroup'
  contents: MilestoneRuleGroupContent[]
  descriptionKey: Scalars['StringKey']
  groupCompletion: DiscreteMilestoneProgress
  logo: Image
  nameKey: Scalars['StringKey']
  rule: MilestoneRuleType
}

export type MilestoneRuleGroupContent = Milestone

export enum MilestoneRuleType {
  ActiveCustomer = 'ACTIVE_CUSTOMER',
  Signup = 'SIGNUP',
  CardActivation = 'CARD_ACTIVATION',
  FirstInvestment = 'FIRST_INVESTMENT',
  SmartDepositCompleted = 'SMART_DEPOSIT_COMPLETED',
  RewardCreated = 'REWARD_CREATED',
  RecurringInvestmentMonthly = 'RECURRING_INVESTMENT_MONTHLY',
  BalanceReached = 'BALANCE_REACHED',
  RealtimeRoundup = 'REALTIME_ROUNDUP',
  Roundup = 'ROUNDUP',
}

export enum MilestoneStatus {
  Locked = 'LOCKED',
  NotStarted = 'NOT_STARTED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
}

export enum MilestoneTheme {
  Invest = 'INVEST',
  Spend = 'SPEND',
  Later = 'LATER',
  Early = 'EARLY',
  Earn = 'EARN',
  Acorns = 'ACORNS',
}

export type MilestoneThemeGroup = {
  __typename?: 'MilestoneThemeGroup'
  contents: MilestoneThemeGroupContent[]
  groupCompletion: DiscreteMilestoneProgress
  groupPointsProgress?: Maybe<DiscreteMilestoneProgress>
  isLocked: Scalars['Boolean']
  theme: MilestoneTheme
}

export type MilestoneThemeGroupContent = MilestoneRuleGroup | Milestone

/** Miscellaneous document requested. */
export type MiscDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'MiscDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Cannot open early account because the beneficiary does not have an SSN */
export type MissingBeneficiarySsnException = {
  __typename?: 'MissingBeneficiarySsnException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** The user needs to attach a funding source to close their early account */
export type MissingFundingSourceException = {
  __typename?: 'MissingFundingSourceException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** The given beneficiary does not have an associated SSN. */
export type MissingSsnBeneficiaryAlert = Alert & {
  __typename?: 'MissingSsnBeneficiaryAlert'
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary
  /**
   * Internal ID of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  beneficiaryId: Scalars['ID']
  /**
   * First name of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  firstName: Scalars['String']
  /** @deprecated The type of the alert is defined by the gql type. */
  type: Scalars['String']
  userId: Scalars['ID']
}

/** The given beneficiary does not have an associated SSN. */
export type MissingSsnBeneficiaryAlertItem = UserAlertsItem & {
  __typename?: 'MissingSsnBeneficiaryAlertItem'
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** modal */
export type Modal = {
  __typename?: 'Modal'
  body: Scalars['String']
  /** offer campaign id */
  campaignId?: Maybe<Scalars['ID']>
  /** list of actions */
  cta: Cta[]
  logo?: Maybe<Image>
  title: Scalars['String']
  /** modal type */
  type: ModalType
}

export enum ModalType {
  /** about */
  About = 'about',
  /** clear input fields */
  Clear = 'clear',
  /** error notification */
  Error = 'error',
  /** privacy notice */
  HeadsUp = 'heads_up',
  /** highlights a specific provider */
  Quote = 'quote',
}

export type MonetaryAmount = {
  __typename?: 'MonetaryAmount'
  currency: Currency
  value: Scalars['Float']
}

/** A monetrary reward that will be provided to a subscriber in some fashion. */
export type MonetaryIncentive = Incentive & {
  __typename?: 'MonetaryIncentive'
  /** Amount of the monetary reward. */
  amount: CurrencyAmount
  copyKey?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  id: Scalars['ID']
  /** Is the monetary reward recurring. */
  recurring: Scalars['Boolean']
  /** Total amount of the reward if recurring. */
  totalAmount: CurrencyAmount
  /**
   * Arbitrary string denoting to fulfillment processes how monetary
   * reward should be provided to a subscriber.
   *
   * Ex. "INVESTMENT"
   */
  type: Scalars['String']
  updatedAt?: Maybe<Scalars['DateTime']>
}

/** Mutation object */
export type Mutation = {
  __typename?: 'Mutation'
  /** @deprecated Use Mutation.authenticate instead */
  createSession?: Maybe<Session>
  /** @deprecated Implicit cookie auth no longer supported. */
  destroySession?: Maybe<Scalars['Void']>
  changePassword?: Maybe<Scalars['Void']>
  changePIN?: Maybe<Scalars['Void']>
  resetPassword?: Maybe<Scalars['Void']>
  resetPIN?: Maybe<Scalars['Void']>
  updateNotification?: Maybe<Scalars['Void']>
  agreeToAcceptanceDocument?: Maybe<Scalars['Void']>
  setPortfolio: User
  requestAccountClosure?: Maybe<Scalars['Void']>
  /** @deprecated Use Mutation.suspendUserDeposits or Mutation.unsuspendUserDeposits instead */
  suspendDeposits?: Maybe<Scalars['Void']>
  linkACHAccount?: Maybe<Scalars['Void']>
  connectACHAccount: ConnectAchAccountResult
  submitRDVs: Scalars['Boolean']
  redeemGiftcard?: Maybe<Scalars['Void']>
  sessionRefresh?: Maybe<Session>
  /** @deprecated Implicit cookie auth no longer supported. */
  refreshCookie?: Maybe<Scalars['Void']>
  createExtensionTransaction?: Maybe<TransactionResult>
  updateExtensionTransaction?: Maybe<TransactionResult>
  makeInvestment: MakeInvestmentPayload
  /** @deprecated Use scheduleRecurringTransfer instead. */
  updateRecurringInvestment: RecurringInvestmentPayload
  /** @deprecated Use cancelRecurringTransfer instead. */
  stopRecurringInvestment: RecurringInvestmentPayload
  createLadderQuote?: Maybe<LadderResponse>
  updateLadderQuote?: Maybe<LadderResponse>
  connectLadderCustomer?: Maybe<LadderLinkResponse>
  /** @deprecated Never implemented. */
  createRollover?: Maybe<PdfFormLinks>
  /** @deprecated Never implemented. */
  createTransfer?: Maybe<PdfFormLinks>
  /** @deprecated Never implemented. */
  submitSignature?: Maybe<PdfFormLinks>
  createInvestmentAccount?: Maybe<CreateInvestmentAccountResponse>
  createIRAWithProfile?: Maybe<CreateInvestmentAccountResponse>
  createLaterContribution?: Maybe<Scalars['Void']>
  laterTotalLiquidation?: Maybe<Scalars['Void']>
  laterCreateIndividualBeneficiary?: Maybe<LaterIndividualBeneficiaryResponse>
  createUser?: Maybe<Session>
  updateContactInfo?: Maybe<User>
  updateEmail?: Maybe<User>
  updateEmployment?: Maybe<User>
  updateInvestorQuestions?: Maybe<User>
  updatePersonalInfo?: Maybe<User>
  updateUserInfo?: Maybe<UpdateUserInfoResult>
  updateSecurityQuestion?: Maybe<User>
  completeRegistration?: Maybe<User>
  /** Create a beneficiary */
  createBeneficiary: CreateBeneficiaryResult
  /** Deactivates the specified account and returns the newley deactived account. */
  deactivateAccount?: Maybe<Account>
  /** Deactivate a beneficiary that is no longer used */
  deactivateBeneficiary: DeactivateBeneficiaryResult
  /** Update a beneficiary's SSN/TIN */
  setBeneficiarySsn: SetBeneficiarySsnResult
  /** Update a single address for a user */
  updateAddress?: Maybe<Address>
  /** Update a beneficiary's basic info */
  updateBeneficiaryInfo: UpdateBeneficiaryInfoResult
  /** Update a single profile for a user */
  updateProfile?: Maybe<Profile>
  /** Update a certificate or card signature for a user */
  updateSignature?: Maybe<Signature>
  activateBankCard?: Maybe<ActivateBankCardPayload>
  createBankAccount?: Maybe<CreateBankAccountPayload>
  lockBankCard?: Maybe<LockBankCardPayload>
  orderBankCard?: Maybe<OrderBankCardResult>
  unlockBankCard?: Maybe<UnlockBankCardPayload>
  updateBankCardPin?: Maybe<UpdateBankCardPinPayload>
  reportBankCardLostStolen?: Maybe<ReportBankCardLostStolenPayload>
  deleteExpiredBankCardOrder?: Maybe<DeleteExpiredBankCardOrderResult>
  closeBankAccount: CloseBankAccountResult
  reissueBankCard?: Maybe<ReissueBankCardResult>
  submitSpendTransactionsDispute: SpendTransactionsDisputeResult
  /** Assign a linked subaccount to a role (i.e. funding source) */
  assignLinkedSubaccount?: Maybe<LinkedSubaccount>
  /** Create a linked account */
  createPlaidLinkedAccount?: Maybe<LinkedAccount>
  /** Generate a Link Token and return either the Link Token of Link URL for use with Account Linking. */
  generateLinkSession: LinkSessionResult
  /** Save a linked account */
  registerLinkSession?: Maybe<RegisterLinkSessionResult>
  /** Updates a plaid account with a new linking error code. Returns the updated linked account. */
  setLinkingError?: Maybe<LinkedAccount>
  /** Unlink account and all attached subaccounts */
  unlinkLinkedAccount?: Maybe<LinkedAccount>
  /** Updates a plaid account with a new link session id. To be used after re-authenticating a linked account */
  updateLinkedAccount?: Maybe<LinkedAccount>
  /** Update a single round up profile for a user */
  roundUpProfile?: Maybe<RoundUpProfile>
  /** Set the manual flag to true on a round up */
  setManualRoundUps: RoundUp[]
  /** Update a single Round Up Account for a given ID */
  updateRoundUpAccount?: Maybe<RoundUpAccount>
  initiateTransfer?: Maybe<InitiateTransferPayload>
  cancelTransfer?: Maybe<CancelTransferPayload>
  startCheckDeposit?: Maybe<StartCheckDepositPayload>
  uploadCheck?: Maybe<UploadCheckPayload>
  completeCheckDeposit?: Maybe<CompleteCheckDepositPayload>
  /** @deprecated Replaced with createSupportTicketOrException mutation. */
  createSupportTicket?: Maybe<SupportTicket>
  createSupportTicketOrException?: Maybe<SupportTicketResponse>
  createAuthenticatedSupportTicket?: Maybe<SupportTicket>
  createSupportTicketWithCustomFields?: Maybe<SupportTicketWithCustomFieldsResponse>
  /** Get Pinwheel Link Token */
  createDirectDepositLinkInfo: CreateDirectDepositLinkInfoSwitch
  /** Add a direct deposit employer */
  startAcornsPdfSwitch?: Maybe<Scalars['Boolean']>
  /** Persists a user intention of perform an online switch. */
  startOnlineSwitch: StartOnlineSwitchPayload
  /** Submits a direct deposit switch via ClickSwitch */
  startSubmittableSwitch?: Maybe<StartSubmittableSwitchPayload>
  /** Update a user's suitability */
  updateSuitability?: Maybe<Suitability_UpdateSuitabilityResult>
  cancelCheckPayment?: Maybe<CancelCheckPaymentResult>
  sendCheckPayment?: Maybe<SendCheckPaymentResult>
  /** Accept an acceptance document with a signature and date */
  acceptDocument: AcceptDocumentResponse
  /** Add a Self Directed Portfolio */
  addSelfDirectedPortfolio: AddSelfDirectedPortfolioResult
  /** Cancel pending investment */
  cancelInvestment: CancelInvestmentResult
  /** Cancel an existing account closure request */
  cancelInvestmentAccountClosureRequest: CancelInvestmentAccountClosureRequestResult
  /** Start the account closure process for the specified investment account */
  closeInvestmentAccount: CloseInvestmentAccountResult
  /** Close an open Acorns user account */
  closeUserAccount: CloseUserAccountResult
  /** Create a Prospect User */
  createProspectUser: CreateProspectUserResult
  /** Legacy document upload */
  legacyUploadDocument: LegacyUploadDocumentResult
  /** Link a funding source via account and routing number */
  linkManualFundingSource: LinkManualFundingSourceResult
  /** Open a Core InvestmentAccount */
  openCoreInvestmentAccount: OpenCoreInvestmentAccountResult
  /** Create an Acorns Early Account */
  openEarlyAccount: OpenEarlyAccountResult
  /** Link a funding source via partner account token */
  partnerLinkManualFundingSource: PartnerLinkFundingSourceResult
  /** Reopen a closed Acorns user account */
  reopenUserAccount: ReopenUserAccountResult
  /** Attempts to close a single or multiple Early investment accounts */
  requestEarlyAccountClosure: RequestEarlyAccountClosureResult[]
  /** Attempts to reopen an investment account. */
  requestInvestmentAccountReopen: RequestInvestmentAccountReopenResult
  /** Suspend user deposits */
  suspendUserDeposits: Scalars['Void']
  /** Unsuspend user deposits */
  unsuspendUserDeposits: Scalars['Void']
  /** Updates Account Portfolio */
  updateAccountPortfolio: UpdateAccountPortfolioResponse
  /** Update the securities and target allocation percentages of the portfolio */
  updatePortfolioSecurities: UpdatePortfolioSecuritiesResult
  /** Updates a registration record */
  updateRegistration: Result
  initiateLaterProgramAccountContribution?: Maybe<LaterProgramAccountContributionResult>
  /**
   * Make a withdrawal from a later account
   * One of either earlyDistributionTaxExceptionReason or reason is required; reason is newer/preferred
   * withdrawalType is no longer supported, since it can be derived
   */
  laterWithdrawal?: Maybe<Scalars['Void']>
  /**  Returns the tax withholding amounts for state and federal */
  taxWithholdingAmounts?: Maybe<TaxWithholdingAmounts>
  /**  Verify and create a later account */
  verifyLaterAccountOrError: LaterAccountInfoOrError
  scheduleRecurringTransfer?: Maybe<ScheduleRecurringTransferResult>
  cancelRecurringTransfer?: Maybe<CancelRecurringTransferResult>
  /** Apply a life quote for a given user/provider name */
  protectApplyLifeQuote?: Maybe<LifeQuoteResponse>
  /** Create a life quote for a given user/provider name */
  protectCreateLifeQuote?: Maybe<LifeQuoteResponse>
  /** Update user coverage for a given user/insurance type */
  protectUpdateCoverage?: Maybe<UpdateCoverageResponse>
  /** Update user calculation response for a given user/insurance type */
  protectUpdateRecommendedLifeCoverage?: Maybe<UpdateRecommendedCoverageResponse>
  /** Update all onboarding responses for a given user */
  protectUpdateResponses?: Maybe<ProtectHome>
  /** Record an action feed event */
  feedEvent?: Maybe<ActionFeedEventResponse>
  addFavoritePartnerOffers: FavoritePartnerOfferGroup
  removeFavoritePartnerOffers: FavoritePartnerOfferGroup
  setFavoritePartnerOffers: FavoritePartnerOfferGroup
  createJobAlert?: Maybe<CreateJobAlertResult>
  removeJobAlert?: Maybe<RemoveJobAlertResult>
  addActionToMilestoneAchievementActionRule: AddActionToMilestoneAchievementActionRuleResult
  createMilestoneAchievementActionRule: CreateMilestoneAchievementActionRuleResult
  createAccountPointsRule: CreateAccountPointsRuleResult
  updateAccountPointsRule: UpdateAccountPointsRuleResult
  createMilestoneAccountLevelDefinition: CreateMilestoneAccountLevelDefinitionResult
  updateMilestoneAccountLevelDefinition: UpdateMilestoneAccountLevelDefinitionResult
  uploadDocuments: FileOrException[]
  uploadUnsolicitedDocuments: FileOrException[]
  createDocumentUpload: CreateDocumentUpload
  /** Initiate registration of a PhoneAuthenticator. */
  initiateSMSChallenge: InitiateSmsChallengeResult
  /** Initiate registration of an EmailAuthenticator. */
  initiateEmailChallenge: InitiateEmailChallengeResult
  /** Re-initiate registration of an Authenticator. */
  reinitiateChallenge: ReinitiateSmsChallengeResult
  /** Register a PhoneAuthenticator. */
  registerPhoneAuthenticator: RegisterPhoneAuthenticatorResult
  /** Register an EmailAuthenticator. */
  registerEmailAuthenticator: RegisterEmailAuthenticatorResult
  /** Request an AuthSession for the provided credentials. */
  authenticate: AuthenticateResult
  setDefaultAuthenticator: SetDefaultAuthenticatorResult
  /** user registration */
  registerUser: RegisterUserResult
  /** password reset request */
  passwordResetRequest?: Maybe<Scalars['Void']>
  /** verifyDevice */
  verifyDevice: VerifyDeviceResult
  /** blockDevice */
  blockDevice: BlockDeviceResult
  /** unblockDevice */
  unblockDevice: UnblockDeviceResult
  /** setAuthenticationPIN */
  setAuthenticationPIN: SetAuthenticationPinResult
  /** verifyPasswords */
  verifyPasswords: VerifyPasswordsResult
  /** updateCredentials */
  updateCredentials: UpdateCredentialsResult
  /**
   * Apply a promotion to an existing subscription. May entitle a subscriber to
   * promotional pricing for their subscription and/or additional incentives.
   */
  applyPromotion: ApplyPromotionResult
  /** Deactivate a user's subscription */
  deactivateTierSubscription: DeactivateTierSubscriptionResult
  /** Request to be waived from being migrated to a new Subscription. */
  requestSubscriptionMigrationWaiver: RequestSubscriptionMigrationWaiverResult
  /** Eventually will replace the current 'subscribeUserToTier' mutation */
  subscribeToTier: SubscribeToTierResult
  /**
   * Attempt to subscribe a user to a specific Tier + TierPrice
   * Reliant on some synchronous calls to service (for statuses)
   */
  subscribeUserToTier: SubscribeUserToTierResult
  /**
   * Subscribes a user to the cheapest default tier based on their current open accounts
   * @deprecated Will be removed soon in-favor-of the more generic Mutation.subscribeUserToTier.
   */
  subscribeUserToTierByOpenAccounts: TierSubscription
  /**
   * Subscribes a user to the cheapest default tier available with provided productKey
   * @deprecated Will be removed soon in-favor-of the more generic Mutation.subscribeUserToTier.
   */
  subscribeUserToTierByProductKey: TierSubscription
  /** Unsubscribes a user to from their current tier */
  unsubscribeUserFromTier: UnsubscribeUserFromTierResult
  enterEvent: EnterEventResult
  enterSweepstakes: EnterSweepstakesResult
  splitDepositSettings: SplitDepositSettingsMutation
  splitDeposit: SplitDepositMutation
  configureSplitDepositDirectDepositIntentSetting?: Maybe<ConfigureSplitDepositDirectDepositIntentSettingResult>
  configureSplitDepositDirectDepositSetting?: Maybe<ConfigureSplitDepositDirectDepositSettingResult>
  /** Change the amount of an outside contribution payment intent */
  changeOutsideContributionAmount: ChangeOutsideContributionAmountResult
  /** Create a new Outside Contribution */
  createOutsideContribution: CreateOutsideContributionResult
  /** Generate outside contribution payment token */
  createOutsideContributionCheckoutCart: CreateOutsideContributionCheckoutCartResult
  authenticateForFeeNegotiation: AuthenticateForFeeNegotiationResult
  authenticateForFeeNegotiationChallengeMethod: AuthenticateNegotiationStatusResult
  authenticateForFeeNegotiationChallenge: AuthenticateNegotiationStatusResult
  submitBankFeeNegotiation: SubmitBankFeeNegotiationResult
}

/** Mutation object */
export type MutationCreateSessionArgs = {
  email: Scalars['String']
  password: Scalars['String']
  longSession?: Maybe<Scalars['Boolean']>
  captchaToken?: Maybe<Scalars['String']>
}

/** Mutation object */
export type MutationChangePasswordArgs = {
  oldPassword: Scalars['String']
  newPassword: Scalars['String']
  securityAnswer: SecurityAnswer
}

/** Mutation object */
export type MutationChangePinArgs = {
  oldPIN: Scalars['String']
  newPIN: Scalars['String']
  questionId: Scalars['String']
  answer: Scalars['String']
}

/** Mutation object */
export type MutationResetPasswordArgs = {
  email: Scalars['String']
}

/** Mutation object */
export type MutationResetPinArgs = {
  email: Scalars['String']
}

/** Mutation object */
export type MutationUpdateNotificationArgs = {
  channel: Scalars['String']
  category?: Maybe<Scalars['String']>
  subcategory?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  active: Scalars['Boolean']
  uuid?: Maybe<Scalars['ID']>
}

/** Mutation object */
export type MutationAgreeToAcceptanceDocumentArgs = {
  id: Scalars['ID']
}

/** Mutation object */
export type MutationSetPortfolioArgs = {
  input: SetPortfolioInput
}

/** Mutation object */
export type MutationRequestAccountClosureArgs = {
  input: RequestAccountClosureInput
}

/** Mutation object */
export type MutationSuspendDepositsArgs = {
  suspended: Scalars['Boolean']
}

/** Mutation object */
export type MutationLinkAchAccountArgs = {
  routing: Scalars['String']
  account: Scalars['String']
}

/** Mutation object */
export type MutationConnectAchAccountArgs = {
  input: ConnectAchAccountInput
}

/** Mutation object */
export type MutationSubmitRdVsArgs = {
  deposits: Array<Maybe<Scalars['Float']>>
}

/** Mutation object */
export type MutationRedeemGiftcardArgs = {
  pin: Scalars['String']
}

/** Mutation object */
export type MutationSessionRefreshArgs = {
  pin: Scalars['String']
  longSession?: Maybe<Scalars['Boolean']>
}

/** Mutation object */
export type MutationCreateExtensionTransactionArgs = {
  campaignId: Scalars['String']
  salesAmount?: Maybe<Scalars['Float']>
}

/** Mutation object */
export type MutationUpdateExtensionTransactionArgs = {
  id: Scalars['String']
  status: Scalars['String']
}

/** Mutation object */
export type MutationMakeInvestmentArgs = {
  input: MakeInvestmentInput
}

/** Mutation object */
export type MutationUpdateRecurringInvestmentArgs = {
  input: RecurringInvestmentInput
}

/** Mutation object */
export type MutationStopRecurringInvestmentArgs = {
  investmentAccountId?: Maybe<Scalars['String']>
}

/** Mutation object */
export type MutationCreateLadderQuoteArgs = {
  firstName: Scalars['String']
  lastName: Scalars['String']
  age: Scalars['Int']
  email: Scalars['String']
  phone: Scalars['String']
  address: Scalars['String']
  city: Scalars['String']
  state: StateCode
  zip: Scalars['String']
}

/** Mutation object */
export type MutationUpdateLadderQuoteArgs = {
  quoteId: Scalars['ID']
  coverage: Scalars['Int']
}

/** Mutation object */
export type MutationConnectLadderCustomerArgs = {
  quoteId: Scalars['ID']
}

/** Mutation object */
export type MutationCreateRolloverArgs = {
  custodianName: Scalars['String']
  custodianId?: Maybe<Scalars['ID']>
  custodianAddress?: Maybe<CustodianAddressInput>
  custodianPhone?: Maybe<Scalars['String']>
  accountBalance: Scalars['Float']
}

/** Mutation object */
export type MutationCreateTransferArgs = {
  custodianName: Scalars['String']
  custodianId?: Maybe<Scalars['ID']>
  custodianAddress?: Maybe<CustodianAddressInput>
  custodianPhone?: Maybe<Scalars['String']>
  accountBalance: Scalars['Float']
}

/** Mutation object */
export type MutationSubmitSignatureArgs = {
  signature: Scalars['String']
  statement?: Maybe<Scalars['String']>
}

/** Mutation object */
export type MutationCreateInvestmentAccountArgs = {
  iraType?: Maybe<InvestmentAccountTypes>
}

/** Mutation object */
export type MutationCreateIraWithProfileArgs = {
  iraType?: Maybe<InvestmentAccountTypes>
  profileAttributes: Array<Maybe<ProfileAttribute>>
}

/** Mutation object */
export type MutationCreateLaterContributionArgs = {
  accountId: Scalars['ID']
  amount: Scalars['Float']
  year?: Maybe<Scalars['Int']>
}

/** Mutation object */
export type MutationLaterTotalLiquidationArgs = {
  investmentAccountId: Scalars['ID']
  input?: Maybe<LaterTotalLiquidationInput>
}

/** Mutation object */
export type MutationLaterCreateIndividualBeneficiaryArgs = {
  accountId: Scalars['ID']
  firstName: Scalars['String']
  lastName: Scalars['String']
  percentageShare?: Maybe<Scalars['Float']>
  birthDate: Scalars['DateTime']
  ssn?: Maybe<Scalars['String']>
  relationship?: Maybe<Scalars['String']>
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  zip?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
}

/** Mutation object */
export type MutationCreateUserArgs = {
  input: CreateUserInput
}

/** Mutation object */
export type MutationUpdateContactInfoArgs = {
  input: ContactInfoInput
}

/** Mutation object */
export type MutationUpdateEmailArgs = {
  email: Scalars['String']
}

/** Mutation object */
export type MutationUpdateEmploymentArgs = {
  input: EmploymentInput
}

/** Mutation object */
export type MutationUpdateInvestorQuestionsArgs = {
  input: InvestorQuestionsInput
}

/** Mutation object */
export type MutationUpdatePersonalInfoArgs = {
  input: PersonalInfoInput
}

/** Mutation object */
export type MutationUpdateUserInfoArgs = {
  input: PersonalInfoInput
}

/** Mutation object */
export type MutationUpdateSecurityQuestionArgs = {
  input: SecurityQuestionInput
}

/** Mutation object */
export type MutationCreateBeneficiaryArgs = {
  input: BeneficiaryInput
}

/** Mutation object */
export type MutationDeactivateAccountArgs = {
  accountId: Scalars['ID']
}

/** Mutation object */
export type MutationDeactivateBeneficiaryArgs = {
  id: Scalars['ID']
}

/** Mutation object */
export type MutationSetBeneficiarySsnArgs = {
  id: Scalars['ID']
  ssn: Scalars['String']
}

/** Mutation object */
export type MutationUpdateAddressArgs = {
  addressType: AddressType
  input: AddressInput
  ownerId?: Maybe<Scalars['ID']>
}

/** Mutation object */
export type MutationUpdateBeneficiaryInfoArgs = {
  id: Scalars['ID']
  input: BeneficiaryInfoInput
}

/** Mutation object */
export type MutationUpdateProfileArgs = {
  input: ProfileInput
}

/** Mutation object */
export type MutationUpdateSignatureArgs = {
  signatureType: SignatureType
  svgFile: Scalars['String']
}

/** Mutation object */
export type MutationActivateBankCardArgs = {
  input: ActivateBankCardInput
}

/** Mutation object */
export type MutationCreateBankAccountArgs = {
  input: CreateBankAccountInput
}

/** Mutation object */
export type MutationLockBankCardArgs = {
  input: LockBankCardInput
}

/** Mutation object */
export type MutationOrderBankCardArgs = {
  input: OrderBankCardInput
}

/** Mutation object */
export type MutationUpdateBankCardPinArgs = {
  input: UpdateBankCardPinInput
}

/** Mutation object */
export type MutationReportBankCardLostStolenArgs = {
  input: ReportBankCardLostStolenInput
}

/** Mutation object */
export type MutationCloseBankAccountArgs = {
  input: CloseBankAccountInput
}

/** Mutation object */
export type MutationReissueBankCardArgs = {
  input: ReissueBankCardInput
}

/** Mutation object */
export type MutationSubmitSpendTransactionsDisputeArgs = {
  input: SubmitSpendTransactionsDisputeInput
}

/** Mutation object */
export type MutationAssignLinkedSubaccountArgs = {
  linkedSubaccountId: Scalars['ID']
  input: AssignLinkedSubaccountInput
}

/** Mutation object */
export type MutationCreatePlaidLinkedAccountArgs = {
  publicToken: Scalars['String']
  input: CreatePlaidLinkedAccountInput
}

/** Mutation object */
export type MutationGenerateLinkSessionArgs = {
  userId?: Maybe<Scalars['ID']>
  input: GenerateLinkSessionInput
}

/** Mutation object */
export type MutationRegisterLinkSessionArgs = {
  input: LinkSessionInput
}

/** Mutation object */
export type MutationSetLinkingErrorArgs = {
  linkedAccountId: Scalars['ID']
  linkingErrorCode: SetLinkingErrorInput
}

/** Mutation object */
export type MutationUnlinkLinkedAccountArgs = {
  linkedAccountId: Scalars['ID']
}

/** Mutation object */
export type MutationUpdateLinkedAccountArgs = {
  linkedAccountId: Scalars['ID']
  input: UpdateLinkedAccountInput
}

/** Mutation object */
export type MutationRoundUpProfileArgs = {
  input: RoundUpProfileInput
}

/** Mutation object */
export type MutationSetManualRoundUpsArgs = {
  roundUpIds: Array<Scalars['ID']>
}

/** Mutation object */
export type MutationUpdateRoundUpAccountArgs = {
  enabled: Scalars['Boolean']
  linkedSubaccountId: Scalars['ID']
}

/** Mutation object */
export type MutationInitiateTransferArgs = {
  input: InitiateTransferInput
}

/** Mutation object */
export type MutationCancelTransferArgs = {
  id: Scalars['ID']
  accountId: Scalars['ID']
}

/** Mutation object */
export type MutationStartCheckDepositArgs = {
  input: StartCheckDepositInput
}

/** Mutation object */
export type MutationUploadCheckArgs = {
  input: UploadCheckInput
}

/** Mutation object */
export type MutationCompleteCheckDepositArgs = {
  input: CompleteCheckDepositInput
}

/** Mutation object */
export type MutationCreateSupportTicketArgs = {
  input: CreateSupportTicketInput
}

/** Mutation object */
export type MutationCreateSupportTicketOrExceptionArgs = {
  input: CreateSupportTicketInput
}

/** Mutation object */
export type MutationCreateAuthenticatedSupportTicketArgs = {
  input: CreateSupportTicketInput
}

/** Mutation object */
export type MutationCreateSupportTicketWithCustomFieldsArgs = {
  input: CreateCustomSupportTicketInput
}

/** Mutation object */
export type MutationCreateDirectDepositLinkInfoArgs = {
  input: CreateDirectDepositLinkInfoInput
}

/** Mutation object */
export type MutationStartAcornsPdfSwitchArgs = {
  input: StartAcornsPdfSwitchInput
}

/** Mutation object */
export type MutationStartOnlineSwitchArgs = {
  input: StartOnlineSwitchInput
}

/** Mutation object */
export type MutationStartSubmittableSwitchArgs = {
  input: StartSubmittableSwitchInput
}

/** Mutation object */
export type MutationUpdateSuitabilityArgs = {
  suitabilityInput: Suitability_SuitabilityInput[]
}

/** Mutation object */
export type MutationCancelCheckPaymentArgs = {
  id: Scalars['ID']
}

/** Mutation object */
export type MutationSendCheckPaymentArgs = {
  input: SendCheckPaymentInput
}

/** Mutation object */
export type MutationAcceptDocumentArgs = {
  input: AcceptDocumentInput
}

/** Mutation object */
export type MutationAddSelfDirectedPortfolioArgs = {
  input: AddSelfDirectedPortfolioInput
}

/** Mutation object */
export type MutationCancelInvestmentArgs = {
  input: CancelInvestmentInput
}

/** Mutation object */
export type MutationCancelInvestmentAccountClosureRequestArgs = {
  input: CancelInvestmentAccountClosureRequestInput
}

/** Mutation object */
export type MutationCloseInvestmentAccountArgs = {
  input: CloseInvestmentAccountInput
}

/** Mutation object */
export type MutationCreateProspectUserArgs = {
  input: CreateProspectUserInput
}

/** Mutation object */
export type MutationLegacyUploadDocumentArgs = {
  input: LegacyUploadDocumentInput
}

/** Mutation object */
export type MutationLinkManualFundingSourceArgs = {
  input: LinkManualFundingSourceInput
}

/** Mutation object */
export type MutationOpenCoreInvestmentAccountArgs = {
  input: OpenCoreInvestmentAccountInput
}

/** Mutation object */
export type MutationOpenEarlyAccountArgs = {
  input: OpenEarlyAccountInput
}

/** Mutation object */
export type MutationPartnerLinkManualFundingSourceArgs = {
  input: PartnerLinkFundingSourceInput
}

/** Mutation object */
export type MutationRequestEarlyAccountClosureArgs = {
  input: RequestEarlyAccountClosureInput
}

/** Mutation object */
export type MutationRequestInvestmentAccountReopenArgs = {
  input: RequestInvestmentAccountReopenInput
}

/** Mutation object */
export type MutationUpdateAccountPortfolioArgs = {
  input: UpdateAccountPortfolioInput
}

/** Mutation object */
export type MutationUpdatePortfolioSecuritiesArgs = {
  input: UpdatePortfolioSecuritiesInput
}

/** Mutation object */
export type MutationUpdateRegistrationArgs = {
  input: RegistrationInput
}

/** Mutation object */
export type MutationInitiateLaterProgramAccountContributionArgs = {
  input: LaterProgramAccountContributionInput
}

/** Mutation object */
export type MutationLaterWithdrawalArgs = {
  amount: Scalars['Float']
  earlyDistributionTaxExceptionReason?: Maybe<Scalars['String']>
  federalTaxes: Scalars['Float']
  investmentAccountId: Scalars['ID']
  reason?: Maybe<LaterWithdrawalReason>
  stateTaxes: Scalars['Float']
  taxYear: Scalars['Int']
  withdrawalType?: Maybe<LaterWithdrawalType>
}

/** Mutation object */
export type MutationTaxWithholdingAmountsArgs = {
  investmentId: Scalars['ID']
  totalSharesAmount: CurrencyAmountInput
}

/** Mutation object */
export type MutationVerifyLaterAccountOrErrorArgs = {
  investmentAccountId: Scalars['ID']
}

/** Mutation object */
export type MutationScheduleRecurringTransferArgs = {
  input: ScheduleRecurringTransferInput
}

/** Mutation object */
export type MutationCancelRecurringTransferArgs = {
  id: Scalars['ID']
}

/** Mutation object */
export type MutationProtectApplyLifeQuoteArgs = {
  quoteInput: LifeQuoteApplyInput
}

/** Mutation object */
export type MutationProtectCreateLifeQuoteArgs = {
  input: LifeQuoteInput
}

/** Mutation object */
export type MutationProtectUpdateCoverageArgs = {
  coverageResponse: CoverageResponse
}

/** Mutation object */
export type MutationProtectUpdateRecommendedLifeCoverageArgs = {
  calculatorInput: LifeCalculatorInput
}

/** Mutation object */
export type MutationProtectUpdateResponsesArgs = {
  questionResponses: QuestionResponse[]
}

/** Mutation object */
export type MutationFeedEventArgs = {
  feedEvent: ActionFeedEvent
}

/** Mutation object */
export type MutationAddFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput
}

/** Mutation object */
export type MutationRemoveFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput
}

/** Mutation object */
export type MutationSetFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput
}

/** Mutation object */
export type MutationCreateJobAlertArgs = {
  alertCriteria: JobAlertCriteriaInput
}

/** Mutation object */
export type MutationRemoveJobAlertArgs = {
  id: Scalars['String']
}

/** Mutation object */
export type MutationAddActionToMilestoneAchievementActionRuleArgs = {
  addActionToRuleInput: AddActionToMilestoneAchievementActionRuleInput
}

/** Mutation object */
export type MutationCreateMilestoneAchievementActionRuleArgs = {
  createRuleInput: CreateMilestoneAchievementActionRuleInput
}

/** Mutation object */
export type MutationCreateAccountPointsRuleArgs = {
  createAccountPointsRuleInput: CreateAccountPointsRuleInput
}

/** Mutation object */
export type MutationUpdateAccountPointsRuleArgs = {
  updateAccountPointsRuleInput: UpdateAccountPointsRuleInput
}

/** Mutation object */
export type MutationCreateMilestoneAccountLevelDefinitionArgs = {
  createLevelDefinitionInput: CreateMilestoneAccountLevelDefinitionInput
}

/** Mutation object */
export type MutationUpdateMilestoneAccountLevelDefinitionArgs = {
  updateLevelDefinitionInput: UpdateMilestoneAccountLevelDefinitionInput
}

/** Mutation object */
export type MutationUploadDocumentsArgs = {
  input: UploadDocumentsInput
}

/** Mutation object */
export type MutationUploadUnsolicitedDocumentsArgs = {
  input: UploadUnsolicitedDocumentsInput
}

/** Mutation object */
export type MutationCreateDocumentUploadArgs = {
  input: CreateDocumentUploadInput
}

/** Mutation object */
export type MutationInitiateSmsChallengeArgs = {
  input: InitiateSmsChallengeInput
}

/** Mutation object */
export type MutationInitiateEmailChallengeArgs = {
  input: InitiateEmailChallengeInput
}

/** Mutation object */
export type MutationReinitiateChallengeArgs = {
  input: ReinitiateSmsChallengeInput
}

/** Mutation object */
export type MutationRegisterPhoneAuthenticatorArgs = {
  input: RegisterPhoneAuthenticatorInput
  challengeAnswerInput: ChallengeAnswerInput
}

/** Mutation object */
export type MutationRegisterEmailAuthenticatorArgs = {
  input: RegisterEmailAuthenticatorInput
  challengeAnswerInput: ChallengeAnswerInput
}

/** Mutation object */
export type MutationAuthenticateArgs = {
  input: AuthenticateInput
  challengeAnswerInput?: Maybe<ChallengeAnswerInput>
  alternateAuthenticatorId?: Maybe<Scalars['ID']>
}

/** Mutation object */
export type MutationSetDefaultAuthenticatorArgs = {
  input: SetDefaultAuthenticatorInput
}

/** Mutation object */
export type MutationRegisterUserArgs = {
  input: RegisterUserInput
}

/** Mutation object */
export type MutationPasswordResetRequestArgs = {
  input: PasswordResetRequestInput
}

/** Mutation object */
export type MutationVerifyDeviceArgs = {
  input: VerifyDeviceInput
  challengeAnswerInput?: Maybe<ChallengeAnswerInput>
}

/** Mutation object */
export type MutationBlockDeviceArgs = {
  input: BlockDeviceInput
}

/** Mutation object */
export type MutationUnblockDeviceArgs = {
  input: UnblockDeviceInput
}

/** Mutation object */
export type MutationSetAuthenticationPinArgs = {
  input: SetAuthenticationPinInput
}

/** Mutation object */
export type MutationVerifyPasswordsArgs = {
  input: VerifyPasswordsInput
}

/** Mutation object */
export type MutationUpdateCredentialsArgs = {
  input: UserCredentialsInput
}

/** Mutation object */
export type MutationApplyPromotionArgs = {
  input: ApplyPromotionInput
}

/** Mutation object */
export type MutationDeactivateTierSubscriptionArgs = {
  input: DeactivateTierSubscriptionInput
}

/** Mutation object */
export type MutationRequestSubscriptionMigrationWaiverArgs = {
  input: RequestSubscriptionMigrationWaiverInput
}

/** Mutation object */
export type MutationSubscribeToTierArgs = {
  input: SubscribeToTierInput
}

/** Mutation object */
export type MutationSubscribeUserToTierArgs = {
  input: SubscribeUserToTierInput
}

/** Mutation object */
export type MutationSubscribeUserToTierByProductKeyArgs = {
  input?: Maybe<SubscribeUserToTierByProductKeyInput>
}

/** Mutation object */
export type MutationUnsubscribeUserFromTierArgs = {
  input?: Maybe<UnsubscribeUserFromTierInput>
}

/** Mutation object */
export type MutationEnterEventArgs = {
  input: EnterEventInput
}

/** Mutation object */
export type MutationEnterSweepstakesArgs = {
  input: EnterSweepstakesInput
}

/** Mutation object */
export type MutationSplitDepositSettingsArgs = {
  id: Scalars['ID']
  employerHidden?: Maybe<Scalars['Boolean']>
}

/** Mutation object */
export type MutationSplitDepositArgs = {
  id: Scalars['ID']
}

/** Mutation object */
export type MutationConfigureSplitDepositDirectDepositIntentSettingArgs = {
  input: ConfigureSplitDepositDirectDepositIntentSettingInput
}

/** Mutation object */
export type MutationConfigureSplitDepositDirectDepositSettingArgs = {
  input: ConfigureSplitDepositDirectDepositSettingInput
}

/** Mutation object */
export type MutationChangeOutsideContributionAmountArgs = {
  input: ChangeOutsideContributionAmountInput
}

/** Mutation object */
export type MutationCreateOutsideContributionArgs = {
  input: CreateOutsideContributionInput
}

/** Mutation object */
export type MutationCreateOutsideContributionCheckoutCartArgs = {
  input: CreateOutsideContributionCheckoutCartInput
}

/** Mutation object */
export type MutationAuthenticateForFeeNegotiationArgs = {
  input: AuthenticateForFeeNegotiationInput
}

/** Mutation object */
export type MutationAuthenticateForFeeNegotiationChallengeMethodArgs = {
  input: AuthenticateForFeeNegotiationChallengeMethodInput
}

/** Mutation object */
export type MutationAuthenticateForFeeNegotiationChallengeArgs = {
  input: AuthenticateForFeeNegotiationChallengeInput
}

/** Mutation object */
export type MutationSubmitBankFeeNegotiationArgs = {
  input: SubmitBankFeeNegotiationInput
}

/** The provided security percent is negative */
export type NegativeSecurityPercentError = {
  __typename?: 'NegativeSecurityPercentError'
  /** The security in question */
  securityId: Scalars['ID']
}

export type NegotiationServiceConnectionFailure = {
  __typename?: 'NegotiationServiceConnectionFailure'
  message: Scalars['String']
}

/** The next billing date for a user */
export type NextBillingDate = {
  __typename?: 'NextBillingDate'
  next_billing_date?: Maybe<Scalars['String']>
}

export type NextTransferDateResult =
  | RecurringTransferDate
  | MalformedRecurringTransferException

/** Cannot open early account because the beneficiary id is invalid */
export type NoBeneficiaryFoundException = {
  __typename?: 'NoBeneficiaryFoundException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** No Funding Source Alert. */
export type NoFundingSourceUserAlert = UserAlertsItem & {
  __typename?: 'NoFundingSourceUserAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** The user needs to close all other investment accounts before closing this account */
export type NonBasicAccountOpenException = {
  __typename?: 'NonBasicAccountOpenException'
  /** message */
  errorMessage?: Maybe<Scalars['String']>
}

export type Notification = {
  __typename?: 'Notification'
  category?: Maybe<Scalars['String']>
  subcategory?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  active: Scalars['Boolean']
}

export type Notifications = {
  __typename?: 'Notifications'
  emails?: Maybe<Array<Maybe<Notification>>>
  pushes?: Maybe<Array<Maybe<Notification>>>
}

/** Occupation that a user can select */
export type Occupation = {
  __typename?: 'Occupation'
  id: Scalars['ID']
  name: Scalars['String']
}

export type Offer = {
  __typename?: 'Offer'
  /**
   * Meta field enabling clients to delegate to the backend
   * more logic determining when it is valid to present the Offer.
   *
   * Examples: "SUBSCRIPTION_CANCELLATION", "PASSIONS_PRODUCT_EXPLORATION"
   */
  availableIn?: Maybe<Array<Scalars['String']>>
  /** The cohort of subscribers the Offer is available to (driven by the Offer type). */
  availableTo: OfferAvailability
  createdAt: Scalars['DateTime']
  /** Once subscribed to how long is the Offer valid for. */
  expiresAfter?: Maybe<OfferExpiration>
  expiresAt?: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  /** What the Offer entitles a subscriber access to. */
  offering: Offering
  /** Amount the subscriber agrees to pay for access to the Offer's offering. */
  price: OfferPrice
  /** URL to the terms and conditions of the Offer. */
  termsUrl: Scalars['URL']
  /** Indicates semantics of the Offer (generally whom it is available to and when). */
  type: OfferType
  updatedAt?: Maybe<Scalars['DateTime']>
}

export enum OfferAvailability {
  All = 'ALL',
  Cancelled = 'CANCELLED',
  Existing = 'EXISTING',
  New = 'NEW',
  None = 'NONE',
}

export type OfferExpiration = {
  __typename?: 'OfferExpiration'
  period: OfferExpirationPeriod
  value: Scalars['Int']
}

export enum OfferExpirationPeriod {
  Month = 'MONTH',
}

export enum OfferGroupsType {
  Category = 'CATEGORY',
  Ranked = 'RANKED',
}

/** An Offering is something that a subscriber subscribes to access to. */
export type Offering = Product | Tier

export type OfferLocation = {
  __typename?: 'OfferLocation'
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
}

export type OfferLocationInput = {
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
}

export type OfferPrice = {
  __typename?: 'OfferPrice'
  amount: CurrencyAmount
  type: OfferPriceType
}

export type OfferPriceInput = {
  amount: CurrencyAmountInput
  type: OfferPriceType
}

export enum OfferPriceType {
  Free = 'FREE',
  Monthly = 'MONTHLY',
}

export enum OfferType {
  Promotional = 'PROMOTIONAL',
  Standard = 'STANDARD',
}

export enum OnboardingStepType {
  /** basic */
  Basic = 'basic',
  /** binary question */
  BinaryQuestion = 'binary_question',
  /** binary question with skip option */
  BinaryQuestionWithSkip = 'binary_question_with_skip',
  /** informational */
  Informational = 'informational',
  /** multi choice */
  MultiChoice = 'multi_choice',
  /** success */
  Success = 'success',
}

export type OnboardingTipItem = {
  __typename?: 'OnboardingTipItem'
  body: Scalars['String']
  headline: Scalars['String']
  id: Scalars['ID']
  image: Image
  title: Scalars['String']
  type: OnboardingTipType
}

export type OnboardingTips = {
  __typename?: 'OnboardingTips'
  items: OnboardingTipItem[]
}

export enum OnboardingTipType {
  /** introduction */
  Intro = 'intro',
  /** feature */
  Feature = 'feature',
}

/** Online Switches are performed through the Employer's URL. */
export type OnlineSwitch = SwitchInterface & {
  __typename?: 'OnlineSwitch'
  source: SwitchSource
  type: SwitchType
  /** Employer URL */
  url: Scalars['String']
  vendorTargetId?: Maybe<Scalars['ID']>
}

/** Cannot close user account if user has open spend/investment accounts */
export type OpenAccountsException = {
  __typename?: 'OpenAccountsException'
  /** User's open account types */
  openAccountTypes?: Maybe<Array<Scalars['String']>>
}

/** Input for creating a Core InvestmentAccount */
export type OpenCoreInvestmentAccountInput = {
  /** ID of the portfolio for this investment account */
  portfolioId: Scalars['String']
}

/** Result from opening a Core InvestmentAccount */
export type OpenCoreInvestmentAccountResult =
  | CoreAccountAlreadyExistsException
  | InvalidPortfolioIdException
  | InvestmentAccount
  | InvestmentAccountCreationException
  | UserClosedException
  | UserNotFoundException

/** Input for creating an early investment account */
export type OpenEarlyAccountInput = {
  /** Name of investment account */
  investmentAccountName?: Maybe<Scalars['String']>
  /** Beneficiary ID */
  beneficiaryId: Scalars['ID']
  /** Termination age of the investment account */
  terminationAge: Scalars['Int']
  /** State in which to open the investment account (defaults to custodian's state) */
  stateCode?: Maybe<Scalars['String']>
}

/** Result from opening an Early Investment Account */
export type OpenEarlyAccountResult =
  | BeneficiaryAccountExistsException
  | CoreAccountClosedException
  | InternalErrorException
  | InvalidStateException
  | InvalidTerminationAgeException
  | InvestmentAccount
  | MaxAccountsCreatedException
  | MissingBeneficiarySsnException
  | NoBeneficiaryFoundException
  | UserClosedException
  | UserNotFoundException
  | UserNotVerifiedException

export enum OperationStage {
  ProcessingCredentials = 'PROCESSING_CREDENTIALS',
  AwaitingTfaOption = 'AWAITING_TFA_OPTION',
  ProcessingTfaOption = 'PROCESSING_TFA_OPTION',
  AwaitingTfaCode = 'AWAITING_TFA_CODE',
  ProcessingTfaCode = 'PROCESSING_TFA_CODE',
  AuthCompleted = 'AUTH_COMPLETED',
  AuthFailed = 'AUTH_FAILED',
}

export enum Order {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type OrderBankCardInput = {
  isDocumentsAccepted: Scalars['Boolean']
  prefundTransfer?: Maybe<BankCardPrefundTransfer>
  isReopen?: Maybe<Scalars['Boolean']>
  paymentProcessor?: Maybe<BankCardPaymentProcessor>
}

export type OrderBankCardResult = BankCardOrder

/** Outside contribution object */
export type OutsideContribution = TimestampsInterface & {
  __typename?: 'OutsideContribution'
  accountId: Scalars['ID']
  checkoutCart: OutsideContributionCheckoutCart
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  failureReason?: Maybe<Scalars['String']>
  id: Scalars['ID']
  investmentId?: Maybe<Scalars['ID']>
  note?: Maybe<Scalars['String']>
  noteAuthor?: Maybe<Scalars['String']>
  paymentMethodId: Scalars['ID']
  state: ContributionState
  transferRequestId?: Maybe<Scalars['ID']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** an outside contribution checkout cart object */
export type OutsideContributionCheckoutCart = TimestampsInterface & {
  __typename?: 'OutsideContributionCheckoutCart'
  code: OutsideContributionCode
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  feeAmount: Scalars['String']
  id: Scalars['ID']
  investmentAmount: Scalars['String']
  paymentIntentId: Scalars['ID']
  status: CheckoutCartStatus
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** Code for outside contribution */
export type OutsideContributionCode = TimestampsInterface & {
  __typename?: 'OutsideContributionCode'
  /** Unique code that has one-to-one relationship with investment Account */
  code: Scalars['String']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  investmentAccountId: Scalars['ID']
  recipientFirstName: Scalars['String']
  /** This is the id of who the contribution is going to. Most likely beneficiary id */
  recipientId: Scalars['ID']
  signupBonusUrl: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  url: Scalars['String']
  userId: Scalars['ID']
}

/** Object representing an outside contribution prospect */
export type OutsideContributionProspect = Prospect & {
  __typename?: 'OutsideContributionProspect'
  email: Scalars['String']
  id: Scalars['ID']
}

export type Owner = {
  __typename?: 'Owner'
  description?: Maybe<Scalars['String']>
  greyLogoImageUrl?: Maybe<Scalars['URL']>
  colorBackgroundLogoImageUrl?: Maybe<Scalars['URL']>
  id: Scalars['ID']
  imageUrl?: Maybe<Scalars['URL']>
  monochromeImageUrl?: Maybe<Scalars['URL']>
  name?: Maybe<Scalars['String']>
  slug?: Maybe<Scalars['String']>
  twitterHandle?: Maybe<Scalars['String']>
}

export enum PackageStatus {
  /** Not Found */
  NotFound = 'notFound',
  /** Found – No Status */
  NoStatus = 'noStatus',
  /** Logged at USPS */
  LoggedAtUsps = 'loggedAtUSPS',
  /** Customer Recall */
  CustomerRecall = 'customerRecall',
  /** Delivered */
  Delivered = 'delivered',
  /** Dead Letter */
  DeadLetter = 'deadLetter',
  /** Forwarded to New Address */
  ForwardedToNewAddress = 'forwardedToNewAddress',
  /** Scanned in Route */
  ScannedInRoute = 'scannedInRoute',
  /** Notice Left for Recipient */
  NoticeLeftForRecipient = 'noticeLeftForRecipient',
  /** New Item */
  NewItem = 'newItem',
  /** Out for Delivery */
  OutForDelivery = 'outForDelivery',
  /** Available for Pickup */
  AvailableForPickup = 'availableForPickup',
  /** Returned to Sender */
  ReturnedToSender = 'returnedToSender',
  /** Undeliverable */
  Undeliverable = 'undeliverable',
  /** Delivery Status Not Updated */
  DeliveryStatusNotUpdated = 'deliveryStatusNotUpdated',
  /** Other */
  Other = 'other',
}

/** Specifies Page Information */
export type PageInfo = {
  __typename?: 'PageInfo'
  hasNextPage: Scalars['Boolean']
  hasPreviousPage: Scalars['Boolean']
  limit: Scalars['Int']
}

export type PageInput = {
  after?: Maybe<Scalars['ID']>
  first?: Maybe<Scalars['Int']>
}

/** Query attributes for Direct Deposit Parameterized PDF Generation */
export type ParameterizedPdfInput = {
  /** User ID */
  userId: Scalars['ID']
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Employer Name */
  employerName: Scalars['String']
  /** Date Signed */
  dateSigned: Scalars['String']
  /** Amount Option */
  distributionType: DirectDepositDistribution
  /** Value of Amount Option Chosen */
  distributionAmount?: Maybe<Scalars['Float']>
  /** Session ID */
  sessionId?: Maybe<Scalars['ID']>
}

export type Partner = {
  __typename?: 'Partner'
  accountToken?: Maybe<Scalars['String']>
  authorization?: Maybe<PartnerAuthorizationData>
  clientCredentialsToken?: Maybe<Scalars['String']>
  clientId?: Maybe<Scalars['ID']>
  existingAccountRedirectUri?: Maybe<Scalars['String']>
  externalId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  logoTypeUrl?: Maybe<Scalars['String']>
  name: Scalars['String']
  plaidInstitutionId?: Maybe<Scalars['ID']>
  routingNumbers?: Maybe<PartnerRoutingNumber[]>
  user: PartnerUserPayload
  website: Scalars['String']
}

export type PartnerAuthorizationData = {
  __typename?: 'PartnerAuthorizationData'
  provider: Scalars['String']
  uid: Scalars['String']
  accessToken?: Maybe<Scalars['String']>
  refreshToken?: Maybe<Scalars['String']>
  expiresAt?: Maybe<Scalars['DateTime']>
}

export type PartnerChoices = {
  __typename?: 'PartnerChoices'
  body: Scalars['String']
  cta: Cta
  icon: Image
  title: Scalars['String']
}

/** Input for creating a manual, ACH funding source from a partner account token */
export type PartnerLinkFundingSourceInput = {
  /** the account token associated with a routing and account number */
  accountToken: Scalars['String']
}

/** PartnerLinkFundingSourceResult */
export type PartnerLinkFundingSourceResult =
  | CurrentBankStatementNotProvided
  | FundingSourceAccount
  | FundingSourceAlreadyExists
  | InvalidAccountNumber
  | InvalidAccountToken
  | InvalidManualLink
  | InvalidRoutingNumber
  | PreviousFundingSourcePending
  | RdvVerificationRequired

export type PartnerOfferGroup = {
  __typename?: 'PartnerOfferGroup'
  /** display body for the group */
  body?: Maybe<Scalars['String']>
  carouselType: CarouselType
  id: Scalars['ID']
  /** list of offers in the group */
  offers: PartnerOfferGroupItem[]
  /** display title for the group */
  title?: Maybe<Scalars['String']>
}

/** Used to customize offer group contents */
export type PartnerOfferGroupFilterInput = {
  /** Location is required for job offers */
  location?: Maybe<OfferLocationInput>
}

export type PartnerOfferGroupItem =
  | EarnOffer
  | PromoOffer
  | JobSearchOffer
  | JobOffer

/** Specifies the offer group type input */
export type PartnerOfferGroupsTypeInput = {
  type: OfferGroupsType
}

export type PartnerRoutingNumber = {
  __typename?: 'PartnerRoutingNumber'
  routingNumber: Scalars['String']
}

export type PartnerUserPayload = {
  __typename?: 'PartnerUserPayload'
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  dob?: Maybe<Scalars['String']>
  ssn?: Maybe<Scalars['String']>
  address1?: Maybe<Scalars['String']>
  address2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  zip?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
  usCitizen?: Maybe<Scalars['Boolean']>
}

export type PasswordResetRequestInput = {
  email: Scalars['EmailAddress']
}

/** Decorator type for items that have attached notes for display */
export type PastAnnotatedItem = {
  /** Past Item ID */
  id: Scalars['ID']
  /** Annotation on the item */
  note?: Maybe<Scalars['String']>
  /** Author of the note */
  noteAuthor?: Maybe<Scalars['String']>
}

/** A base set of fields that each type of PastItem must implement */
export type PastCoreCombinedItem = {
  /** Past Item ID */
  id: Scalars['ID']
  isCombinedInvestment: Scalars['Boolean']
}

/** A generic money movement line item for the Core account */
export type PastCoreItem = PastItem & {
  __typename?: 'PastCoreItem'
  /** Past Item ID */
  id: Scalars['ID']
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
  /** The title of the item */
  title: Scalars['String']
  /** The current state of the item */
  status: PastItemStatus
  amount?: Maybe<CurrencyAmount>
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
}

/** Metrics for core to be displayed in the summary */
export type PastCoreSummary = {
  __typename?: 'PastCoreSummary'
  investments: CurrencyAmount
  /** Total gain / loss including fees */
  netReturns: CurrencyAmount
  dividends: CurrencyAmount
  foundMoneyRewards: CurrencyAmount
  referralRewards: CurrencyAmount
  withdrawals: CurrencyAmount
}

/** A base set of fields that each traded PastItem must implement */
export type PastCoreTradedItem = {
  /** Past Item ID */
  id: Scalars['ID']
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl?: Maybe<Scalars['URL']>
}

/** Metrics for early to be displayed in the summary */
export type PastEarlySummary = {
  __typename?: 'PastEarlySummary'
  contributions: CurrencyAmount
  /** Total gain / loss including fees */
  netReturns: CurrencyAmount
  dividends: CurrencyAmount
  withdrawals: CurrencyAmount
}

/** A base set of fields that each type of PastItem must implement */
export type PastItem = {
  /** Past Item ID */
  id: Scalars['ID']
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
  /** The title of the item */
  title: Scalars['String']
  /** The current state of the item */
  status: PastItemStatus
  amount?: Maybe<CurrencyAmount>
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
}

/** PastItem connection object */
export type PastItemConnection = {
  __typename?: 'PastItemConnection'
  edges: PastItemEdge[]
  pageInfo: PageInfo
}

export type PastItemEdge = {
  __typename?: 'PastItemEdge'
  node?: Maybe<PastItem>
  cursor: Scalars['ID']
}

export enum PastItemStatus {
  Pending = 'pending',
  Selling = 'selling',
  Transferring = 'transferring',
  Complete = 'complete',
}

export type PastLaterSummary = {
  __typename?: 'PastLaterSummary'
  contributions: CurrencyAmount
  currentYearContributions: CurrencyAmount
  dividends: CurrencyAmount
  netReturns: CurrencyAmount
  priorYearContributions: CurrencyAmount
  withdrawals: CurrencyAmount
}

/** A generic money movement line item for the Spend account */
export type PastSpendItem = PastItem &
  SpendItem & {
    __typename?: 'PastSpendItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount?: Maybe<CurrencyAmount>
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

/** Metrics for spend to be displayed in the summary */
export type PastSpendSummary = {
  __typename?: 'PastSpendSummary'
  /** @deprecated Will be displayed on Past Core Summary */
  foundMoneyPlus?: Maybe<CurrencyAmount>
  /**
   * Withdrawals for this month. Current month is based on current PST time
   * @deprecated Use `debitsLast30Days`
   */
  debits?: Maybe<CurrencyAmount>
  /**
   * One time or direct deposits for this month. Current month is based on current PST time
   * @deprecated Use `depositsLast30Days`
   */
  deposits?: Maybe<CurrencyAmount>
  /** Withdrawals/purchases for the last 30 days. Based on current PST time */
  debitsLast30Days?: Maybe<CurrencyAmount>
  /** One time or direct deposits for the last 30 days. Based on current PST time */
  depositsLast30Days?: Maybe<CurrencyAmount>
  /** Primary account's current available balance */
  availableBalance?: Maybe<CurrencyAmount>
  instantRoundUps?: Maybe<CurrencyAmount>
}

/** Query attributes for Direct Deposit PDF URL Generation */
export type PdfDownloadUrlInput = {
  /** User ID */
  userId: Scalars['ID']
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Employer Name */
  employerName: Scalars['String']
  /** Session ID */
  sessionId?: Maybe<Scalars['ID']>
}

/** Returns URL with JWT token to lambda for Front-end */
export type PdfDownloadUrlPayload = {
  __typename?: 'PdfDownloadUrlPayload'
  /** PDF Download URL */
  url: Scalars['String']
}

export type PdfFormLinks = {
  __typename?: 'PdfFormLinks'
  formUrls: Array<Maybe<Scalars['String']>>
  id: Scalars['ID']
}

/** Performance values for a given Investment Account */
export type Performance = {
  __typename?: 'Performance'
  /** Investment account values based on previous market day's closing prices */
  accountValues?: Maybe<Array<Maybe<AccountValue>>>
  /** The dollar change in account value over the reporting period */
  marketChange?: Maybe<Scalars['Float']>
  /** The percentage change in account value over the reporting period */
  marketChangePercent?: Maybe<Scalars['Float']>
  /** The percentage change in account value over the reporting period (excluding fees) */
  marketChangePercentWithoutFees?: Maybe<Scalars['Float']>
  /** The dollar change in account value over the reporting period (excluding fees) */
  marketChangeWithoutFees?: Maybe<Scalars['Float']>
  /** Investment account value based on previous market day's closing prices */
  previousCloseAmount?: Maybe<Scalars['Float']>
  /**
   * The total dollar amount invested over the reporting period
   * @deprecated Will not be supported in the future
   */
  totalInvested?: Maybe<Scalars['Float']>
  /**
   * The total dollar amount invested over the reporting period (including pending investments)
   * @deprecated Will not be supported in the future
   */
  totalInvestedWithPending?: Maybe<Scalars['Float']>
}

export type PersonalInfoInput = {
  address1?: Maybe<Scalars['String']>
  address2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  dob?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  employer?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  occupation?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
  ssn?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  usCitizen?: Maybe<Scalars['Boolean']>
  zip?: Maybe<Scalars['String']>
}

/** Miscellaneous attributes and information about a user's phone numbers */
export type Phone = TimestampsInterface & {
  __typename?: 'Phone'
  /** Country code */
  countryCode: Scalars['String']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Internal ID for phone */
  id: Scalars['ID']
  /** Phone Number */
  phoneNumber: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Internal ID for user */
  userId: Scalars['ID']
  /** Phone has been verified */
  verified: Scalars['Boolean']
}

export type PhoneAuthenticator = Authenticator & {
  __typename?: 'PhoneAuthenticator'
  id: Scalars['ID']
  name: Scalars['String']
  lastUsedAt?: Maybe<Scalars['DateTime']>
  phoneNumber: Scalars['PhoneNumber']
  deviceId: Scalars['ID']
  createdAt: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
}

export type PhoneNumberOptedOutException = {
  __typename?: 'PhoneNumberOptedOutException'
  message: Scalars['String']
}

export enum PinwheelLinkTokenRequiredJobs {
  DirectDepositSwitch = 'DirectDepositSwitch',
}

export type PoBoxAddressError = {
  __typename?: 'POBoxAddressError'
  message: Scalars['String']
}

/** Acorns Managed Portfolio Object */
export type Portfolio = BasePortfolio & {
  __typename?: 'Portfolio'
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation
  /** Description of the portfolio */
  description: Scalars['String']
  /** Indicates the ETFs that the portfolio is composed of */
  etfs?: Maybe<Etf[]>
  /**
   * Indicates the actual holdings a user owns per ETF
   * @deprecated Use portfolioSecurities instead
   */
  holdings?: Maybe<PortfolioHolding[]>
  /** ID of the Portfolio */
  id: Scalars['ID']
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String']
  /** Indicates a key based off of the portfolio name */
  nameKey: Scalars['String']
  /** Securities that are associated with the portfolio */
  portfolioSecurities?: Maybe<PortfolioSecurity[]>
  /** Indicates the display priority */
  position?: Maybe<Scalars['Int']>
  /** Indicates the projection of the portfolio */
  projection?: Maybe<PortfolioProjection>
  /** Indicates how risky the portfolio is */
  riskLevel: PortfolioRiskLevel
  /** Indicates if the portfolio is standard or sustainable */
  theme: PortfolioTheme
}

/** Portfolio Allocation Object */
export type PortfolioAllocation = {
  __typename?: 'PortfolioAllocation'
  /** Percentage of investment allocated to this portfolio */
  allocationPercent: Scalars['Float']
  /** ID of the PortfolioAllocation */
  portfolioId: Scalars['ID']
}

/** Portfolio Holding */
export type PortfolioHolding = {
  __typename?: 'PortfolioHolding'
  /** The dollar amount of shares a user has */
  amount: Scalars['Float']
  id: Scalars['ID']
  /** The Acorns-assigned name of the ETF */
  name: Scalars['String']
  /** The actual percentage of a user's portfolio the ETF accounts for */
  percentage: Scalars['Float']
  /** The quanity of shares a user has */
  shares: Scalars['Float']
  /** The ETF's trading symbol */
  symbol: Scalars['String']
}

/** Portfolio Not Found */
export type PortfolioNotFoundException = {
  __typename?: 'PortfolioNotFoundException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Portfolio Projection */
export type PortfolioProjection = {
  __typename?: 'PortfolioProjection'
  /** The projected average growth rate */
  averageGrowthRate: Scalars['Float']
  /** The projected highest growth rate */
  highestGrowthRate: Scalars['Float']
  /** The projected lowest growth rate */
  lowestGrowthRate: Scalars['Float']
}

export enum PortfolioRiskLevel {
  Conservative = 'CONSERVATIVE',
  ModeratelyConservative = 'MODERATELY_CONSERVATIVE',
  Moderate = 'MODERATE',
  ModeratelyAggressive = 'MODERATELY_AGGRESSIVE',
  Aggressive = 'AGGRESSIVE',
  Custom = 'CUSTOM',
}

/** Portfolio Security */
export type PortfolioSecurity = {
  __typename?: 'PortfolioSecurity'
  /** The current percentage of the market value over the customer's total balance */
  currentAllocationPercentage: Scalars['Float']
  id: Scalars['ID']
  /** The market value of shares owned by the customer */
  marketValue: MonetaryAmount
  /** The Acorns-assigned name of the security */
  name: Scalars['String']
  /** The quanity of shares a user has */
  shares: Scalars['Float']
  /** The security's trading symbol */
  symbol: Scalars['String']
  /** The target percentage of the market value over the customer's total balance */
  targetAllocationPercentage?: Maybe<Scalars['Float']>
  /** The customer's returns for today */
  todaysReturn: MarketReturn
  /** The customer's returns for all time for the security */
  totalReturn: MarketReturn
}

export enum PortfolioTheme {
  Standard = 'STANDARD',
  Sustainable = 'SUSTAINABLE',
  SelfDirected = 'SELF_DIRECTED',
}

/** Failed to update portfolio on investment account */
export type PortfolioUpdateFailedException = {
  __typename?: 'PortfolioUpdateFailedException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type PositiveCurrencyAmountInput = {
  currency: Currency
  value: Scalars['PositiveFloat']
}

/** quote premium */
export type Premium = {
  __typename?: 'Premium'
  amount: Scalars['Float']
  term: Scalars['Int']
}

/** Query input to get user specific premiums for a life quote */
export type PremiumsInput = {
  /** Provider key */
  providerName: ProviderName
  /** Specific coverage amount to get premiums for */
  coverageAmount?: Maybe<Scalars['Int']>
}

/** Life quote query results */
export type PremiumsResult = {
  __typename?: 'PremiumsResult'
  quoteData: QuoteResult
  quoteStatus: QuoteStatus
}

export enum PresentableWithdrawalStatus {
  Pending = 'pending',
  SellingInvestments = 'sellingInvestments',
  Transferring = 'transferring',
  Complete = 'complete',
  Canceled = 'canceled',
  Refunded = 'refunded',
  Failed = 'failed',
}

/** Existing funding source in pending state */
export type PreviousFundingSourcePending = {
  __typename?: 'PreviousFundingSourcePending'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

/** Canonical representation of an Acorns product that can be used and billed for. */
export type Product = {
  __typename?: 'Product'
  /** Indicates wether or not the Product is available to new Users. */
  active: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  id: Scalars['ID']
  key: ProductKey
  name: Scalars['String']
  updatedAt: Scalars['DateTime']
}

/** Ref for product name */
export enum ProductKey {
  Early = 'EARLY',
  Invest = 'INVEST',
  Later = 'LATER',
  Spend = 'SPEND',
}

export enum ProductSetupTipType {
  /** spend - setup direct deposit */
  SpendDirectDeposit = 'spend_direct_deposit',
  /** spend - setup recurring deposit */
  SpendRecurringDeposit = 'spend_recurring_deposit',
  /** spend - setup smart deposit */
  SpendSmartDeposit = 'spend_smart_deposit',
  /** spend - smart deposit sweepstakes */
  SpendSmartDepositSweepstakes = 'spend_smart_deposit_sweepstakes',
  /** spend - set spend as primary */
  SpendSetAsPrimary = 'spend_set_as_primary',
  /** spend - incentive to setup direct deposit */
  SpendDirectDepositIncentive = 'spend_direct_deposit_incentive',
  /** invest - link primary checking */
  InvestLinkPrimaryChecking = 'invest_link_primary_checking',
  /** invest - link roundup cards */
  InvestLinkRoundupCards = 'invest_link_roundup_cards',
  /** invest - set auto roundups */
  InvestSetAutoRoundups = 'invest_set_auto_roundups',
  /** invest - schedule regular deposits */
  InvestScheduleRegularDeposits = 'invest_schedule_regular_deposits',
  /** invest - make first investment */
  InvestMakeFirstInvestment = 'invest_make_first_investment',
  /** invest - try sustainable portfolio */
  InvestTrySustainablePortfolio = 'invest_try_sustainable_portfolio',
  /** later - link primary checking */
  LaterLinkPrimaryChecking = 'later_link_primary_checking',
  /** later schedule regular deposits */
  LaterScheduleRegularDeposits = 'later_schedule_regular_deposits',
  /** later - make first investment */
  LaterMakeFirstInvestment = 'later_make_first_investment',
  /** later - set a beneficiary */
  LaterSetABeneficiary = 'later_set_a_beneficiary',
  /** later - try sustainable portfolio */
  LaterTrySustainablePortfolio = 'later_try_sustainable_portfolio',
  /** early - setup recurring transfers */
  EarlyRecurringTransfer = 'early_recurring_transfer',
  /** early - setup direct deposit */
  EarlyDirectDeposit = 'early_direct_deposit',
  /** early - try sustainable portfolio */
  EarlyTrySustainablePortfolio = 'early_try_sustainable_portfolio',
  /** all contexts - nps survey */
  NpsSurvey = 'nps_survey',
  /** all contexts - referral promotion */
  ReferralPromotion = 'referral_promotion',
  /** home - path to million promotion */
  PathToMillion = 'path_to_million',
  /** home - wildfire chrome extension */
  WildfireChromeExtension = 'wildfire_chrome_extension',
  /** home - try sustainable portfolio */
  HomeTrySustainablePortfolio = 'home_try_sustainable_portfolio',
  /** home - harvest bank fees */
  HarvestBankFees = 'harvest_bank_fees',
  /** home - earn safari extension */
  EarnSafariExtension = 'earn_safari_extension',
}

/** Miscellaneous attributes and information about a user */
export type Profile = TimestampsInterface & {
  __typename?: 'Profile'
  /** Annual income */
  annualIncome?: Maybe<Scalars['Int']>
  /** Combined annual income */
  combinedAnnualIncome?: Maybe<Scalars['Int']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Employees */
  employees?: Maybe<Employees>
  /** Employment status */
  employmentStatus?: Maybe<EmploymentStatus>
  /** Filing type */
  filingType?: Maybe<FilingType>
  /** First name */
  firstName?: Maybe<Scalars['String']>
  /** Funds availability */
  fundsAvailability?: Maybe<FundsAvailability>
  /** Last name */
  lastName?: Maybe<Scalars['String']>
  /** Marital status */
  maritalStatus?: Maybe<MaritalStatus>
  /** Retirement plan access */
  retirementPlanAccess?: Maybe<RetirementPlanAccess>
  /** Self employed income */
  selfEmployedIncome?: Maybe<Scalars['Int']>
  /** Signature type */
  signatures: Array<Maybe<Signature>>
  /** Last four of SSN */
  ssnLastFour?: Maybe<Scalars['String']>
  /** User has paused their transfers */
  transfersPaused?: Maybe<Scalars['Boolean']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Internal ID for user */
  userId: Scalars['ID']
}

export type ProfileAttribute = {
  key: Scalars['String']
  value: Scalars['JSON']
}

/** Changeable attributes for user profiles */
export type ProfileInput = {
  /** Status of user's employment */
  employmentStatus?: Maybe<EmploymentStatus>
  /** Funds availability */
  fundsAvailability?: Maybe<FundsAvailability>
  /** Marital status */
  maritalStatus?: Maybe<MaritalStatus>
  /** How the user wants to access their retirement plan */
  retirementPlanAccess?: Maybe<RetirementPlanAccess>
  /** How the user files their taxes */
  filingType?: Maybe<FilingType>
  /** Number of employees the user has (if self employed) */
  employees?: Maybe<Employees>
  /** Total annual income */
  combinedAnnualIncome?: Maybe<Scalars['Int']>
  /** Self employed income */
  selfEmployedIncome?: Maybe<Scalars['Int']>
  /** Non-self employed income */
  annualIncome?: Maybe<Scalars['Int']>
  /** Pause transfers */
  transfersPaused?: Maybe<Scalars['Boolean']>
}

export enum ProgramAccountType {
  Plan = 'PLAN',
}

/** Display wrapper for featured promo offer */
export type PromoOffer = {
  __typename?: 'PromoOffer'
  /** Background/featured image */
  backgroundImage: Image
  /** Display body for the offer */
  body?: Maybe<Scalars['String']>
  /** Desktop Background/featured image */
  desktopBackgroundImage: Image
  id: Scalars['ID']
  /** Company/partner logo */
  logo?: Maybe<Image>
  /** Partner url */
  partnerUrl: Scalars['URL']
  /** Display subtitle for the offer */
  subtitle?: Maybe<Scalars['String']>
  /** Display title for the offer */
  title: Scalars['String']
}

/** Time-bound pricing and/or additional incentives offered to subscibers of a particular offering (tier or product). */
export type Promotion = {
  __typename?: 'Promotion'
  /** Wether or not the promotion is available for new applications. */
  active: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  /** How long the promotion lasts once applied to a subscription. */
  duration?: Maybe<PromotionDuration>
  /** When the promotion is set to expire and become inactive. */
  expiresAt?: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  /** Additional incentives the promotion entitles subscribers to. */
  incentives?: Maybe<Incentive[]>
  name: Scalars['String']
  /** Services that the promotion is for. */
  offering: Offering
  /** Metadata indicating in what contexts a client should present the promotion. */
  presentInContexts: Array<Scalars['String']>
  /** Link to legal terms and conditions of the promotion. */
  termsUrl: Scalars['URL']
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type PromotionConsumedError = {
  __typename?: 'PromotionConsumedError'
  message: Scalars['String']
}

export type PromotionDuration = {
  __typename?: 'PromotionDuration'
  period: PromotionDurationPeriod
  periodCount: Scalars['Int']
}

export enum PromotionDurationPeriod {
  Month = 'MONTH',
}

export type PromotionExpiredError = {
  __typename?: 'PromotionExpiredError'
  expiredAt: Scalars['DateTime']
  message: Scalars['String']
}

export type PromotionFilterInput = {
  presentInContexts?: Maybe<PromotionPresentInContextsFilterInput>
}

export type PromotionNotFoundError = {
  __typename?: 'PromotionNotFoundError'
  message: Scalars['String']
}

export type PromotionPresentInContextsFilterInput = {
  in?: Maybe<Array<Scalars['String']>>
}

export type Prospect = {
  email: Scalars['String']
  id: Scalars['ID']
}

export enum ProspectType {
  Grow = 'GROW',
  LaterWaitlist = 'LATER_WAITLIST',
  OutsideContribution = 'OUTSIDE_CONTRIBUTION',
}

export type ProtectContext = {
  __typename?: 'ProtectContext'
  style: Scalars['String']
  widgetType: WidgetReferenceType
}

export type ProtectHome = {
  __typename?: 'ProtectHome'
  cta: Cta
  id: Scalars['ID']
  title: Scalars['String']
  widgets: ProtectHomeWidget[]
}

export type ProtectHomeWidget =
  | Education
  | ExploreCarousel
  | HomeIcons
  | InsuranceSection

export type ProtectLander = {
  __typename?: 'ProtectLander'
  body: Scalars['String']
  cta: Cta
  id: Scalars['ID']
  image?: Maybe<Image>
  lastCheckinAt?: Maybe<Scalars['DateTime']>
  logo?: Maybe<Image>
  tipTitle: Scalars['String']
  title: Scalars['String']
  tutorialTitle: Scalars['String']
}

export type ProtectLearningCenter = {
  __typename?: 'ProtectLearningCenter'
  articles: Article[]
  body: Scalars['String']
  eyebrow: Scalars['String']
  id: Scalars['ID']
  image: Image
  title: Scalars['String']
}

export type Provider = {
  __typename?: 'Provider'
  cta?: Maybe<Cta>
  id: Scalars['ID']
  image: Image
  isSelected: Scalars['Boolean']
  title: Scalars['String']
}

export enum ProviderName {
  /** Ladder Life */
  Ladderlife = 'ladderlife',
}

export type ProviderSearch = {
  __typename?: 'ProviderSearch'
  body: Scalars['String']
  cta: Cta
  insuranceType: InsuranceType
  providers: Provider[]
  searchImage?: Maybe<Image>
  searchTitle: Scalars['String']
  subtitle: Scalars['String']
  title: Scalars['String']
  unknownProvider: UnknownProvider
}

export type Query = {
  __typename?: 'Query'
  /** Get the currently authenticated user */
  user?: Maybe<User>
  /** Get an action feed for the currently authenticated user */
  actionFeed?: Maybe<Array<Maybe<ActionCard>>>
  /** Get information about a user's primary funding source */
  fundingSourceInfo?: Maybe<FundingSourceInfo>
  /** @deprecated Use the past queries instead. */
  activity?: Maybe<Array<Maybe<Activity>>>
  /** Get a list of documents the user needs to accept */
  acceptanceDocuments?: Maybe<Array<Maybe<AcceptanceDocument>>>
  /** Get all acceptance documents */
  allAcceptanceDocuments?: Maybe<Array<Maybe<AcceptanceDocument>>>
  acceptanceDocument?: Maybe<AcceptanceDocument>
  /**
   * Fetch recurring investment settings for the specified InvestmentAccount
   * (defaults to the authenticated User's Core InvestmentAccount if not specified).
   */
  recurringInvestmentSettings?: Maybe<RecurringInvestmentSettings>
  investments?: Maybe<Array<Maybe<Investment>>>
  /** @deprecated Use Query.investmentAccountsByUserId instead. */
  allInvestmentAccounts?: Maybe<InvestmentAccount[]>
  market?: Maybe<Market>
  performance?: Maybe<Performance>
  settings?: Maybe<Settings>
  notifications?: Maybe<Notifications>
  statements?: Maybe<Array<Maybe<Statement>>>
  /** @deprecated Toggles no longer supported. This will always returns true. */
  toggle?: Maybe<Toggle>
  partner?: Maybe<Partner>
  allSuitabilityQuestions?: Maybe<Array<Maybe<SuitabilityQuestion>>>
  allSecurityQuestions?: Maybe<Array<Maybe<SecurityQuestion>>>
  allCloseAccountReasons?: Maybe<Array<Maybe<CloseAccountReason>>>
  accountStrength?: Maybe<AccountStrengthResult>
  userStatus?: Maybe<UserStatus>
  extensionOwners?: Maybe<Array<Maybe<ExtensionOwner>>>
  extensionCampaignStore?: Maybe<ExtensionCampaignStore>
  extensionCampaignStores?: Maybe<Array<Maybe<ExtensionCampaignStore>>>
  extensionRewardsSummary: ExtensionRewardsSummary
  extensionTransactions?: Maybe<Array<Maybe<ExtensionTransaction>>>
  foundMoneyOffer?: Maybe<FoundMoneyOffer>
  /** @deprecated Use activeEarnOffers instead. */
  foundMoneyOffers?: Maybe<FoundMoneyOffer[]>
  foundMoneyCampaigns?: Maybe<FoundMoneyCampaign[]>
  foundMoneyRewards?: Maybe<Array<Maybe<FoundMoneyReward>>>
  foundMoneySummary?: Maybe<FoundMoneySummary>
  foundMoneyOfferCategories?: Maybe<FoundMoneyOfferCategory[]>
  laterAccounts?: Maybe<Array<Maybe<LaterAccount>>>
  laterBeneficiaries?: Maybe<Array<Maybe<LaterIndividualBeneficiary>>>
  laterHistory?: Maybe<Array<Maybe<LaterHistoryItem>>>
  laterPortfolioPerformance?: Maybe<LaterPortfolioPerformance>
  /** @deprecated Never implemented. */
  laterDeposits?: Maybe<Array<Maybe<LaterDeposit>>>
  /** @deprecated Never implemented. */
  rolloverAccounts?: Maybe<RolloverAccounts>
  /** @deprecated Never implemented. */
  custodianCompanies?: Maybe<Array<Maybe<CustodianCompany>>>
  withholdingDefaults?: Maybe<WithholdingDefaults>
  laterContributionHistory?: Maybe<ContributionHistoryItem[]>
  eligibility?: Maybe<Eligibility>
  remoteStrings?: Maybe<Scalars['JSON']>
  /** Fetch a list of accounts for a user */
  accounts: Array<Maybe<Account>>
  /** Fetch a list of addresses for a user */
  addresses: Array<Maybe<Address>>
  /** Fetch all beneficiary alerts for a user */
  alertHubBeneficiaryAlerts?: Maybe<AlertHubBeneficiaryAlert[]>
  /** Fetch all beneficiaries for a user */
  beneficiaries?: Maybe<Beneficiary[]>
  /** Fetch a beneficiary with a given ID */
  beneficiary?: Maybe<Beneficiary>
  /** Fetch all beneficiary alerts for a user */
  beneficiaryAlerts?: Maybe<Alert[]>
  /** Fetch a list of occupations */
  occupations?: Maybe<Array<Maybe<Occupation>>>
  /** Fetch a single profile for a user */
  profile: Profile
  /** Fetch a list of signatures for a user */
  signatures: Array<Maybe<Signature>>
  /** Fetch billing cycles given an ID */
  billingCycle?: Maybe<BillingCycle>
  /** Fetch billing cycles given a user ID */
  billingCycles?: Maybe<BillingCycle[]>
  /** Fetch a fee given the ID */
  fee?: Maybe<Fee>
  /** Fetch all fees given an argument */
  fees?: Maybe<Fee[]>
  /** Fetch the next billing date for a user */
  nextBillingDate?: Maybe<NextBillingDate>
  /** Used to determine if an address is deliverable or offer corrections to make it deliverable. */
  addressDeliverability?: Maybe<AddressDeliverabilityResult>
  allBankAccounts?: Maybe<Array<Maybe<BankAccount>>>
  allBankCards?: Maybe<Array<Maybe<BankCard>>>
  bankMetadata?: Maybe<BankMetadata>
  bankCardOrder?: Maybe<BankCardOrder>
  bankTransaction?: Maybe<BankTransaction>
  /** @deprecated Use backend documents instead */
  allBankDocuments?: Maybe<Array<Maybe<BankDocument>>>
  allBankStatements?: Maybe<Array<Maybe<BankStatement>>>
  spendAlerts?: Maybe<Array<Maybe<SpendAlert>>>
  allBankTransactions?: Maybe<BankTransactionConnection>
  spendAtms?: Maybe<SpendAtmsResult>
  spendAccount?: Maybe<SpendAccount>
  bankCardReissue?: Maybe<BankCardReissue>
  bankAccountClosureReasons: BankAccountClosureReason[]
  /** Fetch a Financial Institution by external ID */
  financialInstitution?: Maybe<FinancialInstitution>
  /** Fetch all Financial Institutions */
  financialInstitutions: FinancialInstitutionTypePagination
  /** Fetch a linked account */
  linkedAccount?: Maybe<LinkedAccount>
  /** Fetch alerts for linked account */
  linkedAccountAlerts?: Maybe<LinkedAccountAlertsResponse[]>
  /** Fetch webhook URLs */
  linkedAccountWebhooks: Webhooks
  /** Fetch linked accounts for a given user */
  linkedAccounts: LinkedAccount[]
  /** Fetch a linked subaccount */
  linkedSubaccount?: Maybe<LinkedSubaccount>
  /** Fetch linked subaccounts for a given user */
  linkedSubaccounts: LinkedSubaccount[]
  /** Fetch a round up account for a specified linked subaccount */
  roundUpAccount?: Maybe<RoundUpAccount>
  /** List round up accounts for a given user */
  roundUpAccounts: RoundUpAccount[]
  /** Fetch a single round up profile for a user */
  roundUpProfile?: Maybe<RoundUpProfile>
  /** List round ups for a given user */
  roundUps: RoundUpTypePagination
  /** Fetch all Core items for the Past screen. Defaults to only return non-pending transactions */
  allPastCoreItems?: Maybe<PastItemConnection>
  /** Fetch all Later items for the Past screen. Defaults to only return non-pending transactions */
  allPastLaterItems?: Maybe<PastItemConnection>
  allPastSpendItems?: Maybe<PastItemConnection>
  /** Fetch all Early items for the Past screen. Defaults to only return non-pending transactions */
  allPastEarlyItems?: Maybe<PastItemConnection>
  pastCoreSummary?: Maybe<PastCoreSummary>
  pastEarlySummary?: Maybe<PastEarlySummary>
  /** Totals for Spend */
  pastSpendSummary?: Maybe<PastSpendSummary>
  /** Fetch all Core items for the Past screen. */
  allPastCoreItemChildren?: Maybe<PastItem[]>
  pastSpendTransactionItem?: Maybe<PastItem>
  allTransferableFrom?: Maybe<TransferableFrom[]>
  allTransferableTo?: Maybe<TransferableTo[]>
  estimatedTransferDates?: Maybe<EstimatedTransferDatesPayload>
  allReturnedCheckDeposits?: Maybe<ReturnedCheckDeposit[]>
  /** Evaluates check deposit session to determine if it is submittable. */
  evaluateCheckDeposit?: Maybe<EvaluateCheckDepositPayload>
  /** Returns list of categories and nested subcategories for dynamic values in contact form */
  allContactCategories?: Maybe<ContactCategory[]>
  /** Returns all support articles */
  allSupportArticles?: Maybe<Array<Maybe<SupportArticle>>>
  /** Returns all the current categories within the Help Center */
  allSupportCategories?: Maybe<Array<Maybe<SupportCategory>>>
  /** Returns all support sections */
  allSupportSections?: Maybe<Array<Maybe<SupportSection>>>
  /** Returns all support ticket forms */
  allSupportTicketForms?: Maybe<Array<Maybe<SupportTicketForm>>>
  /**
   * See if in-app support chat is currently enabled. This is a fault-tolerant
   * query and thus will return `false` rather than fail.
   * @deprecated Replaced with more general supportSchedule query.
   */
  supportChatEnabled: Scalars['Boolean']
  /**
   * See if specified support channel is currently enabled. This is a
   * fault-tolerant query and thus will return `false` rather than fail.
   */
  supportSchedule?: Maybe<ScheduleResult>
  /** Returns contact form alert message if it has been set in Zesty */
  contactFormAlert?: Maybe<ContactFormAlert>
  /** Returns most common faq articles if it has been set in Zesty */
  supportMostCommonFaq?: Maybe<ContactFaq[]>
  /** Returns help form submission content */
  helpFormContent?: Maybe<HelpFormContent>
  /** Returns support article given an id */
  supportArticle?: Maybe<SupportArticle>
  /** Returns support section given an id */
  supportSection?: Maybe<SupportSection>
  /** Returns support category given an id */
  supportCategory?: Maybe<SupportCategory>
  /** Returns all articles in section given a sectionId  */
  supportArticlesBySectionId?: Maybe<Array<Maybe<SupportArticle>>>
  /** Returns instant support articles from search term currently in search field */
  instantSearchSupportArticles?: Maybe<Array<Maybe<SearchSupportArticleResult>>>
  /** Return the given support ticket form by id */
  supportTicketForm?: Maybe<SupportTicketForm>
  supportTicketFormField?: Maybe<SupportTicketFormField>
  /** Returns all relevant support articles and all categories given a query */
  searchSupportArticles?: Maybe<SearchSupportResult>
  /** Returns all support sections by category id */
  supportSectionsByCategoryId?: Maybe<Array<Maybe<SupportSection>>>
  /** Get the Card Delivery Status */
  allCardTrackingStatuses?: Maybe<CardDeliveryStatus[]>
  /** Return the user switches' state */
  directDepositState: DirectDepositStatePayload
  /** Generate Updated Base 64 Encoded PDF String */
  generateUpdatedPdf?: Maybe<GenerateUpdatedPdfPayload>
  /** Base 64 Encoded Parameterized PDF String */
  parameterizedPdf?: Maybe<GenerateUpdatedPdfPayload>
  /** PDF Download URL */
  pdfDownloadUrl?: Maybe<PdfDownloadUrlPayload>
  /** Employer Search */
  searchEmployers?: Maybe<SearchEmployersPayload>
  /** Top Employers */
  topEmployers: TopEmployerPayload
  /** Fetch the user's recommended portfolio */
  recommendedPortfolio?: Maybe<Suitability_Portfolio>
  /** Fetch all suitability questions and answers */
  suitabilityResponses?: Maybe<Suitability_SuitabilityResponse[]>
  /** Return if a client should use suitability service for a particular user */
  suitabilityServiceEnabled?: Maybe<Scalars['Boolean']>
  allCheckPayments?: Maybe<AllCheckPaymentsResult>
  estimatedCheckPaymentDates?: Maybe<EstimatedCheckPaymentDates>
  verifyCheckPaymentRecipientAddress?: Maybe<VerifyCheckPaymentRecipientAddressResult>
  /** Investment account closure reasons */
  closureReasonsByInvestmentAccountType: InvestmentAccountClosureReason[]
  /** State and Territory regulations for Early Account for the given Custodian */
  earlyAccountClosureReasons: InvestmentAccountClosureReason[]
  /** State and Territory regulations for Early Account for the given Custodian */
  earlyAccountStateRegulation: EarlyAccountStateRegulationResult
  /** DEPRECATED - Use InvestmentAccountTransferability instead */
  earlyAccountTransferInfo?: Maybe<EarlyAccountTransferInfo>
  /** Fetches stored information about the ETF. */
  etf?: Maybe<Etf>
  /** Fetches a list of funding source(s) for the user */
  fundingSourceAccounts?: Maybe<FundingSourceAccount[]>
  /** Fetches an investment account for the authorized user */
  investmentAccount?: Maybe<InvestmentAccount>
  /** Return an investment account by the beneficiary ID */
  investmentAccountByBeneficiaryId?: Maybe<InvestmentAccount>
  /** Fetch user's investment accounts */
  investmentAccountsByUserId: InvestmentAccount[]
  /** Fetch user's referral invitation */
  invitationForUser?: Maybe<Referral>
  /** Portfolios */
  portfolios: Portfolio[]
  /** Fetch user's referral */
  referralForUser?: Maybe<Referral>
  /** Fetches a registration record for a prospective user */
  registration: Result
  /** An array of the alerts for a user. */
  userAlerts?: Maybe<UserAlertsResponse[]>
  /**  AF cards to show user based on later state, e.g. "Create a beneficiary!" */
  laterAlerts?: Maybe<Alert[]>
  /**
   *  Contribution ability per year; only years in the current "tax window" returned
   * @deprecated Use laterUserContributionAbility
   */
  laterContributionAbility?: Maybe<Array<Maybe<ContributionAbility>>>
  laterUserContributionAbility?: Maybe<LaterContributionAbilityResult>
  pastLaterSummary?: Maybe<PastLaterSummary>
  /**  Estimated withholding amounts (only on gains for Roth IRAs) */
  withholdingEstimates?: Maybe<WithholdingEstimates>
  yearLaterReport: YearLaterReport
  recurringTransfers?: Maybe<Array<Maybe<RecurringTransfer>>>
  nextTransferDate?: Maybe<NextTransferDateResult>
  /** present the protect context */
  protectContext?: Maybe<ProtectContext>
  /** retrieve coverage shop cards */
  protectCoverageShop?: Maybe<CoverageShop>
  /** retrieve protect homepage content */
  protectHome?: Maybe<ProtectHome>
  /** Retrieve Insurance Home page info */
  protectInsuranceHome?: Maybe<InsuranceHome>
  /** retrieve lander page content */
  protectLander?: Maybe<ProtectLander>
  /** retrieve protect learning center content */
  protectLearningCenter?: Maybe<ProtectLearningCenter>
  /** Retrieve life calculator survey page info along with previous user input (if available) */
  protectLifeCalculatorSurvey?: Maybe<LifeCalculatorSurvey>
  /** retrieve user specific monthly premiums for life insurance quote */
  protectLifeQuotePremiums?: Maybe<PremiumsResult>
  /** Retrieve life quote survey for screens 1-3 */
  protectLifeQuoteSurvey?: Maybe<LifeQuoteSurvey>
  /** retrieve the full set of questions */
  protectOnboardingQuestions?: Maybe<Question[]>
  /** retrieve provider search page content and providers list */
  protectProviders?: Maybe<ProviderSearch>
  /** retrieve insurance recommendations */
  protectRecommendations?: Maybe<Recommendations>
  /** retrieve recommended coverage amount for life insurance */
  protectRecommendedLifeCoverage?: Maybe<RecommendedLifeCoverage>
  /** query account summary information */
  activitySummary?: Maybe<ActivitySummaryResponse>
  /** query finish setup information */
  finishSetup?: Maybe<FinishSetup>
  /** query the account onboarding tips modal */
  onboardingTips?: Maybe<OnboardingTips>
  /** Get personalized offers for a given user */
  personalizedFoundMoney?: Maybe<FoundMoneyCampaignV2[]>
  personalizedFoundMoneyV2?: Maybe<FoundMoneyCampaignV2[]>
  activeEarnOffers: EarnOfferQueryPage
  /** Retrieve EarnOffer by campaignOfferId with fall back support by campaignId */
  earnOfferByCampaignOfferId?: Maybe<EarnOffer>
  /** Retrieves list of favorite EarnOffers that the user is currently eligible for */
  favoriteEarnOffers: FavoritePartnerOfferGroup
  searchActiveEarnOffers: EarnOfferQueryPage
  partnerOfferGroup?: Maybe<PartnerOfferGroup>
  partnerOfferGroupsByType?: Maybe<PartnerOfferGroup[]>
  jobAlerts?: Maybe<JobAlert[]>
  jobSearch?: Maybe<Jobs_Offer[]>
  jobSearchV2?: Maybe<Jobs_OfferConnection>
  jobSearchPage?: Maybe<JobSearchPage>
  jobEducationContent?: Maybe<Jobs_Education>
  milestone?: Maybe<Milestone>
  milestonesByTheme?: Maybe<MilestoneThemeGroup>
  milestoneHub?: Maybe<MilestoneHub>
  featuredMilestones: FeaturedMilestones
  milestoneChallenge?: Maybe<MilestoneChallenge>
  promoMilestoneChallengeId?: Maybe<Scalars['ID']>
  milestoneHubEligible?: Maybe<Eligibility>
  milestoneAchievementActionRule?: Maybe<MilestoneAchievementActionRule>
  milestoneAchievementActionRules: MilestoneAchievementActionRule[]
  accountPointsRuleByMilestoneId?: Maybe<AccountPointsRule>
  accountPointsRules?: Maybe<AccountPointsRule[]>
  milestoneAccountLevelDefinitions?: Maybe<MilestoneAccountLevelDefinition[]>
  documentRequest?: Maybe<DocumentRequest>
  documentRequests?: Maybe<DocumentRequestsConnection>
  registeredAuthenticators?: Maybe<Authenticator[]>
  authProfile?: Maybe<AuthProfile>
  authAlerts?: Maybe<AuthAlert[]>
  devicesByUserId?: Maybe<Device[]>
  device?: Maybe<Device>
  offer?: Maybe<Offer>
  /** Lookup a specific Product by it's unique id. */
  product?: Maybe<Product>
  /** Lookup a specific Product by it's unique key. */
  productByKey?: Maybe<Product>
  /** List all Products. */
  products?: Maybe<Product[]>
  /** Lookup a particular promotion by it's unique id. */
  promotion?: Maybe<Promotion>
  /** Get a list of promotions to which a user is eligible. */
  promotionsByUserId?: Maybe<Promotion[]>
  subscriptionMigration?: Maybe<SubscriptionMigration>
  subscriptionMigrationWaiver?: Maybe<SubscriptionMigrationWaiver>
  subscriptionMigrationWaiversByUserId?: Maybe<SubscriptionMigrationWaiver[]>
  /** Lookup a Tier by it's unique id. */
  tier?: Maybe<Tier>
  /**
   * Returns a tier group w/ tiers, products, prices, etc. Can not be tied to
   * a specfic user (needs to support anonymous users).
   * id is optional for case of returning default
   */
  tierGroup?: Maybe<TierGroup>
  /** TierGroup for specific user (includes the Tier they are subscribed to) */
  tierGroupForUser?: Maybe<TierGroup>
  /**
   * Returns the cheapest tier option for a given user's open accounts
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByOpenAccounts?: Maybe<TierOption>
  /**
   * Returns the cheapest tier option for a given product key
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByProductKey?: Maybe<TierOption>
  /**
   * For a given TierPriceId, returns the TierOption associated with that price id.
   * Returns InvalidTierPriceId if the tier price id is not found.
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByTierPriceId?: Maybe<TierOptionByTierPriceIdResult>
  /** Any arbitrary subscription (current or historical) */
  tierSubscription?: Maybe<TierSubscription>
  /** A User's TierSubscription by User.uuid. */
  tierSubscriptionByUserId?: Maybe<TierSubscription>
  /**
   * The current subscription for an arbitrary user
   * @deprecated Use Query.tierSubscriptionByUserId.
   */
  tierSubscriptionForUser?: Maybe<TierSubscriptionForUser>
  /** All of a Users's TierSubscriptions by User.uuid. */
  tierSubscriptionHistoryByUserId?: Maybe<TierSubscriptionConnection>
  splitDepositSettings?: Maybe<SplitDepositSettings>
  splitDepositSettingsByUserId?: Maybe<SplitDepositSettings[]>
  smartDepositMetadata?: Maybe<SmartDepositMetadataResult>
  /** Fetch a code given the code uuid */
  outsideContributionCode?: Maybe<OutsideContributionCode>
  /** Fetch a code given the code string */
  outsideContributionCodeByCode?: Maybe<OutsideContributionCode>
  /** Fetch a code given the investment account id */
  outsideContributionCodeByInvestmentAccountId?: Maybe<OutsideContributionCode>
  earnCTADataByUserId?: Maybe<EarnCtaRecord[]>
  bankFeesByUserId?: Maybe<BankFee[]>
  bankFeeSummaryByUserId?: Maybe<BankFeeSummary>
  authenticateForFeeNegotiationStatusByLinkedAccountId?: Maybe<AuthenticateForFeeNegotiationStatus>
  bankFeeNegotiationAlerts?: Maybe<BankFeeNegotiationAlert[]>
  advocate?: Maybe<Advocate>
  friend?: Maybe<Friend>
  securityBySymbol?: Maybe<Security>
  securityPerformanceBySymbol?: Maybe<SecurityPerformance>
  cohortEligibility: CohortEligibility[]
}

export type QueryActionFeedArgs = {
  input?: Maybe<ActionCardsInput>
}

export type QueryActivityArgs = {
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type QueryAcceptanceDocumentsArgs = {
  requiredFor?: Maybe<Scalars['String']>
}

export type QueryAllAcceptanceDocumentsArgs = {
  requiredFor?: Maybe<Scalars['String']>
}

export type QueryAcceptanceDocumentArgs = {
  type: Scalars['String']
}

export type QueryRecurringInvestmentSettingsArgs = {
  investmentAccountId?: Maybe<Scalars['ID']>
}

export type QueryInvestmentsArgs = {
  filter?: Maybe<InvestmentFilter>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type QueryPerformanceArgs = {
  start: Scalars['DateTime']
  days: Scalars['Int']
  investmentAccountId?: Maybe<Scalars['ID']>
}

export type QueryStatementsArgs = {
  type: Scalars['String']
  investmentAccountId?: Maybe<Scalars['ID']>
  limit?: Maybe<Scalars['Int']>
  offset?: Maybe<Scalars['Int']>
}

export type QueryToggleArgs = {
  projectId: Scalars['String']
  toggleId: Scalars['String']
  context?: Maybe<Scalars['JSON']>
}

export type QueryPartnerArgs = {
  oauthToken: Scalars['String']
  payloadToken: Scalars['String']
}

export type QueryAccountStrengthArgs = {
  accountId?: Maybe<Scalars['String']>
}

export type QueryExtensionCampaignStoreArgs = {
  id: Scalars['ID']
  campaignId: Scalars['ID']
}

export type QueryExtensionCampaignStoresArgs = {
  campaignId?: Maybe<Scalars['ID']>
  domain?: Maybe<Scalars['String']>
}

export type QueryFoundMoneyOfferArgs = {
  id: Scalars['ID']
  origin?: Maybe<Scalars['String']>
  sessionId?: Maybe<Scalars['String']>
}

export type QueryFoundMoneyOffersArgs = {
  origin?: Maybe<Scalars['String']>
  sessionId?: Maybe<Scalars['String']>
  promoted?: Maybe<Scalars['Boolean']>
}

export type QueryFoundMoneyCampaignsArgs = {
  origin?: Maybe<Scalars['String']>
  sessionId?: Maybe<Scalars['String']>
}

export type QueryLaterBeneficiariesArgs = {
  investmentAccountId: Scalars['ID']
}

export type QueryLaterHistoryArgs = {
  accountId: Scalars['ID']
  page?: Maybe<Scalars['Int']>
  limit?: Maybe<Scalars['Int']>
}

export type QueryLaterPortfolioPerformanceArgs = {
  accountId: Scalars['ID']
}

export type QueryWithholdingDefaultsArgs = {
  investmentAccountId: Scalars['ID']
  withdrawalAmount: CurrencyAmountInput
  earlyDistributionTaxExceptionReason?: Maybe<Scalars['String']>
}

export type QueryLaterContributionHistoryArgs = {
  investmentAccountId: Scalars['ID']
}

export type QueryEligibilityArgs = {
  eligibilityScope: EligibilityScope
}

export type QueryAccountsArgs = {
  status?: Maybe<Array<Maybe<AccountStatus>>>
}

export type QueryAddressesArgs = {
  addressType?: Maybe<AddressType>
}

export type QueryBeneficiaryArgs = {
  id: Scalars['ID']
}

export type QuerySignaturesArgs = {
  signatureType?: Maybe<SignatureType>
}

export type QueryBillingCycleArgs = {
  id?: Maybe<Scalars['ID']>
}

export type QueryBillingCyclesArgs = {
  state?: Maybe<Array<Maybe<BillingCycleState>>>
}

export type QueryFeeArgs = {
  id: Scalars['ID']
}

export type QueryFeesArgs = {
  billingCycleId?: Maybe<Scalars['ID']>
  accountId?: Maybe<Scalars['ID']>
}

export type QueryAddressDeliverabilityArgs = {
  input: AddressDeliverabilityInput
}

export type QueryAllBankAccountsArgs = {
  input: AllBankAccountsInput
}

export type QueryAllBankCardsArgs = {
  filter?: Maybe<AllBankCardsFilter>
}

export type QueryBankTransactionArgs = {
  id: Scalars['ID']
}

export type QueryAllBankDocumentsArgs = {
  input: AllBankDocumentsInput
}

export type QueryAllBankTransactionsArgs = {
  pagination?: Maybe<PageInput>
  accountId?: Maybe<Scalars['ID']>
}

export type QuerySpendAtmsArgs = {
  input: SpendAtmsInput
}

export type QueryFinancialInstitutionArgs = {
  externalId: Scalars['String']
  linkable?: Maybe<Scalars['Boolean']>
}

export type QueryFinancialInstitutionsArgs = {
  includeBlacklisted?: Maybe<Scalars['Boolean']>
  supportsAuth?: Maybe<Scalars['Boolean']>
  supportsFunding?: Maybe<Scalars['Boolean']>
  q?: Maybe<Scalars['String']>
  includeDirectBank?: Maybe<Scalars['Boolean']>
  pageInput?: Maybe<PageInput>
}

export type QueryLinkedAccountArgs = {
  linkedAccountId: Scalars['ID']
}

export type QueryLinkedAccountsArgs = {
  linked?: Maybe<Scalars['Boolean']>
  externalSources?: Maybe<LinkedAccountExternalSourceEnum[]>
}

export type QueryLinkedSubaccountArgs = {
  linkedSubaccountId: Scalars['ID']
}

export type QueryLinkedSubaccountsArgs = {
  linked?: Maybe<Scalars['Boolean']>
}

export type QueryRoundUpAccountArgs = {
  linkedSubaccountId: Scalars['ID']
}

export type QueryRoundUpsArgs = {
  state?: Maybe<RoundUpState[]>
  transactionDateAfter?: Maybe<Scalars['String']>
  transactionDateBefore?: Maybe<Scalars['String']>
  investmentId?: Maybe<Scalars['ID']>
  autoInvestable?: Maybe<Scalars['Boolean']>
  manual?: Maybe<Scalars['Boolean']>
  targetAccountId?: Maybe<Scalars['ID']>
  pageInput?: Maybe<PageInput>
}

export type QueryAllPastCoreItemsArgs = {
  excludeFees?: Maybe<Scalars['Boolean']>
  pagination?: Maybe<PageInput>
  filter?: Maybe<AllPastCoreItemsSchemaFilter>
}

export type QueryAllPastLaterItemsArgs = {
  excludeFees?: Maybe<Scalars['Boolean']>
  pagination?: Maybe<PageInput>
  filter?: Maybe<AllPastLaterItemsSchemaFilter>
}

export type QueryAllPastSpendItemsArgs = {
  pagination?: Maybe<PageInput>
  filter?: Maybe<AllPastSpendItemsSchemaFilter>
}

export type QueryAllPastEarlyItemsArgs = {
  excludeFees?: Maybe<Scalars['Boolean']>
  pagination?: Maybe<PageInput>
  filter?: Maybe<AllPastEarlyItemsSchemaFilter>
  beneficiaryAccountId: Scalars['String']
}

export type QueryPastEarlySummaryArgs = {
  beneficiaryAccountId: Scalars['String']
}

export type QueryAllPastCoreItemChildrenArgs = {
  pastItemId: Scalars['ID']
}

export type QueryPastSpendTransactionItemArgs = {
  transactionId: Scalars['String']
}

export type QueryAllTransferableToArgs = {
  input: AllTransferableToInput
}

export type QueryEstimatedTransferDatesArgs = {
  input: EstimatedTransferDatesInput
}

export type QueryEvaluateCheckDepositArgs = {
  input: EvaluateCheckDepositInput
}

export type QueryAllSupportArticlesArgs = {
  filter?: Maybe<AllSupportArticlesFilterInput>
  isPrivate?: Maybe<Scalars['Boolean']>
}

export type QueryAllSupportSectionsArgs = {
  isPrivate?: Maybe<Scalars['Boolean']>
}

export type QuerySupportScheduleArgs = {
  input: ScheduleInput
}

export type QueryHelpFormContentArgs = {
  form: HelpFormType
}

export type QuerySupportArticleArgs = {
  id: Scalars['ID']
  isPrivate?: Maybe<Scalars['Boolean']>
}

export type QuerySupportSectionArgs = {
  sectionId: Scalars['ID']
  isPrivate?: Maybe<Scalars['Boolean']>
}

export type QuerySupportCategoryArgs = {
  categoryId: Scalars['ID']
}

export type QuerySupportArticlesBySectionIdArgs = {
  sectionId: Scalars['ID']
  isPrivate?: Maybe<Scalars['Boolean']>
}

export type QueryInstantSearchSupportArticlesArgs = {
  query: Scalars['String']
  isPrivate: Scalars['Boolean']
}

export type QuerySupportTicketFormArgs = {
  id: Scalars['ID']
}

export type QuerySupportTicketFormFieldArgs = {
  id: Scalars['ID']
}

export type QuerySearchSupportArticlesArgs = {
  query: Scalars['String']
  isPrivate: Scalars['Boolean']
}

export type QuerySupportSectionsByCategoryIdArgs = {
  categoryId: Scalars['ID']
  isPrivate?: Maybe<Scalars['Boolean']>
}

export type QueryAllCardTrackingStatusesArgs = {
  userId?: Maybe<Scalars['ID']>
}

export type QueryGenerateUpdatedPdfArgs = {
  input: PdfDownloadUrlInput
}

export type QueryParameterizedPdfArgs = {
  input: ParameterizedPdfInput
}

export type QueryPdfDownloadUrlArgs = {
  input: PdfDownloadUrlInput
}

export type QuerySearchEmployersArgs = {
  input: SearchEmployersInput
}

export type QueryAllCheckPaymentsArgs = {
  pageInput?: Maybe<PageInput>
}

export type QueryVerifyCheckPaymentRecipientAddressArgs = {
  input: VerifyCheckPaymentRecipientAddressInputType
}

export type QueryClosureReasonsByInvestmentAccountTypeArgs = {
  product?: Maybe<InvestmentProduct>
}

export type QueryEarlyAccountStateRegulationArgs = {
  stateCode?: Maybe<Scalars['String']>
}

export type QueryEarlyAccountTransferInfoArgs = {
  investmentAccountId: Scalars['ID']
}

export type QueryEtfArgs = {
  symbol: Scalars['String']
}

export type QueryInvestmentAccountArgs = {
  id: Scalars['ID']
}

export type QueryInvestmentAccountByBeneficiaryIdArgs = {
  beneficiaryId: Scalars['ID']
}

export type QueryInvestmentAccountsByUserIdArgs = {
  filter?: Maybe<InvestmentAccountsByUserIdFilter>
}

export type QueryLaterContributionAbilityArgs = {
  investmentAccountId?: Maybe<Scalars['ID']>
}

export type QueryPastLaterSummaryArgs = {
  investmentAccountId?: Maybe<Scalars['ID']>
}

export type QueryWithholdingEstimatesArgs = {
  federalWithholdingPercentage: Scalars['Float']
  investmentAccountId: Scalars['ID']
  reason?: Maybe<LaterWithdrawalReason>
  stateWithholdingPercentage: Scalars['Float']
  withdrawalAmount: CurrencyAmountInput
}

export type QueryYearLaterReportArgs = {
  year: Scalars['Int']
}

export type QueryRecurringTransfersArgs = {
  filter?: Maybe<RecurringTransfersFilterInput>
}

export type QueryNextTransferDateArgs = {
  recurrenceRule: RecurrenceRuleInput
}

export type QueryProtectInsuranceHomeArgs = {
  insuranceType: InsuranceType
}

export type QueryProtectLifeQuotePremiumsArgs = {
  parameters: PremiumsInput
}

export type QueryProtectLifeQuoteSurveyArgs = {
  providerName: ProviderName
}

export type QueryProtectProvidersArgs = {
  insuranceType: InsuranceType
}

export type QueryActivitySummaryArgs = {
  product?: Maybe<ActivitySummaryProduct>
  accountId?: Maybe<Scalars['ID']>
}

export type QueryFinishSetupArgs = {
  feedContext: FeedContext
  accountId: Scalars['ID']
}

export type QueryOnboardingTipsArgs = {
  feedContext: FeedContext
}

export type QueryActiveEarnOffersArgs = {
  tag?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  cursor?: Maybe<Scalars['String']>
}

export type QueryEarnOfferByCampaignOfferIdArgs = {
  campaignOfferId: Scalars['String']
  origin: Scalars['String']
  sessionId: Scalars['String']
}

export type QuerySearchActiveEarnOffersArgs = {
  searchTerm: Scalars['String']
  tag?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  cursor?: Maybe<Scalars['String']>
}

export type QueryPartnerOfferGroupArgs = {
  id: Scalars['String']
  filter?: Maybe<PartnerOfferGroupFilterInput>
}

export type QueryPartnerOfferGroupsByTypeArgs = {
  partnerOfferGroupsTypeInput: PartnerOfferGroupsTypeInput
}

export type QueryJobSearchArgs = {
  searchCriteria: JobSearchCriteriaInput
}

export type QueryJobSearchV2Args = {
  searchCriteria: JobSearchCriteriaInput
  pagination: PageInput
  saveAsRecentSearch?: Maybe<Scalars['Boolean']>
}

export type QueryMilestoneArgs = {
  id: Scalars['ID']
}

export type QueryMilestonesByThemeArgs = {
  theme: MilestoneTheme
  filter?: Maybe<MilestoneByThemeFilterInput>
}

export type QueryMilestoneChallengeArgs = {
  id: Scalars['ID']
}

export type QueryMilestoneHubEligibleArgs = {
  registrationCompletedAt: Scalars['DateTime']
}

export type QueryMilestoneAchievementActionRuleArgs = {
  milestoneID: Scalars['ID']
}

export type QueryAccountPointsRuleByMilestoneIdArgs = {
  milestoneID: Scalars['ID']
}

export type QueryDocumentRequestArgs = {
  input: DocumentRequestInput
}

export type QueryDocumentRequestsArgs = {
  input: DocumentRequestsInput
}

export type QueryOfferArgs = {
  id: Scalars['ID']
}

export type QueryProductArgs = {
  id: Scalars['ID']
}

export type QueryProductByKeyArgs = {
  productKey: ProductKey
}

export type QueryPromotionArgs = {
  id: Scalars['ID']
}

export type QueryPromotionsByUserIdArgs = {
  filter?: Maybe<PromotionFilterInput>
  limit?: Maybe<Scalars['Int']>
}

export type QuerySubscriptionMigrationArgs = {
  id: Scalars['ID']
}

export type QuerySubscriptionMigrationWaiverArgs = {
  id: Scalars['ID']
}

export type QueryTierArgs = {
  id: Scalars['ID']
}

export type QueryTierGroupArgs = {
  id?: Maybe<Scalars['ID']>
}

export type QueryTierOptionByProductKeyArgs = {
  productKey: ProductKey
  tierGroupId?: Maybe<Scalars['ID']>
}

export type QueryTierOptionByTierPriceIdArgs = {
  tierPriceId: Scalars['ID']
}

export type QueryTierSubscriptionArgs = {
  id: Scalars['ID']
}

export type QueryTierSubscriptionHistoryByUserIdArgs = {
  after?: Maybe<Scalars['String']>
  limit?: Maybe<Scalars['Int']>
  reverse?: Maybe<Scalars['Boolean']>
}

export type QuerySplitDepositSettingsArgs = {
  id: Scalars['ID']
}

export type QuerySplitDepositSettingsByUserIdArgs = {
  filter?: Maybe<SplitDepositSettingsFilterInput>
  normalizeToFrequency?: Maybe<SplitDepositNormalizationFrequency>
}

export type QuerySmartDepositMetadataArgs = {
  smartDepositMetadataInput: SmartDepositMetadataInput
}

export type QueryOutsideContributionCodeArgs = {
  id: Scalars['ID']
}

export type QueryOutsideContributionCodeByCodeArgs = {
  code: Scalars['String']
}

export type QueryOutsideContributionCodeByInvestmentAccountIdArgs = {
  investmentAccountId: Scalars['ID']
}

export type QueryEarnCtaDataByUserIdArgs = {
  id: Scalars['ID']
}

export type QueryBankFeesByUserIdArgs = {
  first: Scalars['Int']
  offset: Scalars['Int']
  statusFilter: Array<Maybe<FeeStatusFilter>>
}

export type QueryAuthenticateForFeeNegotiationStatusByLinkedAccountIdArgs = {
  linkedAccountId: Scalars['ID']
}

export type QueryFriendArgs = {
  advocateReferralCode?: Maybe<Scalars['String']>
}

export type QuerySecurityBySymbolArgs = {
  input: SecurityBySymbolInput
}

export type QuerySecurityPerformanceBySymbolArgs = {
  input: SecurityPerformanceBySymbolInput
}

export type QueryCohortEligibilityArgs = {
  scopes: CohortEligibilityScope[]
}

/** Insurance onboarding question */
export type Question = {
  __typename?: 'Question'
  /** body text */
  body?: Maybe<Scalars['String']>
  /** Default answer */
  defaultAnswer?: Maybe<Answer>
  /** eyebrow text */
  eyebrow?: Maybe<Scalars['String']>
  /** headline text */
  headline?: Maybe<Scalars['String']>
  /** Internal question ID */
  id: Scalars['ID']
  /** image */
  image?: Maybe<Image>
  /** Possible answers to be selected for the related question */
  possibleAnswers?: Maybe<Answer[]>
  /** tip text */
  tip?: Maybe<Scalars['String']>
  /** title text */
  title?: Maybe<Scalars['String']>
  /** Onboarding step type */
  type: OnboardingStepType
}

/** Possible answer for questions */
export type QuestionAnswer = {
  __typename?: 'QuestionAnswer'
  /** name identifier */
  name: QuestionAnswerName
  /** Question Answer text */
  title: Scalars['String']
}

export enum QuestionAnswerName {
  /** male gender */
  Male = 'male',
  /** female gender */
  Female = 'female',
  /** other genders */
  Other = 'other',
  /** boolean yes */
  Yes = 'yes',
  /** boolean no */
  No = 'no',
}

/** A user response for a question */
export type QuestionResponse = {
  /** Question asked */
  questionId: Scalars['ID']
  /** Associated answers to the question */
  answers: Array<Scalars['ID']>
}

export enum QuoteOrigin {
  /** indicates user accessed quote through Protect */
  Protect = 'PROTECT',
  /** indicates user accessed quote through Found Money */
  FoundMoney = 'FOUND_MONEY',
}

export type QuoteResult = IneligibilityLander | LifeQuoteResultSliders

export type QuoteSlider = {
  __typename?: 'QuoteSlider'
  body?: Maybe<Scalars['String']>
  defaultValue: Scalars['Int']
  headline: Scalars['String']
  maxLabel?: Maybe<Scalars['String']>
  minLabel?: Maybe<Scalars['String']>
  possibleValues: Array<Scalars['Int']>
  questionName: Scalars['String']
  tip?: Maybe<Tip>
}

export enum QuoteStatus {
  /** successfully retrieved insurance quote */
  Success = 'success',
  /** user is ineligible for insurance quote */
  Ineligible = 'ineligible',
}

/** A user's metadata */
export type QuoteUserMetadata = {
  /** campaign id */
  campaignId: Scalars['ID']
  /** session id */
  sessionId: Scalars['ID']
  /** quote origin */
  origin: QuoteOrigin
}

/** The link token for use in the client created account link URL. */
export type RawLinkSession = {
  __typename?: 'RawLinkSession'
  /** The External ID that should be used in the link creation process. */
  externalId: Scalars['ID']
  /** The Link Token a client should use for account linking. */
  token: Scalars['String']
}

/** RDVs are required user alert. */
export type RdvRequiredUserAlert = UserAlertsItem & {
  __typename?: 'RdvRequiredUserAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** The current funding source must be verified with RDVs prior to linking */
export type RdvVerificationRequired = {
  __typename?: 'RdvVerificationRequired'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId?: Maybe<Scalars['ID']>
}

export type RecaptchaException = {
  __typename?: 'RecaptchaException'
  errorCodes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type Recommendations = {
  __typename?: 'Recommendations'
  body: Scalars['String']
  cta: Cta
  id: Scalars['ID']
  image: Image
  title: Scalars['String']
  widgets: RecommendationWidget[]
}

export type RecommendationWidget = BriefInsuranceSection

/** Return type for the protectRecommendedLifeCoverage query */
export type RecommendedLifeCoverage = {
  __typename?: 'RecommendedLifeCoverage'
  about: AboutSection
  cta: Cta
  disclaimer: Disclaimer
  title: Scalars['String']
  widgets: RecommendedLifeCoverageWidget[]
}

export type RecommendedLifeCoverageWidget =
  | CollapsedLifeRecommendation
  | ExpandedLifeRecommendation
  | InsuranceCarousel

/** Duplicate Record Exists Error */
export type RecordAlreadyExistsError = {
  __typename?: 'RecordAlreadyExistsError'
  message: Scalars['String']
}

export type RecordDoesNotExistError = {
  __typename?: 'RecordDoesNotExistError'
  message: Scalars['String']
}

export enum RecurrenceFrequency {
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY',
}

export type RecurrenceRule = {
  __typename?: 'RecurrenceRule'
  frequency: RecurrenceFrequency
  byWeekDay?: Maybe<DayOfWeek[]>
  byMonthDay?: Maybe<Array<Scalars['Int']>>
  interval: Scalars['Int']
  startDate?: Maybe<Scalars['DateTime']>
  endDate?: Maybe<Scalars['DateTime']>
}

export type RecurrenceRuleInput = {
  frequency: RecurrenceFrequency
  byWeekDay?: Maybe<DayOfWeek[]>
  byMonthDay?: Maybe<Array<Scalars['Int']>>
  interval: Scalars['Int']
  startDate?: Maybe<Scalars['DateTime']>
  endDate?: Maybe<Scalars['DateTime']>
}

export type RecurringInvestmentInput = {
  amount: Scalars['Float']
  day: Scalars['Int']
  frequency: InvestmentFrequency
  investmentAccountId?: Maybe<Scalars['String']>
}

export type RecurringInvestmentPayload = {
  __typename?: 'RecurringInvestmentPayload'
  recurringInvestmentSettings: RecurringInvestmentSettings
}

/** Recurring deposit settings for an account */
export type RecurringInvestmentSettings = TimestampsInterface & {
  __typename?: 'RecurringInvestmentSettings'
  amount?: Maybe<Scalars['Float']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  day?: Maybe<Scalars['Int']>
  frequency?: Maybe<InvestmentFrequency>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export type RecurringTransfer = {
  __typename?: 'RecurringTransfer'
  id: Scalars['ID']
  recurrenceRule: RecurrenceRule
  active: Scalars['Boolean']
  transferEvent: RecurringTransferEvent
  nextTransferDate?: Maybe<Scalars['Date']>
}

export type RecurringTransferAccount = {
  __typename?: 'RecurringTransferAccount'
  type: RecurringTransferAccountType
  id: Scalars['ID']
}

export type RecurringTransferAccountIdFilterInput = {
  targetAccountId: Scalars['ID']
  filter?: Maybe<RecurringTransferDirectionFilterInput>
}

export type RecurringTransferAccountInput = {
  type: RecurringTransferAccountType
  id: Scalars['ID']
}

export enum RecurringTransferAccountType {
  Spend = 'SPEND',
}

export type RecurringTransferDate = {
  __typename?: 'RecurringTransferDate'
  nextTransferDate?: Maybe<Scalars['Date']>
}

export enum RecurringTransferDirection {
  Deposit = 'DEPOSIT',
  Withdrawal = 'WITHDRAWAL',
}

export type RecurringTransferDirectionFilterInput = {
  direction: RecurringTransferDirection
}

export type RecurringTransferEvent = {
  __typename?: 'RecurringTransferEvent'
  targetAccount: RecurringTransferAccount
  fundingSource: RecurringTransferFundingSource
  direction: RecurringTransferDirection
  amount: CurrencyAmount
}

export type RecurringTransferEventInput = {
  targetAccount: RecurringTransferAccountInput
  fundingSource: RecurringTransferFundingSourceInput
  direction: RecurringTransferDirection
  amount: CurrencyAmountInput
}

export type RecurringTransferFundingSource = {
  __typename?: 'RecurringTransferFundingSource'
  type: RecurringTransferFundingSourceType
  id: Scalars['ID']
}

export type RecurringTransferFundingSourceInput = {
  type: RecurringTransferFundingSourceType
  id: Scalars['ID']
}

export enum RecurringTransferFundingSourceType {
  Internal = 'INTERNAL',
  External = 'EXTERNAL',
}

export type RecurringTransferPathException = {
  __typename?: 'RecurringTransferPathException'
  path: Array<Scalars['String']>
  exception: RecurringTransferPathExceptionCase
}

export enum RecurringTransferPathExceptionCase {
  Blank = 'BLANK',
  InvalidValue = 'INVALID_VALUE',
}

export type RecurringTransfersFilterInput = {
  targetAccountType: RecurringTransferAccountType
  filter?: Maybe<RecurringTransferAccountIdFilterInput>
}

/** Fetch a referral */
export type Referral = {
  __typename?: 'Referral'
  code: Scalars['String']
  referreeRewardAmount: Scalars['Float']
  referrerRewardAmount: Scalars['Float']
  url: Scalars['String']
}

/** Object with friend campaign information such as completed events and reward statuses */
export type ReferralCampaign = {
  __typename?: 'ReferralCampaign'
  /** The id of the friend participating in the campaign */
  friendUserId?: Maybe<Scalars['ID']>
  /** The email of the friend participating in the campaign */
  friendEmail: Scalars['String']
  /** The id of the advocate participating in the campaign */
  advocateUserId?: Maybe<Scalars['ID']>
  /** The email of the advocate participating in the campaign */
  advocateEmail: Scalars['String']
  /** The id of the referral campaign that is also associated with the campaign id in Extole */
  campaignId: Scalars['ID']
  /** The name of the campaign */
  name?: Maybe<Scalars['String']>
  /** A list of events and their statuses to earn reward */
  events?: Maybe<ReferralEvent[]>
  /** Friend Reward for completing all necessary steps */
  friendRewards?: Maybe<ReferralReward[]>
  /**
   * Advocate Reward for completing all necessary steps. The object assumes that the
   * advocateUserId on type ReferralCampaign is the user that will receive the reward, but
   * friends can potentially have multiple advocates. Further investigation may be required.
   */
  advocateRewards?: Maybe<ReferralReward[]>
}

/** Object containing status of event associated with a Referral */
export type ReferralEvent = {
  __typename?: 'ReferralEvent'
  /**
   * Referral event nonce
   * @deprecated Field no longer supported
   */
  referralEventId?: Maybe<Scalars['String']>
  /** Type of referral event */
  referralEventType: ReferralEventType
  /** Status based on activity of friend */
  status: ReferralEventStatus
  /** Date event was completed if status is 'COMPLETED' */
  dateCompleted?: Maybe<Scalars['DateTime']>
}

/** input type specifying the parameters to create an event */
export type ReferralEventInput = {
  eventType: ReferralEventType
  userId: Scalars['String']
  eventNonce?: Maybe<Scalars['ID']>
  eventDetails?: Maybe<Scalars['JSON']>
}

/** Status of referral events */
export enum ReferralEventStatus {
  /** Friend has initiated event but event has not fully processed */
  Pending = 'PENDING',
  /** Friend has completed event */
  Completed = 'COMPLETED',
  /** Friend has not started or completed event */
  NotStarted = 'NOT_STARTED',
}

/** Descriptions of User actions needed to earn reward */
export enum ReferralEventType {
  /** User has made initial investment into core account */
  InvestCore = 'INVEST_CORE',
  /** User has made initial investment into early account */
  InvestEarly = 'INVEST_EARLY',
  /** User has made initial investment into later account */
  InvestLater = 'INVEST_LATER',
  /** User has signed the referral agreement */
  ReferralAgreementSigned = 'REFERRAL_AGREEMENT_SIGNED',
  /** User has initialized the registration process */
  SignedUp = 'SIGNED_UP',
  /** User has been verified */
  UserVerified = 'USER_VERIFIED',
  /** User has a funding source linked */
  FsLinked = 'FS_LINKED',
  /** User has completed registration */
  RegistrationCompleted = 'REGISTRATION_COMPLETED',
  /** User has opened a Later account */
  LaterAccountOpened = 'LATER_ACCOUNT_OPENED',
  /** User has opened an Early account */
  EarlyAccountOpened = 'EARLY_ACCOUNT_OPENED',
  /** User has opened a Spend account */
  SpendAccountOpened = 'SPEND_ACCOUNT_OPENED',
  /** User has made a transfer into a Spend Account */
  DepositSpend = 'DEPOSIT_SPEND',
  /** Unknown referral event type */
  Unknown = 'UNKNOWN',
}

/** Object that holds referral statistics for an Acorns User */
export type ReferralHistory = {
  __typename?: 'ReferralHistory'
  /** The number of status pending referrals for a user */
  numPendingReferrals?: Maybe<Scalars['Int']>
  /** The number of completed referrals for a user */
  numCompletedReferrals?: Maybe<Scalars['Int']>
  /** The total monetary reward amount the user has earned */
  totalReferralRewardsEarned?: Maybe<CurrencyAmount>
  friendSummary?: Maybe<FriendSummary[]>
}

/** Object containing reward information for completing a campaign */
export type ReferralReward = {
  __typename?: 'ReferralReward'
  /** Name of the referral reward */
  name?: Maybe<Scalars['String']>
  /** Value of reward for completing all events in a campaign */
  value: Scalars['String']
  /** Value type for completing all events in a campaign */
  valueType?: Maybe<ReferralValueType>
  /** The status of the reward associated with activity campaign */
  rewardStatus?: Maybe<ReferralRewardStatus>
  /** The date the reward was fulfilled (if applicable) */
  rewardFulfilledAtDate?: Maybe<Scalars['DateTime']>
}

/** The current status of a referral reward */
export enum ReferralRewardStatus {
  /** Reward has not been created */
  NotCreated = 'NOT_CREATED',
  /** User has earned reward by completing all campaign steps, but reward still needs to be issued. */
  Earned = 'EARNED',
  /** Reward has been issued by Acorns */
  Fulfilled = 'FULFILLED',
}

/** Summary of updated reward */
export type ReferralRewardSummary = {
  __typename?: 'ReferralRewardSummary'
  /** Status of this referral for Friend/Acorns User */
  status: ReferralRewardStatus
  /** The Acorns User acting as an advocate for this referral reward */
  advocateUserId?: Maybe<Scalars['ID']>
}

export enum ReferralRewardUpdateStatus {
  /** User and Friend have been rewarded */
  Rewarded = 'REWARDED',
  /** Referral has been cancelled */
  Cancelled = 'CANCELLED',
}

export enum ReferralStatus {
  /** Referral has been sent to a friend */
  Sent = 'SENT',
  /** Friend has used referral code but still has events they need to complete */
  Pending = 'PENDING',
  /** User and Friend have completed referral and should be rewarded */
  Completed = 'COMPLETED',
  /** User and Friend have been rewarded */
  Rewarded = 'REWARDED',
  /** Referral has expired because events were not finished before campaign end date */
  Expired = 'EXPIRED',
  /** Referral has been cancelled */
  Cancelled = 'CANCELLED',
}

/** input type specifyig the parameters that can be updated */
export type ReferralUserUpdateInput = {
  userId?: Maybe<Scalars['ID']>
  email: Scalars['String']
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
}

/** Value types of reward associated with completion of a referral */
export enum ReferralValueType {
  Usd = 'USD',
}

export type RefreshAuthTokenInput = {
  refreshToken: Scalars['String']
}

/** refreshAuthToken results */
export type RefreshAuthTokenResult = AuthSession | TokenExpiredException

export type RegisterEmailAuthenticatorInput = {
  email: Scalars['EmailAddress']
  name?: Maybe<Scalars['String']>
  setDefault?: Maybe<Scalars['Boolean']>
}

export type RegisterEmailAuthenticatorResult =
  | EmailAuthenticator
  | AuthChallengeAnswerIncorrectException
  | AuthChallengeAnswerAttemptsExhaustedException
  | AuthChallengeExpiredException
  | AuthenticatorTypeAlreadyRegisteredException
  | ExistingEmailVerifiedException

/** Returns a Linked Account Type or AsyncLinkSessionResult. */
export type RegisterLinkSessionResult = AsyncLinkSessionResult | LinkedAccount

export type RegisterPhoneAuthenticatorInput = {
  phoneNumber: Scalars['PhoneNumber']
  name?: Maybe<Scalars['String']>
  setDefault?: Maybe<Scalars['Boolean']>
}

export type RegisterPhoneAuthenticatorResult =
  | PhoneAuthenticator
  | AuthChallengeAnswerIncorrectException
  | AuthChallengeAnswerAttemptsExhaustedException
  | AuthChallengeExpiredException
  | InvalidPhoneNumberException
  | AuthenticatorTypeAlreadyRegisteredException

export type RegisterUserInput = {
  email: Scalars['EmailAddress']
  password: Scalars['String']
  udid: Scalars['String']
}

/** registerUser results */
export type RegisterUserResult =
  | AuthSession
  | EmailTakenException
  | InvalidPasswordException

/** Registration fields */
export type RegistrationInput = {
  /** The entry point for a registration */
  funnel: Funnel
}

export type ReinitiateSmsChallengeInput = {
  challengeId: Scalars['ID']
}

export type ReinitiateSmsChallengeResult =
  | SmsAuthChallenge
  | EmailAuthChallenge
  | AuthChallengeExpiredException

export type ReissueBankCardEligibility =
  | ReissueBankCardEligible
  | ReissueBankCardIneligible

export type ReissueBankCardEligible = {
  __typename?: 'ReissueBankCardEligible'
  originalCardCreatedAt: Scalars['Date']
}

export type ReissueBankCardExistsError = {
  __typename?: 'ReissueBankCardExistsError'
  /** BankCardRequest id / new bank card id */
  id: Scalars['ID']
}

export type ReissueBankCardIneligible = {
  __typename?: 'ReissueBankCardIneligible'
  issues: Array<Maybe<ReissueBankCardIneligibleIssue>>
}

export enum ReissueBankCardIneligibleIssue {
  CardAdminLocked = 'CARD_ADMIN_LOCKED',
  ActiveBankCardRequest = 'ACTIVE_BANK_CARD_REQUEST',
}

export type ReissueBankCardInput = {
  reason: BankCardRequestReason
  reasonComment?: Maybe<Scalars['String']>
  reasonDate?: Maybe<Scalars['Date']>
  mailingAddress: BankCardRequestMailingAddressInput
}

export type ReissueBankCardResult = BankCardRequest | ReissueBankCardExistsError

export enum RejectedReason {
  DocumentExpired = 'documentExpired',
  IncorrectDocumentType = 'incorrectDocumentType',
  IncorrectName = 'incorrectName',
  InvalidResidentialAddress = 'invalidResidentialAddress',
  MissingName = 'missingName',
  NoVisibleDate = 'noVisibleDate',
  PoorImageQuality = 'poorImageQuality',
  MismatchedName = 'mismatchedName',
  NotEligibleForPromotion = 'notEligibleForPromotion',
  SsnAlreadyUsed = 'ssnAlreadyUsed',
}

export type RejectUploadedDocumentInput = {
  note?: Maybe<Scalars['String']>
  reason: RejectedReason
  documentRequestId: Scalars['ID']
  reviewerId: Scalars['ID']
}

/** Relink Linked Account Alert. */
export type RelinkLinkedAccountAlert = UserAlertsItem & {
  __typename?: 'RelinkLinkedAccountAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Indicates remove operation succeeded */
export type RemovedJobAlert = {
  __typename?: 'RemovedJobAlert'
  id: Scalars['ID']
}

export type RemoveJobAlertResult = RemovedJobAlert

/** Reopen User Account Response */
export type ReopenUserAccountResult =
  | UserNotFoundException
  | UserReopenLockedException
  | UserReopenSuspendedException
  | User_V2

export type ReportBankCardLostStolenInput = {
  lockReason: BankCardPermanentLockReason
}

export type ReportBankCardLostStolenPayload = {
  __typename?: 'ReportBankCardLostStolenPayload'
  bankCard?: Maybe<BankCard>
}

export type RequestAccountClosureInput = {
  comments?: Maybe<Scalars['String']>
  reason: Scalars['String']
}

export type RequestDocumentUploadInput = {
  documentType: DocumentType
  /** ID of the entity being indirectly referenced by this request */
  externalId?: Maybe<Scalars['ID']>
  /** ID of previously rejected document request */
  parentRequestId?: Maybe<Scalars['ID']>
  requestedFileCount?: Maybe<Scalars['Int']>
  /** ID of support rep that requested the document */
  requesterId?: Maybe<Scalars['ID']>
  /** Idempotency key for ensuring that duplicate requests are not made */
  requestKey?: Maybe<Scalars['String']>
}

/** Input for closing an early investment account */
export type RequestEarlyAccountClosureInput = {
  /** The ID's of the early accounts to be closed */
  investmentAccountIds: Array<Scalars['ID']>
  /** The reason for the account closure */
  reason: InvestmentAccountClosureReason
}

/** Result from closing an Investment Account */
export type RequestEarlyAccountClosureResult =
  | AccountAlreadyClosedException
  | ClosureRequestExistsException
  | FundingSourceRequiresRdvException
  | InternalErrorException
  | InvalidAccountTypeException
  | InvestmentAccount
  | InvestmentAccountNeedsTransferException
  | MissingFundingSourceException

/** Input for requesting to reopen an investment account */
export type RequestInvestmentAccountReopenInput = {
  /** The ID of the investment account to be reopened */
  investmentAccountId: Scalars['ID']
}

/** Result from requesting to reopen an investment account */
export type RequestInvestmentAccountReopenResult =
  | ExistingRequestPendingReview
  | ExistingRequestPendingUserAction
  | InvalidSubscriptionTierException
  | InvestmentAccountNotClosedException
  | InvestmentAccountNotFoundException
  | InvestmentAccountReopenRequest

export type RequestSubscriptionMigrationWaiverInput = {
  reason: SubscriptionMigrationWaiverReason
  subscriptionMigrationId: Scalars['ID']
}

export type RequestSubscriptionMigrationWaiverResult =
  | InvalidTierForMigrationError
  | SubscriptionMigrationInvalidError
  | SubscriptionMigrationWaiver

export type ResourceNotFoundError = {
  __typename?: 'ResourceNotFoundError'
  requestId: Scalars['ID']
}

/** A registration record for a prospective user */
export type Result = {
  __typename?: 'Result'
  funnel: Funnel
}

export enum RetirementPlanAccess {
  /** Single user has access to an employer's retirement plan */
  Yes = 'yes',
  /** Single user has no access to retirement plan */
  No = 'no',
  /** Married user and spouse have access to a retirement plan */
  Both = 'both',
  /** Married user has access to a retirement plan without spouse */
  OnlyMe = 'onlyMe',
  /** Married user does not have access to a retirement plan, but spouse does */
  Spouse = 'spouse',
  /** Neither married user nor spouse have access to a retirement plan */
  Neither = 'neither',
}

/** A returned check */
export type ReturnedCheckDeposit = {
  __typename?: 'ReturnedCheckDeposit'
  /** Amount for check. */
  amount: CurrencyAmount
  /** Date check was returned. */
  rejectedDate: Scalars['DateTime']
  /** Returned Check Deposit Image URL for front of check. */
  frontCheckImageUrl: Scalars['String']
  /** Returned Check Deposit Image URL for back of check. */
  backCheckImageUrl: Scalars['String']
}

export type RewardSummary = {
  __typename?: 'RewardSummary'
  value: Scalars['Float']
  currency: Scalars['String']
}

export enum RiskStatus {
  Fixable = 'fixable',
  Confirmable = 'confirmable',
  HardReject = 'hard_reject',
}

export enum RolloverAccountCode {
  Est = 'EST',
  Roi = 'ROI',
  Esr = 'ESR',
  Drb = 'DRB',
  Ria = 'RIA',
  Skt = 'SKT',
  Sep = 'SEP',
  Sti = 'STI',
  Gvb = 'GVB',
  Tia = 'TIA',
}

export type RolloverAccounts = {
  __typename?: 'RolloverAccounts'
  accounts?: Maybe<Array<Maybe<RolloverAccountType>>>
}

export type RolloverAccountType = {
  __typename?: 'RolloverAccountType'
  name: Scalars['String']
  code: RolloverAccountCode
}

/** A transaction with excess change to invest into an Acorns account */
export type RoundUp = TimestampsInterface & {
  __typename?: 'RoundUp'
  amount: Scalars['Float']
  change: Scalars['Float']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  instant: Scalars['Boolean']
  investmentId?: Maybe<Scalars['ID']>
  investmentNonce?: Maybe<Scalars['ID']>
  linkedSubaccountId: Scalars['ID']
  manual: Scalars['Boolean']
  multiplier?: Maybe<Scalars['Float']>
  name: Scalars['String']
  roundUpAccount: RoundUpAccount
  roundUpProfile: RoundUpProfile
  state: RoundUpState
  /** The target account in which this round up has been invested. */
  targetAccountId?: Maybe<Scalars['ID']>
  total?: Maybe<Scalars['Float']>
  transactionDate: Scalars['DateTime']
  transactionDisplayDate: Scalars['Date']
  transactionId: Scalars['ID']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
}

/** Round up settings for a specific linked account */
export type RoundUpAccount = TimestampsInterface & {
  __typename?: 'RoundUpAccount'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  enabled: Scalars['Boolean']
  linkedSubaccountId: Scalars['ID']
  roundUpProfile: RoundUpProfile
  roundUps: RoundUp[]
  startDate?: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
}

/** Round up settings for a user */
export type RoundUpProfile = TimestampsInterface & {
  __typename?: 'RoundUpProfile'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  multiplier: Scalars['Float']
  realTimeRoundUpEligible: Scalars['Boolean']
  roundUpAccounts: RoundUpAccount[]
  roundUpCount: Scalars['Int']
  roundUpTotal: Scalars['Float']
  roundUps: RoundUp[]
  roundUpsEnabled: Scalars['Boolean']
  /**
   * True if user has auto roundups off (making all roundups manual, even from
   * Spend accounts)or at least one enabled non-spend roundup account.
   */
  showRoundUpsProgress: Scalars['Boolean']
  /** The target account to which a user's round up investments will be made. */
  targetAccountId?: Maybe<Scalars['ID']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
  wholeDollarAmount: Scalars['Float']
}

/** Round up settings for a user */
export type RoundUpProfileRoundUpCountArgs = {
  state?: Maybe<RoundUpState[]>
  spend?: Maybe<Scalars['Boolean']>
  targetAccountId?: Maybe<Scalars['ID']>
}

/** Round up settings for a user */
export type RoundUpProfileRoundUpTotalArgs = {
  state?: Maybe<RoundUpState[]>
  spend?: Maybe<Scalars['Boolean']>
  targetAccountId?: Maybe<Scalars['ID']>
}

/** Changeable attributes for user profiles */
export type RoundUpProfileInput = {
  /** Toggle global user setting for auto round ups */
  roundUpsEnabled?: Maybe<Scalars['Boolean']>
  /** Round up multiplier */
  multiplier?: Maybe<Scalars['Float']>
  /** Round up to custom dollar amount */
  wholeDollarAmount?: Maybe<Scalars['Float']>
  /** Acorns account ID of roundups destination */
  targetAccountId?: Maybe<Scalars['ID']>
}

export enum RoundUpState {
  /** Round ups that have yet to be invested */
  Pending = 'pending',
  /** Round ups which are ready to be invested */
  Waiting = 'waiting',
  /** Round ups that requested to be invested but have not been transferred */
  RoundedUp = 'roundedUp',
  /** Round ups associated with an investment */
  Invested = 'invested',
  /** Round ups that were canceled, either before or after an investment was created */
  Canceled = 'canceled',
  /** Round ups that will be invested automatically */
  AutoInvestable = 'autoInvestable',
}

export enum RoundUpType {
  RealTime = 'realTime',
  Auto = 'auto',
}

/** An individual edge within the paginated list of RoundUpType */
export type RoundUpTypeEdge = {
  __typename?: 'RoundUpTypeEdge'
  /** The unique key used for pagination */
  cursor: Scalars['ID']
  /** The RoundUpType record in the edge */
  node: RoundUp
}

/** Relay style pagination information for RoundUpType */
export type RoundUpTypePagination = {
  __typename?: 'RoundUpTypePagination'
  edges: RoundUpTypeEdge[]
  pageInfo: PageInfo
}

export enum SalaryInterval {
  Hour = 'HOUR',
  Week = 'WEEK',
  Month = 'MONTH',
  Year = 'YEAR',
}

export type SamePasswordsException = {
  __typename?: 'SamePasswordsException'
  message: Scalars['String']
}

export type ScheduleInput = {
  type: ScheduleType
}

export type ScheduleRecurringTransferInput = {
  recurrenceRule: RecurrenceRuleInput
  transferEvent: RecurringTransferEventInput
}

export type ScheduleRecurringTransferResult =
  | RecurringTransfer
  | MalformedRecurringTransferException

export type ScheduleResult = {
  __typename?: 'ScheduleResult'
  active: Scalars['Boolean']
  name?: Maybe<Scalars['String']>
}

export enum ScheduleType {
  Chat = 'chat',
  Email = 'email',
  Phone = 'phone',
}

/** Query attributes for Employer Search */
export type SearchEmployersInput = {
  /** Search Term */
  searchTerm?: Maybe<Scalars['String']>
  /** Switch Type */
  switchType?: Maybe<SwitchType>
  /** Session ID */
  sessionId?: Maybe<Scalars['ID']>
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
}

/** Search Results */
export type SearchEmployersPayload = {
  __typename?: 'SearchEmployersPayload'
  results?: Maybe<Employer[]>
  /** Unique Tracking ID */
  trackingId: Scalars['ID']
}

export type SearchSupportArticleResult = {
  __typename?: 'SearchSupportArticleResult'
  id: Scalars['ID']
  author: SupportAuthor
  draft: Scalars['Boolean']
  promoted: Scalars['Boolean']
  position?: Maybe<Scalars['Int']>
  section: SupportSection
  createdAt: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
  name: Scalars['String']
  title: Scalars['String']
  outdated: Scalars['Boolean']
  editedAt: Scalars['DateTime']
  body: Scalars['String']
  snippet: Scalars['String']
  resultType: Scalars['String']
}

export type SearchSupportResult = {
  __typename?: 'SearchSupportResult'
  relevantSearchCategories: Array<Maybe<SupportCategory>>
  relevantSearchArticles: Array<Maybe<SearchSupportArticleResult>>
}

/** Secret Squirrel Error */
export type SecretSquirrelException = {
  __typename?: 'SecretSquirrelException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type Security = {
  symbol: Scalars['TickerSymbol']
  type: SecurityType
  week52High: BigCurrencyAmount
  week52Low: BigCurrencyAmount
  lastClosePrice: BigCurrencyAmount
  openPrice: BigCurrencyAmount
  shortName: Scalars['String']
  longName: Scalars['String']
  volume: Scalars['BigDecimal']
  marketCap: Scalars['BigDecimal']
  securityProfile: SecurityProfile
  securityHeadlines: SecurityHeadline[]
  lastUpdatedAt: Scalars['DateTime']
  earliestPriceDate: Scalars['Date']
}

/** Describes a target allocation percentage for the specified security */
export type SecurityAllocationTarget = {
  /** ID of the targeted security */
  securityId: Scalars['ID']
  /** Target allocation percentage, ex: 33 -> 33% */
  securityPercent: Scalars['Int']
}

export type SecurityAnswer = {
  questionId: Scalars['ID']
  response: Scalars['String']
}

export type SecurityBySymbolInput = {
  symbol: Scalars['TickerSymbol']
}

export type SecurityGain = {
  __typename?: 'SecurityGain'
  percent?: Maybe<Scalars['BigDecimal']>
  marketValue?: Maybe<BigCurrencyAmount>
}

export type SecurityHeadline = {
  __typename?: 'SecurityHeadline'
  createdAt: Scalars['DateTime']
  source: Scalars['String']
  headline: Scalars['String']
  storyUrl: Scalars['Url']
  thumbnailUrl?: Maybe<Scalars['Url']>
}

export type SecurityPerformance = {
  __typename?: 'SecurityPerformance'
  gain: SecurityGain
  prices?: Maybe<SecurityPrice[]>
}

export type SecurityPerformanceBySymbolInput = {
  symbol: Scalars['TickerSymbol']
  startDate: Scalars['String']
  endDate: Scalars['String']
}

export type SecurityPrice = {
  __typename?: 'SecurityPrice'
  date: Scalars['Date']
  marketValue: BigCurrencyAmount
}

export type SecurityProfile = {
  __typename?: 'SecurityProfile'
  description?: Maybe<Scalars['String']>
  tradingSectors: TradingSector[]
  logoUrl?: Maybe<Scalars['Url']>
  defaultLogoUrl?: Maybe<Scalars['Url']>
}

export type SecurityQuestion = {
  __typename?: 'SecurityQuestion'
  id?: Maybe<Scalars['ID']>
  text?: Maybe<Scalars['String']>
}

export type SecurityQuestionInput = {
  answer1: Scalars['String']
  question1: Scalars['String']
}

export enum SecurityType {
  Etf = 'ETF',
  Stock = 'STOCK',
  Bond = 'BOND',
}

/** User Directed Portfolio Object */
export type SelfDirectedPortfolio = BasePortfolio & {
  __typename?: 'SelfDirectedPortfolio'
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation
  /** Description of the portfolio */
  description: Scalars['String']
  /** ID of the Portfolio */
  id: Scalars['ID']
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String']
  /** Securities that are associated with the portfolio */
  portfolioSecurities?: Maybe<PortfolioSecurity[]>
}

export type SendCheckPaymentInput = {
  nonce: Scalars['String']
  recipient: CheckPaymentRecipientInput
  recipientAddress: CheckPaymentAddressInput
  amount: CurrencyAmountInput
  memo?: Maybe<Scalars['String']>
  fromAccountId: Scalars['ID']
}

/** Check or errors */
export type SendCheckPaymentResult =
  | CheckPayment
  | AuthorizationError
  | DuplicateActionError
  | InvalidAddressError

export type Session = {
  __typename?: 'Session'
  token: Scalars['ID']
  uuid: Scalars['ID']
  redirectUrl?: Maybe<Scalars['String']>
}

export type SetAuthenticationPinInput = {
  pin: Scalars['String']
  pinConfirmation: Scalars['String']
}

/** set authentication pin results */
export type SetAuthenticationPinResult =
  | SetAuthenticationPinSuccess
  | InvalidPinException
  | UserCredentialsNotFoundException

export type SetAuthenticationPinSuccess = {
  __typename?: 'SetAuthenticationPINSuccess'
  userId: Scalars['ID']
}

/** Response to a beneficiary ssn update */
export type SetBeneficiarySsnResult =
  | Beneficiary
  | BeneficiaryNotFoundException
  | InternalErrorException
  | InvalidSsnException
  | SecretSquirrelException
  | SsnAlreadyInUseException
  | SsnMatchesCustodianException
  | SsnUpdateForbiddenException

export type SetDefaultAuthenticatorInput = {
  authenticatorId: Scalars['ID']
}

export type SetDefaultAuthenticatorResult =
  | PhoneAuthenticator
  | EmailAuthenticator
  | AuthenticatorNotFoundException
  | AuthenticatorAlreadyDefaultException

/** Options to set an account with a linking error */
export type SetLinkingErrorInput = {
  /** Error to give the linked account */
  code: LinkedAccountLinkingErrorsEnum
}

export type SetPortfolioInput = {
  id: Scalars['ID']
}

export type Settings = {
  __typename?: 'Settings'
  /** @deprecated Highly non-performant! */
  automaticRoundup: Scalars['Boolean']
  /** @deprecated Highly non-performant! */
  allowDebitCard: Scalars['Boolean']
  /** @deprecated Highly non-performant! */
  threshold: Scalars['Int']
  /** @deprecated Highly non-performant! */
  dollarRoundupAmount: Scalars['Float']
  /** @deprecated Highly non-performant! */
  roundupMultiplier: Scalars['Int']
  depositsSuspended?: Maybe<Scalars['Boolean']>
  /** @deprecated Highly non-performant! */
  notifications: Notifications
}

export type SetUpTip = {
  __typename?: 'SetUpTip'
  backgroundImage: Image
  body: Scalars['String']
  ctaDetails: ActionFeedCta
  id: Scalars['ID']
  image: Image
  type: ProductSetupTipType
}

export type Signature = TimestampsInterface & {
  __typename?: 'Signature'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Type of profile */
  profile?: Maybe<Profile>
  /** Type of signature */
  signatureType: SignatureType
  /** SVG file */
  svgFile: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Internal ID for user */
  userId: Scalars['ID']
}

export enum SignatureType {
  /** A signature for the user investment certificate */
  Certificate = 'certificate',
  /** A signature used for the user spend debit card */
  DebitCard = 'debitCard',
  /** A signature used for the user direct deposit PDF form */
  DirectDeposit = 'directDeposit',
}

export type SmartDepositMetadataInput = {
  supportedTargetAccounts: SplitDepositTargetAccountType[]
}

export type SmartDepositMetadataResult = {
  __typename?: 'SmartDepositMetadataResult'
  recommendedAllocations: SplitDepositAllocation[]
  targetAccounts: SplitDepositTargetAccount[]
}

export type SmsAuthChallenge = AuthChallenge & {
  __typename?: 'SMSAuthChallenge'
  id: Scalars['ID']
  maskedPhoneNumber: Scalars['String']
  alternateAuthenticators: AuthenticatorInfo[]
}

export type SocialCopies = {
  __typename?: 'SocialCopies'
  campaignTaxonomy?: Maybe<Scalars['String']>
  category?: Maybe<Scalars['String']>
  copy?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  targetMedium?: Maybe<Scalars['String']>
}

export type SpendAccount = {
  __typename?: 'SpendAccount'
  status: SpendAccountStatus
  isReopenable?: Maybe<Scalars['Boolean']>
  isEligible: Scalars['Boolean']
  lockReason?: Maybe<BankAccountLockReason>
  bankCardOrder?: Maybe<BankCardOrder>
  isDirectDepositIncentiveEligible: Scalars['Boolean']
}

export enum SpendAccountStatus {
  NotOpened = 'NOT_OPENED',
  Open = 'OPEN',
  Closed = 'CLOSED',
  Reopening = 'REOPENING',
  Locked = 'LOCKED',
  Opening = 'OPENING',
}

export type SpendAlert = {
  userId: Scalars['ID']
  type: Scalars['String']
}

export type SpendAtm = {
  __typename?: 'SpendAtm'
  address: SpendAtmAddress
  phoneNumber?: Maybe<Scalars['String']>
  atmName: Scalars['String']
  imageUrl?: Maybe<Scalars['String']>
}

export type SpendAtmAddress = {
  __typename?: 'SpendAtmAddress'
  latitude: Scalars['String']
  longitude: Scalars['String']
  addressLine?: Maybe<Scalars['String']>
  cityName?: Maybe<Scalars['String']>
  stateCode?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  postalCode?: Maybe<Scalars['String']>
}

export type SpendAtmReimbursementItem = PastItem &
  SpendItem & {
    __typename?: 'SpendATMReimbursementItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SpendAtmsCoordinateInput = {
  latitude: Scalars['String']
  longitude: Scalars['String']
}

export type SpendAtmsInput = {
  searchCoordinate: SpendAtmsCoordinateInput
  searchRadius?: Maybe<Scalars['Float']>
}

export type SpendAtmsPayload = {
  __typename?: 'SpendAtmsPayload'
  atms?: Maybe<Array<Maybe<SpendAtm>>>
  executedSearchRadius?: Maybe<Scalars['String']>
}

export type SpendAtmsResult = SpendAtmsPayload | SpendAtmVendorUnavailableError

export type SpendAtmVendorUnavailableError = {
  __typename?: 'SpendAtmVendorUnavailableError'
  requestId?: Maybe<Scalars['String']>
}

export type SpendAtmWithdrawalItem = PastItem &
  SpendItem & {
    __typename?: 'SpendATMWithdrawalItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SpendBillPayItem = PastItem &
  SpendItem & {
    __typename?: 'SpendBillPayItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SpendCheckDepositItem = PastItem &
  SpendItem & {
    __typename?: 'SpendCheckDepositItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SpendCheckPaymentItem = PastItem &
  SpendItem & {
    __typename?: 'SpendCheckPaymentItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SpendDigitalWalletItem = PastItem &
  SpendItem & {
    __typename?: 'SpendDigitalWalletItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SpendDirectDepositItem = PastItem &
  SpendItem & {
    __typename?: 'SpendDirectDepositItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SpendDisputesResponse = {
  __typename?: 'SpendDisputesResponse'
  id?: Maybe<Scalars['Int']>
  creationDateTime?: Maybe<Scalars['DateTime']>
  disputeDateTime?: Maybe<Scalars['DateTime']>
  description: Scalars['String']
  questions: SpendTransactionsDisputeQuestions[]
  transactions: SpendTransactionsResponse[]
}

export type SpendECheckItem = PastItem &
  SpendItem & {
    __typename?: 'SpendECheckItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

/** A base set of fields that each PastItem from Spend transactions must implement */
export type SpendItem = {
  /** When funds associated with the transaction became available. */
  availableAt?: Maybe<Scalars['DateTime']>
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String']
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String']
}

export type SpendPurchaseItem = PastItem &
  SpendItem & {
    __typename?: 'SpendPurchaseItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SpendRealTimeRoundUpItem = PastItem &
  SpendItem & {
    __typename?: 'SpendRealTimeRoundUpItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    /** The investment amount after being multiplied. */
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    /** The investment amount prior to being multiplied */
    initialAmount?: Maybe<CurrencyAmount>
    multiplier?: Maybe<Scalars['Int']>
  }

export type SpendTransactionsDisputeCustomersResponse = {
  __typename?: 'SpendTransactionsDisputeCustomersResponse'
  customerNumber?: Maybe<Scalars['String']>
  accountNumber?: Maybe<Scalars['String']>
  applicationCode?: Maybe<Scalars['String']>
  productCode?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  disputes: SpendDisputesResponse[]
}

export type SpendTransactionsDisputeQuestions = {
  __typename?: 'SpendTransactionsDisputeQuestions'
  question?: Maybe<Scalars['String']>
  answer?: Maybe<Scalars['String']>
}

export type SpendTransactionsDisputeResponse = {
  __typename?: 'SpendTransactionsDisputeResponse'
  customers: SpendTransactionsDisputeCustomersResponse
}

export type SpendTransactionsDisputeResult = SpendTransactionsDisputeResponse

export type SpendTransactionsInput = {
  id: Scalars['ID']
  amount: Scalars['String']
  description: Scalars['String']
  createdAt?: Maybe<Scalars['DateTime']>
  availableAt?: Maybe<Scalars['DateTime']>
  settledAt?: Maybe<Scalars['DateTime']>
  status: BankTransactionStatus
  tag?: Maybe<Scalars['String']>
  type: BankTransactionType
  typeCode: Scalars['String']
  updatedAt?: Maybe<Scalars['DateTime']>
  voidedAt?: Maybe<Scalars['DateTime']>
}

export type SpendTransactionsResponse = {
  __typename?: 'SpendTransactionsResponse'
  id?: Maybe<Scalars['Int']>
  status?: Maybe<Scalars['String']>
  description: Scalars['String']
  postingDate: Scalars['DateTime']
  amount: Scalars['Float']
  disputedAmount: Scalars['Float']
  transactionCode: Scalars['String']
  coreTransactionId: Scalars['String']
}

export type SpendTransferInItem = PastItem &
  SpendItem & {
    __typename?: 'SpendTransferInItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SpendTransferOutItem = PastItem &
  SpendItem & {
    __typename?: 'SpendTransferOutItem'
    /** Past Item ID */
    id: Scalars['ID']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
    /** The title of the item */
    title: Scalars['String']
    /** The current state of the item */
    status: PastItemStatus
    amount: CurrencyAmount
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** When funds associated with the transaction became available. */
    availableAt?: Maybe<Scalars['DateTime']>
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
  }

export type SplitDeposit = {
  __typename?: 'SplitDeposit'
  allocations: SplitDepositAllocation[]
  createdAt: Scalars['String']
  distributedAt?: Maybe<Scalars['String']>
  expectedNextDepositAmount?: Maybe<Scalars['String']>
  expectedNextDepositAt?: Maybe<Scalars['String']>
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isCancelable: Scalars['Boolean']
  isCanceled: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
  /** @deprecated deprecated, use allocations instead */
  savingsRatePercent: Scalars['String']
  settingsId: Scalars['ID']
  /** @deprecated deprecated, use allocations instead */
  splitDistribution: DistributionAmounts
  transactionAmount: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
  willDistributeAutomaticallyAt?: Maybe<Scalars['String']>
}

export type SplitDepositAllocation = {
  allocationPercent: Scalars['String']
  nickname?: Maybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

export type SplitDepositAllocationInput = {
  allocationPercent: Scalars['String']
  nickname?: Maybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

export type SplitDepositDailyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositDailyRecurrenceRule'
  frequency: SplitDepositRecurrenceFrequency
}

export type SplitDepositDirectDepositAllocation = SplitDepositAllocation & {
  __typename?: 'SplitDepositDirectDepositAllocation'
  allocationPercent: Scalars['String']
  nickname?: Maybe<Scalars['String']>
  normalizedAmount?: Maybe<FormattedMonetaryAmount>
  normalizedDailyAmount?: Maybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

export type SplitDepositDirectDepositIntentSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositDirectDepositIntentSetting'
  allocations: SplitDepositDirectDepositAllocation[]
  createdAt: Scalars['String']
  /** @deprecated deprecated */
  distributionType: DistributionType
  /** @deprecated use name instead */
  employer: Scalars['String']
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']
  /** @deprecated deprecated */
  employerName: Scalars['String']
  estimatedPaycheckAmount: CurrencyAmount
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
  name: Scalars['String']
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
  deposits?: Maybe<SplitDeposit[]>
}

export type SplitDepositDirectDepositIntentSettingDepositsArgs = {
  orderBy?: Maybe<Order>
  limit?: Maybe<Scalars['Int']>
}

export type SplitDepositDirectDepositSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositDirectDepositSetting'
  allocations: SplitDepositDirectDepositAllocation[]
  awaitingConfiguration: Scalars['Boolean']
  createdAt: Scalars['String']
  /** @deprecated deprecated */
  distributionType: DistributionType
  /** @deprecated use name instead */
  employer: Scalars['String']
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']
  /** @deprecated deprecated */
  employerName: Scalars['String']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
  name: Scalars['String']
  normalizedAmount?: Maybe<FormattedMonetaryAmount>
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
  deposits?: Maybe<SplitDeposit[]>
  totalAmounts?: Maybe<TotalAmounts>
}

export type SplitDepositDirectDepositSettingDepositsArgs = {
  orderBy?: Maybe<Order>
  limit?: Maybe<Scalars['Int']>
}

export type SplitDepositMonthlyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositMonthlyRecurrenceRule'
  byMonthDay: Array<Scalars['Int']>
  frequency: SplitDepositRecurrenceFrequency
}

export type SplitDepositMutation = {
  __typename?: 'SplitDepositMutation'
  id: Scalars['ID']
  userId: Scalars['ID']
  execute: SplitDeposit
  cancel: SplitDeposit
}

export enum SplitDepositNormalizationFrequency {
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY',
}

export type SplitDepositRecurrenceAllocation = SplitDepositAllocation & {
  __typename?: 'SplitDepositRecurrenceAllocation'
  allocationPercent: Scalars['String']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  legacyRecurrenceAmount?: Maybe<FormattedMonetaryAmount>
  legacyRecurrenceRule?: Maybe<SplitDepositRecurrenceRule>
  nickname?: Maybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

export enum SplitDepositRecurrenceFrequency {
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY',
}

export type SplitDepositRecurrenceRule = {
  frequency: SplitDepositRecurrenceFrequency
}

export type SplitDepositRecurrenceSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositRecurrenceSetting'
  allocations: SplitDepositRecurrenceAllocation[]
  createdAt: Scalars['String']
  /** @deprecated deprecated */
  distributionType: DistributionType
  /** @deprecated use name instead */
  employer: Scalars['String']
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']
  /** @deprecated deprecated */
  employerName: Scalars['String']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  name: Scalars['String']
  normalizedAmount?: Maybe<FormattedMonetaryAmount>
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
  deposits?: Maybe<SplitDeposit[]>
}

export type SplitDepositRecurrenceSettingDepositsArgs = {
  orderBy?: Maybe<Order>
  limit?: Maybe<Scalars['Int']>
}

export type SplitDepositSettings = {
  allocations: SplitDepositAllocation[]
  createdAt: Scalars['String']
  /** @deprecated deprecated */
  distributionType: DistributionType
  /** @deprecated use name instead */
  employer: Scalars['String']
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']
  /** @deprecated deprecated */
  employerName: Scalars['String']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  name: Scalars['String']
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
  deposits?: Maybe<SplitDeposit[]>
}

export type SplitDepositSettingsDepositsArgs = {
  orderBy?: Maybe<Order>
  limit?: Maybe<Scalars['Int']>
}

export type SplitDepositSettingsFilterInput = {
  settingTypes: SplitDepositSettingType[]
  showHiddenEmployerSettings?: Maybe<Scalars['Boolean']>
}

export type SplitDepositSettingsMutation = {
  __typename?: 'SplitDepositSettingsMutation'
  employer: Scalars['String']
  employerHidden: Scalars['Boolean']
  id: Scalars['ID']
  userId: Scalars['ID']
  configure: SplitDepositSettings
}

export type SplitDepositSettingsMutationConfigureArgs = {
  input: ConfigureSettingsInput
}

export enum SplitDepositSettingType {
  DirectDeposit = 'DIRECT_DEPOSIT',
  DirectDepositIntent = 'DIRECT_DEPOSIT_INTENT',
  Recurrence = 'RECURRENCE',
}

export type SplitDepositTargetAccount = {
  __typename?: 'SplitDepositTargetAccount'
  nickname?: Maybe<Scalars['String']>
  targetAccountId?: Maybe<Scalars['ID']>
  targetAccountType: SplitDepositTargetAccountType
}

export enum SplitDepositTargetAccountType {
  Spend = 'SPEND',
  Invest = 'INVEST',
  Later = 'LATER',
  Early = 'EARLY',
  Save = 'SAVE',
}

export type SplitDepositWeeklyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositWeeklyRecurrenceRule'
  byWeekDay: DayOfWeek[]
  frequency: SplitDepositRecurrenceFrequency
}

/** This SSN already belongs to another beneficiary for this custodian */
export type SsnAlreadyInUseException = {
  __typename?: 'SsnAlreadyInUseException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** SSN supporting document requested user alert. */
export type SsnDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'SSNDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** This SSN is a duplicate of the current custodian's SSN */
export type SsnMatchesCustodianException = {
  __typename?: 'SsnMatchesCustodianException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** Beneficiary's ssn cannot be updated */
export type SsnUpdateForbiddenException = {
  __typename?: 'SsnUpdateForbiddenException'
  /** message */
  message?: Maybe<Scalars['String']>
}

export type SsnUsedError = {
  __typename?: 'SSNUsedError'
  message: Scalars['String']
}

/** Attributes for starting PDF Switch */
export type StartAcornsPdfSwitchInput = {
  /** [DEPRECATED] Use employerName instead. */
  name?: Maybe<Scalars['String']>
  /** Employer Name */
  employerName?: Maybe<Scalars['String']>
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Session ID */
  sessionId?: Maybe<Scalars['ID']>
}

/** Starts a check deposit session. */
export type StartCheckDepositInput = {
  /** The client info to pass to Ensenta for validation purposes */
  clientInfo: ClientInfo
}

/** Starts a check deposit session with our vendor. */
export type StartCheckDepositPayload = {
  __typename?: 'StartCheckDepositPayload'
  /** Token that represents a session with our vendor. */
  sessionToken: Scalars['String']
}

/** Attributes for starting Online Switch */
export type StartOnlineSwitchInput = {
  /** Employer ID */
  employerId: Scalars['ID']
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Session ID */
  sessionId?: Maybe<Scalars['ID']>
}

export type StartOnlineSwitchPayload = SwitchPayloadInterface & {
  __typename?: 'StartOnlineSwitchPayload'
  userSwitch: UserSwitch
}

/** Changeable attributes for addresses */
export type StartSubmittableSwitchAddressInput = {
  /** Street 1 */
  street1: Scalars['String']
  /** Street 2 */
  street2?: Maybe<Scalars['String']>
  /** City */
  city: Scalars['String']
  /** State */
  state: Scalars['String']
  /** Country */
  country: Scalars['String']
  /** Zip code */
  zipCode: Scalars['String']
}

/** Attributes for starting Submittable Switch */
export type StartSubmittableSwitchInput = {
  /** Employer ID */
  employerId: Scalars['ID']
  /** Bank Account ID */
  bankAccountId?: Maybe<Scalars['ID']>
  /** Session ID */
  sessionId?: Maybe<Scalars['ID']>
  /** Employee ID */
  nonSsnEmployeeId?: Maybe<Scalars['String']>
  /** Employer Address */
  employerLocationAddress?: Maybe<StartSubmittableSwitchAddressInput>
}

export type StartSubmittableSwitchPayload = SwitchPayloadInterface & {
  __typename?: 'StartSubmittableSwitchPayload'
  userSwitch: UserSwitch
}

export enum StateCode {
  Al = 'AL',
  Ak = 'AK',
  Az = 'AZ',
  Ar = 'AR',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ia = 'IA',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Me = 'ME',
  Md = 'MD',
  Ma = 'MA',
  Mi = 'MI',
  Mn = 'MN',
  Ms = 'MS',
  Mo = 'MO',
  Mt = 'MT',
  Ne = 'NE',
  Nv = 'NV',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Ny = 'NY',
  Nc = 'NC',
  Nd = 'ND',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Vt = 'VT',
  Va = 'VA',
  Wa = 'WA',
  Wv = 'WV',
  Wi = 'WI',
  Wy = 'WY',
  As = 'AS',
  Dc = 'DC',
  Fm = 'FM',
  Gu = 'GU',
  Mh = 'MH',
  Mp = 'MP',
  Pw = 'PW',
  Pr = 'PR',
  Vi = 'VI',
}

export type Statement = {
  __typename?: 'Statement'
  id: Scalars['ID']
  month: Scalars['Int']
  year: Scalars['Int']
  statementType: StatementType
  createdAt: Scalars['DateTime']
  updatedAt?: Maybe<Scalars['DateTime']>
  day: Scalars['Int']
  startDate?: Maybe<Scalars['DateTime']>
  endDate?: Maybe<Scalars['DateTime']>
  uploaded?: Maybe<Scalars['Boolean']>
  archivableId?: Maybe<Scalars['ID']>
  archivableType?: Maybe<Scalars['String']>
  s3Filename?: Maybe<Scalars['String']>
  investmentAccountId: Scalars['ID']
  link?: Maybe<StatementLink>
  investmentAccountType?: Maybe<InvestmentAccountType>
  formType?: Maybe<FormType>
}

export type StatementLink = {
  __typename?: 'StatementLink'
  url: Scalars['String']
  downloadUrl: Scalars['String']
}

export enum StatementType {
  User = 'user',
  DailyUserTradeConfirmation = 'daily_user_trade_confirmation',
  Tax = 'tax',
}

export type Stock = Security & {
  __typename?: 'Stock'
  symbol: Scalars['TickerSymbol']
  type: SecurityType
  week52High: BigCurrencyAmount
  week52Low: BigCurrencyAmount
  lastClosePrice: BigCurrencyAmount
  openPrice: BigCurrencyAmount
  shortName: Scalars['String']
  longName: Scalars['String']
  volume: Scalars['BigDecimal']
  marketCap: Scalars['BigDecimal']
  securityProfile: SecurityProfile
  securityHeadlines: SecurityHeadline[]
  lastUpdatedAt: Scalars['DateTime']
  earliestPriceDate: Scalars['Date']
}

export type SubcategoryMessage = {
  __typename?: 'SubcategoryMessage'
  id: Scalars['ID']
  title?: Maybe<Scalars['String']>
  body?: Maybe<Scalars['String']>
  ctaText?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

export type Submission = {
  __typename?: 'Submission'
  /** The name of the bank associated with this negotiation submission. */
  bank: BankName
  /** The ID of the associated bank connection. */
  linkedAccountId: Scalars['ID']
  /** The date the negotiation submission was created. Ex: 'Tue, 29 Dec 2020 04:16:41 GMT' */
  created: Scalars['DateTime']
  /** A uinique identifier for this submission: 'Chase Bank_1609215401.1132371'  */
  key: Scalars['String']
  /** The current status for this negotaition submission. */
  status: SubmissionStatus
  /** The date this submission was last edited. Ex: 'Fri, 22 Jan 2021 03:25:33 GMT' */
  updated: Scalars['DateTime']
}

export type SubmissionError = {
  __typename?: 'SubmissionError'
  errors?: Maybe<Array<Maybe<Scalars['String']>>>
}

export enum SubmissionStatus {
  Pending = 'PENDING',
  ConnectionError = 'CONNECTION_ERROR',
  Completed = 'COMPLETED',
  DelayCharge = 'DELAY_CHARGE',
  Collect = 'COLLECT',
}

export type SubmitBankFeeNegotiationInput = {
  linkedAccountId: Scalars['ID']
}

export type SubmitBankFeeNegotiationResponse = {
  __typename?: 'SubmitBankFeeNegotiationResponse'
  message: Scalars['String']
  status: Scalars['String']
}

export type SubmitBankFeeNegotiationResult =
  | SubmitBankFeeNegotiationResponse
  | LinkedAccountNotFound

export type SubmitSpendTransactionsDisputeInput = {
  cardNumber: Scalars['String']
  message: Scalars['String']
  spendCardDetails: Scalars['String']
  merchantInfo: Scalars['String']
  eSignature: Scalars['String']
  disputeReason: Scalars['String']
  selectedTransactions: SpendTransactionsInput[]
}

/** Submittable Switches are performed via Click Switch API. */
export type SubmittableSwitch = SwitchInterface & {
  __typename?: 'SubmittableSwitch'
  requiresEmployerMailingAddress?: Maybe<Scalars['Boolean']>
  requiresNonSsnEmployeeId?: Maybe<Scalars['Boolean']>
  requiresSsnLastFour?: Maybe<Scalars['Boolean']>
  source: SwitchSource
  type: SwitchType
  vendorTargetId: Scalars['ID']
}

export type SubscriberIneligibleError = {
  __typename?: 'SubscriberIneligibleError'
  message: Scalars['String']
}

export type SubscribeToTierInput = {
  feedback?: Maybe<Scalars['String']>
  tierId: Scalars['ID']
  tierPriceId: Scalars['ID']
  userId: Scalars['ID']
}

export type SubscribeToTierResult =
  | InvalidTier
  | InvalidTierPrice
  | TierSubscription

export type SubscribeUserToTierByProductKeyInput = {
  /** Deprecated */
  createdBy?: Maybe<TierSubscriptionCreatedBy>
  /**
   * Subscription requests with an effective date earlier than the current subscription's createdAt
   * timestamp will be ignored. Defaults to current time.
   */
  effectiveAt?: Maybe<Scalars['DateTime']>
  productKey: ProductKey
  tierGroupId?: Maybe<Scalars['ID']>
}

export type SubscribeUserToTierInput = {
  /** Deprecated */
  createdBy?: Maybe<TierSubscriptionCreatedBy>
  tierPriceId: Scalars['ID']
}

export type SubscribeUserToTierResult =
  | InvalidTierPriceId
  | TierDowngradeActionRequired
  | TierSubscription

export type SubscriptionMigration = {
  __typename?: 'SubscriptionMigration'
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  effectiveAt: Scalars['DateTime']
  fromTier: Tier
  id: Scalars['ID']
  toTier: Tier
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type SubscriptionMigrationInvalidError = {
  __typename?: 'SubscriptionMigrationInvalidError'
  message: Scalars['String']
}

export type SubscriptionMigrationWaiver = {
  __typename?: 'SubscriptionMigrationWaiver'
  accepted: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  migration: SubscriptionMigration
  reason: SubscriptionMigrationWaiverReason
  updatedAt?: Maybe<Scalars['DateTime']>
}

export enum SubscriptionMigrationWaiverReason {
  FinancialHardship = 'FINANCIAL_HARDSHIP',
}

/** transition actions for a subscription */
export enum SubscriptionTransitionAction {
  AddPromotion = 'ADD_PROMOTION',
  Deactivate = 'DEACTIVATE',
  Downgrade = 'DOWNGRADE',
  Upgrade = 'UPGRADE',
}

export type Suitability = {
  __typename?: 'Suitability'
  answer?: Maybe<Scalars['String']>
  answerId?: Maybe<Scalars['ID']>
  pickerId?: Maybe<Scalars['String']>
  questionId?: Maybe<Scalars['ID']>
}

/** Recommended portfolio for user based off their suitability responses */
export type Suitability_Portfolio = {
  __typename?: 'suitability_Portfolio'
  /** the portfolio description */
  description: Scalars['String']
  /** The portfolio ID */
  id: Scalars['ID']
  /** The portfolio name */
  name: Scalars['String']
}

/** Possible answer for a suitability question */
export type Suitability_SuitabilityAnswer = {
  __typename?: 'suitability_SuitabilityAnswer'
  /** Human readable text to display a description to an answer */
  description?: Maybe<Scalars['String']>
  /** Internal ID for a suitability answer */
  id: Scalars['ID']
  /** Value for clients to use to fetch strings */
  key: Scalars['String']
  /** Summary of an answer used for displaying why a portfolio was recommended */
  summary?: Maybe<Scalars['String']>
  /** Human readable text to display an answer to a suitability question */
  text: Scalars['String']
}

/** A user's input to update their suitabiliity */
export type Suitability_SuitabilityInput = {
  /** The question ID */
  questionId: Scalars['ID']
  /** The answer ID */
  answerId: Scalars['ID']
}

/** Suitability question asked for recommending portfolios */
export type Suitability_SuitabilityQuestion = {
  __typename?: 'suitability_SuitabilityQuestion'
  /** Default answer to the related suitability question */
  defaultAnswer?: Maybe<Suitability_SuitabilityAnswer>
  /** Internal ID for a suitability question */
  id: Scalars['ID']
  /** Value for clients to use to fetch strings */
  key: Scalars['String']
  /** Possible answers to be selected for the related question */
  possibleAnswers: Suitability_SuitabilityAnswer[]
  /** Human readable text to display the suitability question */
  text: Scalars['String']
}

/** A given user's suitability response for each question and answer */
export type Suitability_SuitabilityResponse = {
  __typename?: 'suitability_SuitabilityResponse'
  /** Associated answer to the suitability question */
  answer?: Maybe<Suitability_SuitabilityAnswer>
  /** Default answer to the related suitability question */
  question: Suitability_SuitabilityQuestion
}

/** Return wrapper type for the UpdateSuitability mutation */
export type Suitability_UpdateSuitabilityResult = {
  __typename?: 'suitability_UpdateSuitabilityResult'
  /** The recommended portfolio for the user's suitability responses */
  recommendedPortfolio?: Maybe<Suitability_Portfolio>
  /** Internal ID for a suitability answer */
  suitabilityResponses: Suitability_SuitabilityResponse[]
}

export type SuitabilityAnswer = {
  __typename?: 'SuitabilityAnswer'
  id: Scalars['ID']
  answer: Scalars['String']
}

export type SuitabilityInput = {
  questionId: Scalars['ID']
  answerId: Scalars['ID']
}

export type SuitabilityQuestion = {
  __typename?: 'SuitabilityQuestion'
  id: Scalars['ID']
  pickerId: Scalars['ID']
  placeholder: Scalars['String']
  answers: Array<Maybe<SuitabilityAnswer>>
  defaultAnswer: SuitabilityAnswer
}

export type SummaryItem = {
  __typename?: 'SummaryItem'
  amount: CurrencyAmount
  title: Scalars['String']
}

export type SupportArticle = {
  __typename?: 'SupportArticle'
  id: Scalars['ID']
  title: Scalars['String']
  body: Scalars['String']
  editedAt: Scalars['DateTime']
  sectionId: Scalars['ID']
  author: SupportAuthor
  promoted?: Maybe<Scalars['Boolean']>
  section: SupportSection
  category: SupportCategory
  private?: Maybe<Scalars['Boolean']>
}

export type SupportAuthor = {
  __typename?: 'SupportAuthor'
  id: Scalars['ID']
  name: Scalars['String']
  photo: SupportAuthorPhoto
}

export type SupportAuthorPhoto = {
  __typename?: 'SupportAuthorPhoto'
  contentUrl: Scalars['String']
}

export type SupportCategory = {
  __typename?: 'SupportCategory'
  description: Scalars['String']
  id: Scalars['ID']
  name: Scalars['String']
}

export type SupportSection = {
  __typename?: 'SupportSection'
  id: Scalars['ID']
  name: Scalars['String']
  articles: Array<Maybe<SupportArticle>>
  category: SupportCategory
  categoryId: Scalars['ID']
}

export type SupportTicket = {
  __typename?: 'SupportTicket'
  description: Scalars['String']
  id: Scalars['ID']
  subject: Scalars['String']
  url: Scalars['String']
}

export type SupportTicketForm = {
  __typename?: 'SupportTicketForm'
  id: Scalars['ID']
  displayName?: Maybe<Scalars['String']>
  ticketFields?: Maybe<Array<Maybe<SupportTicketFormField>>>
  active?: Maybe<Scalars['Boolean']>
  isDefault?: Maybe<Scalars['Boolean']>
  createdAt?: Maybe<Scalars['DateTime']>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type SupportTicketFormField = {
  __typename?: 'SupportTicketFormField'
  active?: Maybe<Scalars['Boolean']>
  createdAt?: Maybe<Scalars['DateTime']>
  description?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  id: Scalars['ID']
  required?: Maybe<Scalars['Boolean']>
  title: Scalars['String']
  type: Scalars['String']
  systemFieldOptions?: Maybe<Array<Maybe<CustomFieldOption>>>
  customFieldOptions?: Maybe<Array<Maybe<CustomFieldOption>>>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type SupportTicketResponse = SupportTicket | RecaptchaException

export type SupportTicketWithCustomFieldsResponse =
  | SupportTicket
  | SubmissionError

export type SupportUser = {
  __typename?: 'SupportUser'
  name?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
}

export type Sweepstake = {
  __typename?: 'Sweepstake'
  id?: Maybe<Scalars['ID']>
  name: Scalars['String']
  createdAt: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
}

export type SweepstakesSubmission = {
  __typename?: 'SweepstakesSubmission'
  name: Scalars['String']
  email?: Maybe<Scalars['EmailAddress']>
  reason: Scalars['String']
  sweepstakesId: Scalars['String']
}

/** Common attributes for all Switch Types */
export type SwitchInterface = {
  source: SwitchSource
  type: SwitchType
}

export enum SwitchMethod {
  /** Used clickswitch */
  Clickswitch = 'clickswitch',
  /** Used clickswitch and online */
  ClickswitchOnline = 'clickswitchOnline',
  /** Used clickswitch, online, and PDF */
  ClickswitchOnlinePdf = 'clickswitchOnlinePdf',
  /** Used clickswitch and PDF */
  ClickswitchPdf = 'clickswitchPdf',
  /** Used online */
  Online = 'online',
  /** Used online and PDF */
  OnlinePdf = 'onlinePdf',
  /** Used pdf */
  Pdf = 'pdf',
  /** Unknown */
  Unknown = 'unknown',
  /** None */
  None = 'none',
}

export type SwitchPayloadInterface = {
  userSwitch: UserSwitch
}

export enum SwitchSource {
  Acorns = 'acorns',
  ClickSwitch = 'clickSwitch',
}

export enum SwitchState {
  /** Attempted to setup direct deposit */
  Attempted = 'attempted',
  /** Completed direct deposit setup */
  Switched = 'switched',
  /** Viewed PDF screen or went to Online Portal */
  Viewed = 'viewed',
  /** User has not interacted with direct deposit in Acorns */
  NoInteraction = 'noInteraction',
}

export enum SwitchStatus {
  /** New for processing */
  New = 'new',
  /** Ready for processing */
  Ready = 'ready',
  /** Sent to ClickSwitch */
  Submitted = 'submitted',
  /** PDF generated */
  PdfGenerated = 'pdfGenerated',
  /** Deposit confirmed in Spend account */
  Completed = 'completed',
  /** PDF downloaded */
  PdfDownloaded = 'pdfDownloaded',
}

export enum SwitchType {
  /** Default PDF */
  Pdf = 'pdf',
  /** Online */
  Online = 'online',
  /** Submittable Generic */
  Submittable = 'submittable',
  /** Submittable Custom */
  SubmittableCustom = 'submittableCustom',
}

export type SystemCardLockedSpendAlert = SpendAlert & {
  __typename?: 'SystemCardLockedSpendAlert'
  userId: Scalars['ID']
  type: Scalars['String']
}

export type TaxWithholdingAmounts = {
  __typename?: 'TaxWithholdingAmounts'
  /**  total amount that will be withheld from the feds */
  federalWithholdingAmount: MonetaryAmount
  /**  total amount that will be withheld from the state */
  stateWithholdingAmount: MonetaryAmount
}

export enum TfaNotification {
  PushNotification = 'PUSH_NOTIFICATION',
}

export type TfaOptions = {
  __typename?: 'TfaOptions'
  /** A list of phone numbers to send a TFA code. */
  phone?: Maybe<Array<Scalars['String']>>
  /** A list of emails to send a TFA code. */
  email?: Maybe<Array<Scalars['String']>>
  /** A list of questions to select from and answer. */
  question?: Maybe<Array<Scalars['String']>>
  notification?: Maybe<TfaNotification[]>
}

export enum TfaStatus {
  Required = 'REQUIRED',
  Failed = 'FAILED',
  Authorized = 'AUTHORIZED',
  Pending = 'PENDING',
}

export enum TfaType {
  Email = 'EMAIL',
  Phone = 'PHONE',
  Question = 'QUESTION',
  Notification = 'NOTIFICATION',
  Pending = 'PENDING',
}

export type Tier = {
  __typename?: 'Tier'
  /** Indicates whether a tier is active or deprecated */
  active: Scalars['Boolean']
  description: Scalars['String']
  /** @deprecated Use Query.products and Tier.products instead. */
  excludedProducts: TierProduct[]
  id: Scalars['ID']
  /** @deprecated Use Query.products and Tier.products instead. */
  includedProducts: TierProduct[]
  key: TierKey
  name: Scalars['String']
  /** Associated Products available when subscribed to this Tier. */
  products?: Maybe<Product[]>
  /** (DONT USE) Internal only, may be removed without warning. */
  tierGroupId: Scalars['ID']
  /** Price of Tier */
  tierPrice: TierPrice
}

/** Individual action in a list of required actions */
export type TierDowngradeAction = {
  __typename?: 'TierDowngradeAction'
  key: TierDowngradeActionKey
}

/** Actions that must be taken to complete a downgrade workflow */
export enum TierDowngradeActionKey {
  CloseEarlyAccount = 'CLOSE_EARLY_ACCOUNT',
  CloseInvestAccount = 'CLOSE_INVEST_ACCOUNT',
  CloseLaterAccount = 'CLOSE_LATER_ACCOUNT',
  CloseSpendAccount = 'CLOSE_SPEND_ACCOUNT',
}

/** The list of required actions */
export type TierDowngradeActionRequired = {
  __typename?: 'TierDowngradeActionRequired'
  actions: TierDowngradeAction[]
}

/** Grouping of Tiers w/default tier, etc. */
export type TierGroup = {
  __typename?: 'TierGroup'
  active: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  /** Used to key A/B test off of */
  id: Scalars['ID']
  /** Tier ID which is the "preferred" one (i.e "Acorns recommends") */
  preferredTierId: Scalars['ID']
  tierOptions: TierOption[]
  updatedAt: Scalars['DateTime']
  winbackTierOption?: Maybe<TierOption>
}

export enum TierKey {
  /** Hardship $1 tier for our winback campaign */
  Assist = 'ASSIST',
  /** Legacy $2 SPEND tier */
  Bronze = 'BRONZE',
  Copper = 'COPPER',
  /** Promotional tier for Cricket Wireless subscribers. */
  Cricket = 'CRICKET',
  Gold = 'GOLD',
  /** Promotional free tier for active military and veterans */
  Military = 'MILITARY',
  Null = 'NULL',
  Silver = 'SILVER',
}

/** Combination of a Tier and available prices to choose from. */
export type TierOption = {
  __typename?: 'TierOption'
  preferredTierPrice: TierPrice
  tier: Tier
  tierPrices: TierPrice[]
}

export type TierOptionByTierPriceIdResult = InvalidTierPriceId | TierOption

/** Pricing configuration used for a tier */
export type TierPrice = {
  __typename?: 'TierPrice'
  amount: CurrencyAmount
  billingFrequency: BillingFrequency
  id: Scalars['ID']
  /** (DONT USE) Internal only, may be removed without warning. */
  tierId: Scalars['ID']
}

/** (Deprecated) Minimal representation of an Acorns product. */
export type TierProduct = {
  __typename?: 'TierProduct'
  /** used as unique identifier for this product */
  key: ProductKey
}

/** Unique combo of Tier and TierPrice tied to a User */
export type TierSubscription = {
  __typename?: 'TierSubscription'
  /** Reference to an Promotion the subscriber is actively consuming. */
  activePromotion?: Maybe<Promotion>
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<TierSubscriptionCreatedBy>
  id: Scalars['ID']
  migration?: Maybe<SubscriptionMigration>
  migrationId?: Maybe<Scalars['ID']>
  /** The Offer the subscriber subscribed to for access to their Tier. */
  offer?: Maybe<Offer>
  /** Indicates when the subscribers current Offer expires. */
  offerExpiresAt?: Maybe<Scalars['DateTime']>
  /** Indicates when a promotion was applied to the subscription. */
  promotionAppliedAt?: Maybe<Scalars['DateTime']>
  /** Indication of when a subscribers promotion ends. */
  promotionExpiresAt?: Maybe<Scalars['DateTime']>
  status: TierSubscriptionStatus
  tier: Tier
  tierPrice: TierPrice
  transition?: Maybe<TierSubscriptionTransition>
  updatedAt: Scalars['DateTime']
}

export type TierSubscriptionAlreadyDeactivated = {
  __typename?: 'TierSubscriptionAlreadyDeactivated'
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export type TierSubscriptionConnection = {
  __typename?: 'TierSubscriptionConnection'
  edges: TierSubscription[]
  pageInfo: TierSubscriptionPageInfo
}

export enum TierSubscriptionCreatedBy {
  /** Subscription created by the pre-launch backfill script */
  Backfill = 'BACKFILL',
  /** Flag to indicate user ought to be billed by the "legacy" billing system */
  LegacyUser = 'LEGACY_USER',
  /** Subscription record that was created as a result of a migration */
  Migration = 'MIGRATION',
  /** User auto-subscribed based on the status of their open accounts */
  SubscribedByOpenAccounts = 'SUBSCRIBED_BY_OPEN_ACCOUNTS',
  /** Subscription created via INTERNAL client request (either an admin or an internal process) */
  System = 'SYSTEM',
  /** Subscription created via EXTERNAL client request */
  User = 'USER',
}

/** account deactivation reasons */
export enum TierSubscriptionDeactivationReason {
  AcornsCostsTooMuch = 'ACORNS_COSTS_TOO_MUCH',
  CantAffordToInvestAtThisTime = 'CANT_AFFORD_TO_INVEST_AT_THIS_TIME',
  ConcernedAboutTheMarket = 'CONCERNED_ABOUT_THE_MARKET',
  DontWantToInvest = 'DONT_WANT_TO_INVEST',
  NotEnoughControlOverMyInvestments = 'NOT_ENOUGH_CONTROL_OVER_MY_INVESTMENTS',
  NotSureHowAcornsWorks = 'NOT_SURE_HOW_ACORNS_WORKS',
  NotTheRightTimeToInvest = 'NOT_THE_RIGHT_TIME_TO_INVEST',
  Other = 'OTHER',
  PoorInvestmentPerformance = 'POOR_INVESTMENT_PERFORMANCE',
  SwitchingToAnotherService = 'SWITCHING_TO_ANOTHER_SERVICE',
  ThisIsTemporaryIllBeBack = 'THIS_IS_TEMPORARY_ILL_BE_BACK',
  TroubleConnectingMyBank = 'TROUBLE_CONNECTING_MY_BANK',
  UnexpectedChargesToMyBank = 'UNEXPECTED_CHARGES_TO_MY_BANK',
}

export type TierSubscriptionForUser =
  | TierSubscription
  | TierSubscriptionNotFound
  | TierSubscriptionUnsubscribed

/** Returned if there is no found tier subscription */
export type TierSubscriptionNotFound = {
  __typename?: 'TierSubscriptionNotFound'
  message: Scalars['String']
}

/** Metadata for pagination of Tier Subscription History */
export type TierSubscriptionPageInfo = {
  __typename?: 'TierSubscriptionPageInfo'
  cursor?: Maybe<Scalars['String']>
  hasNext: Scalars['Boolean']
}

/** Status of a tier subscription */
export enum TierSubscriptionStatus {
  /** An active subscription */
  Active = 'ACTIVE',
  /** A cancelled subscription */
  Inactive = 'INACTIVE',
  /** In the process of either upgrading or downgrading a subscription */
  Transitioning = 'TRANSITIONING',
}

/** Information about a transitioning subscription */
export type TierSubscriptionTransition = {
  __typename?: 'TierSubscriptionTransition'
  desiredTier?: Maybe<Tier>
  /**
   * Once we've decoupled our Tier and TierPrice, we'll need to make sure we're
   * subscribing the user to the proper Tier and TierPrice
   */
  desiredTierPrice?: Maybe<TierPrice>
  initiatedAt: Scalars['DateTime']
  subscriptionDeactivationReason?: Maybe<TierSubscriptionDeactivationReason>
  transitionAction: SubscriptionTransitionAction
}

/** User has unsubscribed from their tier (account closed) */
export type TierSubscriptionUnsubscribed = {
  __typename?: 'TierSubscriptionUnsubscribed'
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export type TimestampsInterface = {
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** Details for tips */
export type Tip = {
  __typename?: 'Tip'
  body: Scalars['String']
  image?: Maybe<Image>
  title?: Maybe<Scalars['String']>
}

export type Toggle = {
  __typename?: 'Toggle'
  id: Scalars['String']
  value: Scalars['Boolean']
  invalid?: Maybe<Scalars['Boolean']>
}

export type TokenExpiredException = {
  __typename?: 'TokenExpiredException'
  message: Scalars['String']
}

/** Top Employer Name and Logo */
export type TopEmployer = {
  __typename?: 'TopEmployer'
  /** Employer Name */
  employerName: Scalars['String']
  /** Employer switch type */
  employerSwitchType: SwitchType
  /** Employer Logo URL */
  logo: Scalars['String']
  /** Employer online URL */
  onlineSwitchUrl?: Maybe<Scalars['String']>
}

/** Top Employer List */
export type TopEmployerPayload = {
  __typename?: 'TopEmployerPayload'
  topEmployersList: TopEmployer[]
}

export type TopHolding = {
  __typename?: 'TopHolding'
  symbol?: Maybe<Scalars['TickerSymbol']>
  securityName: Scalars['String']
  /** The number of shares that this security makes up of the ETF */
  numberOfShares?: Maybe<Scalars['BigDecimal']>
  /** The percentage of shares that this security makes up of the ETF */
  sharePercentage: Scalars['BigDecimal']
  /** The market value that this security makes up of the ETF */
  marketValue: BigCurrencyAmount
}

export type TotalAmounts = {
  __typename?: 'TotalAmounts'
  totalContributedAmount: CurrencyAmount
  totalDepositedAmount: CurrencyAmount
}

export enum TradingSector {
  BasicMaterials = 'BASIC_MATERIALS',
  CommunicationServices = 'COMMUNICATION_SERVICES',
  ConsumerCyclical = 'CONSUMER_CYCLICAL',
  ConsumerDefensive = 'CONSUMER_DEFENSIVE',
  Energy = 'ENERGY',
  FinancialServices = 'FINANCIAL_SERVICES',
  HealthCare = 'HEALTH_CARE',
  Industrials = 'INDUSTRIALS',
  RealEstate = 'REAL_ESTATE',
  Technology = 'TECHNOLOGY',
  Utilities = 'UTILITIES',
}

export enum TransactionCategory {
  Fee = 'FEE',
  Refund = 'REFUND',
}

export type TransactionResult = {
  __typename?: 'TransactionResult'
  id: Scalars['String']
}

/** Transfer transactions object */
export type Transfer = {
  __typename?: 'Transfer'
  id: Scalars['ID']
  amount: CurrencyAmount
  state: TransferState
  from: TransferableAccount
  to: TransferableAccount
  createdAt: Scalars['DateTime']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
  /** When this was cancelled. NULL if never cancelled */
  canceledAt?: Maybe<Scalars['DateTime']>
}

export type TransferableAccount = {
  __typename?: 'TransferableAccount'
  id: Scalars['ID']
  /** The name of the account. e.g. Chase Checking */
  name: Scalars['String']
  /** The type of Acorns account we are tracking for the user */
  type: TransferableAccountTypeEnum
  /**
   * A snapshot of the accounts last balance if available to acorns. External
   * accounts wont have this. This is the value of the AVAILABLE balance.
   */
  balance?: Maybe<CurrencyAmount>
  /** The last 4 digits of the account or null if unavailable */
  accountNumberMasked?: Maybe<Scalars['String']>
  /** Whether an account is linked from plaid, spend, paypal, direct_bank or manual */
  externalSource?: Maybe<ExternalSource>
}

export enum TransferableAccountTypeEnum {
  Spend = 'spend',
  Save = 'save',
  Core = 'core',
  External = 'external',
  Later = 'later',
  Early = 'early',
}

/** Info on accounts that can be transferred from */
export type TransferableFrom = {
  __typename?: 'TransferableFrom'
  from: TransferableAccount
}

/** Info about accounts that can be transferred to */
export type TransferableTo = {
  __typename?: 'TransferableTo'
  to: TransferableAccount
  /** This field will be null if there is no max limit */
  min?: Maybe<CurrencyAmount>
  /** This field will be null if there is no max limit */
  max?: Maybe<CurrencyAmount>
}

export enum TransferState {
  Initiated = 'initiated',
  Transferring = 'transferring',
  Completed = 'completed',
  Canceled = 'canceled',
}

export type UnableToCancelCheckError = {
  __typename?: 'UnableToCancelCheckError'
  requestId: Scalars['ID']
}

export type UnauthorizedException = {
  __typename?: 'UnauthorizedException'
  message: Scalars['String']
}

export type UnblockDeviceInput = {
  deviceId: Scalars['ID']
}

/** unblockDevice results */
export type UnblockDeviceResult = Device | DeviceNotFoundException

/** Unknown provider */
export type UnknownProvider = {
  __typename?: 'UnknownProvider'
  cta: Cta
  image: Image
  subtitle?: Maybe<Scalars['String']>
}

export type UnlockBankCardPayload = {
  __typename?: 'UnlockBankCardPayload'
  bankCard?: Maybe<BankCard>
}

/** The LinkedAccount associated with the linked_account_id will never be valid with the external provider */
export type UnrecoverableLinkedAccountError = {
  __typename?: 'UnrecoverableLinkedAccountError'
  /** ID of the unrecoverable LinkedAccount */
  linkedAccountId: Scalars['ID']
}

export type UnsubscribeUserFromTierInput = {
  /** Deprecated */
  createdBy?: Maybe<TierSubscriptionCreatedBy>
}

export type UnsubscribeUserFromTierResult =
  | TierDowngradeActionRequired
  | TierSubscriptionUnsubscribed

/** The associated beneficiary does not have a verified SSN */
export type UnverifiedBeneficiarySsnAlert = Alert & {
  __typename?: 'UnverifiedBeneficiarySsnAlert'
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary
  /**
   * Internal ID of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  beneficiaryId: Scalars['ID']
  /**
   * First name of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  firstName: Scalars['String']
  /** @deprecated The type of the alert is defined by the gql type. */
  type: Scalars['String']
  userId: Scalars['ID']
}

/** The associated beneficiary does not have a verified SSN */
export type UnverifiedBeneficiarySsnAlertItem = UserAlertsItem & {
  __typename?: 'UnverifiedBeneficiarySsnAlertItem'
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type UpdateAccountPointsRuleInput = {
  /** detailed explanation about how points are earned */
  details?: Maybe<Scalars['String']>
  milestoneID: Scalars['ID']
  /** summarized explanation about how points are earned */
  summary?: Maybe<Scalars['String']>
}

export type UpdateAccountPointsRuleResult =
  | RecordAlreadyExistsError
  | RecordDoesNotExistError
  | AccountPointsRule

/** Input to update account portfolio */
export type UpdateAccountPortfolioInput = {
  /** Portfolio Risk Type */
  riskLevel: PortfolioRiskLevel
  /** Portfolio theme */
  theme: PortfolioTheme
  /** Investment account ID */
  investmentAccountId: Scalars['ID']
}

/** Update Account Portfolio Response */
export type UpdateAccountPortfolioResponse =
  | InvalidActionOnAccount
  | InvestmentAccount
  | InvestmentAccountNotFoundException
  | PortfolioNotFoundException
  | PortfolioUpdateFailedException

export type UpdateAuthEmailInput = {
  email: Scalars['EmailAddress']
}

export type UpdateAuthEmailResult = AuthProfile | ExistingEmailVerifiedException

export type UpdateAuthPhoneNumberInput = {
  phoneNumber: Scalars['PhoneNumber']
}

export type UpdateAuthPhoneNumberResult =
  | AuthProfile
  | InvalidPhoneNumberException
  | ExistingPhoneVerifiedException

export type UpdateBankCardPinInput = {
  newPin: Scalars['BankCardPin']
}

export type UpdateBankCardPinPayload = {
  __typename?: 'UpdateBankCardPinPayload'
  bankCard?: Maybe<BankCard>
}

/** Response to a beneficiary update */
export type UpdateBeneficiaryInfoResult =
  | Beneficiary
  | BeneficiaryNotFoundException
  | InternalErrorException
  | InvalidAddressException
  | InvalidEmailException
  | InvalidPhoneException

/** Return type for the ProtectUpdateCoverage mutation */
export type UpdateCoverageResponse = {
  __typename?: 'UpdateCoverageResponse'
  success: Scalars['Boolean']
}

/** updateCredentials results */
export type UpdateCredentialsResult =
  | Credentials
  | EmailTakenException
  | BlockedEmailDomainException
  | UserCredentialsNotFoundException

/** Attributes for updating the linked account */
export type UpdateLinkedAccountInput = {
  /** Plaid link session id */
  linkSessionId: Scalars['String']
}

export type UpdateMilestoneAccountLevelDefinitionInput = {
  /** what is the background image when active */
  activeBackgroundUrl?: Maybe<Scalars['String']>
  /** what is the foreground image when active */
  activeForegroundUrl?: Maybe<Scalars['String']>
  /** level id, e.g. 3 */
  id: Scalars['Int']
  /** what is the background image when inactive */
  inactiveBackgroundUrl?: Maybe<Scalars['String']>
}

export type UpdateMilestoneAccountLevelDefinitionResult =
  | RecordDoesNotExistError
  | MilestoneAccountLevelDefinition

export type UpdateMilestoneChallengeDefinitionInput = {
  /** additional information about this challenge */
  details?: Maybe<Scalars['String']>
  id: Scalars['ID']
  logo?: Maybe<ImageInput>
  /** descriptive identifier */
  name: Scalars['String']
}

export type UpdateMilestoneChallengeDefinitionResult =
  | MilestoneChallengeDefinition
  | RecordDoesNotExistError

export type UpdateMilestoneChallengePointsRuleInput = {
  challengeID: Scalars['ID']
  /** legal copy about how points are earned */
  earningDetails?: Maybe<Scalars['String']>
  /** summarized information about how points are earned */
  earningSummary?: Maybe<Scalars['String']>
  milestoneID: Scalars['ID']
}

export type UpdateMilestoneChallengePointsRuleResult =
  | MilestoneChallengePointsRule
  | RecordDoesNotExistError

export type UpdateMilestoneDefinitionInput = {
  id: Scalars['ID']
  /** an optional logo used for inactive milestone states (e.g. LOCKED, NOT_STARTED) */
  inactiveLogo?: Maybe<ImageInput>
  /** default logo */
  logo?: Maybe<ImageInput>
  /** descriptive identifier */
  name?: Maybe<Scalars['String']>
}

export type UpdateMilestoneDefinitionResult =
  | MilestoneDefinition
  | RecordDoesNotExistError

/** Input for updatePortfolioSecurities */
export type UpdatePortfolioSecuritiesInput = {
  /** Investment Account ID */
  investmentAccountId: Scalars['ID']
  /** Portfolio ID */
  portfolioId: Scalars['ID']
  /** List of Securities and their target allocation percent */
  securityAllocations: SecurityAllocationTarget[]
}

/** Result of updating a portfolio's securities */
export type UpdatePortfolioSecuritiesResult =
  | InvalidAllocationPercentError
  | InvalidSecurityError
  | InvestmentAccount
  | NegativeSecurityPercentError

/** Return type for ProtectUpdateRecommendedLifeCoverage mutation */
export type UpdateRecommendedCoverageResponse = {
  __typename?: 'UpdateRecommendedCoverageResponse'
  success: Scalars['Boolean']
}

/** Returned if failure updating reward */
export type UpdateReferralRewardError = {
  __typename?: 'UpdateReferralRewardError'
  message: Scalars['String']
}

export type UpdateReferralRewardResponse =
  | ReferralRewardSummary
  | UpdateReferralRewardError

export type UpdateUserInfoResult =
  | User
  | SsnUsedError
  | InvalidSsnError
  | PoBoxAddressError

/** Uploads a check image to the provided session. */
export type UploadCheckInput = {
  checkImage: CheckImage
  /** The session the image will be uploaded to. */
  sessionToken: Scalars['String']
}

/** Response from uploading a check image. */
export type UploadCheckPayload = {
  __typename?: 'UploadCheckPayload'
  /** Session image was uploaded to. */
  sessionToken: Scalars['String']
}

export type UploadDocumentsInput = {
  documentRequestId: Scalars['ID']
  documents: Array<Scalars['Upload']>
  documentType: DocumentType
}

export type UploadFailedError = {
  __typename?: 'UploadFailedError'
  message: Scalars['String']
}

export type UploadUnsolicitedDocumentsInput = {
  documents: Array<Scalars['Upload']>
  documentType: DocumentType
  /** Idempotency key for ensuring that duplicate requests are not made */
  requestKey?: Maybe<Scalars['String']>
  status?: Maybe<DocumentStatus>
}

export type User = {
  __typename?: 'User'
  uuid: Scalars['ID']
  email: Scalars['String']
  phoneNumber?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  dob?: Maybe<Scalars['String']>
  usCitizen?: Maybe<Scalars['Boolean']>
  employer?: Maybe<Scalars['String']>
  occupation?: Maybe<Scalars['String']>
  verified?: Maybe<Scalars['Boolean']>
  pinCreated?: Maybe<Scalars['Boolean']>
  registrationComplete?: Maybe<Scalars['Boolean']>
  registrationCompletedAt?: Maybe<Scalars['DateTime']>
  sourceId?: Maybe<Scalars['String']>
  closedAt?: Maybe<Scalars['DateTime']>
  address1?: Maybe<Scalars['String']>
  address2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['USStateName']>
  zip?: Maybe<Scalars['String']>
  fundingSource?: Maybe<FundingSource>
  fundingSourceCanChange?: Maybe<Scalars['Boolean']>
  fundingSourceChangeRequiresApproval?: Maybe<Scalars['Boolean']>
  portfolio?: Maybe<Portfolio>
  uploads: UserUpload[]
  pendingBalance?: Maybe<Scalars['Float']>
  currentBalance: Scalars['Float']
  allocationProfileId?: Maybe<Scalars['ID']>
  recommendedAllocationProfileId?: Maybe<Scalars['ID']>
  /** @deprecated Field no longer supported */
  employedAffiliatedWithBrokerDealer?: Maybe<Scalars['Boolean']>
  /** @deprecated Field no longer supported */
  shareholderOrDirector?: Maybe<Scalars['Boolean']>
  /** @deprecated Field no longer supported */
  subjectToBackupWithholding?: Maybe<Scalars['Boolean']>
  /** @deprecated Field no longer supported */
  securityQuestion: SecurityQuestion
  /** @deprecated Use Query.suitabilityResponses instead. */
  suitability?: Maybe<Array<Maybe<Suitability>>>
  /** @deprecated Field no longer supported */
  referralCode?: Maybe<Scalars['String']>
  /** @deprecated Use Query.userAlerts instead. */
  alerts?: Maybe<Array<Maybe<UserAlert>>>
  /** @deprecated Highly non-performant! */
  totals: UserTotals
  /** @deprecated Highly non-performant! */
  dailyChange?: Maybe<UserDailyChange>
  /** @deprecated Use RoundUpProfile.roundUpTotal instead. */
  roundUps: UserRoundUps
  /** @deprecated Use Profile.maritalStatus instead. */
  maritalStatus?: Maybe<MaritalStatusType>
  investmentAccounts?: Maybe<InvestmentAccount[]>
}

/** Object representing an acorns user */
export type User_V2 = {
  __typename?: 'User_v2'
  closedAt?: Maybe<Scalars['Date']>
  email: Scalars['String']
  uuid: Scalars['ID']
}

/** A user alert. */
export type UserAlert = UserAlertsItem & {
  __typename?: 'UserAlert'
  id: Scalars['ID']
  /** The type of the alert */
  type: Scalars['String']
  key: Scalars['String']
  title: Scalars['String']
  description: Scalars['String']
  metadata?: Maybe<Scalars['String']>
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type UserAlertsItem = {
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Response from user alert query */
export type UserAlertsResponse =
  | AddressDocumentRequestedUserAlert
  | BankDocumentRequestedUserAlert
  | IdentityDocumentRequestedUserAlert
  | InsufficientFundsUserAlert
  | InvestmentsPausedUserAlert
  | MiscDocumentRequestedUserAlert
  | NoFundingSourceUserAlert
  | RdvRequiredUserAlert
  | SsnDocumentRequestedUserAlert
  | UserAlert
  | W9DocumentRequestedUserAlert

export type UserCardLockedSpendAlert = SpendAlert & {
  __typename?: 'UserCardLockedSpendAlert'
  userId: Scalars['ID']
  type: Scalars['String']
}

/** The provided user is closed */
export type UserClosedException = {
  __typename?: 'UserClosedException'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The provided user id */
  userId?: Maybe<Scalars['ID']>
}

export type UserCredentialsInput = {
  email: Scalars['EmailAddress']
}

export type UserCredentialsNotFoundException = {
  __typename?: 'UserCredentialsNotFoundException'
  message: Scalars['String']
}

export type UserDailyChange = {
  __typename?: 'UserDailyChange'
  accountChange?: Maybe<Scalars['Float']>
  accountPercent?: Maybe<Scalars['Float']>
  change?: Maybe<Scalars['Float']>
  percentage?: Maybe<Scalars['Float']>
  marketChange?: Maybe<Scalars['Float']>
  marketPercent?: Maybe<Scalars['Float']>
}

/** A reopen check for an investment account reopen request. */
export type UserInvestmentAccountReopenCheck = TimestampsInterface & {
  __typename?: 'UserInvestmentAccountReopenCheck'
  /** The ID of the reopen request to which this check belongs. */
  accountReopenRequestId: Scalars['Int']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** The UUID of the investment account for which this check was made. */
  investmentAccountId: Scalars['ID']
  /** A boolean indicating whether this check passed or failed.  */
  passed: Scalars['Boolean']
  /** The check type. */
  reopenCheckType: InvestmentAccountReopenCheck
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** UUID of the user to whom the account the reopen request was made for belongs. */
  userUuid: Scalars['ID']
}

export type UserLockedException = {
  __typename?: 'UserLockedException'
  message: Scalars['String']
}

/** No user was found for the ID provided */
export type UserNotFound = {
  __typename?: 'UserNotFound'
  /** The provided user id */
  userId?: Maybe<Scalars['ID']>
}

/** No user was found for the ID provided */
export type UserNotFoundException = {
  __typename?: 'UserNotFoundException'
  /** message */
  message?: Maybe<Scalars['String']>
  /** The provided user id */
  userId?: Maybe<Scalars['ID']>
}

/** Custodian must be verified in order to open an Early Account */
export type UserNotVerifiedException = {
  __typename?: 'UserNotVerifiedException'
  /** message */
  message?: Maybe<Scalars['String']>
}

/** The provided user is locked */
export type UserReopenLockedException = {
  __typename?: 'UserReopenLockedException'
  /** The date the user was locked */
  lockedAt: Scalars['DateTime']
  /** The provided user id */
  userId?: Maybe<Scalars['ID']>
}

/** The provided user is suspended */
export type UserReopenSuspendedException = {
  __typename?: 'UserReopenSuspendedException'
  /** The date the user was suspended */
  suspendedAt: Scalars['DateTime']
  /** The reason the user was suspended */
  suspendedReason?: Maybe<Scalars['String']>
  /** The provided user id */
  userId?: Maybe<Scalars['ID']>
}

export type UserRoundUps = {
  __typename?: 'UserRoundUps'
  total: Scalars['Float']
  waiting: Scalars['Float']
}

export type UserStatus = {
  __typename?: 'UserStatus'
  userId: Scalars['String']
  closed: Scalars['Boolean']
  closedAt?: Maybe<Scalars['DateTime']>
  verified: Scalars['Boolean']
  verifiedAt?: Maybe<Scalars['DateTime']>
  registrationComplete: Scalars['Boolean']
  registrationCompleteAt?: Maybe<Scalars['DateTime']>
}

export type UserSuspendedException = {
  __typename?: 'UserSuspendedException'
  message: Scalars['String']
}

/** Describes a user request for a direct deposit switch. */
export type UserSwitch = {
  __typename?: 'UserSwitch'
  /** Creation Date */
  createdAt: Scalars['String']
  /** Switch ID */
  id: Scalars['ID']
  /** Indicates whether the user is already depositing on the Spend account or not. */
  isComplete: Scalars['Boolean']
  /** Status of the direct deposit switch. */
  status: SwitchStatus
  /** Switch Type */
  switchType: SwitchType
  /** Last Updated Date */
  updatedAt: Scalars['String']
  /** User ID */
  userId: Scalars['ID']
  /** Switch ID provided by the vendor. */
  vendorSwitchId?: Maybe<Scalars['ID']>
}

export type UserTotals = {
  __typename?: 'UserTotals'
  totalInvested?: Maybe<Scalars['Float']>
  totalDeposits?: Maybe<Scalars['Float']>
  totalWithdrawn?: Maybe<Scalars['Float']>
  totalDividends?: Maybe<Scalars['Float']>
  totalFees?: Maybe<Scalars['Float']>
  totalReferrals?: Maybe<Scalars['Float']>
  totalFoundMoney?: Maybe<Scalars['Float']>
  totalGainLoss?: Maybe<Scalars['Float']>
  totalOtherRewards?: Maybe<Scalars['Float']>
  /** @deprecated Use RoundUpProfile.roundUpTotal instead. */
  totalRoundUps?: Maybe<Scalars['Float']>
}

export type UserUpload = {
  __typename?: 'UserUpload'
  id: Scalars['ID']
  documentType?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
}

export enum UsStateCodes {
  /** Alabama */
  Al = 'AL',
  /** Alaska */
  Ak = 'AK',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** Arkansas */
  Ar = 'AR',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** Delaware */
  De = 'DE',
  /** District Of Columbia */
  Dc = 'DC',
  /** Federated States Of Micronesia */
  Fm = 'FM',
  /** Florida */
  Fl = 'FL',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Iowa */
  Ia = 'IA',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Maine */
  Me = 'ME',
  /** Marshall Islands */
  Mh = 'MH',
  /** Maryland */
  Md = 'MD',
  /** Massachusetts */
  Ma = 'MA',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Mississippi */
  Ms = 'MS',
  /** Missouri */
  Mo = 'MO',
  /** Montana */
  Mt = 'MT',
  /** Nebraska */
  Ne = 'NE',
  /** Nevada */
  Nv = 'NV',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** New York */
  Ny = 'NY',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Palau */
  Pw = 'PW',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Vermont */
  Vt = 'VT',
  /** U.S. Virgin Islands */
  Vi = 'VI',
  /** Virginia */
  Va = 'VA',
  /** Washington */
  Wa = 'WA',
  /** West Virginia */
  Wv = 'WV',
  /** Wisconsin */
  Wi = 'WI',
  /** Wyoming */
  Wy = 'WY',
  /** Armed Forces America */
  Aa = 'AA',
  /** Armed Forces Europe */
  Ae = 'AE',
  /** Armed Forces Pacific */
  Ap = 'AP',
}

export type VerifyCheckPaymentRecipientAddressInputType = {
  recipient: CheckPaymentRecipientInput
  recipientAddress: CheckPaymentAddressInput
}

/** Address deliverable by mail carrier or InvalidAddressError */
export type VerifyCheckPaymentRecipientAddressResult =
  | CheckPaymentRecipientAddressType
  | InvalidAddressError
  | AuthorizationError

export type VerifyDeviceInput = {
  deviceId: Scalars['ID']
}

/** verifyDevice results */
export type VerifyDeviceResult =
  | SmsAuthChallenge
  | EmailAuthChallenge
  | DeviceNotFoundException

export type VerifyPasswordsInput = {
  oldPassword: Scalars['String']
  newPassword: Scalars['String']
}

/** verifyPasswords results */
export type VerifyPasswordsResult =
  | VerifyPasswordsSuccess
  | IncorrectOldPasswordException
  | SamePasswordsException
  | InvalidPasswordException
  | UnauthorizedException

export type VerifyPasswordsSuccess = {
  __typename?: 'VerifyPasswordsSuccess'
  isValid: Scalars['Boolean']
}

export type VersionMismatchException = {
  __typename?: 'VersionMismatchException'
  latestVersion?: Maybe<Scalars['ID']>
}

/** W9 document requested. */
export type W9DocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'W9DocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** URLs for linked account webhooks */
export type Webhooks = {
  __typename?: 'Webhooks'
  /** URL for plaid webhooks */
  plaid: Scalars['String']
}

/** A URL which represents the location of the account linking source the client should use. */
export type WebviewLinkSession = {
  __typename?: 'WebviewLinkSession'
  /** The URL a client should use for account linking. */
  url: Scalars['URL']
}

export enum WidgetReferenceType {
  /** Protect Context */
  ProtectContext = 'protect_context',
  /** Protect Onboarding Questions */
  ProtectOnboarding = 'protect_onboarding',
  /** Onboarding Results/Recommendations */
  ProtectRecommendations = 'protect_recommendations',
  /** Protect Home page */
  ProtectHome = 'protect_home',
  /** Protect Provider Search */
  ProtectProviders = 'protect_providers',
  /** Protect Insurance Home */
  ProtectInsuranceHome = 'protect_insurance_home',
  /** Protect Coverage Shop */
  ProtectCoverageShop = 'protect_coverage_shop',
  /** Auto Insurance Offer Query */
  ProtectAutoInsurance = 'protect_auto_insurance',
  /** Life Insurance Offer Query */
  ProtectLifeInsurance = 'protect_life_insurance',
  /** Renters Insurance Offer Query */
  ProtectRentersInsurance = 'protect_renters_insurance',
  /** Home Insurance Offer Query */
  ProtectHomeInsurance = 'protect_home_insurance',
  /** Pet Insurance Offer Query */
  ProtectPetInsurance = 'protect_pet_insurance',
}

/** Withdrawal Investment Object */
export type Withdrawal = {
  __typename?: 'Withdrawal'
  amount: Scalars['Float']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  presentableWithdrawalStatus: PresentableWithdrawalStatus
}

export type WithholdingDefaults = {
  __typename?: 'WithholdingDefaults'
  federalWithholdingPercentage: Scalars['Float']
  stateWithholdingPercentage: Scalars['Float']
  showStateWithholdingField: Scalars['Boolean']
  showFederalWithholdingField: Scalars['Boolean']
}

export type WithholdingEstimates = {
  __typename?: 'WithholdingEstimates'
  /**  estimated amount that will be delivered to the customer */
  estimatedCustomerAmount: MonetaryAmount
  /**  estimated total amount that will be withheld for federal taxes */
  estimatedFederalWithholdingAmount: MonetaryAmount
  /**  estimated total amount that will be withheld for state taxes */
  estimatedStateWithholdingAmount: MonetaryAmount
  /**  estimated earnings that will be taxed */
  estimatedTaxableEarnings: MonetaryAmount
  /**  estimated total amount that will be withheld (state and federal) */
  estimatedTotalWithholdingAmount: MonetaryAmount
}

export type YearLaterReport = {
  __typename?: 'YearLaterReport'
  accountBalance: Scalars['Float']
  accountCreationDate: Scalars['String']
  accountPerformance: Scalars['Float']
  accountType: Scalars['String']
  firstDepositAmountForYear?: Maybe<Scalars['Float']>
  firstDepositDateForYear?: Maybe<Scalars['String']>
  recurringContributionAmount: Scalars['Float']
  recurringContributionFrequency?: Maybe<InvestmentFrequency>
  totalDeposits: Scalars['Float']
  totalDepositsForYear: Scalars['Float']
  totalDividends: Scalars['Float']
  totalNetReturns: Scalars['Float']
  totalWithdrawals: Scalars['Float']
  userAge: Scalars['Int']
}

export type AuthenticateMutationVariables = Exact<{
  input: AuthenticateInput
}>

export type AuthenticateMutation = { __typename?: 'Mutation' } & {
  authenticate:
    | ({ __typename: 'SMSAuthChallenge' } & Pick<
        SmsAuthChallenge,
        'id' | 'maskedPhoneNumber'
      > & {
          alternateAuthenticators: Array<
            { __typename?: 'AuthenticatorInfo' } & Pick<
              AuthenticatorInfo,
              'id' | 'type'
            >
          >
        })
    | ({ __typename: 'EmailAuthChallenge' } & Pick<
        EmailAuthChallenge,
        'id' | 'maskedEmail'
      > & {
          alternateAuthenticators: Array<
            { __typename?: 'AuthenticatorInfo' } & Pick<
              AuthenticatorInfo,
              'id' | 'type'
            >
          >
        })
    | ({ __typename: 'AuthSession' } & Pick<
        AuthSession,
        'id' | 'token' | 'identityId'
      >)
    | { __typename: 'AuthenticatorUnavailableException' }
    | ({ __typename: 'InvalidCredentialsException' } & Pick<
        InvalidCredentialsException,
        'message'
      >)
    | ({ __typename: 'UserSuspendedException' } & Pick<
        UserSuspendedException,
        'message'
      >)
    | ({ __typename: 'DeviceBlockedException' } & Pick<
        DeviceBlockedException,
        'message'
      >)
    | ({ __typename: 'UserLockedException' } & Pick<
        UserLockedException,
        'message'
      >)
    | { __typename: 'LoginRateLimitedException' }
    | { __typename: 'PhoneNumberOptedOutException' }
    | { __typename: 'AuthChallengeAnswerIncorrectException' }
    | { __typename: 'AuthChallengeAnswerAttemptsExhaustedException' }
    | { __typename: 'AuthChallengeExpiredException' }
    | { __typename: 'AuthenticatorTypeAlreadyRegisteredException' }
}

export type ChallengeAuthenticateMutationVariables = Exact<{
  input: AuthenticateInput
  challengeAnswerInput?: Maybe<ChallengeAnswerInput>
  alternateAuthenticatorId?: Maybe<Scalars['ID']>
}>

export type ChallengeAuthenticateMutation = { __typename?: 'Mutation' } & {
  authenticate:
    | ({ __typename: 'SMSAuthChallenge' } & Pick<
        SmsAuthChallenge,
        'id' | 'maskedPhoneNumber'
      > & {
          alternateAuthenticators: Array<
            { __typename?: 'AuthenticatorInfo' } & Pick<
              AuthenticatorInfo,
              'id' | 'type'
            >
          >
        })
    | ({ __typename: 'EmailAuthChallenge' } & Pick<
        EmailAuthChallenge,
        'id' | 'maskedEmail'
      > & {
          alternateAuthenticators: Array<
            { __typename?: 'AuthenticatorInfo' } & Pick<
              AuthenticatorInfo,
              'id' | 'type'
            >
          >
        })
    | ({ __typename: 'AuthSession' } & Pick<
        AuthSession,
        'id' | 'token' | 'identityId'
      >)
    | { __typename: 'AuthenticatorUnavailableException' }
    | { __typename: 'InvalidCredentialsException' }
    | { __typename: 'UserSuspendedException' }
    | { __typename: 'DeviceBlockedException' }
    | ({ __typename: 'UserLockedException' } & Pick<
        UserLockedException,
        'message'
      >)
    | { __typename: 'LoginRateLimitedException' }
    | { __typename: 'PhoneNumberOptedOutException' }
    | ({ __typename: 'AuthChallengeAnswerIncorrectException' } & Pick<
        AuthChallengeAnswerIncorrectException,
        'message'
      >)
    | ({ __typename: 'AuthChallengeAnswerAttemptsExhaustedException' } & Pick<
        AuthChallengeAnswerAttemptsExhaustedException,
        'message'
      >)
    | ({ __typename: 'AuthChallengeExpiredException' } & Pick<
        AuthChallengeExpiredException,
        'message'
      >)
    | { __typename: 'AuthenticatorTypeAlreadyRegisteredException' }
}

export type ReinitiateChallengeMutationVariables = Exact<{
  input: ReinitiateSmsChallengeInput
}>

export type ReinitiateChallengeMutation = { __typename?: 'Mutation' } & {
  reinitiateChallenge:
    | ({ __typename?: 'SMSAuthChallenge' } & Pick<
        SmsAuthChallenge,
        'id' | 'maskedPhoneNumber'
      >)
    | ({ __typename?: 'EmailAuthChallenge' } & Pick<
        EmailAuthChallenge,
        'id' | 'maskedEmail'
      >)
    | ({ __typename?: 'AuthChallengeExpiredException' } & Pick<
        AuthChallengeExpiredException,
        'message'
      >)
}
